import styled from '@emotion/styled';
import React$1, { memo, useEffect, useMemo, Fragment, useState, useRef, useCallback } from 'react';
import StarRatings from 'react-star-ratings';
import { useMediaQuery } from 'react-responsive';
import { Modal as Modal$2 } from 'react-responsive-modal';
import striptags from 'striptags';
import { LazyLoadImage, LazyLoadComponent } from 'react-lazy-load-image-component';
import { css } from '@emotion/react';
import { Carousel } from 'react-responsive-carousel';
import { motion, AnimateSharedLayout } from 'framer-motion';
import require$$1 from 'react-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var reactActivity = {exports: {}};

(function (module, exports) {
	(function webpackUniversalModuleDefinition(root, factory) {
		module.exports = factory(React$1);
	})(commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE__297__) {
	return /******/ (() => { // webpackBootstrap
	/******/ 	var __webpack_modules__ = ({

	/***/ 930:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Bounce_Bounce)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
	var getRelativeTime = __webpack_require__(531);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};




	var Bounce = function (_a) {
	    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
	    var renderSquares = function () {
	        var res = [];
	        for (var i = 1; i <= 3; i++) {
	            res.unshift(external_react_.createElement("div", { key: i, style: {
	                    animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, i / -10),
	                } }));
	        }
	        return res;
	    };
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-bounce", speed: speed, defaultAnimationDuration: 0.8 }, rest), renderSquares()));
	};
	/* harmony default export */ const Bounce_Bounce = (Bounce);



	/***/ }),

	/***/ 843:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Digital_Digital)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
	var getRelativeTime = __webpack_require__(531);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};




	var Digital = function (_a) {
	    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
	    var rects = [];
	    for (var i = 1; i <= 3; i++) {
	        rects.unshift(external_react_.createElement("div", { key: i, style: {
	                animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, i / -10),
	            } }));
	    }
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-digital", defaultAnimationDuration: 0.8, speed: speed }, rest), rects));
	};
	/* harmony default export */ const Digital_Digital = (Digital);



	/***/ }),

	/***/ 266:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Dots_Dots)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
	var getRelativeTime = __webpack_require__(531);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};




	var Dots = function (_a) {
	    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-dots", speed: speed, defaultAnimationDuration: 0.8 }, rest),
	        external_react_.createElement("div", { className: "rai-circle", style: { animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, -0.3) } }),
	        external_react_.createElement("div", { className: "rai-circle", style: { animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, -0.2) } }),
	        external_react_.createElement("div", { className: "rai-circle", style: { animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, -0.1) } })));
	};
	/* harmony default export */ const Dots_Dots = (Dots);



	/***/ }),

	/***/ 831:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Levels_Levels)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
	var getRelativeTime = __webpack_require__(531);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};




	var Levels = function (_a) {
	    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-levels", speed: speed, defaultAnimationDuration: 1.5 }, rest),
	        external_react_.createElement("div", { className: "rai-levels-container" },
	            external_react_.createElement("div", { className: "rai-bar" }),
	            external_react_.createElement("div", { className: "rai-bar", style: { animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, -0.25) } }),
	            external_react_.createElement("div", { className: "rai-bar", style: { animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, -0.4) } }))));
	};
	/* harmony default export */ const Levels_Levels = (Levels);



	/***/ }),

	/***/ 874:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Sentry_Sentry)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
	var getRelativeTime = __webpack_require__(531);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};




	var Sentry = function (_a) {
	    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, rest = __rest(_a, ["speed"]);
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-sentry", speed: speed, defaultAnimationDuration: 0.8 }, rest),
	        external_react_.createElement("div", { className: "rai-wave-container" },
	            external_react_.createElement("div", { className: "rai-wave" })),
	        external_react_.createElement("div", { className: "rai-wave-container" },
	            external_react_.createElement("div", { className: "rai-wave", style: { animationDelay: (0, getRelativeTime/* getRelativeTime */.n)(speed, -0.4) } }))));
	};
	/* harmony default export */ const Sentry_Sentry = (Sentry);



	/***/ }),

	/***/ 752:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Spinner_Spinner)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};



	var Spinner = function (props) {
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-spinner", defaultAnimationDuration: 0.6 }, props),
	        external_react_.createElement("div", { className: "rai-spinner-outer" }),
	        external_react_.createElement("div", { className: "rai-spinner-inner" })));
	};
	/* harmony default export */ const Spinner_Spinner = (Spinner);



	/***/ }),

	/***/ 209:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Squares_Squares)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};



	var Squares = function (props) {
	    var squares = [];
	    for (var i = 1; i <= 3; i++) {
	        squares.unshift(external_react_.createElement("div", { key: i, className: "rai-square", style: { animationDelay: "-" + i / 10 + "s" } }));
	    }
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-squares", defaultAnimationDuration: 0.8 }, props), squares));
	};
	/* harmony default export */ const Squares_Squares = (Squares);



	/***/ }),

	/***/ 918:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "default": () => (/* reexport */ Windmill_Windmill)
	});
	// extracted by mini-css-extract-plugin

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/ActivityIndicator/index.ts + 1 modules
	var ActivityIndicator = __webpack_require__(438);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};



	var Windmill = function (props) {
	    return (external_react_.createElement(ActivityIndicator/* default */.Z, __assign({ indicatorClassName: "rai-windmill", defaultAnimationDuration: 0.8 }, props)));
	};
	/* harmony default export */ const Windmill_Windmill = (Windmill);



	/***/ }),

	/***/ 438:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


	// EXPORTS
	__webpack_require__.d(__webpack_exports__, {
	  "Z": () => (/* reexport */ ActivityIndicator_ActivityIndicator)
	});

	// EXTERNAL MODULE: external "react"
	var external_react_ = __webpack_require__(297);
	// EXTERNAL MODULE: ./src/shared/getRelativeTime.ts
	var getRelativeTime = __webpack_require__(531);
	var __assign = function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};


	var ActivityIndicator = function (_a) {
	    var style = _a.style, _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.speed, speed = _c === void 0 ? 1 : _c, defaultAnimationDuration = _a.defaultAnimationDuration, color = _a.color, className = _a.className, _d = _a.animating, animating = _d === void 0 ? true : _d, children = _a.children, indicatorClassName = _a.indicatorClassName;
	    if (!animating) {
	        return null;
	    }
	    var animationDuration = (0, getRelativeTime/* getRelativeTime */.n)(speed, defaultAnimationDuration);
	    return (external_react_.createElement("div", { "data-testid": "rai-activity-indicator", className: "rai-container " + indicatorClassName + (className ? " " + className : ""), style: __assign({ color: color, fontSize: size + "px", animationDuration: animationDuration }, style) }, children));
	};
	/* harmony default export */ const ActivityIndicator_ActivityIndicator = (ActivityIndicator);



	/***/ }),

	/***/ 531:
	/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

	/* harmony export */ __webpack_require__.d(__webpack_exports__, {
	/* harmony export */   "n": () => (/* binding */ getRelativeTime)
	/* harmony export */ });
	var getRelativeTime = function (speed, delay) {
	    return (1 / speed) * delay + "s";
	};


	/***/ }),

	/***/ 297:
	/***/ ((module) => {

	module.exports = __WEBPACK_EXTERNAL_MODULE__297__;

	/***/ })

	/******/ 	});
	/************************************************************************/
	/******/ 	// The module cache
	/******/ 	var __webpack_module_cache__ = {};
	/******/ 	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/ 		// Check if module is in cache
	/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
	/******/ 		if (cachedModule !== undefined) {
	/******/ 			return cachedModule.exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = __webpack_module_cache__[moduleId] = {
	/******/ 			// no module.id needed
	/******/ 			// no module.loaded needed
	/******/ 			exports: {}
	/******/ 		};
	/******/ 	
	/******/ 		// Execute the module function
	/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
	/******/ 	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/ 	
	/************************************************************************/
	/******/ 	/* webpack/runtime/define property getters */
	/******/ 	(() => {
	/******/ 		// define getter functions for harmony exports
	/******/ 		__webpack_require__.d = (exports, definition) => {
	/******/ 			for(var key in definition) {
	/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
	/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
	/******/ 				}
	/******/ 			}
	/******/ 		};
	/******/ 	})();
	/******/ 	
	/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
	/******/ 	(() => {
	/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop));
	/******/ 	})();
	/******/ 	
	/******/ 	/* webpack/runtime/make namespace object */
	/******/ 	(() => {
	/******/ 		// define __esModule on exports
	/******/ 		__webpack_require__.r = (exports) => {
	/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 			}
	/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 		};
	/******/ 	})();
	/******/ 	
	/************************************************************************/
	var __webpack_exports__ = {};
	// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
	(() => {
	__webpack_require__.r(__webpack_exports__);
	/* harmony export */ __webpack_require__.d(__webpack_exports__, {
	/* harmony export */   "Dots": () => (/* reexport safe */ _Dots__WEBPACK_IMPORTED_MODULE_0__.default),
	/* harmony export */   "Bounce": () => (/* reexport safe */ _Bounce__WEBPACK_IMPORTED_MODULE_1__.default),
	/* harmony export */   "Levels": () => (/* reexport safe */ _Levels__WEBPACK_IMPORTED_MODULE_2__.default),
	/* harmony export */   "Sentry": () => (/* reexport safe */ _Sentry__WEBPACK_IMPORTED_MODULE_3__.default),
	/* harmony export */   "Spinner": () => (/* reexport safe */ _Spinner__WEBPACK_IMPORTED_MODULE_4__.default),
	/* harmony export */   "Squares": () => (/* reexport safe */ _Squares__WEBPACK_IMPORTED_MODULE_5__.default),
	/* harmony export */   "Digital": () => (/* reexport safe */ _Digital__WEBPACK_IMPORTED_MODULE_6__.default),
	/* harmony export */   "Windmill": () => (/* reexport safe */ _Windmill__WEBPACK_IMPORTED_MODULE_7__.default)
	/* harmony export */ });
	/* harmony import */ var _Dots__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(266);
	/* harmony import */ var _Bounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(930);
	/* harmony import */ var _Levels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(831);
	/* harmony import */ var _Sentry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(874);
	/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(752);
	/* harmony import */ var _Squares__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(209);
	/* harmony import */ var _Digital__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(843);
	/* harmony import */ var _Windmill__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(918);










	})();

	/******/ 	return __webpack_exports__;
	/******/ })()
	;
	});
} (reactActivity));

var COLORS = {
    GENERAL: {
        PRIMARY: '#FF4D4F',
        SECONDARY: '#5AC486',
    },
    STATUS: {
        SUCCESS_OR_POSITIVE: '#46A7ED',
        INFORMATION: '#5AC486',
        WARNING_OR_NOTICE: '#F2CA4D',
        ERROR_OR_DANGER: '#D71526',
    },
    TEXT: {
        PRIMARY: 'rgba(0, 0, 0, 0.87)',
        NO_IMPORTANT: 'rgba(0, 0, 0, 0.67)',
        NOTE_OR_CAPTION: 'rgba(0, 0, 0, 0.38)',
        DISABLE: 'rgba(0, 0, 0, 0.15)',
        PLACEHOLDER: 'rgba(0, 0, 0, 0.23)',
        INVERSE_PRIMARY: '#ffffff',
    },
    // 背景が暗いときなどのテキストカラー
    INVERT_TEXT: {
        PRIMARY: '#ffffff',
        NO_IMPORTANT: 'rgba(255, 255, 255, 0.6)',
        NOTE_OR_CAPTION: 'rgba(255, 255, 255, 0.38)',
        DISABLE: 'rgba(255, 255, 255, 0.15)',
        PLACEHOLDER: 'rgba(255, 255, 255, 0.23)',
    },
    BORDER: {
        STRONG: 'rgba(0, 0, 0, 0.87)',
        PRIMARY: 'rgba(0, 0, 0, 0.15)',
        SECONDARY: 'rgba(0, 0, 0, 0.09)',
    },
    BACKGROUND: {
        BASE: '#F5F5F5',
        SURFACE: '#FFFFFF',
        FORM: '#F0F0F0',
        OVERLAY: 'rgba(0, 0, 0, 0.4)',
    },
    SHADOW: {
        DEFAULT: 'rgba(0, 0, 0, 0.2)',
    },
};
var OPACITIES = {
    OPACITY_87: 0.87,
    OPACITY_67: 0.67,
    OPACITY_38: 0.38,
    OPACITY_23: 0.23,
    OPACITY_15: 0.15,
    OPACITY_9: 0.09,
};
// NOTE: (zoma) 期間限定セールで使われる色。
// 値をオブジェクトのキーはBFFのEnumを使って、`LIMITED_TIME_SALE_COLORS[limitedTimeSaleType].COLOR` のように使用される。
var LIMITED_TIME_SALE_COLORS = {
    NewYear: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#E4202D',
    },
    SummerSale: {
        COLOR: '#F7D77F',
        BACKGROUND: '#1479CA',
    },
    AutumnSale: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#DD260D',
    },
    AutumnSaleFinal: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#A05359',
    },
    BlackFriday: {
        COLOR: COLORS.STATUS.WARNING_OR_NOTICE,
        BACKGROUND: '#000000',
    },
    WinterSale: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#495881',
    },
    ChristmasSale: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#D14345',
    },
    YearEnd: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#CC3032',
    },
    StrongYenSale: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#CBA036',
    },
    SpecialSale: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#D63838',
    },
    SpecialSale2: {
        COLOR: '#FFFFFF',
        BACKGROUND: '#F46363',
    }
};

/**
 * valueがあるときに`${key}: ${value};`の形のStringを返す
 * @param key
 * @param value
 * @returns
 */
var addStyleIfNotUndefined = function (key, value) {
    if (typeof value === 'undefined' || value === null)
        return '';
    return "".concat(key, ": ").concat(value, ";");
};

var FONT_FAMILY = {
    // NotoSans JP
    NOTO_SANS_JP: 'Noto Sans JP',
    AVENIR_NEXT: 'Avenir Next',
    SANS_SERIF: 'sans-serif',
};
var FONT_WEIGHT = {
    WEIGHT_900: '900',
    WEIGHT_800: '800',
    WEIGHT_700: '700',
    WEIGHT_600: '600',
    WEIGHT_500: '500',
    WEIGHT_400: '400',
    WEIGHT_300: '300',
    WEIGHT_200: '200',
    WEIGHT_100: '100',
    WEIGHT_NORMAL: 'normal',
    WEIGHT_BOLD: 'bold',
};
/**
 * モバイルのフォントの定義。
 * [デザイン](https://www.figma.com/file/W2sr826Nq97JZZ4cAjig1P/Style-Guide?node-id=715%3A2083) の「Typography for Mobile」と対応している
 */
var MOBILE_FONT_STYLES = {
    HEADLINE_1: {
        fontSize: '24px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.8,
        letterSpacing: '0.01em',
    },
    HEADLINE_2: {
        fontSize: '20px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.8,
        letterSpacing: '0.02em',
    },
    HEADLINE_3: {
        fontSize: '18px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.8,
        letterSpacing: '0.04em',
    },
    SUB_TITLE_1: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.04em',
    },
    SUB_TITLE_2: {
        fontSize: '14px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.04em',
    },
    BODY_BOLD_1: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_1: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_BOLD_2: {
        fontSize: '14px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_2: {
        fontSize: '14px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_BOLD_3: {
        fontSize: '13px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_3: {
        fontSize: '13px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.8,
        letterSpacing: '0.06em',
    },
    NOTE_BOLD_1: {
        fontSize: '12px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NOTE_1: {
        fontSize: '12px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NOTE_BOLD_2: {
        fontSize: '11px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NOTE_2: {
        fontSize: '11px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    CAPTION_BOLD_1: {
        fontSize: '10px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    CAPTION_1: {
        fontSize: '10px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NUM_1: {
        fontSize: '20px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.06em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_2: {
        fontSize: '18px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.06em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_3: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.06em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_4: {
        fontSize: '14px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.06em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_5: {
        fontSize: '12px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.06em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_6: {
        fontSize: '11px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.06em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_7: {
        fontSize: '10px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.06em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
};
/**
 * PCのフォントの定義。
 * [デザイン](https://www.figma.com/file/W2sr826Nq97JZZ4cAjig1P/Style-Guide?node-id=715%3A2083) の「Typography for Mobile」と対応している
 */
var PC_FONT_STYLES = {
    HEADLINE_1: {
        fontSize: '36px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.8,
        letterSpacing: '0.01em',
    },
    HEADLINE_2: {
        fontSize: '24px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.8,
        letterSpacing: '0.01em',
    },
    HEADLINE_3: {
        fontSize: '20px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.8,
        letterSpacing: '0.02em',
    },
    SUB_TITLE_1: {
        fontSize: '18px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.8,
        letterSpacing: '0.04em',
    },
    SUB_TITLE_2: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.04em',
    },
    BODY_BOLD_1: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_1: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_BOLD_2: {
        fontSize: '14px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_2: {
        fontSize: '14px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_BOLD_3: {
        fontSize: '13px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    BODY_3: {
        fontSize: '13px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.8,
        letterSpacing: '0.06em',
    },
    NOTE_BOLD_1: {
        fontSize: '12px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NOTE_1: {
        fontSize: '12px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NOTE_BOLD_2: {
        fontSize: '11px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NOTE_2: {
        fontSize: '11px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    CAPTION_BOLD_1: {
        fontSize: '10px',
        fontWeight: FONT_WEIGHT.WEIGHT_700,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    CAPTION_1: {
        fontSize: '10px',
        fontWeight: FONT_WEIGHT.WEIGHT_400,
        lineHeight: 1.6,
        letterSpacing: '0.06em',
    },
    NUM_1: {
        fontSize: '24px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.01em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_2: {
        fontSize: '20px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_3: {
        fontSize: '18px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_4: {
        fontSize: '16px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_5: {
        fontSize: '14px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_6: {
        fontSize: '12px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_7: {
        fontSize: '11px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
    NUM_8: {
        fontSize: '10px',
        fontWeight: FONT_WEIGHT.WEIGHT_600,
        lineHeight: 1.2,
        letterSpacing: '0.02em',
        fontFamily: FONT_FAMILY.AVENIR_NEXT,
    },
};
/**
 * FontのスタイルのStringをつくる
 * @param 型を指定
 * @returns
 */
var createFontStyle = function (_a) {
    var fontSize = _a.fontSize, fontWeight = _a.fontWeight, lineHeight = _a.lineHeight, letterSpacing = _a.letterSpacing, fontFamily = _a.fontFamily;
    return "\n    font-size: ".concat(fontSize, ";\n    font-weight: ").concat(fontWeight, ";\n    ").concat(addStyleIfNotUndefined('line-height', lineHeight), "\n    ").concat(addStyleIfNotUndefined('letter-spacing', letterSpacing), "\n    ").concat(addStyleIfNotUndefined('font-family', fontFamily), "\n  ");
};

/**
 * z-indexを管理する定数
 * Material UIを参考にしている
 * https://mui.com/customization/z-index/
 */
var Z_INDEX = {
    // スクロールタブメニュー
    TAB_MENU: 900,
    // フッター
    FOOTER: 950,
    // ステップコンポーネント
    STEPPER: 1000,
    // ナビゲーションバーなど
    NAVIGATION: 1100,
    // ドロワー
    DRAWER: 1200,
    // モーダル
    MODAL: 1300,
    // Snackbar
    SNACKBAR: 1400,
    // ツールチップ
    TOOLTIP: 1500,
    // オーバーレイスピナー
    OVERLAY_SPINNER: 1500,
    // PC用グローバルヘッダー
    PC_GLOBAL_HEADER: 9000,
    // PC用グローバルヘッダーのメニュー
    PC_GLOBAL_HEADER_MENUS: 9010,
};

var CocoOverlaySpinner = function (_a) {
    var messageTitle = _a.messageTitle, messageBody = _a.messageBody;
    return (React$1.createElement(Overlay, { onClick: function (e) { return e.stopPropagation(); } },
        React$1.createElement(Container$1n, null,
            React$1.createElement(reactActivity.exports.Spinner, { size: 25, color: COLORS.TEXT.INVERSE_PRIMARY, speed: 0.85 }),
            React$1.createElement(MessageContainer, null,
                React$1.createElement(MessageTitle, null, messageTitle),
                typeof messageBody !== 'undefined' && (React$1.createElement(MessageBody, null, messageBody))))));
};
var index$G = memo(CocoOverlaySpinner);
var Overlay = styled.div(templateObject_1$1B || (templateObject_1$1B = __makeTemplateObject(["\n  background-color: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: ", ";\n"], ["\n  background-color: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: ", ";\n"])), Z_INDEX.OVERLAY_SPINNER);
var Container$1n = styled.div(templateObject_2$1p || (templateObject_2$1p = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var MessageContainer = styled.div(templateObject_3$18 || (templateObject_3$18 = __makeTemplateObject(["\n  padding: 34px 20px 0;\n"], ["\n  padding: 34px 20px 0;\n"])));
var MessageTitle = styled.p(templateObject_4$Z || (templateObject_4$Z = __makeTemplateObject(["\n  ", "\n  text-align: center;\n  white-space: pre-line;\n  color: ", ";\n"], ["\n  ", "\n  text-align: center;\n  white-space: pre-line;\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_1), COLORS.TEXT.INVERSE_PRIMARY);
var MessageBody = styled.p(templateObject_5$N || (templateObject_5$N = __makeTemplateObject(["\n  ", "\n  text-align: center;\n  white-space: pre-line;\n  color: ", ";\n  margin-top: 16px;\n"], ["\n  ", "\n  text-align: center;\n  white-space: pre-line;\n  color: ", ";\n  margin-top: 16px;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.TEXT.INVERSE_PRIMARY);
var templateObject_1$1B, templateObject_2$1p, templateObject_3$18, templateObject_4$Z, templateObject_5$N;

var CocoDivider = function (_a) {
    var color = _a.color, size = _a.size, style = _a.style;
    return (React$1.createElement(DividerDiv, { color: color || 'rgba(0, 0, 0, 0.05)', size: size || '1px', style: style }));
};
var CocoDivider$1 = memo(CocoDivider);
var DividerDiv = styled.div(templateObject_1$1A || (templateObject_1$1A = __makeTemplateObject(["\n  box-sizing: border-box;\n  width: ", ";\n  border-bottom: solid ", "\n    ", ";\n"], ["\n  box-sizing: border-box;\n  width: ", ";\n  border-bottom: solid ", "\n    ", ";\n"])), function (props) {
    return props.style && props.style.width ? props.style.width : '100%';
}, function (props) { var _a; return (_a = props.size) !== null && _a !== void 0 ? _a : ''; }, function (props) { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : ''; });
var templateObject_1$1A;

var CocoRatings = function (_a) {
    var rating = _a.rating, _b = _a.numberOfStars, numberOfStars = _b === void 0 ? 5 : _b, _c = _a.starDimension, starDimension = _c === void 0 ? '14px' : _c, _d = _a.starSpacing, starSpacing = _d === void 0 ? '0px' : _d, _e = _a.showOneStar, showOneStar = _e === void 0 ? false : _e, _f = _a.showRatingValue, showRatingValue = _f === void 0 ? false : _f, _g = _a.showFivePointScaleRating, showFivePointScaleRating = _g === void 0 ? false : _g, ratingValueStyle = _a.ratingValueStyle, ratingSubValueStyle = _a.ratingSubValueStyle;
    return (React$1.createElement(Container$1m, null,
        showOneStar ? (React$1.createElement(StarRatings, { rating: 1, starRatedColor: COLORS.GENERAL.PRIMARY, starEmptyColor: "rgba(0, 0, 0, 0.1)", numberOfStars: 1, starSpacing: starSpacing, starDimension: starDimension, svgIconViewBox: "0 0 16 15", svgIconPath: "M7.552.908a.5.5 0 0 1 .896 0l1.787 3.62a.5.5 0 0 0 .376.274l3.995.58a.5.5 0 0 1 .277.853l-2.89 2.818a.5.5 0 0 0-.144.442l.682 3.979a.5.5 0 0 1-.726.527l-3.572-1.879a.5.5 0 0 0-.466 0l-3.573 1.879a.5.5 0 0 1-.725-.527l.682-3.979a.5.5 0 0 0-.143-.442L1.117 6.235a.5.5 0 0 1 .277-.853l3.995-.58a.5.5 0 0 0 .376-.274L7.552.908z" })) : (React$1.createElement(StarRatings, { rating: rating, starRatedColor: COLORS.GENERAL.PRIMARY, starEmptyColor: "rgba(0, 0, 0, 0.1)", numberOfStars: numberOfStars, starSpacing: starSpacing, starDimension: starDimension, svgIconViewBox: "0 0 16 15", svgIconPath: "M7.552.908a.5.5 0 0 1 .896 0l1.787 3.62a.5.5 0 0 0 .376.274l3.995.58a.5.5 0 0 1 .277.853l-2.89 2.818a.5.5 0 0 0-.144.442l.682 3.979a.5.5 0 0 1-.726.527l-3.572-1.879a.5.5 0 0 0-.466 0l-3.573 1.879a.5.5 0 0 1-.725-.527l.682-3.979a.5.5 0 0 0-.143-.442L1.117 6.235a.5.5 0 0 1 .277-.853l3.995-.58a.5.5 0 0 0 .376-.274L7.552.908z" })),
        showRatingValue && (React$1.createElement(RatingText, { style: ratingValueStyle }, rating.toFixed(1))),
        showFivePointScaleRating && (React$1.createElement(FiveScaleRatingTextContainer, null,
            React$1.createElement(FiveScaleRatingText, { style: ratingValueStyle }, rating.toFixed(1)),
            React$1.createElement(FiveScaleRatingSubText, { style: ratingSubValueStyle }, "/5")))));
};
var CocoRatings$1 = memo(CocoRatings);
var Container$1m = styled.div(templateObject_1$1z || (templateObject_1$1z = __makeTemplateObject(["\n  display: flex;\n  align-items: baseline;\n"], ["\n  display: flex;\n  align-items: baseline;\n"])));
var RatingText = styled.span(templateObject_2$1o || (templateObject_2$1o = __makeTemplateObject(["\n  margin-left: 5px;\n  color: ", ";\n  ", ";\n"], ["\n  margin-left: 5px;\n  color: ", ";\n  ", ";\n"])), COLORS.GENERAL.PRIMARY, createFontStyle(__assign({}, MOBILE_FONT_STYLES.NUM_4)));
var FiveScaleRatingTextContainer = styled.div(templateObject_3$17 || (templateObject_3$17 = __makeTemplateObject(["\n  display: flex;\n  align-items: baseline;\n"], ["\n  display: flex;\n  align-items: baseline;\n"])));
var FiveScaleRatingText = styled.span(templateObject_4$Y || (templateObject_4$Y = __makeTemplateObject(["\n  margin-left: 4px;\n  margin-right: 0;\n  color: ", ";\n  ", ";\n"], ["\n  margin-left: 4px;\n  margin-right: 0;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.HEADLINE_1), { letterSpacing: '0.02em', fontWeight: FONT_WEIGHT.WEIGHT_600 })));
var FiveScaleRatingSubText = styled.span(templateObject_5$M || (templateObject_5$M = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.SUB_TITLE_1), { fontWeight: FONT_WEIGHT.WEIGHT_600, letterSpacing: '0.06em' })));
var templateObject_1$1z, templateObject_2$1o, templateObject_3$17, templateObject_4$Y, templateObject_5$M;

var img$b = "data:image/png;base64,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";

var img$a = "data:image/png;base64,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";

var img$9 = "data:image/png;base64,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";

var CocoProductLogo = function (_a) {
    var type = _a.type, style = _a.style;
    return (React$1.createElement(Container$1l, { style: style }, type === 'black' ? (React$1.createElement(LogoImage, { src: img$a, alt: "\u3053\u3053\u308D\u304B\u3089" })) : type === 'white' ? (React$1.createElement(LogoImage, { src: img$9, alt: "\u3053\u3053\u308D\u304B\u3089" })) : (React$1.createElement(PCLogoImage, { src: img$b, alt: "\u3053\u3053\u308D\u304B\u3089" }))));
};
var CocoProductLogo$1 = memo(CocoProductLogo);
var Container$1l = styled.div(templateObject_1$1y || (templateObject_1$1y = __makeTemplateObject([""], [""])));
var LogoImage = styled.img(templateObject_2$1n || (templateObject_2$1n = __makeTemplateObject(["\n  width: 125px;\n  height: 23px;\n"], ["\n  width: 125px;\n  height: 23px;\n"])));
var PCLogoImage = styled.img(templateObject_3$16 || (templateObject_3$16 = __makeTemplateObject(["\n  width: 163px;\n  height: 30px;\n"], ["\n  width: 163px;\n  height: 30px;\n"])));
var templateObject_1$1y, templateObject_2$1n, templateObject_3$16;

var CocoBubbleComment = function (_a) {
    var comment = _a.comment, _b = _a.iconPositionRight, iconPositionRight = _b === void 0 ? false : _b, style = _a.style;
    return (React$1.createElement(BubbleCommentContainer, { style: style, iconPositionRight: iconPositionRight },
        React$1.createElement(Comment$1, null, comment)));
};
var CocoBubbleComment$1 = memo(CocoBubbleComment);
var BubbleCommentContainer = styled.div(templateObject_1$1x || (templateObject_1$1x = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  color: ", ";\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid ", ";\n  ", ";\n  color: ", ";\n  background-color: ", ";\n\n  ::before {\n    content: '';\n    position: absolute;\n    display: block;\n    z-index: 1;\n    border-style: solid;\n    border-color: ", " transparent;\n    border-width: ", ";\n    top: 17px;\n    left: ", ";\n    right: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  ::after {\n    content: '';\n    position: absolute;\n    display: block;\n    z-index: 0;\n    border-style: solid;\n    border-color: #e7e7e7 transparent;\n    border-width: ", ";\n    top: 16px;\n    left: ", ";\n    right: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"], ["\n  position: relative;\n  display: inline-block;\n  color: ", ";\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid ", ";\n  ", ";\n  color: ", ";\n  background-color: ", ";\n\n  ::before {\n    content: '';\n    position: absolute;\n    display: block;\n    z-index: 1;\n    border-style: solid;\n    border-color: ", " transparent;\n    border-width: ", ";\n    top: 17px;\n    left: ", ";\n    right: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n\n  ::after {\n    content: '';\n    position: absolute;\n    display: block;\n    z-index: 0;\n    border-style: solid;\n    border-color: #e7e7e7 transparent;\n    border-width: ", ";\n    top: 16px;\n    left: ", ";\n    right: ", ";\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"])), COLORS.TEXT.PRIMARY, COLORS.BORDER.SECONDARY, createFontStyle(MOBILE_FONT_STYLES.NOTE_1), COLORS.TEXT.NO_IMPORTANT, COLORS.BACKGROUND.SURFACE, COLORS.BACKGROUND.SURFACE, function (props) {
    return props.iconPositionRight ? '8px 8px 0 0' : '8px 0 0 8px';
}, function (props) { return (props.iconPositionRight ? 'unset' : '2.4px'); }, function (props) { return (props.iconPositionRight ? '2.4px' : 'unset'); }, function (props) { return (props.iconPositionRight ? 'unset' : '-8px'); }, function (props) { return (props.iconPositionRight ? '-8px' : 'unset'); }, function (props) {
    return props.iconPositionRight ? '8px 8px 0 0' : '8px 0 0 8px';
}, function (props) { return (props.iconPositionRight ? 'unset' : 0); }, function (props) { return (props.iconPositionRight ? 0 : 'unset'); }, function (props) { return (props.iconPositionRight ? 'unset' : '-8px'); }, function (props) { return (props.iconPositionRight ? '-8px' : 'unset'); });
var Comment$1 = styled.div(templateObject_2$1m || (templateObject_2$1m = __makeTemplateObject(["\n  > a {\n    color: ", ";\n  }\n"], ["\n  > a {\n    color: ", ";\n  }\n"])), COLORS.GENERAL.PRIMARY);
var templateObject_1$1x, templateObject_2$1m;

var CocoBreadCrumbList = function (_a) {
    var breadCrumbItems = _a.breadCrumbItems, style = _a.style, itemTextStyle = _a.itemTextStyle, withoutPaddingLeft = _a.withoutPaddingLeft;
    return (React$1.createElement(BreadCrumb, { itemScope: true, itemType: "https://schema.org/BreadcrumbList", style: style, withoutPaddingLeft: withoutPaddingLeft }, breadCrumbItems.map(function (item, index) {
        return (React$1.createElement(BreadCrumbItem, { itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/ListItem", key: index, withoutPaddingLeft: withoutPaddingLeft },
            typeof item.linkUrl === 'undefined' ? (React$1.createElement("span", { itemProp: "name", style: itemTextStyle }, item.name)) : (React$1.createElement("a", { itemProp: "item", href: item.linkUrl },
                React$1.createElement("span", { itemProp: "name", style: itemTextStyle }, item.name))),
            React$1.createElement("meta", { itemProp: "position", content: (index + 1).toString() })));
    })));
};
var index$F = memo(CocoBreadCrumbList);
var BreadCrumb = styled.ul(templateObject_1$1w || (templateObject_1$1w = __makeTemplateObject(["\n  overflow-x: scroll;\n  -webkit-overflow-scrolling: touch;\n  white-space: nowrap;\n  letter-spacing: -0.4em;\n  padding-left: ", "px;\n  background: ", ";\n"], ["\n  overflow-x: scroll;\n  -webkit-overflow-scrolling: touch;\n  white-space: nowrap;\n  letter-spacing: -0.4em;\n  padding-left: ", "px;\n  background: ", ";\n"])), function (props) { return (props.withoutPaddingLeft ? 0 : 10); }, COLORS.BACKGROUND.BASE);
var BreadCrumbItem = styled.li(templateObject_2$1l || (templateObject_2$1l = __makeTemplateObject(["\n  display: inline-block;\n  letter-spacing: 1px;\n  padding-left: 5px;\n  font-size: 13px;\n\n  &:last-child span {\n    font-weight: bold;\n    color: ", ";\n  }\n\n  &:after {\n    content: '>';\n  }\n\n  &:last-child:after {\n    content: none;\n  }\n\n  a {\n    display: inline-block;\n    padding: 14px 8px 12px 2px;\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ", "\n"], ["\n  display: inline-block;\n  letter-spacing: 1px;\n  padding-left: 5px;\n  font-size: 13px;\n\n  &:last-child span {\n    font-weight: bold;\n    color: ", ";\n  }\n\n  &:after {\n    content: '>';\n  }\n\n  &:last-child:after {\n    content: none;\n  }\n\n  a {\n    display: inline-block;\n    padding: 14px 8px 12px 2px;\n    text-decoration: none;\n    color: ", ";\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ", "\n"])), COLORS.TEXT.PRIMARY, COLORS.TEXT.NO_IMPORTANT, function (props) {
    return props.withoutPaddingLeft
        ? "\n    &:first-child {\n      padding-left: 0;\n      > * {\n        padding-left: 0;\n      }\n    }\n  "
        : undefined;
});
var templateObject_1$1w, templateObject_2$1l;

// 参考: https://gist.github.com/bartholomej/8415655
var TABLET_MAX_WIDTH = '768px';

var useLocalState$k = function (_a) {
    var isOpen = _a.isOpen, topMarginVh = _a.topMarginVh;
    useEffect(function () {
        var _a;
        // モーダルが閉じるときに
        if (!isOpen) {
            // コンテンツのスクロール位置をトップに戻す
            (_a = document === null || document === void 0 ? void 0 : document.querySelector('.react-responsive-modal-container')) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
        }
    }, [isOpen]);
    var animationDuration = useMemo(function () {
        return typeof topMarginVh === 'number' && topMarginVh > 40 ? 350 : 250;
    }, [topMarginVh]);
    return {
        animationDuration: animationDuration,
    };
};

var CocoModal = function (_a) {
    var _b;
    var title = _a.title, subTitle = _a.subTitle, topMarginVh = _a.topMarginVh, appearance = _a.appearance, isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children, classNames = _a.classNames, container = _a.container, _c = _a.withNavigation, withNavigation = _c === void 0 ? true : _c, _d = _a.minWidth, minWidth = _d === void 0 ? TABLET_MAX_WIDTH : _d, styles = _a.styles, navigationTitleStyle = _a.navigationTitleStyle, navigationSubTitleStyle = _a.navigationSubTitleStyle, _e = _a.closeOnOverlayClick, closeOnOverlayClick = _e === void 0 ? true : _e, _f = _a.closeOnEsc, closeOnEsc = _f === void 0 ? true : _f, _g = _a.center, center = _g === void 0 ? true : _g;
    var isPC = useMediaQuery({
        query: "(min-width: ".concat(minWidth, ")"),
    });
    var animationDuration = useLocalState$k({
        isOpen: isOpen,
        topMarginVh: topMarginVh,
    }).animationDuration;
    var background = (_b = appearance === null || appearance === void 0 ? void 0 : appearance.background) !== null && _b !== void 0 ? _b : COLORS.BACKGROUND.SURFACE;
    return (React$1.createElement(OuterContainer$1, null,
        React$1.createElement(Modal$2, { center: center, animationDuration: animationDuration, open: isOpen, closeOnOverlayClick: closeOnOverlayClick, showCloseIcon: false, focusTrapped: false, onClose: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); }, container: container, closeOnEsc: closeOnEsc, classNames: __assign({ modalAnimationIn: 'enterCustomModalModalAnimation', modalAnimationOut: 'leaveCustomModalModalAnimation' }, classNames), styles: {
                root: __assign({ zIndex: Z_INDEX.MODAL }, styles === null || styles === void 0 ? void 0 : styles.root),
                overlay: {
                    padding: 0,
                },
                modal: __assign({ marginTop: typeof topMarginVh === 'number' ? "".concat(topMarginVh, "vh") : '0', width: '100%', maxWidth: isPC ? '400px' : '100%', minHeight: typeof topMarginVh === 'number'
                        ? "calc(".concat(100 - topMarginVh, "vh)")
                        : '100vh', animationTimingFunction: 'cubic-bezier(0.2, 0.9, 0.42, 1)', background: background }, styles === null || styles === void 0 ? void 0 : styles.modal),
            } },
            React$1.createElement(Container$1k, null,
                withNavigation && (React$1.createElement(NavigationBar, null,
                    React$1.createElement(NavigationBarInner, { hasSubTitle: typeof subTitle !== 'undefined' },
                        React$1.createElement(NavigationTitle, { "data-testid": "halfModalNavigationTitle", hasOnClose: typeof onClose !== 'undefined', style: navigationTitleStyle },
                            React$1.createElement("span", null, title)),
                        typeof onClose !== 'undefined' && (React$1.createElement(CloseButton$2, { onClick: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); }, hasSubTitle: typeof subTitle !== 'undefined' },
                            React$1.createElement("svg", { width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                React$1.createElement("circle", { cx: "15", cy: "15", r: "15", fill: "black", fillOpacity: "0.2" }),
                                React$1.createElement("rect", { x: "20.0283", y: "9.02844", width: "2", height: "16", transform: "rotate(45 20.0283 9.02844)", fill: "white" }),
                                React$1.createElement("rect", { x: "21.2854", y: "20.3419", width: "2", height: "16", transform: "rotate(135 21.2854 20.3419)", fill: "white" }))))),
                    typeof subTitle !== 'undefined' && (React$1.createElement(NavigationSubTitle, { style: navigationSubTitleStyle }, subTitle)))),
                children))));
};
var CocoModal$1 = memo(CocoModal);
var OuterContainer$1 = styled.div(templateObject_1$1v || (templateObject_1$1v = __makeTemplateObject(["\n  @keyframes enterCustomModalModalAnimation {\n    0% {\n      opacity: 0;\n      transform: translateY(100vh);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  @keyframes leaveCustomModalModalAnimation {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(100vh);\n    }\n  }\n"], ["\n  @keyframes enterCustomModalModalAnimation {\n    0% {\n      opacity: 0;\n      transform: translateY(100vh);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  @keyframes leaveCustomModalModalAnimation {\n    0% {\n      transform: translateY(0);\n    }\n    100% {\n      transform: translateY(100vh);\n    }\n  }\n"])));
var Container$1k = styled.div(templateObject_2$1k || (templateObject_2$1k = __makeTemplateObject([""], [""])));
var NavigationBar = styled.div(templateObject_3$15 || (templateObject_3$15 = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n  background-color: ", ";\n  z-index: ", ";\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);\n"], ["\n  position: sticky;\n  top: 0;\n  background-color: ", ";\n  z-index: ", ";\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);\n"])), COLORS.BACKGROUND.SURFACE, Z_INDEX.MODAL + 1);
var NavigationBarInner = styled.div(templateObject_4$X || (templateObject_4$X = __makeTemplateObject(["\n  display: flex;\n  padding-top: ", ";\n  height: 50px;\n"], ["\n  display: flex;\n  padding-top: ", ";\n  height: 50px;\n"])), function (props) { return (props.hasSubTitle ? '11px' : '0'); });
var CloseButton$2 = styled.div(templateObject_5$L || (templateObject_5$L = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: ", ";\n\n  img {\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: ", ";\n\n  img {\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n  }\n"])), function (props) { return (props.hasSubTitle ? '0 10px 0 0' : '10px'); });
var NavigationTitle = styled.p(templateObject_6$A || (templateObject_6$A = __makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n  flex-grow: 1;\n  ", ";\n  margin: auto 0;\n  padding-left: ", ";\n\n  span {\n    display: inline-block;\n    padding: 0;\n  }\n"], ["\n  text-align: center;\n  color: ", ";\n  flex-grow: 1;\n  ", ";\n  margin: auto 0;\n  padding-left: ", ";\n\n  span {\n    display: inline-block;\n    padding: 0;\n  }\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_1), { fontSize: '15px' })), function (props) { return (props.hasOnClose ? '40px' : '0'); });
var NavigationSubTitle = styled.p(templateObject_7$q || (templateObject_7$q = __makeTemplateObject(["\n  text-align: center;\n  display: inline-block;\n  width: 100%;\n  ", ";\n  margin: 4px 0 11px;\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  text-align: center;\n  display: inline-block;\n  width: 100%;\n  ", ";\n  margin: 4px 0 11px;\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_2), { lineHeight: '120%', letterSpacing: '0.02em' })), COLORS.TEXT.NOTE_OR_CAPTION);
var templateObject_1$1v, templateObject_2$1k, templateObject_3$15, templateObject_4$X, templateObject_5$L, templateObject_6$A, templateObject_7$q;

var addAutoFormatAndCompress = function (path) {
    return "".concat(path, "?auto=format,compress");
};

var CocoLINEBanner = function (_a) {
    var lineLinkUrl = _a.lineLinkUrl, imgixHost = _a.imgixHost, style = _a.style;
    return (React$1.createElement(Container$1j, { style: style },
        React$1.createElement(Banner, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/shared/ui-components/CocoLINEBanner/line-banner.png")) }),
        React$1.createElement(Content$8, null,
            React$1.createElement(Text$4, null, "\u304A\u60A9\u307F\u306E\u70B9\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001LINE\u3067\u30B9\u30BF\u30C3\u30D5\u307E\u3067\u304A\u6C17\u8EFD\u306B\u3054\u76F8\u8AC7\u304F\u3060\u3055\u3044\u3002"),
            React$1.createElement(LINELink$1, { href: lineLinkUrl, target: "_blank" },
                React$1.createElement("svg", { width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginRight: '4px' } },
                    React$1.createElement("g", { id: "icon-line" },
                        React$1.createElement("g", { id: "icon-line_2" },
                            React$1.createElement("g", { id: "Group" },
                                React$1.createElement("path", { id: "Fill 1", fillRule: "evenodd", clipRule: "evenodd", d: "M23.1122 10.1361C23.1122 5.32041 18.3352 1.40259 12.463 1.40259C6.59158 1.40259 1.81396 5.32041 1.81396 10.1361C1.81396 14.4533 5.60249 18.0689 10.72 18.7526C11.0669 18.8281 11.5388 18.9837 11.6583 19.2832C11.7654 19.5551 11.7285 19.9816 11.6926 20.2564C11.6926 20.2564 11.5676 21.0156 11.5407 21.1778C11.4943 21.4497 11.3267 22.2419 12.463 21.7577C13.5997 21.2737 18.5959 18.1085 20.8301 15.5094H20.8295C22.373 13.7991 23.1122 12.0634 23.1122 10.1361Z", fill: "white" })),
                            React$1.createElement("path", { id: "Fill 4", fillRule: "evenodd", clipRule: "evenodd", d: "M9.39425 7.48254C9.27928 7.48254 9.18604 7.57827 9.18604 7.6961V12.4782C9.18604 12.596 9.27928 12.6915 9.39425 12.6915H10.1441C10.2591 12.6915 10.3523 12.596 10.3523 12.4782V7.6961C10.3523 7.57827 10.2591 7.48254 10.1441 7.48254H9.39425Z", fill: "#53B535" }),
                            React$1.createElement("path", { id: "Fill 6", fillRule: "evenodd", clipRule: "evenodd", d: "M14.5563 7.48254C14.4411 7.48254 14.3481 7.57827 14.3481 7.6961V10.5371L12.2133 7.57764C12.2086 7.56986 12.2028 7.5627 12.1973 7.55597C12.1918 7.54987 12.1875 7.54545 12.1834 7.54124C12.176 7.53451 12.1723 7.53115 12.1682 7.5282C12.1594 7.52126 12.1557 7.51852 12.152 7.51621C12.1422 7.51011 12.1385 7.508 12.1348 7.5059C12.1243 7.50085 12.1204 7.49917 12.1161 7.49748C12.1053 7.49348 12.1014 7.49201 12.0971 7.49096C12.0858 7.48801 12.0819 7.48696 12.0778 7.48633C12.0655 7.48423 12.0618 7.48402 12.0581 7.4836C12.0448 7.48296 12.0426 7.48254 12.0401 7.48254H11.2902C11.1753 7.48254 11.082 7.57827 11.082 7.6961V12.4782C11.082 12.596 11.1753 12.6915 11.2902 12.6915H12.0401C12.1553 12.6915 12.2485 12.596 12.2485 12.4782V9.63805L14.3858 12.6015C14.4003 12.6227 14.4186 12.6402 14.4387 12.6541C14.445 12.6585 14.4491 12.6612 14.4536 12.6638C14.4626 12.6688 14.4659 12.6705 14.4694 12.6722C14.4819 12.6772 14.4835 12.6781 14.4858 12.6789C14.4907 12.6806 14.4952 12.6821 14.4999 12.6835C14.5198 12.689 14.5376 12.6915 14.5563 12.6915H15.3062C15.4213 12.6915 15.5144 12.596 15.5144 12.4782V7.6961C15.5144 7.57827 15.4213 7.48254 15.3062 7.48254H14.5563Z", fill: "#53B535" }),
                            React$1.createElement("path", { id: "Fill 8", fillRule: "evenodd", clipRule: "evenodd", d: "M6.2991 11.494V7.6961C6.2991 7.57806 6.20585 7.48254 6.09088 7.48254H5.34103C5.22606 7.48254 5.13281 7.57806 5.13281 7.6961V12.4778C5.13281 12.5354 5.15515 12.5874 5.19101 12.6257C5.23446 12.6688 5.28487 12.6915 5.34062 12.6915H8.33656C8.45153 12.6915 8.54436 12.5956 8.54436 12.4778V11.7077C8.54436 11.5899 8.45153 11.494 8.33656 11.494H6.2991Z", fill: "#53B535" }),
                            React$1.createElement("path", { id: "Fill 10", fillRule: "evenodd", clipRule: "evenodd", d: "M19.4459 8.68012C19.5609 8.68012 19.6539 8.58439 19.6539 8.46636V7.69652C19.6539 7.57848 19.5609 7.48254 19.4459 7.48254H16.4504C16.3938 7.48254 16.3432 7.50548 16.3057 7.54293C16.2643 7.58732 16.2422 7.63908 16.2422 7.6961V12.4778C16.2422 12.5356 16.2645 12.5876 16.3004 12.6257C16.3434 12.6688 16.394 12.6915 16.45 12.6915H19.4459C19.5609 12.6915 19.6539 12.5958 19.6539 12.4778V11.7079C19.6539 11.5899 19.5609 11.4942 19.4459 11.4942H17.4087V10.6858H19.4459C19.5609 10.6858 19.6539 10.5901 19.6539 10.4721V9.70222C19.6539 9.58398 19.5609 9.48825 19.4459 9.48825H17.4087V8.68012H19.4459Z", fill: "#53B535" })))),
                "LINE\u7121\u6599\u76F8\u8AC7\u3092\u30B9\u30BF\u30FC\u30C8"))));
};
var index$E = memo(CocoLINEBanner);
var Container$1j = styled.div(templateObject_1$1u || (templateObject_1$1u = __makeTemplateObject(["\n  border-radius: 6px;\n  overflow: hidden;\n  background-color: ", ";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.14);\n"], ["\n  border-radius: 6px;\n  overflow: hidden;\n  background-color: ", ";\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.14);\n"])), COLORS.BACKGROUND.SURFACE);
var Banner = styled.img(templateObject_2$1j || (templateObject_2$1j = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Content$8 = styled.div(templateObject_3$14 || (templateObject_3$14 = __makeTemplateObject(["\n  padding: 12px 15px 15px 15px;\n"], ["\n  padding: 12px 15px 15px 15px;\n"])));
var Text$4 = styled.div(templateObject_4$W || (templateObject_4$W = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.NO_IMPORTANT, createFontStyle(__assign({}, MOBILE_FONT_STYLES.BODY_3)));
var LINELink$1 = styled.a(templateObject_5$K || (templateObject_5$K = __makeTemplateObject(["\n  margin-top: 12px;\n  display: flex;\n  justify-content: center;\n  padding-top: 14.5px;\n  padding-bottom: 14.5px;\n  border-radius: 6px;\n  background-color: #53b535;\n  color: ", ";\n  ", ";\n  text-decoration: none;\n  box-shadow: 0 3px 0 0 #388f1d;\n"], ["\n  margin-top: 12px;\n  display: flex;\n  justify-content: center;\n  padding-top: 14.5px;\n  padding-bottom: 14.5px;\n  border-radius: 6px;\n  background-color: #53b535;\n  color: ", ";\n  ", ";\n  text-decoration: none;\n  box-shadow: 0 3px 0 0 #388f1d;\n"])), COLORS.INVERT_TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { fontSize: '15px' })));
var templateObject_1$1u, templateObject_2$1j, templateObject_3$14, templateObject_4$W, templateObject_5$K;

var CocoLINELinkWithKeyVisual = function (_a) {
    var lineLinkUrl = _a.lineLinkUrl, imgixHost = _a.imgixHost, style = _a.style;
    return (React$1.createElement(Container$1i, { style: style },
        React$1.createElement(Title$o, null,
            "LINE\u3067\u3001\u30B9\u30BF\u30C3\u30D5\u3068\u4E00\u7DD2\u306B",
            React$1.createElement("br", null),
            "\u65C5\u884C\u3092\u4E88\u7D04\u3057\u3066\u307F\u307E\u305B\u3093\u304B\uFF1F"),
        React$1.createElement(KeyVisual, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/shared/ui-components/CocoLINELinkWithKeyVisual/line-banner.jpg")) }),
        React$1.createElement(Text$3, { style: { marginTop: '15px' } }, "\u7D4C\u9A13\u8C4A\u5BCC\u306A\u30B9\u30BF\u30C3\u30D5\u306BLINE\u3067\u76F8\u8AC7\u3057\u306A\u304C\u3089\u3001\u6D77\u5916\u65C5\u884C\u3092\u4E00\u7DD2\u306B\u4E88\u7D04\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"),
        React$1.createElement(Text$3, { style: { marginTop: '8px' } }, "\u304A\u5BA2\u3055\u307E\u306E\u3053\u3060\u308F\u308A\u3084\u3054\u5E0C\u671B\u306B\u5BC4\u308A\u6DFB\u3044\u3001\u7D0D\u5F97\u306E\u3044\u304F\u65C5\u884C\u304C\u4E88\u7D04\u3067\u304D\u308B\u307E\u3067\u4F34\u8D70\u3044\u305F\u3057\u307E\u3059\u3002"),
        React$1.createElement(LINELink, { href: lineLinkUrl, target: "_blank" },
            React$1.createElement("svg", { fill: "none", height: "25", viewBox: "0 0 25 25", width: "25", xmlns: "http://www.w3.org/2000/svg", style: { marginRight: '4px' } },
                React$1.createElement("g", { clipRule: "evenodd", fillRule: "evenodd" },
                    React$1.createElement("path", { d: "m23.112 11.1314c0-4.81569-4.777-8.73351-10.6492-8.73351-5.87147 0-10.64908 3.91782-10.64908 8.73351 0 4.3172 3.78853 7.9328 8.90608 8.6165.3468.0755.8188.2311.9382.5306.1072.2719.0702.6984.0343.9732 0 0-.1249.7592-.1519.9214-.0463.2719-.2139 1.0641.9224.5799 1.1366-.484 6.1329-3.6492 8.3671-6.2483h-.0007c1.5436-1.7103 2.2828-3.446 2.2828-5.3733", fill: "#fff" }),
                    React$1.createElement("g", { fill: "#53b535" },
                        React$1.createElement("path", { d: "m9.39376 8.47791c-.11497 0-.20821.09573-.20821.21355v4.78214c0 .1178.09324.2133.20821.2133h.74984c.115 0 .2082-.0955.2082-.2133v-4.78214c0-.11782-.0932-.21355-.2082-.21355z" }),
                        React$1.createElement("path", { d: "m14.5558 8.47791c-.1152 0-.2082.09573-.2082.21355v2.84094l-2.1348-2.9594c-.0047-.00778-.0105-.01493-.016-.02167-.0055-.0061-.0098-.01052-.0139-.01472-.0074-.00674-.0111-.0101-.0152-.01305-.0088-.00694-.0125-.00968-.0162-.01199-.0098-.0061-.0135-.00821-.0172-.01031-.0105-.00505-.0144-.00673-.0187-.00842-.0108-.00399-.0147-.00547-.019-.00652-.0113-.00294-.0152-.004-.0193-.00463-.0123-.0021-.016-.00231-.0197-.00273-.0133-.00063-.0155-.00105-.018-.00105h-.7498c-.115 0-.2083.09573-.2083.21355v4.78214c0 .1178.0933.2133.2083.2133h.7498c.1152 0 .2084-.0955.2084-.2133v-2.8402l2.1373 2.9634c.0146.0213.0328.0388.0529.0526.0063.0045.0104.0072.0149.0097.0091.0051.0123.0068.0158.0084.0125.0051.0142.0059.0164.0068.0049.0017.0094.0031.0142.0046.0198.0055.0377.008.0563.008h.7499c.1151 0 .2082-.0955.2082-.2133v-4.78214c0-.11782-.0931-.21355-.2082-.21355z" }),
                        React$1.createElement("path", { d: "m6.29885 12.4893v-3.79784c0-.11803-.09324-.21355-.20821-.21355h-.74986c-.11497 0-.20821.09552-.20821.21355v4.78164c0 .0577.02234.1096.0582.1479.04345.0432.09386.0659.1496.0659h2.99595c.11496 0 .2078-.0959.2078-.2138v-.77c0-.1178-.09284-.2138-.2078-.2138z" }),
                        React$1.createElement("path", { d: "m19.4459 9.67548c.115 0 .208-.09573.208-.21376v-.76984c0-.11803-.093-.21397-.208-.21397h-2.9955c-.0566 0-.1072.02293-.1447.06038-.0414.04439-.0635.09615-.0635.15317v4.78164c0 .0579.0223.1099.0582.1479.043.0432.0936.0659.1496.0659h2.9959c.115 0 .208-.0957.208-.2138v-.7698c0-.118-.093-.2138-.208-.2138h-2.0372v-.8083h2.0372c.115 0 .208-.0957.208-.2138v-.7698c0-.1183-.093-.214-.208-.214h-2.0372v-.80812z" })))),
            "LINE\u3067\u76F8\u8AC7\u3059\u308B"),
        React$1.createElement(SmallText, { style: { marginTop: '10px' } }, "\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068LINE\u30A2\u30D7\u30EA\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002\u53CB\u3060\u3061\u306B\u8FFD\u52A0\u5F8C\u3001\u307E\u305A\u306F\u3054\u691C\u8A0E\u4E2D\u306E\u65C5\u884C\u306B\u3064\u3044\u3066\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002")));
};
var CocoLINELinkWithKeyVisual$1 = memo(CocoLINELinkWithKeyVisual);
var Container$1i = styled.div(templateObject_1$1t || (templateObject_1$1t = __makeTemplateObject(["\n  background-color: #fdf6e0;\n  color: ", ";\n"], ["\n  background-color: #fdf6e0;\n  color: ", ";\n"])), COLORS.TEXT.PRIMARY);
var Title$o = styled.p(templateObject_2$1i || (templateObject_2$1i = __makeTemplateObject(["\n  ", ";\n  text-align: center;\n"], ["\n  ", ";\n  text-align: center;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.SUB_TITLE_1), { letterSpacing: '0.1em' })));
var KeyVisual = styled.img(templateObject_3$13 || (templateObject_3$13 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: 15px;\n"], ["\n  width: 100%;\n  margin-top: 15px;\n"])));
var Text$3 = styled.p(templateObject_4$V || (templateObject_4$V = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_3));
var LINELink = styled.a(templateObject_5$J || (templateObject_5$J = __makeTemplateObject(["\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 14.5px;\n  padding-bottom: 14.5px;\n  border-radius: 6px;\n  background-color: #53b535;\n  color: ", ";\n  ", ";\n  text-decoration: none;\n"], ["\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 14.5px;\n  padding-bottom: 14.5px;\n  border-radius: 6px;\n  background-color: #53b535;\n  color: ", ";\n  ", ";\n  text-decoration: none;\n"])), COLORS.INVERT_TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { lineHeight: '20px' })));
var SmallText = styled.p(templateObject_6$z || (templateObject_6$z = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_2), COLORS.TEXT.NO_IMPORTANT);
var templateObject_1$1t, templateObject_2$1i, templateObject_3$13, templateObject_4$V, templateObject_5$J, templateObject_6$z;

var CocoHeaderBar = function (_a) {
    var title = _a.title, onClickBack = _a.onClickBack, children = _a.children, style = _a.style;
    return (React$1.createElement(Container$1h, { style: style },
        React$1.createElement(BackArrowAndTitle, null,
            React$1.createElement(Title$n, null, title),
            typeof onClickBack !== 'undefined' && (React$1.createElement(BackArrowIcon, { fill: "none", height: "50", viewBox: "0 0 50 50", width: "50", xmlns: "http://www.w3.org/2000/svg", onClick: onClickBack },
                React$1.createElement("path", { d: "m18 24.4851 8.4853 8.4853 1.8856-1.8856-6.5996-6.5997 6.5997-6.5995-1.8856-1.8857z", fill: "#000" })))),
        typeof children !== 'undefined' && children));
};
var index$D = memo(CocoHeaderBar);
var Container$1h = styled.div(templateObject_1$1s || (templateObject_1$1s = __makeTemplateObject(["\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  background: ", ";\n"], ["\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  background: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var BackArrowAndTitle = styled.div(templateObject_2$1h || (templateObject_2$1h = __makeTemplateObject(["\n  position: relative;\n  padding: 12px 0;\n"], ["\n  position: relative;\n  padding: 12px 0;\n"])));
var BackArrowIcon = styled.svg(templateObject_3$12 || (templateObject_3$12 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n"])));
var Title$n = styled.p(templateObject_4$U || (templateObject_4$U = __makeTemplateObject(["\n  margin: 0;\n  text-align: center;\n  ", ";\n"], ["\n  margin: 0;\n  text-align: center;\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1));
var templateObject_1$1s, templateObject_2$1h, templateObject_3$12, templateObject_4$U;

var useLocalState$j = function (steps, currentStepIndex) {
    var stepWithStatusList = useMemo(function () {
        return steps.map(function (step, index) {
            return {
                step: step,
                status: index === currentStepIndex
                    ? STEP_STATUS.CURRENT
                    : typeof currentStepIndex === 'undefined' ||
                        index > currentStepIndex
                        ? STEP_STATUS.NOT_COMPLETED
                        : STEP_STATUS.COMPLETED,
            };
        });
    }, [currentStepIndex, steps]);
    var isAllDone = useMemo(function () {
        return steps.length === currentStepIndex;
    }, [currentStepIndex, steps]);
    return { stepWithStatusList: stepWithStatusList, isAllDone: isAllDone };
};

var STEP_STATUS = {
    // 完了している
    COMPLETED: 'completed',
    // 現在
    CURRENT: 'current',
    // 完了していない
    NOT_COMPLETED: 'not-completed',
};
var CocoStepper = function (_a) {
    var steps = _a.steps, currentStepIndex = _a.currentStepIndex, isInprogress = _a.isInprogress, style = _a.style;
    var _b = useLocalState$j(steps, currentStepIndex), stepWithStatusList = _b.stepWithStatusList, isAllDone = _b.isAllDone;
    var isCurrent = function (index) { return index === currentStepIndex; };
    var isLastStep = function (index) { return steps.length - 1 === index; };
    return (React$1.createElement(Container$1g, { style: style }, stepWithStatusList.map(function (stepWithStatus, index) { return (React$1.createElement(Fragment, { key: index },
        index > 0 && React$1.createElement(StepToStepLine, { status: stepWithStatus.status }),
        React$1.createElement(Step, { status: stepWithStatus.status },
            React$1.createElement(StepName, { isActive: isCurrent(index) || (isLastStep(index) && isAllDone) }, stepWithStatus.step),
            typeof currentStepIndex !== 'undefined' &&
                index < currentStepIndex && (React$1.createElement(ActiveContainer, null,
                React$1.createElement(Active, null)))),
        index < steps.length - 1 && isInprogress && (React$1.createElement(StepToStepLine, { status: stepWithStatus.status })))); })));
};
var CocoStepper$1 = memo(CocoStepper);
var Active = function () { return (React$1.createElement("svg", { style: { position: 'absolute', right: '-1px', top: '-1px' }, width: "13", height: "13", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React$1.createElement("circle", { cx: "7.5", cy: "7", r: "7", fill: "#5AC486" }),
    React$1.createElement("path", { d: "M6.66191 10.0806C6.41868 10.0806 6.17546 9.98938 5.96264 9.80696L3.5 7.34432L4.86813 5.97619L6.66191 7.76996L10.4319 4L11.8 5.36813L7.36117 9.80696C7.17876 9.98938 6.93553 10.0806 6.66191 10.0806Z", fill: "white" }))); };
var Container$1g = styled.div(templateObject_1$1r || (templateObject_1$1r = __makeTemplateObject(["\n  height: 50px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n"], ["\n  height: 50px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n"])));
var Step = styled.div(templateObject_2$1g || (templateObject_2$1g = __makeTemplateObject(["\n  height: 14px;\n  width: 14px;\n  border: ", ";\n  border-color: ", ";\n  box-sizing: border-box;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n"], ["\n  height: 14px;\n  width: 14px;\n  border: ", ";\n  border-color: ", ";\n  box-sizing: border-box;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n"])), function (props) {
    return props.status === STEP_STATUS.CURRENT
        ? "2px solid ".concat(COLORS.GENERAL.SECONDARY)
        : '2px solid transparent';
}, function (props) {
    return props.status === STEP_STATUS.COMPLETED
        ? COLORS.GENERAL.SECONDARY
        : props.status === STEP_STATUS.NOT_COMPLETED
            ? '#E8E8E8'
            : COLORS.GENERAL.SECONDARY;
});
var StepName = styled.span(templateObject_3$11 || (templateObject_3$11 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  position: absolute;\n  width: max-content;\n  max-width: 100px;\n  top: 15px;\n  transform: translateX(-50%);\n  left: 50%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  ", ";\n  color: ", ";\n  position: absolute;\n  width: max-content;\n  max-width: 100px;\n  top: 15px;\n  transform: translateX(-50%);\n  left: 50%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])), function (props) {
    return props.isActive
        ? createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_2), { lineHeight: 1.4 }))
        : createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_2), { lineHeight: 1.4, fontWeight: '500' }));
}, function (props) {
    return props.isActive ? "".concat(COLORS.GENERAL.SECONDARY) : "".concat(COLORS.TEXT.DISABLE);
});
var StepToStepLine = styled.div(templateObject_4$T || (templateObject_4$T = __makeTemplateObject(["\n  border-top: ", ";\n  width: 100%;\n  flex-grow: 1;\n"], ["\n  border-top: ", ";\n  width: 100%;\n  flex-grow: 1;\n"])), function (props) {
    return props.status === STEP_STATUS.COMPLETED ||
        props.status === STEP_STATUS.CURRENT
        ? "2px solid ".concat(COLORS.GENERAL.SECONDARY)
        : "2px solid ".concat(COLORS.BACKGROUND.BASE);
});
var ActiveContainer = styled.div(templateObject_5$I || (templateObject_5$I = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1$1r, templateObject_2$1g, templateObject_3$11, templateObject_4$T, templateObject_5$I;

var ARROW_ICON_SIZE = '42px';
var CocoFlightHeader = function (_a) {
    var departureAirport = _a.departureAirport, arrivalAirport = _a.arrivalAirport, backgroundImageUrl = _a.backgroundImageUrl, arrowImageUrl = _a.arrowImageUrl, style = _a.style;
    return (React$1.createElement(Container$1f, { style: style, backgroundImageUrl: backgroundImageUrl },
        React$1.createElement(AirportContainer$1, null,
            React$1.createElement(CityOrAirportName, null, departureAirport.cityName),
            React$1.createElement(IATACode, null, departureAirport.iataCode),
            React$1.createElement(CityOrAirportName, null, departureAirport.airportName)),
        React$1.createElement(Arrow$1, { src: arrowImageUrl }),
        React$1.createElement(AirportContainer$1, null,
            React$1.createElement(CityOrAirportName, null, arrivalAirport.cityName),
            React$1.createElement(IATACode, null, arrivalAirport.iataCode),
            React$1.createElement(CityOrAirportName, null, arrivalAirport.airportName))));
};
var index$C = memo(CocoFlightHeader);
var Container$1f = styled.div(templateObject_1$1q || (templateObject_1$1q = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 20px 10px;\n  background: ", " no-repeat;\n  background-size: cover;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 20px 10px;\n  background: ", " no-repeat;\n  background-size: cover;\n"])), function (props) { return "url(".concat(props.backgroundImageUrl, ")"); });
var AirportContainer$1 = styled.div(templateObject_2$1f || (templateObject_2$1f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: calc(50% - ", " / 2);\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: calc(50% - ", " / 2);\n"])), ARROW_ICON_SIZE);
var Arrow$1 = styled.img(templateObject_3$10 || (templateObject_3$10 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  object-fit: contain;\n  flex-shrink: 0;\n"], ["\n  width: ", ";\n  height: ", ";\n  object-fit: contain;\n  flex-shrink: 0;\n"])), ARROW_ICON_SIZE, ARROW_ICON_SIZE);
var CityOrAirportName = styled.p(templateObject_4$S || (templateObject_4$S = __makeTemplateObject(["\n  margin: 0;\n  ", "\n  color: ", ";\n"], ["\n  margin: 0;\n  ", "\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { letterSpacing: '0.01em' })), COLORS.INVERT_TEXT.NO_IMPORTANT);
var IATACode = styled.p(templateObject_5$H || (templateObject_5$H = __makeTemplateObject(["\n  margin: 0;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 28px;\n  line-height: 1.2;\n  letter-spacing: 0.1em;\n  color: ", ";\n"], ["\n  margin: 0;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: 28px;\n  line-height: 1.2;\n  letter-spacing: 0.1em;\n  color: ", ";\n"])), FONT_FAMILY.AVENIR_NEXT, COLORS.INVERT_TEXT.PRIMARY);
var templateObject_1$1q, templateObject_2$1f, templateObject_3$10, templateObject_4$S, templateObject_5$H;

var useLocalState$i = function (flightClass) {
    var flightClassLabelAndColors = useMemo(function () {
        switch (flightClass) {
            case FLIGHT_CLASS.FIRST:
                return {
                    label: 'ファースト',
                    textColor: COLORS.STATUS.ERROR_OR_DANGER,
                    backgroundColor: '#FFEBEF',
                };
            case FLIGHT_CLASS.BUSINESS:
                return {
                    label: 'ビジネス',
                    textColor: '#F45914',
                    backgroundColor: '#FDEAE0',
                };
            case FLIGHT_CLASS.ECONOMY_PREMIUM:
                return {
                    label: 'プレミアムエコノミー',
                    textColor: COLORS.STATUS.SUCCESS_OR_POSITIVE,
                    backgroundColor: '#E3F2FC',
                };
            case FLIGHT_CLASS.ECONOMY:
                return {
                    label: 'エコノミー',
                    textColor: '#009B4C',
                    backgroundColor: '#E4F6EA',
                };
        }
    }, [flightClass]);
    return { flightClassLabelAndColors: flightClassLabelAndColors };
};

var CocoFlightClassLabel = function (_a) {
    var flightClass = _a.flightClass, style = _a.style;
    var flightClassLabelAndColors = useLocalState$i(flightClass).flightClassLabelAndColors;
    return (React$1.createElement(Container$1e, { style: __assign(__assign({}, style), { color: flightClassLabelAndColors.textColor, backgroundColor: flightClassLabelAndColors.backgroundColor }) }, flightClassLabelAndColors.label));
};
var CocoFlightClassLabel$1 = memo(CocoFlightClassLabel);
var Container$1e = styled.span(templateObject_1$1p || (templateObject_1$1p = __makeTemplateObject(["\n  padding: 2px 4px;\n  border-radius: 3px;\n  ", ";\n"], ["\n  padding: 2px 4px;\n  border-radius: 3px;\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1));
var templateObject_1$1p;

var CARRIER_TYPE = {
    FULL_CARRIER: 'FULL_CARRIER',
    LCC: 'LCC',
};

// NOTE: (akutsu) Fare_MasterPricerTravelBoardSearchの101ページ参照
var FLIGHT_CLASS = {
    FIRST: 'FIRST',
    BUSINESS: 'BUSINESS',
    ECONOMY_PREMIUM: 'ECONOMY_PREMIUM',
    ECONOMY: 'ECONOMY',
};
var findIndexAtMaxLength = function (strings, length) {
    return strings.findIndex(function (_, i, arr) { return arr.slice(0, i + 1).join('').length > length; });
};
var CocoFlightSummary = function (_a) {
    var flightInfo = _a.flightInfo, imgixHost = _a.imgixHost, onClick = _a.onClick, onClickLink = _a.onClickLink, onClickBaggageAllowance = _a.onClickBaggageAllowance, style = _a.style;
    // NOTE: (zoma) 空港1->空港2->空港3... と並ぶ為 ちょうど良い長さで空港の数を切るためのロジック
    var _b = __read(useState(flightInfo.airportNames), 2), airportNames = _b[0], setAirportNames = _b[1];
    var airportConnectionsContainerRef = useRef(null);
    useEffect(function () {
        var currentRef = airportConnectionsContainerRef.current;
        var observer = new ResizeObserver(function (entries) {
            var e_1, _a;
            try {
                for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                    var entry = entries_1_1.value;
                    var rect = entry.target.getBoundingClientRect();
                    // NOTE: (zoma) カードの長さから、良い感じに空港の数を切る計算
                    var airportIndex = findIndexAtMaxLength(flightInfo.airportNames, rect.width / 13);
                    if (flightInfo.airportNames.length !== airportIndex) {
                        setAirportNames(flightInfo.airportNames.slice(0, airportIndex === -1
                            ? flightInfo.airportNames.length
                            : airportIndex + 1));
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        if (currentRef) {
            observer.observe(currentRef);
        }
        return function () {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [airportNames.length, flightInfo.airportNames]);
    return (React$1.createElement(Container$1d, { style: style },
        React$1.createElement(InnerContainer$5, { onClick: onClick, "data-is-clickable": typeof onClick !== 'undefined' ? 'true' : 'false' },
            React$1.createElement(FlightTimeContainer$1, null,
                React$1.createElement(TimeRangeAndFlightClassContainer, null,
                    React$1.createElement(DepartureToArrivalTimeContainer, null,
                        React$1.createElement(Time$4, null, flightInfo.departureTime),
                        React$1.createElement(Arrow, { width: "12", height: "11", viewBox: "0 0 12 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React$1.createElement("path", { d: "M0.666663 6.16658L8.78 6.16659L5.05333 9.89325L6 10.8333L11.3333 5.49992L6 0.166585L5.06 1.10658L8.78 4.83325L0.666663 4.83325L0.666663 6.16658Z", fill: "black", fillOpacity: "0.87" })),
                        React$1.createElement(Time$4, null,
                            flightInfo.arrivalTime,
                            flightInfo.dayDiff !== 0 && (React$1.createElement("span", null,
                                flightInfo.dayDiff > 0 ? '+' : '-',
                                Math.abs(flightInfo.dayDiff))))),
                    React$1.createElement(CocoFlightClassLabel$1, { flightClass: flightInfo.flightClass })),
                React$1.createElement(TotalTimeAndNumberOfConnections, null,
                    flightInfo.totalTime,
                    "\uFF0F",
                    flightInfo.numberOfConnections === 0
                        ? '直行便'
                        : "\u4E57\u308A\u7D99\u304E".concat(flightInfo.numberOfConnections, "\u56DE"))),
            typeof onClickLink !== 'undefined' ? (React$1.createElement(FlexContainer$4, null,
                React$1.createElement("div", { style: { flex: 1 } },
                    React$1.createElement(AirportConnectionsContainer, { style: { width: '100%' }, ref: airportConnectionsContainerRef },
                        React$1.createElement(AirportConnections, null, airportNames.map(function (airportName, index) { return (React$1.createElement(Fragment, { key: index },
                            index > 0 && (React$1.createElement(SmallArrow, { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                React$1.createElement("path", { d: "M3.0598e-07 4.5L6.085 4.5L3.29 7.295L4 8L8 4L4 -3.49691e-07L3.295 0.705L6.085 3.5L3.93402e-07 3.5L3.0598e-07 4.5Z", fill: "black", fillOpacity: "0.38" }))),
                            React$1.createElement(AirportName$1, { "data-is-last": index === airportNames.length - 1 ? 'true' : 'false' }, airportName))); }))),
                    React$1.createElement(CarrierAndTotalInformationContainer, null,
                        React$1.createElement(CarrierContainer, null,
                            React$1.createElement(CarrierIconContainer, null,
                                React$1.createElement(CarrierIcon$1, { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" },
                                    React$1.createElement("rect", { fill: "#46a7ed", height: "24", rx: "4", width: "24" }),
                                    React$1.createElement("path", { d: "m18.75 15v-1.5l-6-3.75v-4.125c0-.6225-.5025-1.125-1.125-1.125s-1.125.5025-1.125 1.125v4.125l-6 3.75v1.5l6-1.875v4.125l-1.5 1.125v1.125l2.625-.75 2.625.75v-1.125l-1.5-1.125v-4.125z", fill: "#e3f2fc" }))),
                            React$1.createElement(CarrierName, null, flightInfo.carrierName),
                            flightInfo.carrierType === CARRIER_TYPE.LCC && (React$1.createElement(Image$e, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/shared/ui-components/CocoFlightSummary/lcc-icon.png")) })),
                            flightInfo.numberOfConnectingCarriers > 0 && (React$1.createElement(ConnectingCarriers, null,
                                "+\u4ED6",
                                flightInfo.numberOfConnectingCarriers,
                                "\u793E"))))),
                React$1.createElement(FlightDetailTriggerContainer, null,
                    React$1.createElement(FlightDetailTrigger, { onClick: onClickLink },
                        "\u30D5\u30E9\u30A4\u30C8\u8A73\u7D30",
                        React$1.createElement("svg", { width: "7", height: "10", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginLeft: '4px' } },
                            React$1.createElement("path", { d: "M0.757324 0.757324L4.99997 4.99996L0.757324 9.2426", stroke: "#46A7ED", strokeWidth: "2" })))))) : (React$1.createElement(React$1.Fragment, null,
                React$1.createElement(AirportConnectionsContainer, { ref: airportConnectionsContainerRef, style: { width: '100%' } },
                    React$1.createElement(AirportConnections, null, airportNames.map(function (airportName, index) { return (React$1.createElement(Fragment, { key: index },
                        index > 0 && (React$1.createElement(SmallArrow, { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React$1.createElement("path", { d: "M3.0598e-07 4.5L6.085 4.5L3.29 7.295L4 8L8 4L4 -3.49691e-07L3.295 0.705L6.085 3.5L3.93402e-07 3.5L3.0598e-07 4.5Z", fill: "black", fillOpacity: "0.38" }))),
                        React$1.createElement(AirportName$1, { "data-is-last": index === airportNames.length - 1 ? 'true' : 'false' }, airportName))); }))),
                React$1.createElement(CarrierAndTotalInformationContainer, null,
                    React$1.createElement(CarrierContainer, null,
                        React$1.createElement(CarrierIconContainer, null,
                            React$1.createElement(CarrierIcon$1, { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" },
                                React$1.createElement("rect", { fill: "#46a7ed", height: "24", rx: "4", width: "24" }),
                                React$1.createElement("path", { d: "m18.75 15v-1.5l-6-3.75v-4.125c0-.6225-.5025-1.125-1.125-1.125s-1.125.5025-1.125 1.125v4.125l-6 3.75v1.5l6-1.875v4.125l-1.5 1.125v1.125l2.625-.75 2.625.75v-1.125l-1.5-1.125v-4.125z", fill: "#e3f2fc" }))),
                        React$1.createElement(CarrierName, null, flightInfo.carrierName),
                        flightInfo.carrierType === CARRIER_TYPE.LCC && (React$1.createElement(Image$e, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/shared/ui-components/CocoFlightSummary/lcc-icon.png")) })),
                        flightInfo.numberOfConnectingCarriers > 0 && (React$1.createElement(ConnectingCarriers, null,
                            "+\u4ED6",
                            flightInfo.numberOfConnectingCarriers,
                            "\u793E"))),
                    React$1.createElement(Price$5, null, typeof flightInfo.priceDiff !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                        React$1.createElement("span", null,
                            flightInfo.priceDiff < 0 ? '−' : '+',
                            "\u00A5"),
                        Math.abs(flightInfo.priceDiff).toLocaleString())) : typeof flightInfo.totalPrice !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                        React$1.createElement("span", null, "\u00A5"),
                        flightInfo.totalPrice.toLocaleString())) : (React$1.createElement(React$1.Fragment, null)))))),
            typeof flightInfo.note !== 'undefined' && (React$1.createElement(Note$3, null, flightInfo.note))),
        typeof flightInfo.baggageAllowance !== 'undefined' && (React$1.createElement(BaggageContainer, { onClick: onClickBaggageAllowance, "data-is-clickable": typeof onClickBaggageAllowance !== 'undefined' ? 'true' : 'false' },
            React$1.createElement(BaggageInfo, null,
                React$1.createElement(BaggageLabel, null, "\u53D7\u8A17\u624B\u8377\u7269"),
                React$1.createElement(BaggageValue, null, flightInfo.baggageAllowance)),
            typeof onClickBaggageAllowance !== 'undefined' && (React$1.createElement("svg", { width: "8", height: "13", viewBox: "0 0 8 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React$1.createElement("path", { d: "M1.05023 1.55023L5.99998 6.49998L1.05023 11.4497", stroke: "black", strokeOpacity: "0.87", strokeWidth: "2" })))))));
};
var index$B = memo(CocoFlightSummary);
var Container$1d = styled.div(templateObject_1$1o || (templateObject_1$1o = __makeTemplateObject(["\n  border-radius: 6px;\n  border: 1px solid ", ";\n  background: ", ";\n"], ["\n  border-radius: 6px;\n  border: 1px solid ", ";\n  background: ", ";\n"])), COLORS.BORDER.SECONDARY, COLORS.BACKGROUND.SURFACE);
var InnerContainer$5 = styled.div(templateObject_2$1e || (templateObject_2$1e = __makeTemplateObject(["\n  padding: 15px 15px 12px;\n  &[data-is-clickable='true'] {\n    cursor: pointer;\n  }\n"], ["\n  padding: 15px 15px 12px;\n  &[data-is-clickable='true'] {\n    cursor: pointer;\n  }\n"])));
var FlightTimeContainer$1 = styled.div(templateObject_3$$ || (templateObject_3$$ = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var TimeRangeAndFlightClassContainer = styled.div(templateObject_4$R || (templateObject_4$R = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var DepartureToArrivalTimeContainer = styled.div(templateObject_5$G || (templateObject_5$G = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var Time$4 = styled.div(templateObject_6$y || (templateObject_6$y = __makeTemplateObject(["\n  margin-top: 2px;\n  display: flex;\n  flex-direction: row;\n  ", "\n  color: ", ";\n\n  span {\n    ", "\n    color: ", ";\n    margin: -2px 0 0 1px;\n  }\n"], ["\n  margin-top: 2px;\n  display: flex;\n  flex-direction: row;\n  ", "\n  color: ", ";\n\n  span {\n    ", "\n    color: ", ";\n    margin: -2px 0 0 1px;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_3), { fontWeight: 'bold', letterSpacing: '0.01em' })), COLORS.TEXT.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.NUM_7), COLORS.GENERAL.PRIMARY);
var Arrow = styled.svg(templateObject_7$p || (templateObject_7$p = __makeTemplateObject(["\n  margin: 0 5px;\n"], ["\n  margin: 0 5px;\n"])));
var FlexContainer$4 = styled.div(templateObject_8$m || (templateObject_8$m = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n"])));
var TotalTimeAndNumberOfConnections = styled.p(templateObject_9$i || (templateObject_9$i = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  margin-top: 2px;\n"], ["\n  ", "\n  color: ", ";\n  margin-top: 2px;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '150%', letterSpacing: '0.78px' })), COLORS.TEXT.PRIMARY);
var AirportConnectionsContainer = styled.div(templateObject_10$g || (templateObject_10$g = __makeTemplateObject(["\n  display: flex;\n  width: 70%;\n"], ["\n  display: flex;\n  width: 70%;\n"])));
var AirportConnections = styled.div(templateObject_11$d || (templateObject_11$d = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n"])));
var AirportName$1 = styled.span(templateObject_12$b || (templateObject_12$b = __makeTemplateObject(["\n  margin-top: 4px;\n  ", "\n  color: ", ";\n  &[data-is-last='true'] {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  &[data-is-last='false'] {\n    flex-shrink: 0;\n  }\n"], ["\n  margin-top: 4px;\n  ", "\n  color: ", ";\n  &[data-is-last='true'] {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  &[data-is-last='false'] {\n    flex-shrink: 0;\n  }\n"])), createFontStyle(__assign({}, MOBILE_FONT_STYLES.CAPTION_1)), COLORS.TEXT.NOTE_OR_CAPTION);
var SmallArrow = styled.svg(templateObject_13$8 || (templateObject_13$8 = __makeTemplateObject(["\n  margin: 4px 4px 0;\n  flex-shrink: 0;\n"], ["\n  margin: 4px 4px 0;\n  flex-shrink: 0;\n"])));
var Price$5 = styled.p(templateObject_14$8 || (templateObject_14$8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 20px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-left: 2px;\n    font-size: 13px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 20px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-left: 2px;\n    font-size: 13px;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { fontWeight: 'bold', letterSpacing: '0.01em' })), COLORS.TEXT.PRIMARY);
var CarrierAndTotalInformationContainer = styled.div(templateObject_15$5 || (templateObject_15$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"])));
var CarrierContainer = styled.div(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n"])));
var CarrierIconContainer = styled.div(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  position: relative;\n"], ["\n  width: 16px;\n  height: 16px;\n  position: relative;\n"])));
var CarrierIcon$1 = styled.svg(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"], ["\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));
var CarrierName = styled.p(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-left: 4px;\n"], ["\n  ", "\n  color: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-left: 4px;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { lineHeight: 1.8 })), COLORS.TEXT.PRIMARY);
var ConnectingCarriers = styled.p(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-left: 4px;\n"], ["\n  ", "\n  color: ", ";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-left: 4px;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { lineHeight: 1.8 })), COLORS.TEXT.PRIMARY);
var FlightDetailTriggerContainer = styled.div(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n"])));
var FlightDetailTrigger = styled.p(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n  text-wrap: nowrap;\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n  text-wrap: nowrap;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_1), { lineHeight: '120%' })), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var Image$e = styled.img(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  height: 12px;\n  padding-left: 2px;\n"], ["\n  height: 12px;\n  padding-left: 2px;\n"])));
var Note$3 = styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  margin-top: 5px;\n  padding: 6px 8px;\n  background: #e3f2fc;\n  border-radius: 6px;\n  ", "\n  color: ", ";\n"], ["\n  margin-top: 5px;\n  padding: 6px 8px;\n  background: #e3f2fc;\n  border-radius: 6px;\n  ", "\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { lineHeight: '150%' })), COLORS.TEXT.NO_IMPORTANT);
var BaggageContainer = styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  padding: 10px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid ", ";\n  &[data-is-clickable='true'] {\n    cursor: pointer;\n  }\n"], ["\n  padding: 10px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid ", ";\n  &[data-is-clickable='true'] {\n    cursor: pointer;\n  }\n"])), COLORS.BORDER.SECONDARY);
var BaggageInfo = styled.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var BaggageLabel = styled.p(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '150%', letterSpacing: '0.03em' })), COLORS.TEXT.PRIMARY);
var BaggageValue = styled.span(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  margin-left: 5px;\n  padding: 1px 3px;\n  background-color: #e3f2fc;\n  border-radius: 3px;\n  color: #1e8cdd;\n  ", ";\n"], ["\n  margin-left: 5px;\n  padding: 1px 3px;\n  background-color: #e3f2fc;\n  border-radius: 3px;\n  color: #1e8cdd;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_2), { lineHeight: '150%', letterSpacing: '0.03em' })));
var templateObject_1$1o, templateObject_2$1e, templateObject_3$$, templateObject_4$R, templateObject_5$G, templateObject_6$y, templateObject_7$p, templateObject_8$m, templateObject_9$i, templateObject_10$g, templateObject_11$d, templateObject_12$b, templateObject_13$8, templateObject_14$8, templateObject_15$5, templateObject_16$2, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21$1, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;

var DATE_FORMAT_TEMPLATE = {
    YYYY_MM_DD: 'YYYY-MM-DD',
    MONTH_DATE: 'MM/DD',
    YEAR_MONTH_DATE_DAY_JA: 'YYYY年M月D日(ddd)',
};
var DATE_CELL_TYPE = {
    // 選択の開始日のとき
    SELECT_BEGIN: 'select_begin',
    // 選択の終了日のとき
    SELECT_END: 'select_end',
    // 選択されている中間の日のとき
    SELECT_BETWEEN: 'select_between',
    // 選択が単一のときの選択状態
    SELECTED: 'selected',
    // 選択可能な日のとき
    SELECTABLE: 'selectable',
    // 選択不可な日付のとき
    UNSELECTABLE: 'unselectable',
};
var CocoCalendarDateCell = function (_a) {
    var date = _a.date, cellType = _a.cellType, _b = _a.minWidth, minWidth = _b === void 0 ? TABLET_MAX_WIDTH : _b, onClick = _a.onClick;
    return (React$1.createElement(DateCell, null,
        React$1.createElement(DateContentWrapper, { minWidth: minWidth, "data-testid": "input-stay-dates_day-".concat(date.format(DATE_FORMAT_TEMPLATE.YYYY_MM_DD)), "data-cell-type": cellType, onClick: function (e) {
                if (onClick)
                    onClick(e);
            } },
            React$1.createElement(DateContent, null,
                React$1.createElement(DateContentInner, null,
                    React$1.createElement(DateText, { "data-cell-type": cellType, "data-is-saturday": isSaturday(date), "data-is-sunday": isSunDay(date) }, date.date()))))));
};
var CocoCalendarDateCell$1 = memo(CocoCalendarDateCell);
/**
 * 土曜日かどうかを判定
 * https://day.js.org/docs/en/get-set/day#docsNavhttps://day.js.org/docs/en/get-set/day#docsNav
 * @param dayjs
 */
var isSaturday = function (dayjs) { return dayjs.day() === 6; };
/**
 * 日曜日かどうかを判定
 * https://day.js.org/docs/en/get-set/day#docsNavhttps://day.js.org/docs/en/get-set/day#docsNav
 * @param dayjs
 */
var isSunDay = function (dayjs) { return dayjs.day() === 0; };
var DateCell = styled.td(templateObject_1$1n || (templateObject_1$1n = __makeTemplateObject([""], [""])));
var DateContentWrapper = styled.div(templateObject_2$1d || (templateObject_2$1d = __makeTemplateObject(["\n  height: 48px;\n  display: flex;\n  align-items: center;\n\n  :not(&[data-cell-type='unselectable']) {\n    cursor: pointer;\n  }\n\n  @media (min-width: ", ") {\n    &:hover {\n      :not(&[data-cell-type='unselectable']) {\n        background-color: #bcdff9;\n      }\n      border-radius: 100px;\n    }\n  }\n\n  &[data-cell-type='select_begin'],\n  &[data-cell-type='select_end'],\n  &[data-cell-type='selected'] {\n    > div {\n      width: 48px;\n      margin: 0 auto;\n      background-color: #46a7ed;\n      border-radius: 100%;\n\n      :not(&[data-cell-type='selected']) {\n        path {\n          fill: ", ";\n        }\n      }\n    }\n\n    p {\n      color: ", ";\n    }\n  }\n\n  &[data-cell-type='select_begin'] {\n    background: linear-gradient(\n      to right,\n      ", " 50%,\n      #e3f2fc 50%\n    );\n  }\n\n  &[data-cell-type='select_end'] {\n    background: linear-gradient(\n      to right,\n      #e3f2fc 50%,\n      ", " 50%\n    );\n  }\n\n  &[data-cell-type='select_between'] {\n    background-color: #e3f2fc;\n\n    &:hover {\n      border-radius: unset;\n    }\n  }\n"], ["\n  height: 48px;\n  display: flex;\n  align-items: center;\n\n  :not(&[data-cell-type='unselectable']) {\n    cursor: pointer;\n  }\n\n  @media (min-width: ", ") {\n    &:hover {\n      :not(&[data-cell-type='unselectable']) {\n        background-color: #bcdff9;\n      }\n      border-radius: 100px;\n    }\n  }\n\n  &[data-cell-type='select_begin'],\n  &[data-cell-type='select_end'],\n  &[data-cell-type='selected'] {\n    > div {\n      width: 48px;\n      margin: 0 auto;\n      background-color: #46a7ed;\n      border-radius: 100%;\n\n      :not(&[data-cell-type='selected']) {\n        path {\n          fill: ", ";\n        }\n      }\n    }\n\n    p {\n      color: ", ";\n    }\n  }\n\n  &[data-cell-type='select_begin'] {\n    background: linear-gradient(\n      to right,\n      ", " 50%,\n      #e3f2fc 50%\n    );\n  }\n\n  &[data-cell-type='select_end'] {\n    background: linear-gradient(\n      to right,\n      #e3f2fc 50%,\n      ", " 50%\n    );\n  }\n\n  &[data-cell-type='select_between'] {\n    background-color: #e3f2fc;\n\n    &:hover {\n      border-radius: unset;\n    }\n  }\n"])), function (props) { return props.minWidth; }, COLORS.TEXT.INVERSE_PRIMARY, COLORS.TEXT.INVERSE_PRIMARY, COLORS.TEXT.INVERSE_PRIMARY, COLORS.TEXT.INVERSE_PRIMARY);
var DateContent = styled.div(templateObject_3$_ || (templateObject_3$_ = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var DateContentInner = styled.div(templateObject_4$Q || (templateObject_4$Q = __makeTemplateObject([""], [""])));
var DateText = styled.p(templateObject_5$F || (templateObject_5$F = __makeTemplateObject(["\n  ", "\n  text-align: center;\n  color: ", ";\n\n  &[data-is-saturday='true'] {\n    color: #0c68b9;\n  }\n\n  &[data-is-sunday='true'] {\n    color: #ff4d4f;\n  }\n\n  &[data-cell-type='unselectable'] {\n    color: ", ";\n\n    &[data-is-saturday='true'] {\n      color: #b6d2ea;\n    }\n\n    &[data-is-sunday='true'] {\n      color: #ffcaca;\n    }\n  }\n"], ["\n  ", "\n  text-align: center;\n  color: ", ";\n\n  &[data-is-saturday='true'] {\n    color: #0c68b9;\n  }\n\n  &[data-is-sunday='true'] {\n    color: #ff4d4f;\n  }\n\n  &[data-cell-type='unselectable'] {\n    color: ", ";\n\n    &[data-is-saturday='true'] {\n      color: #b6d2ea;\n    }\n\n    &[data-is-sunday='true'] {\n      color: #ffcaca;\n    }\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_3), { letterSpacing: '-0.05em', lineHeight: '100%' })), COLORS.TEXT.PRIMARY, COLORS.SHADOW.DEFAULT);
var templateObject_1$1n, templateObject_2$1d, templateObject_3$_, templateObject_4$Q, templateObject_5$F;

var CocoSelectOptionPageHeader = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, thumbnailURL = _a.thumbnailURL, texts = _a.texts, buttonText = _a.buttonText, onClick = _a.onClick, style = _a.style;
    return (React$1.createElement(Container$1c, { style: style },
        React$1.createElement(FlexContainer$3, null,
            React$1.createElement(ThumbnailImage, { src: thumbnailURL }),
            React$1.createElement(TitleAndSubTitleContainer, null,
                React$1.createElement(Title$m, null, title),
                React$1.createElement(SubTitle, null, subTitle))),
        React$1.createElement(TextsContainer$1, null, texts.map(function (text, index) {
            return (React$1.createElement(IconAndTextContainer, { key: index },
                React$1.createElement("div", null,
                    React$1.createElement("svg", { width: "12", height: "10", viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React$1.createElement("path", { d: "M4.57143 9.39558C4.21978 9.39558 3.86813 9.26371 3.56044 8.99997L0 5.43954L1.97802 3.46151L4.57143 6.05492L10.022 0.60437L12 2.58239L5.58242 8.99997C5.31868 9.26371 4.96703 9.39558 4.57143 9.39558Z", fill: "#5AC486" }))),
                React$1.createElement(Text$2, { key: index }, text)));
        })),
        React$1.createElement("div", null,
            React$1.createElement(Button$1, { onClick: onClick, "data-testid": 'select-option-page-header_button' },
                buttonText,
                " ",
                React$1.createElement(ArrowIcon, null)))));
};
var index$A = memo(CocoSelectOptionPageHeader);
var Container$1c = styled.div(templateObject_1$1m || (templateObject_1$1m = __makeTemplateObject(["\n  padding: 20px;\n  background-color: #e3f2fc;\n  color: ", ";\n"], ["\n  padding: 20px;\n  background-color: #e3f2fc;\n  color: ", ";\n"])), COLORS.TEXT.PRIMARY);
var ThumbnailImage = styled.img(templateObject_2$1c || (templateObject_2$1c = __makeTemplateObject(["\n  width: 50px;\n  height: 50px;\n"], ["\n  width: 50px;\n  height: 50px;\n"])));
var FlexContainer$3 = styled.div(templateObject_3$Z || (templateObject_3$Z = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var TitleAndSubTitleContainer = styled.div(templateObject_4$P || (templateObject_4$P = __makeTemplateObject(["\n  margin-left: 12px;\n"], ["\n  margin-left: 12px;\n"])));
var Title$m = styled.h1(templateObject_5$E || (templateObject_5$E = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1));
var SubTitle = styled.h2(templateObject_6$x || (templateObject_6$x = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.TEXT.NOTE_OR_CAPTION);
var TextsContainer$1 = styled.div(templateObject_7$o || (templateObject_7$o = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var IconAndTextContainer = styled.div(templateObject_8$l || (templateObject_8$l = __makeTemplateObject(["\n  margin-top: 5px;\n  display: flex;\n  align-items: baseline;\n"], ["\n  margin-top: 5px;\n  display: flex;\n  align-items: baseline;\n"])));
var Text$2 = styled.p(templateObject_9$h || (templateObject_9$h = __makeTemplateObject(["\n  margin-left: 5px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-left: 5px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_1), COLORS.TEXT.NO_IMPORTANT);
var Button$1 = styled.a(templateObject_10$f || (templateObject_10$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 0;\n  gap: 2px;\n  background-color: ", ";\n  border-radius: 6px;\n  width: 134px;\n  margin-top: 15px;\n  position: relative;\n  text-align: center;\n  color: ", ";\n  ", ";\n  cursor: pointer;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 0;\n  gap: 2px;\n  background-color: ", ";\n  border-radius: 6px;\n  width: 134px;\n  margin-top: 15px;\n  position: relative;\n  text-align: center;\n  color: ", ";\n  ", ";\n  cursor: pointer;\n"])), COLORS.BACKGROUND.SURFACE, COLORS.STATUS.SUCCESS_OR_POSITIVE, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '1.8' })));
var ArrowIcon = styled.div(templateObject_11$c || (templateObject_11$c = __makeTemplateObject(["\n  margin-left: 5.5px;\n  width: 7px;\n  height: 7px;\n  border-top: 2px solid ", ";\n  border-right: 2px solid ", ";\n  transform: rotate(45deg);\n  margin-top: -1.5px;\n"], ["\n  margin-left: 5.5px;\n  width: 7px;\n  height: 7px;\n  border-top: 2px solid ", ";\n  border-right: 2px solid ", ";\n  transform: rotate(45deg);\n  margin-top: -1.5px;\n"])), COLORS.STATUS.SUCCESS_OR_POSITIVE, COLORS.STATUS.SUCCESS_OR_POSITIVE);
var templateObject_1$1m, templateObject_2$1c, templateObject_3$Z, templateObject_4$P, templateObject_5$E, templateObject_6$x, templateObject_7$o, templateObject_8$l, templateObject_9$h, templateObject_10$f, templateObject_11$c;

var CocoLightBulbTitle = function (_a) {
    var imgixHost = _a.imgixHost, title = _a.title, style = _a.style;
    return (React$1.createElement(TitleSection$2, { style: style },
        React$1.createElement(LeftImageContainer, null,
            React$1.createElement(Image$d, { src: "".concat(addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/light-bulb.png")), "&width=").concat(43 * 3, "&height=").concat(44 * 3, "&fit=crop"), width: 43, height: 44 })),
        React$1.createElement(Title$l, null,
            title.title1,
            React$1.createElement("br", null),
            title.title2),
        React$1.createElement(RightImageContainer, null,
            React$1.createElement(Image$d, { src: "".concat(addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/light-bulb.png")), "&width=").concat(32 * 3, "&height=").concat(32 * 3, "&fit=crop"), width: 32, height: 32 }))));
};
var CocoLightBulbTitle$1 = memo(CocoLightBulbTitle);
var Title$l = styled.h3(templateObject_1$1l || (templateObject_1$1l = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 8px;\n  justify-content: space-around;\n  ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 8px;\n  justify-content: space-around;\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.HEADLINE_3), COLORS.INVERT_TEXT.PRIMARY);
var Image$d = styled.img(templateObject_2$1b || (templateObject_2$1b = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
var TitleSection$2 = styled.div(templateObject_3$Y || (templateObject_3$Y = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var LeftImageContainer = styled.div(templateObject_4$O || (templateObject_4$O = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  bottom: 8px;\n  object-fit: cover;\n"], ["\n  position: absolute;\n  left: 0;\n  bottom: 8px;\n  object-fit: cover;\n"])));
var RightImageContainer = styled.div(templateObject_5$D || (templateObject_5$D = __makeTemplateObject(["\n  position: absolute;\n  transform: rotate(90deg);\n  right: 0;\n  bottom: 14px;\n  object-fit: cover;\n"], ["\n  position: absolute;\n  transform: rotate(90deg);\n  right: 0;\n  bottom: 14px;\n  object-fit: cover;\n"])));
var templateObject_1$1l, templateObject_2$1b, templateObject_3$Y, templateObject_4$O, templateObject_5$D;

var CocoAccordion = function (_a) {
    var items = _a.items, idSuffix = _a.idSuffix, arrowImageUrl = _a.arrowImageUrl, containerStyle = _a.containerStyle, tabsStyle = _a.tabsStyle;
    return (React$1.createElement(Container$1b, { style: containerStyle },
        React$1.createElement(Tabs, { style: tabsStyle }, items.map(function (item, index) { return (React$1.createElement(Tab$1, { key: index },
            React$1.createElement(Input$2, { type: "checkbox", id: "check-".concat(item.title, "-").concat(idSuffix) }),
            React$1.createElement(Title$k, { htmlFor: "check-".concat(item.title, "-").concat(idSuffix), className: "tab-title", arrowImageUrl: arrowImageUrl },
                typeof item.iconElement !== 'undefined' && (React$1.createElement(IconContainer$2, null, item.iconElement)),
                React$1.createElement(TextContainer$1, null,
                    React$1.createElement(TitleText, null, item.title),
                    typeof item.label !== 'undefined' && (React$1.createElement(Label$6, null, item.label)))),
            React$1.createElement(Content$7, { className: "tab-content" },
                React$1.createElement(Description$a, { dangerouslySetInnerHTML: {
                        __html: striptags(item.description, [
                            'p',
                            'strong',
                            'br',
                            'b',
                            'a',
                        ]),
                    } }),
                typeof item.button !== 'undefined' && (React$1.createElement("a", { href: item.button.linkURL, target: '_blank', style: { textDecoration: 'none' }, rel: "noreferrer" },
                    React$1.createElement(CocoWhiteButton, { containerType: 'div', showRightGrayArrow: true, disableHover: true, style: { marginTop: '10px', marginBottom: '3px' } }, item.button.text)))))); }))));
};
var CocoAccordion$1 = memo(CocoAccordion);
var Container$1b = styled.div(templateObject_1$1k || (templateObject_1$1k = __makeTemplateObject([""], [""])));
var Tabs = styled.div(templateObject_2$1a || (templateObject_2$1a = __makeTemplateObject(["\n  border-radius: 6px;\n  border: 2px solid #e8e7e8;\n"], ["\n  border-radius: 6px;\n  border: 2px solid #e8e7e8;\n"])));
var Tab$1 = styled.div(templateObject_3$X || (templateObject_3$X = __makeTemplateObject(["\n  width: 100%;\n  border-bottom: 2px solid ", ";\n  color: ", ";\n  box-sizing: border-box;\n  &:last-child {\n    border-bottom: none;\n  }\n"], ["\n  width: 100%;\n  border-bottom: 2px solid ", ";\n  color: ", ";\n  box-sizing: border-box;\n  &:last-child {\n    border-bottom: none;\n  }\n"])), COLORS.BACKGROUND.BASE, COLORS.TEXT.PRIMARY);
var Title$k = styled.label(templateObject_4$N || (templateObject_4$N = __makeTemplateObject(["\n  padding: 12px 15px 10px;\n  display: flex;\n  cursor: pointer;\n  ", "\n  position: relative;\n  align-items: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  &:after {\n    content: '';\n    display: block;\n    width: 1em;\n    height: 1em;\n    position: absolute;\n    right: 15px;\n    background: ", " no-repeat;\n    text-align: center;\n    transform-origin: 50% 30%;\n    transition: all 0.2s;\n    margin-top: 6px;\n  }\n"], ["\n  padding: 12px 15px 10px;\n  display: flex;\n  cursor: pointer;\n  ", "\n  position: relative;\n  align-items: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  &:after {\n    content: '';\n    display: block;\n    width: 1em;\n    height: 1em;\n    position: absolute;\n    right: 15px;\n    background: ", " no-repeat;\n    text-align: center;\n    transform-origin: 50% 30%;\n    transition: all 0.2s;\n    margin-top: 6px;\n  }\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), function (props) { return "url(".concat(props.arrowImageUrl, ")"); });
var Content$7 = styled.div(templateObject_5$C || (templateObject_5$C = __makeTemplateObject(["\n  height: 0;\n  opacity: 0;\n  padding: 0 15px 0;\n  overflow: hidden;\n  overflow-wrap: break-word;\n  background: ", ";\n  transition: all 0.2s;\n  ", "\n  color: ", ";\n  border-radius: 6px;\n  a:link {\n    color: ", ";\n  }\n  a:visited {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n"], ["\n  height: 0;\n  opacity: 0;\n  padding: 0 15px 0;\n  overflow: hidden;\n  overflow-wrap: break-word;\n  background: ", ";\n  transition: all 0.2s;\n  ", "\n  color: ", ";\n  border-radius: 6px;\n  a:link {\n    color: ", ";\n  }\n  a:visited {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n"])), COLORS.BACKGROUND.SURFACE, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_3), { lineHeight: '160%' })), COLORS.TEXT.NO_IMPORTANT, COLORS.STATUS.SUCCESS_OR_POSITIVE, COLORS.STATUS.SUCCESS_OR_POSITIVE, COLORS.STATUS.SUCCESS_OR_POSITIVE, COLORS.STATUS.SUCCESS_OR_POSITIVE);
var Description$a = styled.div(templateObject_6$w || (templateObject_6$w = __makeTemplateObject([""], [""])));
var Input$2 = styled.input(templateObject_7$n || (templateObject_7$n = __makeTemplateObject(["\n  display: none;\n  &:checked + .tab-title {\n    &:after {\n      transform: rotate(180deg);\n    }\n  }\n  &:checked + .tab-title + .tab-content {\n    padding: 0 15px 10px;\n    height: auto;\n    opacity: 1;\n  }\n"], ["\n  display: none;\n  &:checked + .tab-title {\n    &:after {\n      transform: rotate(180deg);\n    }\n  }\n  &:checked + .tab-title + .tab-content {\n    padding: 0 15px 10px;\n    height: auto;\n    opacity: 1;\n  }\n"])));
var IconContainer$2 = styled.div(templateObject_8$k || (templateObject_8$k = __makeTemplateObject(["\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n"], ["\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n"])));
var TextContainer$1 = styled.div(templateObject_9$g || (templateObject_9$g = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-right: 25px;\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-right: 25px;\n"])));
var TitleText = styled.p(templateObject_10$e || (templateObject_10$e = __makeTemplateObject(["\n  margin: 0;\n  ", "\n  color: ", ";\n"], ["\n  margin: 0;\n  ", "\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_3), COLORS.TEXT.PRIMARY);
var Label$6 = styled.div(templateObject_11$b || (templateObject_11$b = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
var templateObject_1$1k, templateObject_2$1a, templateObject_3$X, templateObject_4$N, templateObject_5$C, templateObject_6$w, templateObject_7$n, templateObject_8$k, templateObject_9$g, templateObject_10$e, templateObject_11$b;

var CocoInputRadio = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, checked = _a.checked, defaultChecked = _a.defaultChecked, inputRef = _a.inputRef, onChange = _a.onChange, children = _a.children, labelStyle = _a.labelStyle, _b = _a.buttonSize, buttonSize = _b === void 0 ? 20 : _b, dataTestId = _a.dataTestId, style = _a.style;
    return (React$1.createElement(Container$1a, { style: style },
        React$1.createElement("input", { id: id, type: "radio", name: name, value: value, checked: checked, defaultChecked: defaultChecked, ref: inputRef, onChange: function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange(event.currentTarget.value); }, autoComplete: 'off', "data-test-id": dataTestId }),
        React$1.createElement(Label$5, { className: "input-radio", htmlFor: id, buttonSize: buttonSize, style: labelStyle }, children)));
};
var CocoInputRadio$1 = memo(CocoInputRadio);
var Container$1a = styled.div(templateObject_1$1j || (templateObject_1$1j = __makeTemplateObject(["\n  input[type='radio'] {\n    display: none;\n  }\n  input[type='radio']:checked {\n    + .input-radio:after {\n      border: 2px solid ", ";\n    }\n    + .input-radio:before {\n      display: block;\n    }\n  }\n"], ["\n  input[type='radio'] {\n    display: none;\n  }\n  input[type='radio']:checked {\n    + .input-radio:after {\n      border: 2px solid ", ";\n    }\n    + .input-radio:before {\n      display: block;\n    }\n  }\n"])), COLORS.GENERAL.PRIMARY);
var Label$5 = styled.label(templateObject_2$19 || (templateObject_2$19 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  margin: 0 20px 0 0;\n  padding-left: 24px;\n  ", "\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: ", "px;\n    height: ", "px;\n    border: 2px solid ", ";\n    border-radius: 10px;\n    background: ", ";\n  }\n  &:before {\n    content: '';\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    left: 4px;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 6px;\n    background-color: ", ";\n    z-index: 1;\n  }\n"], ["\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  margin: 0 20px 0 0;\n  padding-left: 24px;\n  ", "\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: ", "px;\n    height: ", "px;\n    border: 2px solid ", ";\n    border-radius: 10px;\n    background: ", ";\n  }\n  &:before {\n    content: '';\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    left: 4px;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 6px;\n    background-color: ", ";\n    z-index: 1;\n  }\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_2), function (props) { return props.buttonSize; }, function (props) { return props.buttonSize; }, COLORS.SHADOW.DEFAULT, COLORS.BACKGROUND.SURFACE, function (props) { return Number(props.buttonSize) - 8; }, function (props) { return Number(props.buttonSize) - 8; }, COLORS.GENERAL.PRIMARY);
var templateObject_1$1j, templateObject_2$19;

/**
 * 子要素をratioで指定した比率の高さで表示する
 */
var CocoAspectRatio = function (_a) {
    var ratio = _a.ratio, children = _a.children, style = _a.style;
    return (React$1.createElement(Container$19, { style: style },
        React$1.createElement(AspectRatioOuter, { style: {
                paddingTop: "calc(100% * ".concat(ratio, ")"),
            } },
            React$1.createElement(AspectRatioInner, null, children))));
};
var CocoAspectRatio$1 = memo(CocoAspectRatio);
var Container$19 = styled.div(templateObject_1$1i || (templateObject_1$1i = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var AspectRatioOuter = styled.div(templateObject_2$18 || (templateObject_2$18 = __makeTemplateObject(["\n  content: '';\n  display: block;\n"], ["\n  content: '';\n  display: block;\n"])));
var AspectRatioInner = styled.div(templateObject_3$W || (templateObject_3$W = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  > * {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  > * {\n    width: 100%;\n    height: 100%;\n  }\n"])));
var templateObject_1$1i, templateObject_2$18, templateObject_3$W;

var CocoReservationStayPeriod = function (_a) {
    var checkInDate = _a.checkInDate, checkInTimeRange = _a.checkInTimeRange, checkOutDate = _a.checkOutDate, checkOutTime = _a.checkOutTime, style = _a.style;
    return (React$1.createElement(Container$18, { style: style },
        React$1.createElement(Content$6, null,
            React$1.createElement(Heading, null, "\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3"),
            typeof checkInDate !== 'undefined' && React$1.createElement(Date$2, null, checkInDate),
            React$1.createElement(TimeRange, null, checkInTimeRange)),
        React$1.createElement(Bar, null),
        React$1.createElement(Content$6, null,
            React$1.createElement(Heading, null, "\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8"),
            typeof checkOutDate !== 'undefined' && React$1.createElement(Date$2, null, checkOutDate),
            React$1.createElement(TimeRange, null, checkOutTime))));
};
var ReservationStayPeriod = memo(CocoReservationStayPeriod);
var Container$18 = styled.div(templateObject_1$1h || (templateObject_1$1h = __makeTemplateObject(["\n  padding: 7px 15px;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n"], ["\n  padding: 7px 15px;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n"])), COLORS.BORDER.SECONDARY);
var Heading = styled.p(templateObject_2$17 || (templateObject_2$17 = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.NO_IMPORTANT, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { lineHeight: '140%', letterSpacing: '0.04em' })));
var Date$2 = styled.p(templateObject_3$V || (templateObject_3$V = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_5), { lineHeight: '140%', letterSpacing: '0.04em' })));
var TimeRange = styled.p(templateObject_4$M || (templateObject_4$M = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.NO_IMPORTANT, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_7), { lineHeight: '140%', letterSpacing: '0.1em' })));
var Bar = styled.div(templateObject_5$B || (templateObject_5$B = __makeTemplateObject(["\n  width: 1px;\n  height: 40px;\n  background-color: ", ";\n  margin-left: 10px;\n  margin-right: 15px;\n"], ["\n  width: 1px;\n  height: 40px;\n  background-color: ", ";\n  margin-left: 10px;\n  margin-right: 15px;\n"])), COLORS.BORDER.SECONDARY);
var Content$6 = styled.div(templateObject_6$v || (templateObject_6$v = __makeTemplateObject(["\n  width: 50%;\n"], ["\n  width: 50%;\n"])));
var templateObject_1$1h, templateObject_2$17, templateObject_3$V, templateObject_4$M, templateObject_5$B, templateObject_6$v;

var CocoTrifaLink = function (_a) {
    var imgixHost = _a.imgixHost, isGrayBackground = _a.isGrayBackground, style = _a.style;
    return (React$1.createElement(Container$17, { style: style, isGray: isGrayBackground, href: 'https://www.trifa.jp', target: '_blank' },
        React$1.createElement("img", { width: '40px', height: '40px', src: addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/esim/trifa.png")), loading: 'lazy' }),
        React$1.createElement(TextsContainer, null,
            React$1.createElement(AppName, null, "\u30C8\u30EA\u30D5\u30A1 - \u6D77\u5916\u65C5\u884C\u306B\u6700\u9069\u306AeSIM\u306A\u3089trifa"),
            React$1.createElement(CompanyName, null, "trifa Inc."))));
};
var CocoTrifaLink$1 = memo(CocoTrifaLink);
var Container$17 = styled.a(templateObject_1$1g || (templateObject_1$1g = __makeTemplateObject(["\n  padding: 8px 10px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  border: ", ";\n  border-radius: 4px;\n  cursor: pointer;\n  text-decoration: none;\n"], ["\n  padding: 8px 10px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  border: ", ";\n  border-radius: 4px;\n  cursor: pointer;\n  text-decoration: none;\n"])), function (props) {
    return props.isGray
        ? "".concat(COLORS.BACKGROUND.BASE)
        : "".concat(COLORS.BACKGROUND.SURFACE);
}, function (props) {
    return props.isGray ? "1px solid ".concat(COLORS.BORDER.PRIMARY) : 'unset';
});
var TextsContainer = styled.div(templateObject_2$16 || (templateObject_2$16 = __makeTemplateObject(["\n  margin-left: 8px;\n"], ["\n  margin-left: 8px;\n"])));
var AppName = styled.p(templateObject_3$U || (templateObject_3$U = __makeTemplateObject(["\n  ", "\n  color: ", ";\n"], ["\n  ", "\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.TEXT.PRIMARY);
var CompanyName = styled.p(templateObject_4$L || (templateObject_4$L = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var templateObject_1$1g, templateObject_2$16, templateObject_3$U, templateObject_4$L;

var CocoNote = function (_a) {
    var children = _a.children, _b = _a.danger, danger = _b === void 0 ? false : _b, style = _a.style;
    return (React$1.createElement(Note$2, { style: style, danger: danger }, children));
};
var Note$1 = memo(CocoNote);
var Note$2 = styled.div(templateObject_1$1f || (templateObject_1$1f = __makeTemplateObject(["\n  color: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n  ", ";\n  padding: 10px;\n  border-radius: 6px;\n"], ["\n  color: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n  ", ";\n  padding: 10px;\n  border-radius: 6px;\n"])), function (props) { return (props.danger ? COLORS.GENERAL.PRIMARY : '#1479CA'); }, function (props) { return (props.danger ? '#FFEBEF' : '#E3F2FC'); }, function (props) { return (props.danger ? COLORS.GENERAL.PRIMARY : '#67B7EF'); }, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_2), { letterSpacing: '0.1em' })));
var templateObject_1$1f;

var CocoActivityCardList = function (_a) {
    var activities = _a.activities, style = _a.style;
    return (React$1.createElement(Container$16, { style: style }, activities.map(function (activity, index) { return (React$1.createElement(InnerContainer$4, { key: index }, typeof activity.linkUrl !== 'undefined' ? (React$1.createElement(Link$6, { href: activity.linkUrl, target: '_blank', style: { textDecoration: 'none' }, rel: "noreferrer" },
        React$1.createElement(Image$c, { src: activity.imageUrl }),
        React$1.createElement(Content$5, null,
            React$1.createElement(Title$j, null, activity.title),
            React$1.createElement(Description$9, null, activity.description)))) : (React$1.createElement(React$1.Fragment, null,
        React$1.createElement(Image$c, { src: activity.imageUrl }),
        React$1.createElement(Content$5, null,
            React$1.createElement(Title$j, null, activity.title),
            React$1.createElement(Description$9, null, activity.description)))))); })));
};
var index$z = memo(CocoActivityCardList);
var Container$16 = styled.div(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject(["\n  display: flex;\n  overflow-x: auto;\n"], ["\n  display: flex;\n  overflow-x: auto;\n"])));
var InnerContainer$4 = styled.div(templateObject_2$15 || (templateObject_2$15 = __makeTemplateObject(["\n  width: 200px;\n  min-width: 200px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  background: ", ";\n\n  & + & {\n    margin-left: 10px;\n  }\n"], ["\n  width: 200px;\n  min-width: 200px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n  border-radius: 4px;\n  border: 1px solid ", ";\n  background: ", ";\n\n  & + & {\n    margin-left: 10px;\n  }\n"])), COLORS.BORDER.SECONDARY, COLORS.BACKGROUND.SURFACE);
var Link$6 = styled.a(templateObject_3$T || (templateObject_3$T = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var Image$c = styled.img(templateObject_4$K || (templateObject_4$K = __makeTemplateObject(["\n  object-fit: cover;\n  width: 100%;\n  height: 112px;\n"], ["\n  object-fit: cover;\n  width: 100%;\n  height: 112px;\n"])));
var Content$5 = styled.div(templateObject_5$A || (templateObject_5$A = __makeTemplateObject(["\n  padding: 8px 10px 10px 10px;\n"], ["\n  padding: 8px 10px 10px 10px;\n"])));
var Title$j = styled.div(templateObject_6$u || (templateObject_6$u = __makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ", ";\n  ", ";\n"], ["\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '150%', letterSpacing: '0.78px' })));
var Description$9 = styled.div(templateObject_7$m || (templateObject_7$m = __makeTemplateObject(["\n  margin-top: 4px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ", ";\n  ", ";\n"], ["\n  margin-top: 4px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.NO_IMPORTANT, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_1), { lineHeight: '150%', letterSpacing: '0.36px' })));
var templateObject_1$1e, templateObject_2$15, templateObject_3$T, templateObject_4$K, templateObject_5$A, templateObject_6$u, templateObject_7$m;

var CocoLoadingMessage = function (_a) {
    var children = _a.children, isFadeOut = _a.isFadeOut, style = _a.style;
    return (React$1.createElement(Container$15, { style: style, className: isFadeOut ? 'fade-out' : undefined }, children));
};
var index$y = memo(CocoLoadingMessage);
var Container$15 = styled.div(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject(["\n  padding: 12px 24px;\n  background-color: #f2ca4d;\n  text-align: center;\n  ", ";\n\n  @keyframes fade-out-animation {\n    0% {\n      display: block;\n      opacity: 1;\n    }\n    40% {\n      display: block;\n      opacity: 0.5;\n      height: 30px;\n    }\n    100% {\n      display: none;\n      height: 0;\n      opacity: 0;\n    }\n  }\n  &.fade-out {\n    animation: fade-out-animation 0.5s ease-in forwards;\n    padding: 0;\n    display: none;\n  }\n"], ["\n  padding: 12px 24px;\n  background-color: #f2ca4d;\n  text-align: center;\n  ", ";\n\n  @keyframes fade-out-animation {\n    0% {\n      display: block;\n      opacity: 1;\n    }\n    40% {\n      display: block;\n      opacity: 0.5;\n      height: 30px;\n    }\n    100% {\n      display: none;\n      height: 0;\n      opacity: 0;\n    }\n  }\n  &.fade-out {\n    animation: fade-out-animation 0.5s ease-in forwards;\n    padding: 0;\n    display: none;\n  }\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1));
var templateObject_1$1d;

var CocoDiscountLabel = function (_a) {
    var label = _a.label, priceValue = _a.priceValue, labelColor = _a.labelColor, backgroundColor = _a.backgroundColor, style = _a.style;
    return (React$1.createElement(Container$14, { style: style, backgroundColor: backgroundColor },
        React$1.createElement(SaleTitle$1, { color: labelColor }, label),
        " ",
        priceValue));
};
var CocoDiscountLabel$1 = memo(CocoDiscountLabel);
var Container$14 = styled.div(templateObject_1$1c || (templateObject_1$1c = __makeTemplateObject(["\n  width: max-content;\n  padding: 1px 4px;\n  background-color: ", ";\n  border-radius: 2px;\n  ", ";\n  color: ", ";\n"], ["\n  width: max-content;\n  padding: 1px 4px;\n  background-color: ", ";\n  border-radius: 2px;\n  ", ";\n  color: ", ";\n"])), function (props) {
    return typeof props.backgroundColor !== 'undefined'
        ? props.backgroundColor
        : COLORS.GENERAL.SECONDARY;
}, createFontStyle(MOBILE_FONT_STYLES.CAPTION_BOLD_1), COLORS.INVERT_TEXT.PRIMARY);
var SaleTitle$1 = styled.span(templateObject_2$14 || (templateObject_2$14 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) {
    return typeof props.color !== 'undefined'
        ? props.color
        : COLORS.TEXT.INVERSE_PRIMARY;
});
var templateObject_1$1c, templateObject_2$14;

var dayjs_min = {exports: {}};

var hasRequiredDayjs_min;

function requireDayjs_min () {
	if (hasRequiredDayjs_min) return dayjs_min.exports;
	hasRequiredDayjs_min = 1;
	(function (module, exports) {
		!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));
} (dayjs_min));
	return dayjs_min.exports;
}

var dayjs_minExports = requireDayjs_min();

var dist = {exports: {}};

(function (module, exports) {
	!function(e,t){module.exports=t(React$1);}("undefined"!=typeof self?self:commonjsGlobal,(e=>(()=>{var t={156:t=>{t.exports=e;}},r={};function o(e){var n=r[e];if(void 0!==n)return n.exports;var s=r[e]={exports:{}};return t[e](s,s.exports,o),s.exports}o.d=(e,t)=>{for(var r in t)o.o(t,r)&&!o.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]});},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});};var n={};return (()=>{o.r(n),o.d(n,{default:()=>l,useStopwatch:()=>u,useTime:()=>m,useTimer:()=>c});var e=o(156);class t{static expiryTimestamp(e){const t=new Date(e).getTime()>0;return t||console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings",e),t}static onExpire(e){const t=e&&"function"==typeof e;return e&&!t&&console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function",e),t}}class r{static getTimeFromSeconds(e){const t=Math.ceil(e),r=Math.floor(t/86400),o=Math.floor(t%86400/3600),n=Math.floor(t%3600/60);return {totalSeconds:t,seconds:Math.floor(t%60),minutes:n,hours:o,days:r}}static getSecondsFromExpiry(e,t){const r=e-(new Date).getTime();if(r>0){const e=r/1e3;return t?Math.round(e):e}return 0}static getSecondsFromPrevTime(e,t){const r=(new Date).getTime()-e;if(r>0){const e=r/1e3;return t?Math.round(e):e}return 0}static getSecondsFromTimeNow(){const e=new Date;return e.getTime()/1e3-60*e.getTimezoneOffset()}static getFormattedTimeFromSeconds(e,t){const{seconds:o,minutes:n,hours:s}=r.getTimeFromSeconds(e);let i="",a=s;return "12-hour"===t&&(i=s>=12?"pm":"am",a=s%12),{seconds:o,minutes:n,hours:a,ampm:i}}}function s(t,r){const o=(0, e.useRef)();(0, e.useEffect)((()=>{o.current=t;})),(0, e.useEffect)((()=>{if(!r)return ()=>{};const e=setInterval((()=>{o.current&&o.current();}),r);return ()=>clearInterval(e)}),[r]);}const i=1e3;function a(e){if(!t.expiryTimestamp(e))return null;const o=r.getSecondsFromExpiry(e),n=Math.floor(1e3*(o-Math.floor(o)));return n>0?n:i}function c(){let{expiryTimestamp:o,onExpire:n,autoStart:c=!0}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[u,m]=(0, e.useState)(o),[l,d]=(0, e.useState)(r.getSecondsFromExpiry(u)),[p,f]=(0, e.useState)(c),[g,S]=(0, e.useState)(c),[T,y]=(0, e.useState)(a(u)),h=(0, e.useCallback)((()=>{t.onExpire(n)&&n(),f(!1),y(null);}),[n]),x=(0, e.useCallback)((()=>{f(!1);}),[]),v=(0, e.useCallback)((function(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];y(a(e)),S(t),f(t),m(e),d(r.getSecondsFromExpiry(e));}),[]),F=(0, e.useCallback)((()=>{const e=new Date;e.setMilliseconds(e.getMilliseconds()+1e3*l),v(e);}),[l,v]),b=(0, e.useCallback)((()=>{g?(d(r.getSecondsFromExpiry(u)),f(!0)):F();}),[u,g,F]);return s((()=>{T!==i&&y(i);const e=r.getSecondsFromExpiry(u);d(e),e<=0&&h();}),p?T:null),{...r.getTimeFromSeconds(l),start:b,pause:x,resume:F,restart:v,isRunning:p}}function u(){let{autoStart:t,offsetTimestamp:o}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[n,i]=(0, e.useState)(r.getSecondsFromExpiry(o,!0)||0),[a,c]=(0, e.useState)(new Date),[u,m]=(0, e.useState)(n+r.getSecondsFromPrevTime(a||0,!0)),[l,d]=(0, e.useState)(t);s((()=>{m(n+r.getSecondsFromPrevTime(a,!0));}),l?1e3:null);const p=(0, e.useCallback)((()=>{const e=new Date;c(e),d(!0),m(n+r.getSecondsFromPrevTime(e,!0));}),[n]),f=(0, e.useCallback)((()=>{i(u),d(!1);}),[u]),g=(0, e.useCallback)((function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];const o=r.getSecondsFromExpiry(e,!0)||0,n=new Date;c(n),i(o),d(t),m(o+r.getSecondsFromPrevTime(n,!0));}),[]);return {...r.getTimeFromSeconds(u),start:p,pause:f,reset:g,isRunning:l}}function m(){let{format:t}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[o,n]=(0, e.useState)(r.getSecondsFromTimeNow());return s((()=>{n(r.getSecondsFromTimeNow());}),1e3),{...r.getFormattedTimeFromSeconds(o,t)}}function l(t){if((0, e.useEffect)((()=>{console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");}),[]),t.expiryTimestamp){const e=c(t);return {...e,startTimer:e.start,stopTimer:e.pause,resetTimer:()=>{}}}const r=u(t);return {...r,startTimer:r.start,stopTimer:r.pause,resetTimer:r.reset}}})(),n})()));
} (dist));

var CocoLimitedTimeSaleBanner = function (_a) {
    var label = _a.label, labelColor = _a.labelColor, backgroundColor = _a.backgroundColor, endTime = _a.endTime, style = _a.style;
    var _b = dist.exports.useTimer({
        expiryTimestamp: dayjs_minExports(endTime).toDate(),
    }), days = _b.days, hours = _b.hours, minutes = _b.minutes, seconds = _b.seconds;
    return (React$1.createElement(Container$13, { style: style, backgroundColor: backgroundColor },
        React$1.createElement(SaleTitleContainer, null,
            React$1.createElement(SaleTitle, { color: labelColor }, label),
            " \u958B\u50AC\u4E2D\uFF01"),
        React$1.createElement(TimerContainer, null,
            React$1.createElement(TimerText, null, "\u7D42\u4E86\u307E\u3067"),
            React$1.createElement(Time$3, null, days),
            React$1.createElement(TimerText, null, "\u65E5"),
            React$1.createElement(Time$3, null, hours),
            React$1.createElement(TimerText, null, ":"),
            React$1.createElement(Time$3, null, minutes),
            React$1.createElement(TimerText, null, ":"),
            React$1.createElement(Time$3, null, seconds))));
};
var index$x = memo(CocoLimitedTimeSaleBanner);
var Container$13 = styled.div(templateObject_1$1b || (templateObject_1$1b = __makeTemplateObject(["\n  padding: 5px 20px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  padding: 5px 20px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), function (props) { return props.backgroundColor; });
var SaleTitleContainer = styled.div(templateObject_2$13 || (templateObject_2$13 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_1), { lineHeight: 1.8 })), COLORS.INVERT_TEXT.PRIMARY);
var SaleTitle = styled.span(templateObject_3$S || (templateObject_3$S = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.color; });
var TimerContainer = styled.div(templateObject_4$J || (templateObject_4$J = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var TimerText = styled.p(templateObject_5$z || (templateObject_5$z = __makeTemplateObject(["\n  margin-left: 1px;\n  margin-right: 1px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-left: 1px;\n  margin-right: 1px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.INVERT_TEXT.PRIMARY);
var Time$3 = styled.div(templateObject_6$t || (templateObject_6$t = __makeTemplateObject(["\n  width: 18px;\n  height: 18px;\n  border-radius: 2px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"], ["\n  width: 18px;\n  height: 18px;\n  border-radius: 2px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"])), COLORS.BACKGROUND.SURFACE, createFontStyle(MOBILE_FONT_STYLES.CAPTION_BOLD_1));
var templateObject_1$1b, templateObject_2$13, templateObject_3$S, templateObject_4$J, templateObject_5$z, templateObject_6$t;

var img$8 = "data:image/svg+xml,%3csvg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m4.66675 8.66659c1.10666 0 2-.89334 2-2 0-1.10667-.89334-2-2-2-1.10667 0-2 .89333-2 2 0 1.10666.89333 2 2 2zm7.99995-4h-5.33329v4.66666h-5.33333v-6h-1.333332v10.00005h1.333332v-2h12.00002v2h1.3333v-6.00005c0-1.47333-1.1933-2.66666-2.6667-2.66666z' fill='black' fill-opacity='.87'/%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m8 1.33325c.73333 0 1.33333.6 1.33333 1.33334 0 .73333-.6 1.33333-1.33333 1.33333s-1.33333-.6-1.33333-1.33333c0-.73334.6-1.33334 1.33333-1.33334zm6 4.66667h-4v8.66668h-1.33333v-4h-1.33334v4h-1.33333v-8.66668h-4v-1.33333h12z' fill='black'/%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3e %3cpath d='M5.39999 8.8933L7.28666 7.00664L2.60666 2.3333C1.56666 3.3733 1.56666 5.05997 2.60666 6.10664L5.39999 8.8933ZM9.91999 7.68664C10.94 8.15997 12.3733 7.82664 13.4333 6.76664C14.7067 5.4933 14.9533 3.66664 13.9733 2.68664C13 1.7133 11.1733 1.95331 9.89333 3.22664C8.83333 4.28664 8.49999 5.71997 8.97333 6.73997L2.46666 13.2466L3.40666 14.1866L7.99999 9.60664L12.5867 14.1933L13.5267 13.2533L8.93999 8.66664L9.91999 7.68664Z' fill='black' fill-opacity='0.87'/%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m1.3335 4.00016 4.66 4.66667h-4.66v1.99997h6.66l4.6667 4.6667.84-.8333-11.33337-11.33337zm12.3333 4.66667h1v1.99997h-1zm-1.6666 0h1v1.99997h-1zm.5666-5.41333c.4134-.40667.6667-.96667.6667-1.58667h-1c0 .68-.5533 1.23333-1.2333 1.23333v1c1.4933 0 2.6666 1.22 2.6666 2.71334v1.38666h1v-1.38666c0-1.48667-.8533-2.76667-2.1-3.36zm-2.89997 2.54666h1.01997c.7 0 1.3134.49334 1.3134 1.36667v.83333h1v-1.06c0-1.2-1.0667-2.10666-2.3134-2.10666h-1.01997c-.68 0-1.23333-.65334-1.23333-1.33334s.55333-1.16666 1.23333-1.16666v-1c-1.23333 0-2.23333 1-2.23333 2.23333s1 2.23333 2.23333 2.23333zm1.66667 4.82004v-1.95337h-1.95334z' fill='black' fill-opacity='.87'/%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M11 8C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8Z' fill='black' fill-opacity='0.87'/%3e%3cpath d='M5 8C5.55228 8 6 7.55228 6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8Z' fill='black' fill-opacity='0.87'/%3e%3cpath d='M7.99325 1.3335C4.31325 1.3335 1.33325 4.32016 1.33325 8.00016C1.33325 11.6802 4.31325 14.6668 7.99325 14.6668C11.6799 14.6668 14.6666 11.6802 14.6666 8.00016C14.6666 4.32016 11.6799 1.3335 7.99325 1.3335ZM7.99992 13.3335C5.05325 13.3335 2.66659 10.9468 2.66659 8.00016C2.66659 5.0535 5.05325 2.66683 7.99992 2.66683C10.9466 2.66683 13.3333 5.0535 13.3333 8.00016C13.3333 10.9468 10.9466 13.3335 7.99992 13.3335Z' fill='black' fill-opacity='0.87'/%3e%3cpath d='M6 9.3335H10V9.3335C10 10.4381 9.10457 11.3335 8 11.3335V11.3335C6.89543 11.3335 6 10.4381 6 9.3335V9.3335Z' fill='black' fill-opacity='0.87'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1 9L3 11C7.97 6.03 16.03 6.03 21 11L23 9C16.93 2.93 7.08 2.93 1 9ZM9 17L12 20L15 17C13.35 15.34 10.66 15.34 9 17ZM5 13L7 15C9.76 12.24 14.24 12.24 17 15L19 13C15.14 9.14 8.87 9.14 5 13Z' fill='black' fill-opacity='0.87'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M7.33333 6H8.66667V7.33333H7.33333V6ZM6 7.33333H7.33333V8.66667H6V7.33333ZM8.66667 7.33333H10V8.66667H8.66667V7.33333ZM10 6H11.3333V7.33333H10V6ZM4.66667 6H6V7.33333H4.66667V6ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2ZM6 12H4.66667V10.6667H6V12ZM8.66667 12H7.33333V10.6667H8.66667V12ZM11.3333 12H10V10.6667H11.3333V12ZM12.6667 7.33333H11.3333V8.66667H12.6667V10H11.3333V8.66667H10V10H8.66667V8.66667H7.33333V10H6V8.66667H4.66667V10H3.33333V8.66667H4.66667V7.33333H3.33333V3.33333H12.6667V7.33333Z' fill='black' fill-opacity='0.87'/%3e%3c/svg%3e";

var AMENITY_TYPE = {
    BED: 'BED',
    PEOPLES: 'PEOPLES',
    VIEW: 'VIEW',
    NO_SMOKING: 'NO_SMOKING',
    JAPANESE: 'JAPANESE',
    FREE_WIFI: 'FREE_WIFI',
    MEAL: 'MEAL',
};
var Icon$1 = function (_a) {
    var amenityType = _a.amenityType, iconSizePx = _a.iconSizePx;
    return React$1.createElement(StyledIcon, { src: iconSrc(amenityType), size: iconSizePx !== null && iconSizePx !== void 0 ? iconSizePx : 16 });
};
var Icon$2 = memo(Icon$1);
var iconSrc = function (iconType) {
    switch (iconType) {
        case 'BED':
            return img$8;
        case 'PEOPLES':
            return img$7;
        case 'VIEW':
            return img$2;
        case 'NO_SMOKING':
            return img$5;
        case 'FREE_WIFI':
            return img$3;
        case 'JAPANESE':
            return img$4;
        case 'MEAL':
            return img$6;
        default:
            return '';
    }
};
var StyledIcon = styled.img(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n"], ["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n"])), function (props) { return props.size; }, function (props) { return props.size; });
var templateObject_1$1a;

var useLocalState$h = function (amenity, label) {
    var tagLabel = useMemo(function () {
        if (typeof label !== 'undefined')
            return label;
        switch (amenity) {
            case 'JAPANESE':
                return '日本語対応可';
            case 'BED':
                return 'ツイン';
            case 'NO_SMOKING':
                return '禁煙';
            case 'PEOPLES':
                return '定員 2 名 (うち子供は 1 名まで)';
            case 'VIEW':
                return 'オーシャンビュー';
            case 'FREE_WIFI':
                return 'WiFi無料';
            case 'MEAL':
                return '食事なし';
        }
    }, [amenity, label]);
    return {
        tagLabel: tagLabel,
    };
};

var CocoAmenityTag = function (_a) {
    var amenityType = _a.amenityType, label = _a.label, style = _a.style;
    var tagLabel = useLocalState$h(amenityType, label).tagLabel;
    return (React$1.createElement(Container$12, { style: style },
        React$1.createElement(Icon$2, { amenityType: amenityType }),
        React$1.createElement(Label$4, null, tagLabel)));
};
var CocoAmenityTag$1 = memo(CocoAmenityTag);
var Container$12 = styled.div(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject(["\n  background: #f8f7f0;\n  border-radius: 4px;\n  padding: 5px 7px;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n"], ["\n  background: #f8f7f0;\n  border-radius: 4px;\n  padding: 5px 7px;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n"])));
var Label$4 = styled.span(templateObject_2$12 || (templateObject_2$12 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  margin-left: 4px;\n"], ["\n  color: ", ";\n  ", "\n  margin-left: 4px;\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1), { lineHeight: '0.1em' })));
var templateObject_1$19, templateObject_2$12;

var CocoFAQItem = function (_a) {
    var id = _a.id, label = _a.label, answer = _a.answer, style = _a.style;
    return (React$1.createElement(Container$11, { itemScope: true, itemProp: "mainEntity", itemType: "https://schema.org/Question", style: style },
        React$1.createElement(FAQInput, { id: id, className: "faq-check", type: "checkbox" }),
        React$1.createElement(FAQLabel, { className: "faq-question", htmlFor: id, itemProp: "name", "data-testid": "faq-item-".concat(id) }, label),
        React$1.createElement(FAQAnswer, { className: "faq-answer", itemScope: true, itemProp: "acceptedAnswer", itemType: "https://schema.org/Answer" }, typeof answer === 'string' ? (React$1.createElement(AnswerText, { itemProp: "text", dangerouslySetInnerHTML: {
                __html: striptags(answer, ['p', 'strong', 'br', 'b', 'a']),
            } })) : (React$1.createElement(AnswerText, { itemProp: "text" }, answer)))));
};
var CocoFAQItem$1 = memo(CocoFAQItem);
var Container$11 = styled.div(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 8px;\n  word-break: break-all;\n"], ["\n  background: ", ";\n  border-radius: 8px;\n  word-break: break-all;\n"])), COLORS.BACKGROUND.BASE);
var FAQInput = styled.input(templateObject_2$11 || (templateObject_2$11 = __makeTemplateObject(["\n  display: none;\n\n  &:checked + .faq-question:after {\n    content: '\u30FC';\n  }\n\n  &:checked + .faq-question + .faq-answer {\n    visibility: visible;\n    opacity: 1;\n    height: auto;\n    padding: 15px 0;\n  }\n"], ["\n  display: none;\n\n  &:checked + .faq-question:after {\n    content: '\u30FC';\n  }\n\n  &:checked + .faq-question + .faq-answer {\n    visibility: visible;\n    opacity: 1;\n    height: auto;\n    padding: 15px 0;\n  }\n"])));
var FAQLabel = styled.label(templateObject_3$R || (templateObject_3$R = __makeTemplateObject(["\n  display: block;\n  position: relative;\n  padding: 15px 45px 12px 15px;\n  ", "\n  cursor: pointer;\n\n  @media screen and (min-width: 400px) {\n    padding: 20px 45px 18px 15px;\n    font-size: 14px;\n  }\n\n  &:after {\n    content: '\uFF0B';\n    display: block;\n    position: absolute;\n    top: 50%;\n    margin-top: -9px;\n    right: 15px;\n    width: 18px;\n    height: 18px;\n    color: #fff;\n    ", "\n    text-align: center;\n    background: ", ";\n    border-radius: 3px;\n  }\n"], ["\n  display: block;\n  position: relative;\n  padding: 15px 45px 12px 15px;\n  ", "\n  cursor: pointer;\n\n  @media screen and (min-width: 400px) {\n    padding: 20px 45px 18px 15px;\n    font-size: 14px;\n  }\n\n  &:after {\n    content: '\uFF0B';\n    display: block;\n    position: absolute;\n    top: 50%;\n    margin-top: -9px;\n    right: 15px;\n    width: 18px;\n    height: 18px;\n    color: #fff;\n    ", "\n    text-align: center;\n    background: ", ";\n    border-radius: 3px;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '1.5' })), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_3), { lineHeight: '18px' })), COLORS.GENERAL.PRIMARY);
var FAQAnswer = styled.div(templateObject_4$I || (templateObject_4$I = __makeTemplateObject(["\n  display: block;\n  box-sizing: border-box;\n  height: 0;\n  opacity: 0;\n  transition: 0.3s;\n  visibility: hidden;\n  margin: 0 15px;\n  border-top: 1px solid #d8d8d8;\n"], ["\n  display: block;\n  box-sizing: border-box;\n  height: 0;\n  opacity: 0;\n  transition: 0.3s;\n  visibility: hidden;\n  margin: 0 15px;\n  border-top: 1px solid #d8d8d8;\n"])));
var AnswerText = styled.div(templateObject_5$y || (templateObject_5$y = __makeTemplateObject(["\n  color: #333;\n  ", ";\n\n  @media screen and (min-width: 400px) {\n    ", "\n  }\n\n  a {\n    color: #4da1ff;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n"], ["\n  color: #333;\n  ", ";\n\n  @media screen and (min-width: 400px) {\n    ", "\n  }\n\n  a {\n    color: #4da1ff;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_1), { lineHeight: '1.5' })), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_3), { lineHeight: '1.5' })));
var templateObject_1$18, templateObject_2$11, templateObject_3$R, templateObject_4$I, templateObject_5$y;

var useLocalState$g = function (_a) {
    var hotelCautionTextWithHtml = _a.hotelCautionTextWithHtml, showReadMore = _a.showReadMore;
    var _b = __read(useState(showReadMore), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    var expandCaution = useCallback(function () {
        setIsExpanded(true);
    }, []);
    useEffect(function () {
        // htmlで渡されるがstringなので高さの判定ができない
        if (hotelCautionTextWithHtml.length < 140) {
            setIsExpanded(true);
        }
    }, [hotelCautionTextWithHtml]);
    return {
        isExpanded: isExpanded,
        expandCaution: expandCaution,
    };
};

var HotelCaution = function (_a) {
    var hotelCautionTextWithHtml = _a.hotelCautionTextWithHtml, _b = _a.showReadMore, showReadMore = _b === void 0 ? true : _b, style = _a.style;
    var _c = useLocalState$g({
        hotelCautionTextWithHtml: hotelCautionTextWithHtml,
        showReadMore: showReadMore,
    }), isExpanded = _c.isExpanded, expandCaution = _c.expandCaution;
    return (React$1.createElement(React$1.Fragment, null,
        React$1.createElement(Caution, { isExpanded: isExpanded, dangerouslySetInnerHTML: {
                __html: striptags(hotelCautionTextWithHtml, [
                    'p',
                    'strong',
                    'br',
                    'b',
                ]),
            }, style: style }),
        !isExpanded && (React$1.createElement(ReadMoreButton$1, { onClick: expandCaution }, "\u7D9A\u304D\u3092\u307F\u308B..."))));
};
var HotelCaution$1 = memo(HotelCaution);
var TEXT_HEIGHT = '60px';
var Caution = styled.div(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject(["\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 160%;\n  letter-spacing: 0.1em;\n  color: ", ";\n  height: ", ";\n  overflow: ", ";\n\n  :before {\n    left: 0;\n    content: '';\n    background: ", ";\n    width: 100%;\n    height: ", ";\n    position: absolute;\n  }\n"], ["\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 160%;\n  letter-spacing: 0.1em;\n  color: ", ";\n  height: ", ";\n  overflow: ", ";\n\n  :before {\n    left: 0;\n    content: '';\n    background: ", ";\n    width: 100%;\n    height: ", ";\n    position: absolute;\n  }\n"])), COLORS.TEXT.NO_IMPORTANT, function (props) { return (props.isExpanded ? 'auto' : TEXT_HEIGHT); }, function (props) { return (props.isExpanded ? 'visible' : 'hidden'); }, function (props) {
    return props.isExpanded
        ? 'none'
        : 'linear-gradient(to bottom, rgba(255,255,255,0), white)';
}, TEXT_HEIGHT);
var ReadMoreButton$1 = styled.p(templateObject_2$10 || (templateObject_2$10 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: 13px;\n  letter-spacing: 0.1em;\n  color: ", ";\n  padding: 10px 0;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  display: inline-block;\n  font-size: 13px;\n  letter-spacing: 0.1em;\n  color: ", ";\n  padding: 10px 0;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var templateObject_1$17, templateObject_2$10;

var CocoHotelCautions = function (_a) {
    var checkInInstruction = _a.checkInInstruction, checkInSpecialInstruction = _a.checkInSpecialInstruction, optionalFees = _a.optionalFees, knowBeforeYouGo = _a.knowBeforeYouGo, style = _a.style;
    var checkInInstructionText = useMemo(function () {
        if (typeof checkInInstruction === 'undefined' &&
            typeof checkInSpecialInstruction === 'undefined')
            return undefined;
        return [checkInInstruction, checkInSpecialInstruction]
            .filter(function (item) { return typeof item !== 'undefined'; })
            .join('<br />');
    }, [checkInSpecialInstruction, checkInInstruction]);
    return (React$1.createElement(Container$10, { style: style },
        typeof checkInInstructionText !== 'undefined' && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(Title$i, null, "\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u306B\u95A2\u3059\u308B\u7279\u8A18\u4E8B\u9805"),
            React$1.createElement(CautionContainer, null,
                React$1.createElement(HotelCaution$1, { hotelCautionTextWithHtml: checkInInstructionText })))),
        typeof optionalFees !== 'undefined' && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(Title$i, null, "\u30AA\u30D7\u30B7\u30E7\u30F3\u306E\u8FFD\u52A0\u6599\u91D1"),
            React$1.createElement(CautionContainer, null,
                React$1.createElement(HotelCaution$1, { hotelCautionTextWithHtml: optionalFees })))),
        typeof knowBeforeYouGo !== 'undefined' && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(Title$i, null, "\u305D\u306E\u4ED6\u306E\u60C5\u5831"),
            React$1.createElement(CautionContainer, null,
                React$1.createElement(HotelCaution$1, { hotelCautionTextWithHtml: knowBeforeYouGo }))))));
};
var index$w = memo(CocoHotelCautions);
var Container$10 = styled.div(templateObject_1$16 || (templateObject_1$16 = __makeTemplateObject(["\n  div + h3 {\n    margin-top: 15px;\n  }\n"], ["\n  div + h3 {\n    margin-top: 15px;\n  }\n"])));
var Title$i = styled.h3(templateObject_2$$ || (templateObject_2$$ = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 2;\n  letter-spacing: 0.1em;\n  color: ", ";\n"], ["\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 2;\n  letter-spacing: 0.1em;\n  color: ", ";\n"])), COLORS.TEXT.PRIMARY);
var CautionContainer = styled.div(templateObject_3$Q || (templateObject_3$Q = __makeTemplateObject(["\n  margin-top: 4px;\n  p + p {\n    margin-top: 10px;\n  }\n"], ["\n  margin-top: 4px;\n  p + p {\n    margin-top: 10px;\n  }\n"])));
var templateObject_1$16, templateObject_2$$, templateObject_3$Q;

var useLocalState$f = function (isDefaultExpanded) {
    var _a = __read(useState(isDefaultExpanded), 2), expanded = _a[0], setExpanded = _a[1];
    var toggle = useCallback(function () {
        setExpanded(function (value) { return !value; });
    }, []);
    return {
        expanded: expanded,
        toggle: toggle,
    };
};

var CocoSimpleAccordion = function (_a) {
    var title = _a.title, arrowImageUrl = _a.arrowImageUrl, children = _a.children, _b = _a.isDefaultExpanded, isDefaultExpanded = _b === void 0 ? false : _b, titleDOM = _a.titleDOM, id = _a.id, style = _a.style, arrowImageStyle = _a.arrowImageStyle;
    var _c = useLocalState$f(isDefaultExpanded), expanded = _c.expanded, toggle = _c.toggle;
    var _id = typeof id !== 'undefined' ? id : title;
    return (React$1.createElement(Container$$, { style: style },
        React$1.createElement(Input$1, { id: _id, className: "check", type: "checkbox", defaultChecked: isDefaultExpanded, onClick: toggle }),
        React$1.createElement(Label$3, { className: "label", htmlFor: _id, arrowImageUrl: arrowImageUrl, arrowImageStyle: arrowImageStyle }, typeof titleDOM !== 'undefined' ? (titleDOM) : (React$1.createElement(LabelText, null, title))),
        React$1.createElement(Content$4, { className: "content" },
            React$1.createElement(InnerContent, null, expanded && children))));
};
var CocoSimpleAccordion$1 = memo(CocoSimpleAccordion);
var Container$$ = styled.div(templateObject_1$15 || (templateObject_1$15 = __makeTemplateObject(["\n  word-break: break-all;\n"], ["\n  word-break: break-all;\n"])));
var Input$1 = styled.input(templateObject_2$_ || (templateObject_2$_ = __makeTemplateObject(["\n  display: none;\n\n  &:checked + .label:after {\n    transform: rotate(180deg);\n  }\n\n  &:checked + .label + .content {\n    opacity: 1;\n    height: auto;\n  }\n"], ["\n  display: none;\n\n  &:checked + .label:after {\n    transform: rotate(180deg);\n  }\n\n  &:checked + .label + .content {\n    opacity: 1;\n    height: auto;\n  }\n"])));
var Label$3 = styled.label(templateObject_3$P || (templateObject_3$P = __makeTemplateObject(["\n  background: ", ";\n  display: flex;\n  position: relative;\n  cursor: pointer;\n  align-items: center;\n  padding: 15px 20px;\n\n  &:after {\n    content: '';\n    display: block;\n    width: 24px;\n    height: 24px;\n    position: absolute;\n    right: 10px;\n    background: ", " no-repeat;\n    text-align: center;\n    transform-origin: 50% 50%;\n    transition: all 0.2s;\n    ", "\n  }\n"], ["\n  background: ", ";\n  display: flex;\n  position: relative;\n  cursor: pointer;\n  align-items: center;\n  padding: 15px 20px;\n\n  &:after {\n    content: '';\n    display: block;\n    width: 24px;\n    height: 24px;\n    position: absolute;\n    right: 10px;\n    background: ", " no-repeat;\n    text-align: center;\n    transform-origin: 50% 50%;\n    transition: all 0.2s;\n    ", "\n  }\n"])), COLORS.BACKGROUND.SURFACE, function (props) { return "url(".concat(props.arrowImageUrl, ")"); }, function (props) { return (__assign({}, props.arrowImageStyle)); });
var LabelText = styled.p(templateObject_4$H || (templateObject_4$H = __makeTemplateObject(["\n  ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1));
var Content$4 = styled.div(templateObject_5$x || (templateObject_5$x = __makeTemplateObject(["\n  display: block;\n  box-sizing: border-box;\n  height: 0;\n  opacity: 0;\n  transition: all 0.2s;\n"], ["\n  display: block;\n  box-sizing: border-box;\n  height: 0;\n  opacity: 0;\n  transition: all 0.2s;\n"])));
var InnerContent = styled.div(templateObject_6$s || (templateObject_6$s = __makeTemplateObject([""], [""])));
var templateObject_1$15, templateObject_2$_, templateObject_3$P, templateObject_4$H, templateObject_5$x, templateObject_6$s;

var ImageContent = function (_a) {
    var image = _a.image, style = _a.style;
    return (React$1.createElement(Container$_, { style: style },
        React$1.createElement(LazyLoadImage, { effect: "blur", delayTime: 200, threshold: 200, width: '100%', height: '100%', src: image.url, style: {
                objectFit: 'cover',
            } }),
        typeof image.creditText !== 'undefined' && (React$1.createElement(CreditContainer, null, typeof image.creditLinkUrl !== 'undefined' ? (React$1.createElement(Link$5, { href: image.creditLinkUrl, target: "__blank" },
            React$1.createElement(TextCredit, null, image.creditText))) : (React$1.createElement(TextCredit, null, image.creditText))))));
};
var ImageContent$1 = memo(ImageContent);
var Container$_ = styled.div(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject([""], [""])));
var CreditContainer = styled.div(templateObject_2$Z || (templateObject_2$Z = __makeTemplateObject(["\n  margin-top: 5px;\n  display: flex;\n  flex-direction: row-reverse;\n"], ["\n  margin-top: 5px;\n  display: flex;\n  flex-direction: row-reverse;\n"])));
var TextCredit = styled.p(templateObject_3$O || (templateObject_3$O = __makeTemplateObject(["\n  text-align: right;\n  color: ", ";\n  ", ";\n"], ["\n  text-align: right;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { lineHeight: '14px' })));
var Link$5 = styled.a(templateObject_4$G || (templateObject_4$G = __makeTemplateObject(["\n  text-decoration: none;\n  display: contents;\n"], ["\n  text-decoration: none;\n  display: contents;\n"])));
var templateObject_1$14, templateObject_2$Z, templateObject_3$O, templateObject_4$G;

var CocoRichHotelContent = function (_a) {
    var title = _a.title, images = _a.images, description = _a.description, _b = _a.minWidth, minWidth = _b === void 0 ? TABLET_MAX_WIDTH : _b, style = _a.style;
    return (React$1.createElement(Container$Z, { style: style },
        React$1.createElement(TitleContainer$3, null,
            React$1.createElement(Title$h, { minWidth: minWidth }, title)),
        typeof images[0] !== 'undefined' && (React$1.createElement(ImageContent$1, { image: images[0], style: { marginTop: '20px' } })),
        React$1.createElement(Description$8, null, description),
        images.slice(1, images.length).map(function (image) {
            return (React$1.createElement(ImageContent$1, { image: image, style: { marginTop: '20px' }, key: image.url }));
        })));
};
var index$v = memo(CocoRichHotelContent);
var Container$Z = styled.div(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var TitleContainer$3 = styled.div(templateObject_2$Y || (templateObject_2$Y = __makeTemplateObject(["\n  border-left: 4px solid ", ";\n  padding: 5px 0;\n"], ["\n  border-left: 4px solid ", ";\n  padding: 5px 0;\n"])), COLORS.GENERAL.SECONDARY);
var Title$h = styled.h2(templateObject_3$N || (templateObject_3$N = __makeTemplateObject(["\n  margin-left: 15px;\n  color: ", ";\n  ", ";\n  @media screen and (min-width: ", ") {\n    ", ";\n  }\n"], ["\n  margin-left: 15px;\n  color: ", ";\n  ", ";\n  @media screen and (min-width: ", ") {\n    ", ";\n  }\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_1), { letterSpacing: '0.1em' })), function (props) { return props.minWidth; }, createFontStyle(MOBILE_FONT_STYLES.HEADLINE_2));
var Description$8 = styled.p(templateObject_4$F || (templateObject_4$F = __makeTemplateObject(["\n  margin-top: 20px;\n  color: ", ";\n  ", ";\n"], ["\n  margin-top: 20px;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_2), { lineHeight: '180%', letterSpacing: '0.1em' })));
var templateObject_1$13, templateObject_2$Y, templateObject_3$N, templateObject_4$F;

var CocoPlusIcon = function (_a) {
    var fillColor = _a.fillColor, style = _a.style;
    return (React$1.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: style },
        React$1.createElement("circle", { cx: "12", cy: "12", r: "11.5", stroke: "black", strokeOpacity: "0.67" }),
        React$1.createElement("rect", { x: "6.85742", y: "11.1426", width: "10.2857", height: "1.71429", fill: fillColor !== null && fillColor !== void 0 ? fillColor : 'black', fillOpacity: "0.87" }),
        React$1.createElement("rect", { x: "7.28599", y: "11.5711", width: "9.42857", height: "0.857143", stroke: "black", strokeOpacity: "0.67", strokeWidth: "0.857143" }),
        React$1.createElement("rect", { x: "12.8574", y: "6.85718", width: "10.2857", height: "1.71429", transform: "rotate(90 12.8574 6.85718)", fill: fillColor !== null && fillColor !== void 0 ? fillColor : 'black', fillOpacity: "0.87" }),
        React$1.createElement("rect", { x: "12.4289", y: "7.28575", width: "9.42857", height: "0.857143", transform: "rotate(90 12.4289 7.28575)", stroke: "black", strokeOpacity: "0.67", strokeWidth: "0.857143" })));
};
var CocoPlusIcon$1 = memo(CocoPlusIcon);

var CocoMinusIcon = function (_a) {
    var fillColor = _a.fillColor, style = _a.style;
    return (React$1.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: style },
        React$1.createElement("circle", { cx: "12", cy: "12", r: "11.5", stroke: "black", strokeOpacity: "0.67" }),
        React$1.createElement("rect", { x: "6.85742", y: "11.1426", width: "10.2857", height: "1.71429", fill: fillColor !== null && fillColor !== void 0 ? fillColor : 'black', fillOpacity: "0.87" }),
        React$1.createElement("rect", { x: "7.28599", y: "11.5711", width: "9.42857", height: "0.857143", stroke: "black", strokeOpacity: "0.67", strokeWidth: "0.857143" })));
};
var CocoMinusIcon$1 = memo(CocoMinusIcon);

var CocoSkeletonImageContainer = function (_a) {
    var _b = _a.numberOfSkeletons, numberOfSkeletons = _b === void 0 ? 1 : _b, imageUrl = _a.imageUrl, containerStyle = _a.containerStyle, skeletonStyle = _a.skeletonStyle;
    return (React$1.createElement("div", { style: containerStyle }, __spreadArray([], __read(new Array(numberOfSkeletons)), false).map(function (_, index) { return (React$1.createElement(Container$Y, { key: index, style: skeletonStyle },
        React$1.createElement("img", { src: imageUrl, alt: "Skeleton" }))); })));
};
var index$u = memo(CocoSkeletonImageContainer);
var Container$Y = styled.div(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  @keyframes skeleton-animation {\n    0% {\n      transform: translateX(-100%);\n    }\n    50% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }\n  &:before {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    content: '';\n    display: block;\n    background: linear-gradient(\n      90deg,\n      transparent,\n      rgba(255, 255, 255, 0.4),\n      transparent\n    );\n    animation: skeleton-animation 1.8s ease-in infinite;\n  }\n\n  > img {\n    display: block;\n    width: 100%;\n  }\n\n  & + div {\n    margin-top: 15px;\n  }\n"], ["\n  position: relative;\n  overflow: hidden;\n  @keyframes skeleton-animation {\n    0% {\n      transform: translateX(-100%);\n    }\n    50% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }\n  &:before {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    content: '';\n    display: block;\n    background: linear-gradient(\n      90deg,\n      transparent,\n      rgba(255, 255, 255, 0.4),\n      transparent\n    );\n    animation: skeleton-animation 1.8s ease-in infinite;\n  }\n\n  > img {\n    display: block;\n    width: 100%;\n  }\n\n  & + div {\n    margin-top: 15px;\n  }\n"])));
var templateObject_1$12;

var CocoButton = function (props) {
    var _a;
    var background = typeof props.colors !== 'undefined'
        ? "linear-gradient(180deg, ".concat(props.colors.join(','), ");")
        : typeof props.color === 'undefined'
            ? 'initial'
            : props.color;
    var borderColor = typeof props.borderColor !== 'undefined'
        ? props.borderColor
        : 'transparent';
    var borderRadius = typeof props.borderRadius === 'undefined' ? '6px' : props.borderRadius;
    var boxShadow = typeof props.shadowColor === 'undefined' || props.isFlat
        ? 'initial'
        : "0px 3px 0px ".concat(props.shadowColor);
    var minWidth = typeof props.minWidth !== 'undefined' ? props.minWidth : '105px';
    var width = props.fullWidth === true
        ? '100%'
        : typeof props.width !== 'undefined'
            ? props.width
            : 'initial';
    var height = typeof props.height !== 'undefined' ? props.height : 'initial';
    var padding = typeof props.padding === 'undefined'
        ? props.showRightArrow === true || props.showRightGrayArrow === true
            ? '10px 24px 10px 10px'
            : props.showDownwardGrayArrow === true
                ? '10px 46px 10px 10px'
                : '10px'
        : props.padding;
    var color = props.textColor;
    var fontWeight = typeof props.fontWeight === 'undefined' ? 'bold' : props.fontWeight;
    var fontSize = typeof props.textSize === 'undefined' ? '14px' : props.textSize;
    var containerType = (_a = props.containerType) !== null && _a !== void 0 ? _a : 'button';
    return (React$1.createElement(React$1.Fragment, null, containerType === 'button' ? (React$1.createElement(ButtonContainer$2, { "data-right-arrow-visible": props.showRightArrow ? 'visible' : 'invisible', "data-right-gray-arrow-visible": props.showRightGrayArrow ? 'visible' : 'invisible', "data-downward-gray-arrow-visible": props.showDownwardGrayArrow ? 'visible' : 'invisible', "data-hover": props.disableHover ? 'disable' : 'enable', "data-is-disabled": props.disabled ? 'true' : 'false', style: __assign({ background: background, borderColor: borderColor, borderRadius: borderRadius, boxShadow: boxShadow, minWidth: minWidth, width: width, height: height, padding: padding, color: color, fontWeight: fontWeight, fontSize: fontSize }, props.style), onClick: props.onClick ? props.onClick : undefined }, props.children)) : (React$1.createElement(DivContainer, { "data-right-arrow-visible": props.showRightArrow ? 'visible' : 'invisible', "data-right-gray-arrow-visible": props.showRightGrayArrow ? 'visible' : 'invisible', "data-downward-gray-arrow-visible": props.showDownwardGrayArrow ? 'visible' : 'invisible', "data-hover": props.disableHover ? 'disable' : 'enable', "data-is-disabled": props.disabled ? 'true' : 'false', style: __assign({ background: background, borderColor: borderColor, borderRadius: borderRadius, boxShadow: boxShadow, minWidth: minWidth, width: width, height: height, padding: padding, color: color, fontWeight: fontWeight, fontSize: fontSize }, props.style), onClick: props.onClick ? props.onClick : undefined }, props.children))));
};
var CocoButton$1 = memo(CocoButton);
var ButtonStyleCSS = css(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject(["\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  appearance: none;\n  background-color: transparent;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  text-align: center;\n  letter-spacing: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  &[data-right-arrow-visible='visible'] {\n    &:after {\n      content: '';\n      display: block;\n      width: 6px;\n      height: 6px;\n      border-top: solid 2px currentColor;\n      border-right: solid 2px currentColor;\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n      top: 0;\n      bottom: 0;\n      right: 15px;\n      margin: auto;\n      position: absolute;\n    }\n  }\n\n  &[data-right-gray-arrow-visible='visible'] {\n    &:after {\n      content: '';\n      display: block;\n      width: 6px;\n      height: 6px;\n      border-top: solid 2px ", ";\n      border-right: solid 2px ", ";\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n      top: 0;\n      bottom: 0;\n      right: 15px;\n      margin: auto;\n      position: absolute;\n    }\n  }\n\n  &[data-downward-gray-arrow-visible='visible'] {\n    &:after {\n      content: '';\n      display: inline-block;\n      vertical-align: middle;\n      width: 6px;\n      height: 6px;\n      border-bottom: solid 2px ", ";\n      border-right: solid 2px ", ";\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n      top: 0;\n      bottom: 0;\n      right: 15px;\n      margin: auto;\n      position: absolute;\n    }\n  }\n\n  &[data-hover='enable'][data-is-disabled='false'] {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n  &[data-hober='disable'] {\n    &:hover {\n      opacity: 1;\n    }\n  }\n  &[data-is-disabled='true'] {\n    background: #d9d9d9 !important;\n    color: rgba(0, 0, 0, 0.15) !important;\n    border: rgba(0, 0, 0, 0.15) !important;\n    box-shadow: none !important;\n    &:hover {\n      cursor: default !important;\n    }\n  }\n"], ["\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  appearance: none;\n  background-color: transparent;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  text-align: center;\n  letter-spacing: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  &[data-right-arrow-visible='visible'] {\n    &:after {\n      content: '';\n      display: block;\n      width: 6px;\n      height: 6px;\n      border-top: solid 2px currentColor;\n      border-right: solid 2px currentColor;\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n      top: 0;\n      bottom: 0;\n      right: 15px;\n      margin: auto;\n      position: absolute;\n    }\n  }\n\n  &[data-right-gray-arrow-visible='visible'] {\n    &:after {\n      content: '';\n      display: block;\n      width: 6px;\n      height: 6px;\n      border-top: solid 2px ", ";\n      border-right: solid 2px ", ";\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n      top: 0;\n      bottom: 0;\n      right: 15px;\n      margin: auto;\n      position: absolute;\n    }\n  }\n\n  &[data-downward-gray-arrow-visible='visible'] {\n    &:after {\n      content: '';\n      display: inline-block;\n      vertical-align: middle;\n      width: 6px;\n      height: 6px;\n      border-bottom: solid 2px ", ";\n      border-right: solid 2px ", ";\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n      top: 0;\n      bottom: 0;\n      right: 15px;\n      margin: auto;\n      position: absolute;\n    }\n  }\n\n  &[data-hover='enable'][data-is-disabled='false'] {\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n  &[data-hober='disable'] {\n    &:hover {\n      opacity: 1;\n    }\n  }\n  &[data-is-disabled='true'] {\n    background: #d9d9d9 !important;\n    color: rgba(0, 0, 0, 0.15) !important;\n    border: rgba(0, 0, 0, 0.15) !important;\n    box-shadow: none !important;\n    &:hover {\n      cursor: default !important;\n    }\n  }\n"])), COLORS.TEXT.PLACEHOLDER, COLORS.TEXT.PLACEHOLDER, COLORS.BORDER.PRIMARY, COLORS.BORDER.PRIMARY);
var ButtonContainer$2 = styled.button(templateObject_2$X || (templateObject_2$X = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ButtonStyleCSS);
var DivContainer = styled.div(templateObject_3$M || (templateObject_3$M = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ButtonStyleCSS);
var templateObject_1$11, templateObject_2$X, templateObject_3$M;

var CocoRedButton = function (props) {
    return (React$1.createElement(CocoButton$1, __assign({}, props, { color: COLORS.GENERAL.PRIMARY, borderColor: 'rgba(0, 0, 0, 0.1)', shadowColor: '#D93234', textColor: COLORS.INVERT_TEXT.PRIMARY })));
};
var CocoWhiteButton = function (props) {
    return (React$1.createElement(CocoButton$1, __assign({}, props, { color: COLORS.BACKGROUND.SURFACE, borderColor: '#d9d9d9', shadowColor: '#d9d9d9', textColor: COLORS.TEXT.PRIMARY })));
};
var CocoWhiteGradientButton = function (props) {
    return (React$1.createElement(CocoButton$1, __assign({}, props, { colors: ['#FFFFFF 44.27%', '#ECECEC 100%'], borderColor: 'clear', shadowColor: 'rgba(0, 0, 0, 0.1)', borderRadius: '6px', textColor: COLORS.TEXT.PRIMARY })));
};
var CocoDisableButton = function (props) {
    return (React$1.createElement(CocoButton$1, __assign({}, props, { color: '#ECECEC', borderColor: undefined, shadowColor: undefined, borderRadius: '6px', textColor: COLORS.TEXT.DISABLE, disableHover: true })));
};

var CocoCheckLabelButton = function (_a) {
    var children = _a.children, style = _a.style, isChecked = _a.isChecked, onClick = _a.onClick;
    return (React$1.createElement(Container$X, { isChecked: isChecked, onClick: onClick, style: style },
        React$1.createElement(CheckIcon, { fill: isChecked ? COLORS.GENERAL.SECONDARY : COLORS.TEXT.DISABLE }),
        React$1.createElement("span", null, children)));
};
var index$t = memo(CocoCheckLabelButton);
var Container$X = styled.div(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: end;\n  cursor: pointer;\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  background: ", ";\n  padding: 4px 8px 4px 2px;\n  ", ";\n  color: ", ";\n  text-wrap: nowrap;\n  white-space: nowrap;\n"], ["\n  display: inline-flex;\n  align-items: end;\n  cursor: pointer;\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  background: ", ";\n  padding: 4px 8px 4px 2px;\n  ", ";\n  color: ", ";\n  text-wrap: nowrap;\n  white-space: nowrap;\n"])), function (props) {
    return props.isChecked ? COLORS.GENERAL.SECONDARY : COLORS.BORDER.SECONDARY;
}, COLORS.BACKGROUND.SURFACE, createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), function (props) {
    return props.isChecked ? COLORS.GENERAL.SECONDARY : COLORS.TEXT.NO_IMPORTANT;
});
var CheckIcon = function (props) { return (React$1.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React$1.createElement("path", { d: "M8.61113 14.3803C8.26925 14.3803 7.92737 14.2521 7.62823 13.9957L4.16669 10.5342L6.08976 8.61111L8.61113 11.1325L13.9103 5.83333L15.8334 7.75641L9.59404 13.9957C9.33763 14.2521 8.99575 14.3803 8.61113 14.3803Z", fill: props.fill }))); };
var templateObject_1$10;

var useLocalState$e = function (showContentChangeAnimation, content) {
    var _a = __read(useState(false), 2), showContent = _a[0], setShowContent = _a[1];
    useEffect(function () {
        if (showContentChangeAnimation && typeof content !== 'undefined') {
            setShowContent(false);
            var timer_1 = setTimeout(function () {
                setShowContent(true);
            }, 500);
            return function () {
                clearTimeout(timer_1);
            };
        }
    }, [content, showContentChangeAnimation]);
    return { showContent: showContent };
};

var CocoDPFlightFixedFooter = function (_a) {
    var heading = _a.heading, supplement = _a.supplement, buttonText = _a.buttonText, onClick = _a.onClick, imgixHost = _a.imgixHost, onClickLINEIcon = _a.onClickLINEIcon, _b = _a.showContentChangeAnimation, showContentChangeAnimation = _b === void 0 ? false : _b, _c = _a.minWidth, minWidth = _c === void 0 ? TABLET_MAX_WIDTH : _c, style = _a.style;
    var showContent = useLocalState$e(showContentChangeAnimation, heading === null || heading === void 0 ? void 0 : heading.content).showContent;
    return (React$1.createElement(Container$W, { minWidth: minWidth, style: style },
        typeof heading !== 'undefined' && (React$1.createElement(HorizontalContainer, null,
            React$1.createElement(Title$g, null, heading.title),
            React$1.createElement(Content$3, { "data-testid": 'dp-flight-fixed-footer-content', "data-show-animation": showContentChangeAnimation ? 'true' : 'false', "data-show-content": showContent ? 'true' : 'false' }, heading.content))),
        typeof supplement !== 'undefined' && (React$1.createElement(HorizontalContainer, null,
            React$1.createElement(Supplement$1, null, supplement.title),
            React$1.createElement(Supplement$1, { "data-testid": 'dp-flight-fixed-footer-supplement-content' }, supplement.content))),
        typeof buttonText !== 'undefined' && typeof onClick !== 'undefined' && (React$1.createElement(ButtonContainer$1, null,
            typeof onClickLINEIcon !== 'undefined' &&
                typeof imgixHost !== 'undefined' && (React$1.createElement(LINEIcon, { onClick: onClickLINEIcon, "data-testid": 'dp-flight-fixed-footer_line-icon' },
                React$1.createElement(LINEImage, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/line-support-button.png")) }))),
            React$1.createElement(CocoRedButton, { fullWidth: true, height: '47px', onClick: onClick, textSize: 16, "data-testid": 'dp-flight-fixed-footer_red-button' }, buttonText))),
        typeof buttonText !== 'undefined' && typeof onClick === 'undefined' && (React$1.createElement(ButtonContainer$1, null,
            typeof onClickLINEIcon !== 'undefined' &&
                typeof imgixHost !== 'undefined' && (React$1.createElement(LINEIcon, { onClick: onClickLINEIcon, "data-testid": 'dp-flight-fixed-footer_line-icon' },
                React$1.createElement(LINEImage, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/line-support-button.png")) }))),
            React$1.createElement(CocoDisableButton, { fullWidth: true, height: '47px', textSize: 16 }, buttonText)))));
};
var CocoDPFlightFixedFooter$1 = memo(CocoDPFlightFixedFooter);
var Container$W = styled.div(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject(["\n  position: sticky;\n  bottom: 0;\n  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 8px 16px 12px;\n  width: 100%;\n  z-index: ", ";\n  @media (min-width: ", ") {\n    max-width: 400px;\n  }\n\n  p {\n    margin: 0;\n  }\n"], ["\n  position: sticky;\n  bottom: 0;\n  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);\n  background-color: ", ";\n  box-sizing: border-box;\n  padding: 8px 16px 12px;\n  width: 100%;\n  z-index: ", ";\n  @media (min-width: ", ") {\n    max-width: 400px;\n  }\n\n  p {\n    margin: 0;\n  }\n"])), COLORS.BACKGROUND.SURFACE, Z_INDEX.FOOTER, function (props) { return props.minWidth; });
var HorizontalContainer = styled.div(templateObject_2$W || (templateObject_2$W = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var Title$g = styled.p(templateObject_3$L || (templateObject_3$L = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_1));
var Content$3 = styled.p(templateObject_4$E || (templateObject_4$E = __makeTemplateObject(["\n  ", ";\n  &[data-show-animation='true'] {\n    display: block;\n    position: relative;\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n    background-size: 300% 300%;\n    &::after {\n      content: '...';\n      display: block;\n      position: absolute;\n      top: -6px;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      color: #000;\n      text-align: right;\n    }\n    &[data-show-content='true'] {\n      background-image: linear-gradient(to left, #000 40%, #fff 10%);\n      background-position: right 100% center;\n      animation: toLeft 0.9s ease-in forwards;\n      &::after {\n        display: none;\n      }\n    }\n  }\n  @keyframes toLeft {\n    100% {\n      transform: translate(0, 0);\n      background-position: right 0% center;\n    }\n  }\n"], ["\n  ", ";\n  &[data-show-animation='true'] {\n    display: block;\n    position: relative;\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n    background-size: 300% 300%;\n    &::after {\n      content: '...';\n      display: block;\n      position: absolute;\n      top: -6px;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      color: #000;\n      text-align: right;\n    }\n    &[data-show-content='true'] {\n      background-image: linear-gradient(to left, #000 40%, #fff 10%);\n      background-position: right 100% center;\n      animation: toLeft 0.9s ease-in forwards;\n      &::after {\n        display: none;\n      }\n    }\n  }\n  @keyframes toLeft {\n    100% {\n      transform: translate(0, 0);\n      background-position: right 0% center;\n    }\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { letterSpacing: '0.03em' })));
var Supplement$1 = styled.p(templateObject_5$w || (templateObject_5$w = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var ButtonContainer$1 = styled.div(templateObject_6$r || (templateObject_6$r = __makeTemplateObject(["\n  height: 50px;\n  margin-top: 8px;\n  display: flex;\n"], ["\n  height: 50px;\n  margin-top: 8px;\n  display: flex;\n"])));
var LINEIcon = styled.div(templateObject_7$l || (templateObject_7$l = __makeTemplateObject(["\n  width: 36px;\n  margin-right: 15px;\n  cursor: pointer;\n"], ["\n  width: 36px;\n  margin-right: 15px;\n  cursor: pointer;\n"])));
var LINEImage = styled.img(templateObject_8$j || (templateObject_8$j = __makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
var templateObject_1$$, templateObject_2$W, templateObject_3$L, templateObject_4$E, templateObject_5$w, templateObject_6$r, templateObject_7$l, templateObject_8$j;

var DPFlightInputNumberField = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, unitLabel = _a.unitLabel, initialValue = _a.initialValue, minValue = _a.minValue, maxValue = _a.maxValue, onChange = _a.onChange, testid = _a.testid, style = _a.style;
    var _b = __read(useState(initialValue), 2), inputNumber = _b[0], setInputNumber = _b[1];
    var disabledMinusButton = useMemo(function () {
        return inputNumber <= minValue;
    }, [inputNumber, minValue]);
    var disabledPlusButton = useMemo(function () {
        return inputNumber >= maxValue;
    }, [inputNumber, maxValue]);
    return (React$1.createElement(Container$V, { style: style },
        React$1.createElement(LabelContainer, null,
            React$1.createElement(Label$2, null, label),
            typeof subLabel !== 'undefined' && React$1.createElement(SubLabel, null, subLabel)),
        React$1.createElement(InputContainer$1, null,
            React$1.createElement(MinusButton, { disabled: disabledMinusButton, onClick: function () {
                    var value = inputNumber - 1;
                    setInputNumber(value);
                    if (onChange)
                        onChange('minus');
                }, "data-testid": testid ? "input-number-field_minus-".concat(testid) : undefined },
                React$1.createElement(CocoMinusIcon$1, null)),
            React$1.createElement(NumberText, null,
                inputNumber,
                typeof unitLabel !== 'undefined' && unitLabel),
            React$1.createElement(PlusButton, { disabled: disabledPlusButton, onClick: function () {
                    var value = inputNumber + 1;
                    setInputNumber(value);
                    if (onChange)
                        onChange('plus');
                }, "data-testid": testid ? "input-number-field_plus-".concat(testid) : undefined },
                React$1.createElement(CocoPlusIcon$1, null)))));
};
var CocoDPFlightInputNumberField = memo(DPFlightInputNumberField);
var Container$V = styled.div(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var LabelContainer = styled.div(templateObject_2$V || (templateObject_2$V = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n"])));
var Label$2 = styled.span(templateObject_3$K || (templateObject_3$K = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_1));
var SubLabel = styled.span(templateObject_4$D || (templateObject_4$D = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_2));
var InputContainer$1 = styled.div(templateObject_5$v || (templateObject_5$v = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var NumberText = styled.span(templateObject_6$q || (templateObject_6$q = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n  margin: 0 16px;\n"], ["\n  color: ", ";\n  ", ";\n  margin: 0 16px;\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_3), { letterSpacing: '0.02em ' })));
var ButtonCSS = "\t\n  border: none;\n  cursor: pointer;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  appearance: none;\n  text-align: start;\n  background-color: transparent;\n\n  display: flex;\t\n  align-items: center;\t\n  justify-content: center;\t\n";
var MinusButton = styled.button(templateObject_7$k || (templateObject_7$k = __makeTemplateObject(["\n  ", ";\n  opacity: ", ";\n"], ["\n  ", ";\n  opacity: ", ";\n"])), ButtonCSS, function (props) { return (props.disabled ? 0.3 : 1.0); });
var PlusButton = styled.button(templateObject_8$i || (templateObject_8$i = __makeTemplateObject(["\n  ", ";\n  opacity: ", ";\n"], ["\n  ", ";\n  opacity: ", ";\n"])), ButtonCSS, function (props) { return (props.disabled ? 0.3 : 1.0); });
var templateObject_1$_, templateObject_2$V, templateObject_3$K, templateObject_4$D, templateObject_5$v, templateObject_6$q, templateObject_7$k, templateObject_8$i;

var PAGE_LINKS = [
    {
        header: {
            title: '海外旅行',
            link: '/overseas',
        },
        links: [
            {
                title: '海外航空券＋ホテル',
                path: '/overseas/dp-flight',
            },
            {
                title: '海外ホテル',
                path: '/overseas/hotels',
            },
        ],
    },
    {
        header: {
            title: '国内旅行',
            link: '/jp',
        },
        links: [
            {
                title: '国内ホテル・旅館',
                path: '/jp/hotels',
            },
            {
                title: 'レンタカー＋ホテル',
                path: '/jp/dp-car',
            },
            {
                title: 'JR＋ホテル',
                path: '/jp/dp-jr',
            },
            {
                title: '国内航空券＋ホテル',
                path: '/jp/dp-flight',
            },
            {
                title: '旅行モデルコース',
                path: '/plans',
            },
            {
                title: '観光スポット',
                path: '/spots',
            },
        ],
    },
    {
        header: {
            title: 'こころからについて',
            link: undefined,
        },
        links: [
            {
                title: 'サイトマップ',
                path: '/sitemap',
            },
            {
                title: '約款・標識',
                path: '/legal',
            },
            {
                title: '利用規約',
                path: '/terms-of-use',
            },
            {
                title: '特商法に基づく表示',
                path: '/legal/commercial-transactions.pdf',
            },
            {
                title: 'プライバシーポリシー',
                externalHref: 'https://www.hotspring-inc.jp/privacy-policy',
                target: '_blank',
                rel: 'noopener',
            },
            {
                title: 'よくあるお問い合わせ',
                path: '/faq',
            },
            {
                title: '運営会社',
                externalHref: 'https://www.hotspring-inc.jp',
                target: '_blank',
                rel: 'noopener',
            },
        ],
    },
];
var SNS_LINKS = [
    {
        href: 'https://www.instagram.com/cocolocala',
        alt: 'こころから on Instagram',
        src: "/images/icons/sns-instagram.png",
        target: '_blank',
        rel: 'noopener nofollow',
    },
    {
        href: 'https://lin.ee/uxX1eiB',
        alt: 'こころから on LINE',
        src: "/images/icons/sns-line.png",
        target: '_blank',
        rel: 'noopener nofollow',
    },
    {
        href: 'https://twitter.com/cocolocala_jp',
        alt: 'こころから on Twitter',
        src: "/images/icons/sns-twitter.png",
        target: '_blank',
        rel: 'noopener nofollow',
    },
    {
        href: 'https://www.facebook.com/cocolocala',
        alt: 'こころから on facebook',
        src: "/images/icons/sns-facebook.png",
        target: '_blank',
        rel: 'noopener nofollow',
    },
];
var OVERSEAS_LINKS = [
    {
        title: 'ハワイ旅行',
        path: '/us/hawaii/dp-flight',
    },
    {
        title: 'グアム旅行',
        path: '/gu/dp-flight',
    },
    {
        title: '韓国旅行',
        path: '/kr/dp-flight',
    },
    {
        title: '台湾旅行',
        path: '/tw/dp-flight',
    },
    {
        title: '香港旅行',
        path: '/hk/dp-flight',
    },
    {
        title: 'タイ旅行',
        path: '/th/dp-flight',
    },
    {
        title: 'ベトナム旅行',
        path: '/vn/dp-flight',
    },
    {
        title: 'アメリカ旅行',
        path: '/us/dp-flight',
    },
    {
        title: 'フランス旅行',
        path: '/fr/dp-flight',
    },
];
var GLOBAL_MENU_JP_PAGE_LINKS = [
    {
        title: '国内ホテル・旅館',
        path: '/jp/hotels',
        spIconLinkUrl: '/images/icons/category/hotel-only.png',
    },
    {
        title: 'レンタカー+ホテル',
        path: '/jp/dp-car',
        spIconLinkUrl: '/images/icons/category/car-hotel.png',
    },
    {
        title: 'JR+ホテル',
        path: '/jp/dp-jr',
        spIconLinkUrl: '/images/icons/category/jr-hotel.png',
    },
    {
        title: '国内航空券+ホテル',
        path: '/jp/dp-flight',
        spIconLinkUrl: '/images/icons/category/domestic-air-hotel.png',
    },
];
var GLOBAL_MENU_DP_PAGE_LINKS = [
    {
        title: '海外航空券+ホテル予約',
        path: '/overseas/dp-flight',
        spIconLinkUrl: '/images/icons/category/international-air-hotel.png',
    },
    {
        title: '海外ホテル',
        path: '/overseas/hotels',
        spIconLinkUrl: '/images/icons/category/overseas-hotel.png',
    },
];

var SectionItem = function (_a) {
    var title = _a.title, path = _a.path, spIconLinkUrl = _a.spIconLinkUrl, openNewWindow = _a.openNewWindow, imgixHost = _a.imgixHost, onClickItem = _a.onClickItem, style = _a.style;
    return (React$1.createElement(A$4, { href: path, onClick: function () { return onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(); }, target: openNewWindow === true ? '_blank' : undefined },
        React$1.createElement(Container$U, { style: style },
            typeof spIconLinkUrl !== 'undefined' && (React$1.createElement("img", { src: addAutoFormatAndCompress("".concat(imgixHost).concat(spIconLinkUrl)), alt: title })),
            React$1.createElement(Title$f, null, title))));
};
var SectionItem$1 = memo(SectionItem);
var Container$U = styled.div(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n  background: ", ";\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  width: calc(100% - 40px);\n  height: 44px;\n  position: relative;\n  white-space: nowrap;\n  img {\n    width: 36px;\n    margin: 0 10px 0 -10px;\n  }\n  ::after {\n    content: '';\n    border: solid rgba(0, 0, 0, 0.23);\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 4px;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: 17px;\n  }\n"], ["\n  background: ", ";\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  width: calc(100% - 40px);\n  height: 44px;\n  position: relative;\n  white-space: nowrap;\n  img {\n    width: 36px;\n    margin: 0 10px 0 -10px;\n  }\n  ::after {\n    content: '';\n    border: solid rgba(0, 0, 0, 0.23);\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 4px;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: 17px;\n  }\n"])), COLORS.BACKGROUND.SURFACE);
var Title$f = styled.p(templateObject_2$U || (templateObject_2$U = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  ", "\n  color: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { letterSpacing: '0.1em' })), COLORS.TEXT.PRIMARY);
var A$4 = styled.a(templateObject_3$J || (templateObject_3$J = __makeTemplateObject(["\n  display: unset;\n  text-decoration: none;\n  :first-of-type {\n    margin-top: 5px;\n  }\n  :last-of-type {\n    margin-bottom: 5px;\n  }\n"], ["\n  display: unset;\n  text-decoration: none;\n  :first-of-type {\n    margin-top: 5px;\n  }\n  :last-of-type {\n    margin-bottom: 5px;\n  }\n"])));
var templateObject_1$Z, templateObject_2$U, templateObject_3$J;

var SectionTitle$3 = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, style = _a.style;
    return (React$1.createElement(Container$T, { style: style },
        React$1.createElement(Title$e, null, title),
        typeof subtitle !== 'undefined' && React$1.createElement(Subtitle, null, subtitle)));
};
var SectionTitle$4 = memo(SectionTitle$3);
var Container$T = styled.div(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n  background: rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 10px 0 6px 20px;\n  /* 100%\u304B\u3089padding-left\u3092\u5F15\u304F */\n  width: calc(100% - 20px);\n"], ["\n  background: rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 10px 0 6px 20px;\n  /* 100%\u304B\u3089padding-left\u3092\u5F15\u304F */\n  width: calc(100% - 20px);\n"])));
var Title$e = styled.p(templateObject_2$T || (templateObject_2$T = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_3));
var Subtitle = styled.p(templateObject_3$I || (templateObject_3$I = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_1));
var templateObject_1$Y, templateObject_2$T, templateObject_3$I;

var AccordionSectionComponent = function (_a) {
    var sectionTitle = _a.sectionTitle, items = _a.items, imgixHost = _a.imgixHost, style = _a.style;
    return (React$1.createElement(Container$S, { style: style },
        React$1.createElement(Input, { type: "checkbox", id: "check-".concat(sectionTitle) }),
        React$1.createElement(Title$d, { htmlFor: "check-".concat(sectionTitle), className: 'title' }, typeof sectionTitle !== 'undefined' && (React$1.createElement(SectionTitle$4, { title: sectionTitle }))),
        React$1.createElement(Content$2, { className: 'content' }, items.map(function (item, index) {
            return typeof item === 'undefined' ? (React$1.createElement(CocoDivider$1, { key: index, style: { margin: '10px 0' } })) : (React$1.createElement(SectionItem$1, { key: index, title: item.title, path: item.path, spIconLinkUrl: item.spIconLinkUrl, openNewWindow: item.openNewWindow, onClickItem: item.onClickItem, imgixHost: imgixHost, style: style }));
        }))));
};
var AccordionSection = memo(AccordionSectionComponent);
var Container$S = styled.div(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n"])));
var Title$d = styled.label(templateObject_2$S || (templateObject_2$S = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  position: relative;\n  align-items: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  &:after {\n    content: '';\n    border: solid rgba(0, 0, 0, 0.23);\n    border-width: 0 0 2px 2px;\n    display: inline-block;\n    padding: 4px;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: 17px;\n  }\n"], ["\n  display: flex;\n  cursor: pointer;\n  position: relative;\n  align-items: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  &:after {\n    content: '';\n    border: solid rgba(0, 0, 0, 0.23);\n    border-width: 0 0 2px 2px;\n    display: inline-block;\n    padding: 4px;\n    transform: rotate(-45deg);\n    position: absolute;\n    right: 17px;\n  }\n"])));
var Content$2 = styled.div(templateObject_3$H || (templateObject_3$H = __makeTemplateObject(["\n  height: auto;\n  opacity: 1;\n"], ["\n  height: auto;\n  opacity: 1;\n"])));
var Input = styled.input(templateObject_4$C || (templateObject_4$C = __makeTemplateObject(["\n  display: none;\n  &:checked ~ .title {\n    &:after {\n      transform: rotate(-225deg);\n    }\n  }\n  &:checked ~ .content {\n    height: 0;\n    opacity: 0;\n    overflow: hidden;\n    overflow-wrap: break-word;\n    transition: all 0.2s;\n  }\n"], ["\n  display: none;\n  &:checked ~ .title {\n    &:after {\n      transform: rotate(-225deg);\n    }\n  }\n  &:checked ~ .content {\n    height: 0;\n    opacity: 0;\n    overflow: hidden;\n    overflow-wrap: break-word;\n    transition: all 0.2s;\n  }\n"])));
var templateObject_1$X, templateObject_2$S, templateObject_3$H, templateObject_4$C;

var CloseButton = function (_a) {
    var onClick = _a.onClick, style = _a.style;
    return (React$1.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: __assign(__assign({}, style), { cursor: 'pointer' }), onClick: onClick },
        React$1.createElement("path", { d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z", fill: "black", fillOpacity: "0.87" })));
};
var CloseButton$1 = memo(CloseButton);

var SectionComponent = function (_a) {
    var sectionTitle = _a.sectionTitle, subtitle = _a.subtitle, items = _a.items, imgixHost = _a.imgixHost, style = _a.style;
    return (React$1.createElement(Container$R, { style: style },
        typeof sectionTitle !== 'undefined' && (React$1.createElement(SectionTitle$4, { title: sectionTitle, subtitle: subtitle })),
        items.map(function (item, index) {
            return typeof item === 'undefined' ? (React$1.createElement(CocoDivider$1, { key: index, style: { margin: '10px 0' } })) : (React$1.createElement(SectionItem$1, { key: index, title: item.title, path: item.path, spIconLinkUrl: item.spIconLinkUrl, openNewWindow: item.openNewWindow, onClickItem: item.onClickItem, imgixHost: imgixHost, style: style }));
        })));
};
var Section$3 = memo(SectionComponent);
var Container$R = styled.div(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n"])));
var templateObject_1$W;

var SignHeder = function (_a) {
    var signUpHref = _a.signUpHref, signInHref = _a.signInHref;
    return (React$1.createElement("div", null,
        React$1.createElement(MainContainer, null,
            React$1.createElement(A$3, { href: signUpHref, rel: "nofollow" },
                React$1.createElement(CocoRedButton, { containerType: 'div', height: '40px', fullWidth: true }, "\u7121\u6599\u4F1A\u54E1\u767B\u9332")),
            React$1.createElement(A$3, { href: signInHref, rel: "nofollow" },
                React$1.createElement(CocoWhiteButton, { containerType: 'div', height: '40px', fullWidth: true }, "\u30ED\u30B0\u30A4\u30F3")))));
};
var SignHeader = memo(SignHeder);
var MainContainer = styled.div(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  padding: 20px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  padding: 20px;\n"])));
var A$3 = styled.a(templateObject_2$R || (templateObject_2$R = __makeTemplateObject(["\n  text-decoration: none;\n  width: 100%;\n  margin-right: 15px;\n"], ["\n  text-decoration: none;\n  width: 100%;\n  margin-right: 15px;\n"])));
var templateObject_1$V, templateObject_2$R;

var queryString = {};

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

var decodeUriComponent = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

var splitOnFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};

var filterObj = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};

(function (exports) {
	const strictUriEncode$1 = strictUriEncode;
	const decodeComponent = decodeUriComponent;
	const splitOnFirst$1 = splitOnFirst;
	const filterObject = filterObj;

	const isNullOrUndefined = value => value === null || value === undefined;

	const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

	function encoderForArrayFormat(options) {
		switch (options.arrayFormat) {
			case 'index':
				return key => (result, value) => {
					const index = result.length;

					if (
						value === undefined ||
						(options.skipNull && value === null) ||
						(options.skipEmptyString && value === '')
					) {
						return result;
					}

					if (value === null) {
						return [...result, [encode(key, options), '[', index, ']'].join('')];
					}

					return [
						...result,
						[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
					];
				};

			case 'bracket':
				return key => (result, value) => {
					if (
						value === undefined ||
						(options.skipNull && value === null) ||
						(options.skipEmptyString && value === '')
					) {
						return result;
					}

					if (value === null) {
						return [...result, [encode(key, options), '[]'].join('')];
					}

					return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
				};

			case 'colon-list-separator':
				return key => (result, value) => {
					if (
						value === undefined ||
						(options.skipNull && value === null) ||
						(options.skipEmptyString && value === '')
					) {
						return result;
					}

					if (value === null) {
						return [...result, [encode(key, options), ':list='].join('')];
					}

					return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
				};

			case 'comma':
			case 'separator':
			case 'bracket-separator': {
				const keyValueSep = options.arrayFormat === 'bracket-separator' ?
					'[]=' :
					'=';

				return key => (result, value) => {
					if (
						value === undefined ||
						(options.skipNull && value === null) ||
						(options.skipEmptyString && value === '')
					) {
						return result;
					}

					// Translate null to an empty string so that it doesn't serialize as 'null'
					value = value === null ? '' : value;

					if (result.length === 0) {
						return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
					}

					return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
				};
			}

			default:
				return key => (result, value) => {
					if (
						value === undefined ||
						(options.skipNull && value === null) ||
						(options.skipEmptyString && value === '')
					) {
						return result;
					}

					if (value === null) {
						return [...result, encode(key, options)];
					}

					return [...result, [encode(key, options), '=', encode(value, options)].join('')];
				};
		}
	}

	function parserForArrayFormat(options) {
		let result;

		switch (options.arrayFormat) {
			case 'index':
				return (key, value, accumulator) => {
					result = /\[(\d*)\]$/.exec(key);

					key = key.replace(/\[\d*\]$/, '');

					if (!result) {
						accumulator[key] = value;
						return;
					}

					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}

					accumulator[key][result[1]] = value;
				};

			case 'bracket':
				return (key, value, accumulator) => {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');

					if (!result) {
						accumulator[key] = value;
						return;
					}

					if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}

					accumulator[key] = [].concat(accumulator[key], value);
				};

			case 'colon-list-separator':
				return (key, value, accumulator) => {
					result = /(:list)$/.exec(key);
					key = key.replace(/:list$/, '');

					if (!result) {
						accumulator[key] = value;
						return;
					}

					if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}

					accumulator[key] = [].concat(accumulator[key], value);
				};

			case 'comma':
			case 'separator':
				return (key, value, accumulator) => {
					const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
					const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
					value = isEncodedArray ? decode(value, options) : value;
					const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
					accumulator[key] = newValue;
				};

			case 'bracket-separator':
				return (key, value, accumulator) => {
					const isArray = /(\[\])$/.test(key);
					key = key.replace(/\[\]$/, '');

					if (!isArray) {
						accumulator[key] = value ? decode(value, options) : value;
						return;
					}

					const arrayValue = value === null ?
						[] :
						value.split(options.arrayFormatSeparator).map(item => decode(item, options));

					if (accumulator[key] === undefined) {
						accumulator[key] = arrayValue;
						return;
					}

					accumulator[key] = [].concat(accumulator[key], arrayValue);
				};

			default:
				return (key, value, accumulator) => {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}

					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}

	function validateArrayFormatSeparator(value) {
		if (typeof value !== 'string' || value.length !== 1) {
			throw new TypeError('arrayFormatSeparator must be single character string');
		}
	}

	function encode(value, options) {
		if (options.encode) {
			return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
		}

		return value;
	}

	function decode(value, options) {
		if (options.decode) {
			return decodeComponent(value);
		}

		return value;
	}

	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		}

		if (typeof input === 'object') {
			return keysSorter(Object.keys(input))
				.sort((a, b) => Number(a) - Number(b))
				.map(key => input[key]);
		}

		return input;
	}

	function removeHash(input) {
		const hashStart = input.indexOf('#');
		if (hashStart !== -1) {
			input = input.slice(0, hashStart);
		}

		return input;
	}

	function getHash(url) {
		let hash = '';
		const hashStart = url.indexOf('#');
		if (hashStart !== -1) {
			hash = url.slice(hashStart);
		}

		return hash;
	}

	function extract(input) {
		input = removeHash(input);
		const queryStart = input.indexOf('?');
		if (queryStart === -1) {
			return '';
		}

		return input.slice(queryStart + 1);
	}

	function parseValue(value, options) {
		if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
			value = Number(value);
		} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
			value = value.toLowerCase() === 'true';
		}

		return value;
	}

	function parse(query, options) {
		options = Object.assign({
			decode: true,
			sort: true,
			arrayFormat: 'none',
			arrayFormatSeparator: ',',
			parseNumbers: false,
			parseBooleans: false
		}, options);

		validateArrayFormatSeparator(options.arrayFormatSeparator);

		const formatter = parserForArrayFormat(options);

		// Create an object with no prototype
		const ret = Object.create(null);

		if (typeof query !== 'string') {
			return ret;
		}

		query = query.trim().replace(/^[?#&]/, '');

		if (!query) {
			return ret;
		}

		for (const param of query.split('&')) {
			if (param === '') {
				continue;
			}

			let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

			// Missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
			formatter(decode(key, options), value, ret);
		}

		for (const key of Object.keys(ret)) {
			const value = ret[key];
			if (typeof value === 'object' && value !== null) {
				for (const k of Object.keys(value)) {
					value[k] = parseValue(value[k], options);
				}
			} else {
				ret[key] = parseValue(value, options);
			}
		}

		if (options.sort === false) {
			return ret;
		}

		return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
			const value = ret[key];
			if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
				// Sort object keys, not values
				result[key] = keysSorter(value);
			} else {
				result[key] = value;
			}

			return result;
		}, Object.create(null));
	}

	exports.extract = extract;
	exports.parse = parse;

	exports.stringify = (object, options) => {
		if (!object) {
			return '';
		}

		options = Object.assign({
			encode: true,
			strict: true,
			arrayFormat: 'none',
			arrayFormatSeparator: ','
		}, options);

		validateArrayFormatSeparator(options.arrayFormatSeparator);

		const shouldFilter = key => (
			(options.skipNull && isNullOrUndefined(object[key])) ||
			(options.skipEmptyString && object[key] === '')
		);

		const formatter = encoderForArrayFormat(options);

		const objectCopy = {};

		for (const key of Object.keys(object)) {
			if (!shouldFilter(key)) {
				objectCopy[key] = object[key];
			}
		}

		const keys = Object.keys(objectCopy);

		if (options.sort !== false) {
			keys.sort(options.sort);
		}

		return keys.map(key => {
			const value = object[key];

			if (value === undefined) {
				return '';
			}

			if (value === null) {
				return encode(key, options);
			}

			if (Array.isArray(value)) {
				if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
					return encode(key, options) + '[]';
				}

				return value
					.reduce(formatter(key), [])
					.join('&');
			}

			return encode(key, options) + '=' + encode(value, options);
		}).filter(x => x.length > 0).join('&');
	};

	exports.parseUrl = (url, options) => {
		options = Object.assign({
			decode: true
		}, options);

		const [url_, hash] = splitOnFirst$1(url, '#');

		return Object.assign(
			{
				url: url_.split('?')[0] || '',
				query: parse(extract(url), options)
			},
			options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
		);
	};

	exports.stringifyUrl = (object, options) => {
		options = Object.assign({
			encode: true,
			strict: true,
			[encodeFragmentIdentifier]: true
		}, options);

		const url = removeHash(object.url).split('?')[0] || '';
		const queryFromUrl = exports.extract(object.url);
		const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

		const query = Object.assign(parsedQueryFromUrl, object.query);
		let queryString = exports.stringify(query, options);
		if (queryString) {
			queryString = `?${queryString}`;
		}

		let hash = getHash(object.url);
		if (object.fragmentIdentifier) {
			hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
		}

		return `${url}${queryString}${hash}`;
	};

	exports.pick = (input, filter, options) => {
		options = Object.assign({
			parseFragmentIdentifier: true,
			[encodeFragmentIdentifier]: false
		}, options);

		const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
		return exports.stringifyUrl({
			url,
			query: filterObject(query, filter),
			fragmentIdentifier
		}, options);
	};

	exports.exclude = (input, filter, options) => {
		const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

		return exports.pick(input, exclusionFilter, options);
	};
} (queryString));

var useLocalState$d = function (_a) {
    var logout = _a.logout, onClose = _a.onClose;
    var handleLogout = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var href;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, logout()];
                case 1:
                    _a.sent();
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    href = queryString.stringifyUrl({ url: '/' });
                    window.location.href = href;
                    return [2 /*return*/];
            }
        });
    }); }, [logout, onClose]);
    var signUpHref = useMemo(function () {
        var callbackUrl = window.location.pathname + window.location.search;
        return queryString.stringifyUrl({
            url: '/sign-up',
            query: {
                sign_callback: callbackUrl,
            },
        });
    }, []);
    var signInHref = useMemo(function () {
        var callbackUrl = window.location.pathname + window.location.search;
        return queryString.stringifyUrl({
            url: '/sign-in',
            query: {
                sign_callback: callbackUrl,
            },
        });
    }, []);
    return {
        signUpHref: signUpHref,
        signInHref: signInHref,
        handleLogout: handleLogout,
    };
};

var DrawerContent = function (_a) {
    var isMember = _a.isMember, email = _a.email, sections = _a.sections, logout = _a.logout, onClose = _a.onClose, imgixHost = _a.imgixHost, style = _a.style;
    var _b = useLocalState$d({
        logout: logout,
        onClose: onClose,
    }), signUpHref = _b.signUpHref, signInHref = _b.signInHref, handleLogout = _b.handleLogout;
    return (React$1.createElement(ContainerWrapper, null,
        React$1.createElement(Container$Q, { style: __assign({}, style) },
            React$1.createElement(HeaderContainer, null,
                React$1.createElement(CloseButton$1, { onClick: onClose }),
                React$1.createElement(CocoProductLogo$1, { type: 'black', style: {
                        margin: '11px auto 14px auto',
                    } })),
            !isMember && (React$1.createElement(SignHeader, { signUpHref: signUpHref, signInHref: signInHref })),
            sections.map(function (section, index) {
                return 'enableAccordion' in section ? (React$1.createElement(AccordionSection, { key: index, sectionTitle: section.sectionTitle, items: section.items, onClickItem: onClose, imgixHost: imgixHost, style: style })) : (React$1.createElement(Section$3, { key: index, sectionTitle: section.sectionTitle, items: section.items, imgixHost: imgixHost, style: style }));
            }),
            isMember && email && (React$1.createElement(React$1.Fragment, null,
                React$1.createElement(Section$3, { sectionTitle: '会員情報', subtitle: email, items: [
                        {
                            title: 'メールアドレス変更',
                            path: '/sign/reset-email',
                        },
                        {
                            title: 'ログアウト',
                            onClickItem: handleLogout,
                        },
                    ], imgixHost: imgixHost }))),
            React$1.createElement(Section$3, { sectionTitle: 'ヘルプ・その他', items: [
                    {
                        title: 'よくあるお問い合わせ',
                        path: '/faq',
                    },
                ], imgixHost: imgixHost }))));
};
var DrawerContent$1 = memo(DrawerContent);
var ContainerWrapper = styled.div(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  background: ", ";\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  background: ", ";\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])), COLORS.BACKGROUND.SURFACE);
var Container$Q = styled.div(templateObject_2$Q || (templateObject_2$Q = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var HeaderContainer = styled.div(templateObject_3$G || (templateObject_3$G = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 50px;\n  padding: 0 40px 0 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  height: 50px;\n  padding: 0 40px 0 16px;\n"])));
var templateObject_1$U, templateObject_2$Q, templateObject_3$G;

function use100vh() {
    var _a = __read(useState(measureHeight), 2), height = _a[0], setHeight = _a[1];
    var wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce();
    useEffect(function () {
        if (!wasRenderedOnClientAtLeastOnce)
            return;
        function setMeasuredHeight() {
            var measuredHeight = measureHeight();
            setHeight(measuredHeight);
        }
        window.addEventListener('resize', setMeasuredHeight);
        return function () { return window.removeEventListener('resize', setMeasuredHeight); };
    }, [wasRenderedOnClientAtLeastOnce]);
    return wasRenderedOnClientAtLeastOnce ? height : null;
}
function measureHeight() {
    if (!isClient())
        return null;
    return window.innerHeight;
}
// Once we ended up on the client, the first render must look the same as on
// the server so hydration happens without problems. _Then_ we immediately
// schedule a subsequent update and return the height measured on the client.
// It's not needed for CSR-only apps, but is critical for SSR.
function useWasRenderedOnClientAtLeastOnce() {
    var _a = __read(useState(false), 2), wasRenderedOnClientAtLeastOnce = _a[0], setWasRenderedOnClientAtLeastOnce = _a[1];
    useEffect(function () {
        if (isClient()) {
            setWasRenderedOnClientAtLeastOnce(true);
        }
    }, []);
    return wasRenderedOnClientAtLeastOnce;
}
function isClient() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * 全画面表示のモーダル
 * @param param0
 */
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, modalStyle = _a.modalStyle, children = _a.children;
    var viewHeight = use100vh();
    return (React$1.createElement(OuterContainer, null,
        React$1.createElement(Modal$2, { open: isOpen, onClose: onClose, classNames: {
                modalAnimationIn: 'enterDrawerModalAnimation',
                modalAnimationOut: 'leaveDrawerModalAnimation',
            }, focusTrapped: false, showCloseIcon: false, animationDuration: 250, closeOnOverlayClick: true, styles: {
                root: {
                    zIndex: Z_INDEX.MODAL,
                },
                overlay: {
                    padding: 0,
                },
                modal: __assign({ padding: 0, width: '80%', height: "".concat(viewHeight, "px"), margin: 'auto' }, modalStyle),
                modalContainer: {
                    textAlign: 'start',
                },
            } },
            React$1.createElement(Container$P, null, children))));
};
var Modal$1 = memo(Modal);
var OuterContainer = styled.div(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n  @keyframes enterDrawerModalAnimation {\n    0% {\n      opacity: 0;\n      transform: translate(-100%, 0);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0, 0);\n    }\n  }\n  @keyframes leaveDrawerModalAnimation {\n    0% {\n      transform: translate(0, 0);\n    }\n    100% {\n      transform: translate(-100%, 0);\n    }\n  }\n"], ["\n  @keyframes enterDrawerModalAnimation {\n    0% {\n      opacity: 0;\n      transform: translate(-100%, 0);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0, 0);\n    }\n  }\n  @keyframes leaveDrawerModalAnimation {\n    0% {\n      transform: translate(0, 0);\n    }\n    100% {\n      transform: translate(-100%, 0);\n    }\n  }\n"])));
var Container$P = styled.div(templateObject_2$P || (templateObject_2$P = __makeTemplateObject(["\n  position: relative;\n  box-sizing: border-box;\n  height: 100%;\n"], ["\n  position: relative;\n  box-sizing: border-box;\n  height: 100%;\n"])));
var templateObject_1$T, templateObject_2$P;

var CocoDrawer = function (_a) {
    var email = _a.email, isMember = _a.isMember, onClose = _a.onClose, logout = _a.logout, isOpen = _a.isOpen, imgixHost = _a.imgixHost;
    return (React$1.createElement(Modal$1, { isOpen: isOpen, onClose: onClose },
        React$1.createElement(DrawerContent$1, { isMember: isMember, email: email, logout: logout, onClose: onClose, imgixHost: imgixHost, sections: isMember ? MemberSection : NonMemberSection })));
};
var index$s = memo(CocoDrawer);
var DefaultSections = [
    {
        sectionTitle: '海外旅行',
        items: __spreadArray([], __read(GLOBAL_MENU_DP_PAGE_LINKS), false),
        enableAccordion: true,
    },
    {
        sectionTitle: '国内旅行',
        items: __spreadArray(__spreadArray([], __read(GLOBAL_MENU_JP_PAGE_LINKS), false), [
            {
                title: '国内旅行モデルコース',
                path: '/plans',
            },
            {
                title: '国内観光スポット',
                path: '/spots',
            },
        ], false),
        enableAccordion: true,
    },
];
var NonMemberSection = __spreadArray([
    {
        sectionTitle: undefined,
        items: [
            {
                title: '最近チェックしたホテル',
                path: '/histories',
            },
        ],
    }
], __read(DefaultSections), false);
var MemberSection = __spreadArray([
    {
        sectionTitle: '会員メニュー',
        items: [
            {
                title: '予約の確認',
                path: '/order/histories',
            },
            {
                title: '予約に関するお問い合わせ',
                path: '/faq',
            },
            {
                title: '最近チェックしたホテル',
                path: '/histories',
            },
            {
                title: '保存したホテル',
                path: '/bookmarks',
            },
            {
                title: '口コミの投稿・管理',
                path: '/my-reviews',
            },
        ],
    }
], __read(DefaultSections), false);

var useLocalState$c = function (hostUrl) {
    // NOTE: (yukikomatsu) If path is undefined, it is an external link.
    var generateHrefExternalOrInternalPath = useCallback(function (link) {
        if (typeof link.path === 'undefined') {
            return link.externalHref;
        }
        return hostUrl + link.path;
    }, [hostUrl]);
    return {
        generateHrefExternalOrInternalPath: generateHrefExternalOrInternalPath,
    };
};

var CocoFooter = function (_a) {
    var imgixHost = _a.imgixHost, hostUrl = _a.hostUrl, hasLinks = _a.hasLinks, style = _a.style;
    var generateHrefExternalOrInternalPath = useLocalState$c(hostUrl).generateHrefExternalOrInternalPath;
    return (React$1.createElement(Container$O, { style: style },
        hasLinks && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(PageLinks$1, null, PAGE_LINKS.map(function (section, index) { return (React$1.createElement(Section$2, { key: index },
                React$1.createElement(SectionTitle$2, null, typeof section.header.link === 'undefined' ? (section.header.title) : (React$1.createElement(SectionLink$1, { href: section.header.link }, section.header.title))),
                React$1.createElement(LinkList$1, null, section.links.map(function (link, index) {
                    var _a, _b;
                    return (React$1.createElement(LinkListItem$1, { key: index },
                        React$1.createElement(Link$4, { href: generateHrefExternalOrInternalPath(link), target: (_a = link.target) !== null && _a !== void 0 ? _a : undefined, rel: (_b = link.rel) !== null && _b !== void 0 ? _b : undefined }, link.title)));
                })),
                section.header.title === '海外旅行' && (React$1.createElement(LinkList$1, null, OVERSEAS_LINKS.map(function (link, index) { return (React$1.createElement(LinkOverseasListItem$1, { key: index },
                    React$1.createElement(Link$4, { href: generateHrefExternalOrInternalPath(link) }, link.title))); }))))); })),
            React$1.createElement(SnsLinkList$1, null, SNS_LINKS.map(function (link, index) { return (React$1.createElement(SnsLinkListItem$1, { key: index },
                React$1.createElement(Link$4, { href: link.href, target: link.target, rel: link.rel },
                    React$1.createElement(SnsImage$1, { src: addAutoFormatAndCompress("".concat(imgixHost).concat(link.src)), alt: link.alt })))); })))),
        React$1.createElement(LogoContainer$2, { hasLinks: hasLinks },
            React$1.createElement(Link$4, { href: hostUrl },
                React$1.createElement(Logo$1, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/logo/white.png")), alt: "\u3053\u3053\u308D\u304B\u3089" }))),
        React$1.createElement(Licence$1, null,
            "\u6771\u4EAC\u90FD\u77E5\u4E8B\u767B\u9332\u65C5\u884C\u696D\u7B2C2-7574\u53F7",
            React$1.createElement("br", null),
            "\u4E00\u822C\u793E\u56E3\u6CD5\u4EBA\u65E5\u672C\u65C5\u884C\u696D\u5354\u4F1A\uFF08JATA\uFF09\u6B63\u4F1A\u54E1",
            React$1.createElement("br", null),
            "\u00A9 Hotspring, Inc.")));
};
var index$r = memo(CocoFooter);
var Container$O = styled.footer(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n  background-color: #212121;\n  padding: 20px 0;\n"], ["\n  background-color: #212121;\n  padding: 20px 0;\n"])));
var LinkList$1 = styled.ul(templateObject_2$O || (templateObject_2$O = __makeTemplateObject([""], [""])));
var LinkListItem$1 = styled.li(templateObject_3$F || (templateObject_3$F = __makeTemplateObject(["\n  display: inline-block;\n  width: 50%;\n  font-size: 13px;\n  letter-spacing: 1px;\n"], ["\n  display: inline-block;\n  width: 50%;\n  font-size: 13px;\n  letter-spacing: 1px;\n"])));
var LinkOverseasListItem$1 = styled.li(templateObject_4$B || (templateObject_4$B = __makeTemplateObject(["\n  display: inline-block;\n  width: 33.3%;\n  font-size: 13px;\n  letter-spacing: 1px;\n"], ["\n  display: inline-block;\n  width: 33.3%;\n  font-size: 13px;\n  letter-spacing: 1px;\n"])));
var Link$4 = styled.a(templateObject_5$u || (templateObject_5$u = __makeTemplateObject(["\n  display: inline-block;\n  margin-block: 7px;\n  text-decoration: none;\n  color: ", ";\n  ", ";\n"], ["\n  display: inline-block;\n  margin-block: 7px;\n  text-decoration: none;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.INVERSE_PRIMARY, createFontStyle(MOBILE_FONT_STYLES.BODY_3));
var SnsLinkList$1 = styled.ul(templateObject_6$p || (templateObject_6$p = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  align-content: center;\n  margin-inline: 70px;\n"], ["\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  align-content: center;\n  margin-inline: 70px;\n"])));
var SnsLinkListItem$1 = styled.li(templateObject_7$j || (templateObject_7$j = __makeTemplateObject([""], [""])));
var LogoContainer$2 = styled.div(templateObject_8$h || (templateObject_8$h = __makeTemplateObject(["\n  margin: ", ";\n  text-align: center;\n"], ["\n  margin: ", ";\n  text-align: center;\n"])), function (props) { return (props.hasLinks ? '20px auto' : '0 auto 14px'); });
var Licence$1 = styled.p(templateObject_9$f || (templateObject_9$f = __makeTemplateObject(["\n  color: ", ";\n  text-align: center;\n  ", ";\n"], ["\n  color: ", ";\n  text-align: center;\n  ", ";\n"])), COLORS.TEXT.INVERSE_PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_1), { lineHeight: '22px', letterSpacing: '1px' })));
var SnsImage$1 = styled.img(templateObject_10$d || (templateObject_10$d = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n"], ["\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n"])));
var Logo$1 = styled.img(templateObject_11$a || (templateObject_11$a = __makeTemplateObject(["\n  height: 23px;\n  object-fit: cover;\n"], ["\n  height: 23px;\n  object-fit: cover;\n"])));
var PageLinks$1 = styled.div(templateObject_12$a || (templateObject_12$a = __makeTemplateObject(["\n  margin-left: 15px;\n"], ["\n  margin-left: 15px;\n"])));
var Section$2 = styled.div(templateObject_13$7 || (templateObject_13$7 = __makeTemplateObject(["\n  padding: 0 20px;\n  margin-block: 30px;\n"], ["\n  padding: 0 20px;\n  margin-block: 30px;\n"])));
var SectionTitle$2 = styled.h3(templateObject_14$7 || (templateObject_14$7 = __makeTemplateObject(["\n  margin-block-end: 7px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  color: ", ";\n"], ["\n  margin-block-end: 7px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  color: ", ";\n"])), COLORS.TEXT.INVERSE_PRIMARY);
var SectionLink$1 = styled.a(templateObject_15$4 || (templateObject_15$4 = __makeTemplateObject(["\n  display: inline-block;\n  text-decoration: none;\n  color: ", ";\n"], ["\n  display: inline-block;\n  text-decoration: none;\n  color: ", ";\n"])), COLORS.TEXT.INVERSE_PRIMARY);
var templateObject_1$S, templateObject_2$O, templateObject_3$F, templateObject_4$B, templateObject_5$u, templateObject_6$p, templateObject_7$j, templateObject_8$h, templateObject_9$f, templateObject_10$d, templateObject_11$a, templateObject_12$a, templateObject_13$7, templateObject_14$7, templateObject_15$4;

var img$1 = "data:image/svg+xml,%3csvg width='67' height='30' viewBox='0 0 67 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='67' height='30' rx='6' fill='white'/%3e%3crect x='0.5' y='0.5' width='66' height='29' rx='5.5' stroke='black' stroke-opacity='0.09'/%3e%3crect x='8' y='10' width='13' height='2' rx='1' fill='black' fill-opacity='0.87'/%3e%3crect x='8' y='14' width='13' height='2' rx='1' fill='black' fill-opacity='0.87'/%3e%3crect x='8' y='18' width='13' height='2' rx='1' fill='black' fill-opacity='0.87'/%3e%3cpath d='M32.29 11.448L31.462 11.16C31.426 11.358 31.345 11.646 31.282 11.826C31.012 12.591 30.643 13.446 30.058 14.283C29.347 13.734 28.303 12.996 27.529 12.501L27.061 13.068C27.925 13.608 28.933 14.346 29.599 14.886C28.708 15.975 27.601 16.974 26.026 17.712L26.647 18.279C28.213 17.46 29.329 16.389 30.175 15.372C30.949 16.038 31.633 16.677 32.299 17.442L32.866 16.821C32.227 16.128 31.453 15.426 30.643 14.76C31.246 13.887 31.696 12.897 31.993 12.105C32.065 11.916 32.191 11.61 32.29 11.448ZM34.792 12.141V12.951C35.071 12.942 35.368 12.924 35.683 12.924H39.535C39.832 12.924 40.174 12.933 40.426 12.951V12.141C40.174 12.168 39.859 12.177 39.535 12.177H35.683C35.386 12.177 35.08 12.159 34.792 12.141ZM34.018 16.596V17.46C34.324 17.442 34.639 17.415 34.963 17.415H40.354C40.597 17.415 40.903 17.433 41.173 17.46V16.596C40.912 16.623 40.624 16.641 40.354 16.641H34.963C34.639 16.641 34.324 16.614 34.018 16.596ZM48.013 13.716L47.464 13.455C47.383 13.491 47.158 13.518 47.014 13.518H44.278C44.053 13.518 43.783 13.491 43.567 13.464V14.22C43.792 14.211 44.026 14.193 44.287 14.193H47.149C47.122 14.706 46.861 16.461 46.726 17.217H43.468C43.198 17.217 42.937 17.199 42.721 17.181V17.928C42.982 17.91 43.189 17.901 43.468 17.901H48.4C48.589 17.901 48.922 17.91 49.084 17.919V17.19C48.895 17.208 48.571 17.217 48.373 17.217H47.491C47.617 16.389 47.878 14.607 47.95 13.995C47.959 13.923 47.986 13.806 48.013 13.716ZM50.488 14.103V14.985C50.767 14.958 51.244 14.94 51.739 14.94H56.68C57.085 14.94 57.463 14.976 57.643 14.985V14.103C57.445 14.121 57.121 14.148 56.671 14.148H51.739C51.235 14.148 50.758 14.121 50.488 14.103Z' fill='%23303545'/%3e%3c/svg%3e";

var DrawerIcon = function (props) { return (React$1.createElement(Container$N, { onClick: function () { var _a; return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props); }, style: props.style },
    React$1.createElement(Icon, { src: img$1, alt: "\u30E1\u30CB\u30E5\u30FC\u30A2\u30A4\u30B3\u30F3" }))); };
var DrawerIcon$1 = memo(DrawerIcon);
var Container$N = styled.div(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n  cursor: pointer;\n  width: 87px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 0;\n"], ["\n  cursor: pointer;\n  width: 87px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 0;\n"])));
var Icon = styled.img(templateObject_2$N || (templateObject_2$N = __makeTemplateObject(["\n  width: 67px;\n  height: 30px;\n"], ["\n  width: 67px;\n  height: 30px;\n"])));
var templateObject_1$R, templateObject_2$N;

var CocoLogoNavigationBar = function (_a) {
    var hideDrawer = _a.hideDrawer, onClickDrawer = _a.onClickDrawer, hostUrl = _a.hostUrl, currentStepIndex = _a.currentStepIndex, isInprogress = _a.isInprogress, steps = _a.steps, style = _a.style;
    return (React$1.createElement(Container$M, { style: style },
        !hideDrawer && React$1.createElement(DrawerIcon$1, { onClick: onClickDrawer }),
        typeof hostUrl !== 'undefined' ? (React$1.createElement(Link$3, { href: hostUrl },
            React$1.createElement(CocoProductLogo$1, { type: "black", style: {
                    margin: '11px 16px 14px 10px',
                } }))) : (React$1.createElement(CocoProductLogo$1, { type: "black", style: {
                margin: '11px 16px 14px 10px',
            } })),
        typeof currentStepIndex !== 'undefined' &&
            typeof steps !== 'undefined' && (React$1.createElement(CocoStepper$1, { style: { padding: '6px 30px 30px' }, steps: steps, isInprogress: isInprogress, currentStepIndex: currentStepIndex }))));
};
var index$q = memo(CocoLogoNavigationBar);
var Container$M = styled.div(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  background: ", ";\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);\n  z-index: ", ";\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  background: ", ";\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);\n  z-index: ", ";\n"])), COLORS.BACKGROUND.SURFACE, Z_INDEX.NAVIGATION);
var Link$3 = styled.a(templateObject_2$M || (templateObject_2$M = __makeTemplateObject([""], [""])));
var templateObject_1$Q, templateObject_2$M;

var CocoStaffComment = function (_a) {
    var staffComment = _a.staffComment, imgixHost = _a.imgixHost, commentStyle = _a.commentStyle, _b = _a.isBubble, isBubble = _b === void 0 ? true : _b, style = _a.style;
    var iconUrl = useMemo(function () {
        switch (staffComment.status) {
            case 'POSITIVE':
                return addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/positive-staff-icon.png"));
            case 'NEGATIVE':
                return addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/negative-staff-icon.png"));
        }
    }, [staffComment, imgixHost]);
    return (React$1.createElement(Container$L, { style: style, isBubble: isBubble },
        React$1.createElement(IconContainer$1, null,
            React$1.createElement(Image$b, { src: iconUrl, alt: '担当スタッフ' }),
            isBubble && React$1.createElement(IconLabel, null, "\u62C5\u5F53\u30B9\u30BF\u30C3\u30D5")),
        isBubble ? (React$1.createElement(CocoBubbleComment$1, { comment: staffComment.text, style: commentStyle })) : (React$1.createElement(Comment, null, staffComment.text))));
};
var CocoStaffComment$1 = memo(CocoStaffComment);
var Container$L = styled.div(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  padding: ", ";\n"], ["\n  display: flex;\n  align-items: flex-start;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  padding: ", ";\n"])), function (props) {
    return props.isBubble ? 'unset' : "".concat(COLORS.BACKGROUND.SURFACE);
}, function (props) {
    return props.isBubble ? 'unset' : "0px 1px 2px rgba(0, 0, 0, 0.14)";
}, function (props) { return (props.isBubble ? 'unset' : "8px"); }, function (props) { return (props.isBubble ? 'unset' : "12px"); });
var IconContainer$1 = styled.div(templateObject_2$L || (templateObject_2$L = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 7px 0 -7px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 7px 0 -7px;\n"])));
var Image$b = styled.img(templateObject_3$E || (templateObject_3$E = __makeTemplateObject(["\n  width: 48px;\n  height: 48px;\n"], ["\n  width: 48px;\n  height: 48px;\n"])));
var IconLabel = styled.span(templateObject_4$A || (templateObject_4$A = __makeTemplateObject(["\n  margin-top: 3px;\n  white-space: nowrap;\n  color: ", ";\n  ", ";\n  transform: scale(0.7);\n  transform-origin: center top;\n"], ["\n  margin-top: 3px;\n  white-space: nowrap;\n  color: ", ";\n  ", ";\n  transform: scale(0.7);\n  transform-origin: center top;\n"])), COLORS.TEXT.NO_IMPORTANT, createFontStyle(__assign({}, MOBILE_FONT_STYLES.CAPTION_1)));
var Comment = styled.div(templateObject_5$t || (templateObject_5$t = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-left: 12px;\n"], ["\n  ", ";\n  color: ", ";\n  margin-left: 12px;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_1), COLORS.TEXT.NO_IMPORTANT);
var templateObject_1$P, templateObject_2$L, templateObject_3$E, templateObject_4$A, templateObject_5$t;

var useLocalState$b = function (planType, onClick) {
    var onClickHeader = useCallback(function () {
        if (typeof onClick === 'undefined')
            return;
        onClick(planType);
    }, [onClick, planType]);
    return {
        onClickHeader: onClickHeader,
    };
};

var CocoSupportPlan = function (_a) {
    var supportPlanInfo = _a.supportPlanInfo, arrowImageUrl = _a.arrowImageUrl, isSelected = _a.isSelected, onClickRadio = _a.onClickRadio, inputRadioName = _a.inputRadioName, onClickButton = _a.onClickButton, buttonText = _a.buttonText, style = _a.style;
    var onClickHeader = useLocalState$b(supportPlanInfo.planType, onClickRadio).onClickHeader;
    return (React$1.createElement(Container$K, { style: style },
        typeof onClickRadio !== 'undefined' ? (React$1.createElement(Header$5, { onClick: onClickHeader, "data-is-clickable": 'true' },
            React$1.createElement(CocoInputRadio$1, { key: supportPlanInfo.planType, id: "support-plan-type-".concat(supportPlanInfo.planType), name: inputRadioName !== null && inputRadioName !== void 0 ? inputRadioName : "support-plan", value: supportPlanInfo.planType, checked: isSelected, style: { flex: 1, display: 'flex' }, labelStyle: {
                    flex: 1,
                    marginRight: 0,
                    cursor: 'pointer',
                }, buttonSize: 16, dataTestId: "support-plan-type-".concat(supportPlanInfo.planType) },
                React$1.createElement(FlexContainer$2, null,
                    React$1.createElement(Left, null,
                        React$1.createElement(PlanTitleAndDescriptionContainer, null,
                            React$1.createElement(PlanName, { color: supportPlanInfo.planColor }, supportPlanInfo.planName),
                            typeof supportPlanInfo.description !== 'undefined' && (React$1.createElement(PlanDescription, null, supportPlanInfo.description)))),
                    React$1.createElement(Price$4, null, typeof supportPlanInfo.priceDiff !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                        React$1.createElement("span", null,
                            supportPlanInfo.priceDiff < 0 ? '−' : '+',
                            "\u00A5"),
                        Math.abs(supportPlanInfo.priceDiff).toLocaleString())) : typeof supportPlanInfo.totalPrice !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                        React$1.createElement("span", null, "\u00A5"),
                        supportPlanInfo.totalPrice.toLocaleString())) : (React$1.createElement(React$1.Fragment, null))))))) : (React$1.createElement(Header$5, { "data-is-clickable": 'false' },
            React$1.createElement(FlexContainer$2, null,
                React$1.createElement(Left, null,
                    React$1.createElement(PlanTitleAndDescriptionContainer, null,
                        React$1.createElement(PlanName, { color: (typeof onClickButton !== 'undefined' &&
                                typeof buttonText !== 'undefined') ||
                                (typeof onClickButton === 'undefined' &&
                                    typeof buttonText === 'undefined' &&
                                    typeof supportPlanInfo.priceDiff === 'undefined' &&
                                    typeof supportPlanInfo.totalPrice === 'undefined')
                                ? COLORS.TEXT.PRIMARY
                                : supportPlanInfo.planColor }, supportPlanInfo.planName),
                        typeof supportPlanInfo.description !== 'undefined' && (React$1.createElement(PlanDescription, null, supportPlanInfo.description)))),
                typeof onClickButton !== 'undefined' &&
                    typeof buttonText !== 'undefined' ? (React$1.createElement(CocoWhiteButton, { style: {
                        height: '38px',
                    }, fontWeight: 'bold', onClick: onClickButton, "data-testid": "support-plan_button" }, buttonText)) : (React$1.createElement(Price$4, null, typeof supportPlanInfo.priceDiff !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                    React$1.createElement("span", null,
                        supportPlanInfo.priceDiff < 0 ? '−' : '+',
                        "\u00A5"),
                    Math.abs(supportPlanInfo.priceDiff).toLocaleString())) : typeof supportPlanInfo.totalPrice !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                    React$1.createElement("span", null, "\u00A5"),
                    supportPlanInfo.totalPrice.toLocaleString())) : (React$1.createElement(React$1.Fragment, null))))))),
        React$1.createElement(CocoAccordion$1, { items: supportPlanInfo.contents, idSuffix: 'CocoSupportPlan', arrowImageUrl: arrowImageUrl, tabsStyle: {
                border: "2px solid ".concat(COLORS.BACKGROUND.BASE),
                borderLeft: 'none',
                borderRight: 'none',
                borderBottom: 'none',
                borderRadius: '0 0 6px 6px',
            } })));
};
var index$p = memo(CocoSupportPlan);
var Container$K = styled.div(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.14);\n  border-radius: 8px;\n"], ["\n  background-color: ", ";\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.14);\n  border-radius: 8px;\n"])), COLORS.BACKGROUND.SURFACE);
var Header$5 = styled.div(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n  padding: 15px;\n\n  &[data-is-clickable='true'] {\n    cursor: pointer;\n  }\n"], ["\n  padding: 15px;\n\n  &[data-is-clickable='true'] {\n    cursor: pointer;\n  }\n"])));
var FlexContainer$2 = styled.div(templateObject_3$D || (templateObject_3$D = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var Left = styled.div(templateObject_4$z || (templateObject_4$z = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var PlanTitleAndDescriptionContainer = styled.div(templateObject_5$s || (templateObject_5$s = __makeTemplateObject([""], [""])));
var PlanName = styled.p(templateObject_6$o || (templateObject_6$o = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.SUB_TITLE_1), { letterSpacing: '0.04em' })), function (props) { return props.color; });
var PlanDescription = styled.p(templateObject_7$i || (templateObject_7$i = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.TEXT.NOTE_OR_CAPTION);
var Price$4 = styled.div(templateObject_8$g || (templateObject_8$g = __makeTemplateObject(["\n  margin-left: 2px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-right: 1px;\n    ", ";\n    vertical-align: top;\n  }\n"], ["\n  margin-left: 2px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-right: 1px;\n    ", ";\n    vertical-align: top;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { fontWeight: 'bold', letterSpacing: '-0.02em', lineHeight: 1 })), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_4), { fontWeight: 'bold', letterSpacing: '-0.02em' })));
var templateObject_1$O, templateObject_2$K, templateObject_3$D, templateObject_4$z, templateObject_5$s, templateObject_6$o, templateObject_7$i, templateObject_8$g;

var CocoSupportPlanCard = function (_a) {
    var supportPlanInfo = _a.supportPlanInfo, arrowImageUrl = _a.arrowImageUrl, _b = _a.isRecommend, isRecommend = _b === void 0 ? false : _b, idSuffix = _a.idSuffix, style = _a.style;
    return (React$1.createElement(Container$J, { style: style },
        isRecommend && React$1.createElement(RecommendLabel, null, "\u304A\u3059\u3059\u3081"),
        React$1.createElement(Header$4, { isRecommend: isRecommend },
            typeof supportPlanInfo.iconElement !== 'undefined' && (React$1.createElement(ImageContainer$4, null, supportPlanInfo.iconElement)),
            React$1.createElement(Content$1, null,
                React$1.createElement(PlanTitleSection, null,
                    React$1.createElement(Title$c, { color: supportPlanInfo.planColor }, supportPlanInfo.title),
                    typeof supportPlanInfo.price !== 'undefined' && (React$1.createElement(PriceLabel, null, supportPlanInfo.price == 0 ? ('¥0') : (React$1.createElement(React$1.Fragment, null,
                        React$1.createElement("span", { className: "price" },
                            "\u00A5",
                            supportPlanInfo.price.toLocaleString()),
                        React$1.createElement("span", { className: "tax" }, "\u00A0(\u7A0E\u8FBC)")))))),
                React$1.createElement(Description$7, null, supportPlanInfo.description))),
        React$1.createElement(CocoAccordion$1, { items: supportPlanInfo.contents, idSuffix: idSuffix, arrowImageUrl: arrowImageUrl })));
};
var CocoSupportPlanCard$1 = memo(CocoSupportPlanCard);
var Container$J = styled.div(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n  padding: 20px;\n  background: ", ";\n  border-radius: 8px;\n  margin-bottom: 15px;\n  position: relative;\n  overflow: hidden;\n"], ["\n  padding: 20px;\n  background: ", ";\n  border-radius: 8px;\n  margin-bottom: 15px;\n  position: relative;\n  overflow: hidden;\n"])), COLORS.BACKGROUND.SURFACE);
var Header$4 = styled.div(templateObject_2$J || (templateObject_2$J = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 15px;\n  padding-left: ", ";\n"], ["\n  display: flex;\n  margin-bottom: 15px;\n  padding-left: ", ";\n"])), function (props) { return (props.isRecommend ? '13px' : '0'); });
var ImageContainer$4 = styled.div(templateObject_3$C || (templateObject_3$C = __makeTemplateObject(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
var RecommendLabel = styled.div(templateObject_4$y || (templateObject_4$y = __makeTemplateObject(["\n  position: absolute;\n  text-align: center;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  background: ", ";\n  color: ", ";\n  font-weight: 700;\n  font-size: 8px;\n  top: -4px;\n  left: -45px;\n  padding: 20px 35px 5px;\n"], ["\n  position: absolute;\n  text-align: center;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  background: ", ";\n  color: ", ";\n  font-weight: 700;\n  font-size: 8px;\n  top: -4px;\n  left: -45px;\n  padding: 20px 35px 5px;\n"])), COLORS.GENERAL.PRIMARY, COLORS.INVERT_TEXT.PRIMARY);
var Title$c = styled.div(templateObject_5$r || (templateObject_5$r = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-right: 5px;\n"], ["\n  ", ";\n  color: ", ";\n  margin-right: 5px;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.SUB_TITLE_1), { letterSpacing: '0.04em' })), function (props) { return props.color; });
var PriceLabel = styled.div(templateObject_6$n || (templateObject_6$n = __makeTemplateObject(["\n  background: #ffebef;\n  color: ", ";\n  border: 1px solid #ffebef;\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding: 2px 8px;\n  ", ";\n  .price {\n    font-family: ", ";\n    letter-spacing: -0.01em;\n  }\n\n  .tax {\n    font-size: 11px;\n    font-weight: normal;\n  }\n"], ["\n  background: #ffebef;\n  color: ", ";\n  border: 1px solid #ffebef;\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding: 2px 8px;\n  ", ";\n  .price {\n    font-family: ", ";\n    letter-spacing: -0.01em;\n  }\n\n  .tax {\n    font-size: 11px;\n    font-weight: normal;\n  }\n"])), COLORS.GENERAL.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_2), FONT_FAMILY.AVENIR_NEXT);
var PlanTitleSection = styled.div(templateObject_7$h || (templateObject_7$h = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n"])));
var Content$1 = styled.div(templateObject_8$f || (templateObject_8$f = __makeTemplateObject(["\n  position: relative;\n  margin: auto 0 auto 10px;\n"], ["\n  position: relative;\n  margin: auto 0 auto 10px;\n"])));
var Description$7 = styled.div(templateObject_9$e || (templateObject_9$e = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.TEXT.PRIMARY);
var templateObject_1$N, templateObject_2$J, templateObject_3$C, templateObject_4$y, templateObject_5$r, templateObject_6$n, templateObject_7$h, templateObject_8$f, templateObject_9$e;

var useLocalState$a = function (_a) {
    var initCurrentIndex = _a.initCurrentIndex;
    var _b = __read(useState(initCurrentIndex), 2), currentIndex = _b[0], setCurrentIndex = _b[1];
    var onClickHandler = useCallback(function (onClick, item, index) {
        setCurrentIndex(index);
        onClick(item.code);
    }, []);
    return {
        currentIndex: currentIndex,
        onClickHandler: onClickHandler,
    };
};

var CocoDPFlightTabs = function (_a) {
    var items = _a.items, initCurrentIndex = _a.initCurrentIndex, onClick = _a.onClick, style = _a.style;
    var _b = useLocalState$a({ initCurrentIndex: initCurrentIndex }), currentIndex = _b.currentIndex, onClickHandler = _b.onClickHandler;
    return (React$1.createElement(Container$I, { style: style },
        React$1.createElement(TabContainer$1, null, items.map(function (item, index) { return (React$1.createElement(Tab, { key: index, isActive: currentIndex === index, onClick: function () {
                onClickHandler(onClick, item, index);
            } },
            React$1.createElement(React$1.Fragment, null, item.name))); }))));
};
var index$o = memo(CocoDPFlightTabs);
var Container$I = styled.div(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  width: 100%;\n  border-bottom: 1px solid ", ";\n"], ["\n  width: 100%;\n  border-bottom: 1px solid ", ";\n"])), COLORS.BORDER.SECONDARY);
var TabContainer$1 = styled.div(templateObject_2$I || (templateObject_2$I = __makeTemplateObject(["\n  display: flex;\n  padding: 10px 20px 15px 20px;\n  overflow-x: auto;\n"], ["\n  display: flex;\n  padding: 10px 20px 15px 20px;\n  overflow-x: auto;\n"])));
var Tab = styled.div(templateObject_3$B || (templateObject_3$B = __makeTemplateObject(["\n  padding: 6px 8px;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 20px;\n  ", "\n  background-color: ", ";\n  color: ", ";\n  text-wrap: nowrap;\n  white-space: nowrap;\n"], ["\n  padding: 6px 8px;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 20px;\n  ", "\n  background-color: ", ";\n  color: ", ";\n  text-wrap: nowrap;\n  white-space: nowrap;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '13px', letterSpacing: '0.39px' })), function (props) { return (props.isActive ? '#46a7ed' : 'transparent'); }, function (props) {
    return props.isActive ? COLORS.TEXT.INVERSE_PRIMARY : COLORS.TEXT.NO_IMPORTANT;
});
var templateObject_1$M, templateObject_2$I, templateObject_3$B;

var CocoAboutHotelGradeModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, imgixHost = _a.imgixHost, style = _a.style, minWidth = _a.minWidth;
    return (React$1.createElement(CocoModal$1, { title: '星の数(ホテルグレード)について', topMarginVh: 35, isOpen: isOpen, onClose: onClose, minWidth: minWidth },
        React$1.createElement(Container$H, { style: style },
            React$1.createElement(Text$1, null, "\u5404\u30DB\u30C6\u30EB\u306B\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u661F\u306E\u6570\u306F\u3001\u30DB\u30C6\u30EB\u306E\u30B0\u30EC\u30FC\u30C9\u3092\u8868\u3057\u3066\u3044\u307E\u3059\u3002"),
            React$1.createElement(GradeContainer, null,
                React$1.createElement(ImageAndGradeText, null,
                    React$1.createElement(Image$a, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: '1つ星ホテル' }),
                    React$1.createElement(GradeTitle, null, "1\u3064\u661F\u30DB\u30C6\u30EB")),
                React$1.createElement(GradeDescription, null, "\u3068\u306B\u304B\u304F\u304A\u30C8\u30AF\u306B\u65C5\u884C\u3057\u305F\u3044\u65B9\u306B\u304A\u3059\u3059\u3081\u306E\u30EA\u30FC\u30BA\u30CA\u30D6\u30EB\u306A\u30DB\u30C6\u30EB")),
            React$1.createElement(GradeContainer, null,
                React$1.createElement(ImageAndGradeText, null,
                    React$1.createElement(Image$a, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: '2つ星ホテル' }),
                    React$1.createElement(GradeTitle, null, "2\u3064\u661F\u30DB\u30C6\u30EB")),
                React$1.createElement(GradeDescription, null, "\u6700\u4F4E\u9650\u306E\u8A2D\u5099\u3084\u30B5\u30FC\u30D3\u30B9\u304C\u671F\u5F85\u3067\u304D\u308B\u3001\u30B3\u30B9\u30D1\u91CD\u8996\u306E\u65B9\u306B\u304A\u3059\u3059\u3081\u306E\u4F4E\u4FA1\u683C\u5E2F\u30DB\u30C6\u30EB")),
            React$1.createElement(GradeContainer, null,
                React$1.createElement(ImageAndGradeText, null,
                    React$1.createElement(Image$a, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: '3つ星ホテル' }),
                    React$1.createElement(GradeTitle, null, "3\u3064\u661F\u30DB\u30C6\u30EB")),
                React$1.createElement(GradeDescription, null, "\u5145\u5B9F\u306E\u8A2D\u5099\u3084\u30B5\u30FC\u30D3\u30B9\u3067\u5FEB\u9069\u306A\u6EDE\u5728\u3092\u305F\u306E\u3057\u3081\u308B\u3001\u6D77\u5916\u65C5\u884C\u521D\u5FC3\u8005\u306B\u3082\u304A\u3059\u3059\u3081\u306E\u30B9\u30BF\u30F3\u30C0\u30FC\u30C9\u30DB\u30C6\u30EB")),
            React$1.createElement(GradeContainer, null,
                React$1.createElement(ImageAndGradeText, null,
                    React$1.createElement(Image$a, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: '4つ星ホテル' }),
                    React$1.createElement(GradeTitle, null, "4\u3064\u661F\u30DB\u30C6\u30EB")),
                React$1.createElement(GradeDescription, null, "\u8A2D\u5099\u30FB\u30B5\u30FC\u30D3\u30B9\u30FB\u7ACB\u5730\u3092\u517C\u306D\u5099\u3048\u3001\u6587\u53E5\u306A\u3057\u306E\u6EDE\u5728\u304C\u671F\u5F85\u3067\u304D\u308B\u30CF\u30A4\u30AF\u30E9\u30B9\u30DB\u30C6\u30EB")),
            React$1.createElement(GradeContainer, null,
                React$1.createElement(ImageAndGradeText, null,
                    React$1.createElement(Image$a, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: '5つ星ホテル' }),
                    React$1.createElement(GradeTitle, null, "5\u3064\u661F\u30DB\u30C6\u30EB")),
                React$1.createElement(GradeDescription, null, "\u30A8\u30EA\u30A2\u6700\u4E0A\u7D1A\u306E\u8A2D\u5099\u3084\u30B5\u30FC\u30D3\u30B9\u3067\u3001\u65C5\u306E\u76EE\u7684\u306B\u306A\u308B\u30AF\u30E9\u30B9\u306E\u4E00\u6D41\u30E9\u30B0\u30B8\u30E5\u30A2\u30EA\u30FC\u30DB\u30C6\u30EB")))));
};
var index$n = memo(CocoAboutHotelGradeModal);
var Container$H = styled.div(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  padding: 20px;\n  color: ", ";\n  background-color: ", ";\n"], ["\n  padding: 20px;\n  color: ", ";\n  background-color: ", ";\n"])), COLORS.TEXT.NO_IMPORTANT, COLORS.BACKGROUND.SURFACE);
var Text$1 = styled.p(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_1));
var GradeContainer = styled.div(templateObject_3$A || (templateObject_3$A = __makeTemplateObject(["\n  &:first-of-type {\n    margin-top: 15px;\n  }\n  &:not(:first-of-type) {\n    margin-top: 10px;\n  }\n"], ["\n  &:first-of-type {\n    margin-top: 15px;\n  }\n  &:not(:first-of-type) {\n    margin-top: 10px;\n  }\n"])));
var ImageAndGradeText = styled.div(templateObject_4$x || (templateObject_4$x = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Image$a = styled.img(templateObject_5$q || (templateObject_5$q = __makeTemplateObject(["\n  width: 11px;\n  object-fit: cover;\n  margin-bottom: 2px;\n"], ["\n  width: 11px;\n  object-fit: cover;\n  margin-bottom: 2px;\n"])));
var GradeTitle = styled.p(templateObject_6$m || (templateObject_6$m = __makeTemplateObject(["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"], ["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_3));
var GradeDescription = styled.p(templateObject_7$g || (templateObject_7$g = __makeTemplateObject(["\n  margin-top: 3px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-top: 3px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_1), { lineHeight: '150%' })), COLORS.TEXT.NO_IMPORTANT);
var templateObject_1$L, templateObject_2$H, templateObject_3$A, templateObject_4$x, templateObject_5$q, templateObject_6$m, templateObject_7$g;

// NOTE: (@okuda) モダールが画面下に表示されるようmarginTopの調整のために利用する
var MODAL_HEADER_HEIGHT = 50;
var MODAL_CONTENTS_HEIGHT = 485;
var CocoLINEConsultationModal = function (_a) {
    var imgixHost = _a.imgixHost, lineLinkUrl = _a.lineLinkUrl, isOpen = _a.isOpen, onClose = _a.onClose, minWidth = _a.minWidth, style = _a.style;
    return (React$1.createElement(CocoModal$1, { title: "LINE\u3067\u7121\u6599\u76F8\u8AC7", isOpen: isOpen, onClose: onClose, minWidth: minWidth, styles: {
            modal: {
                marginTop: "calc(100vh - ".concat(MODAL_HEADER_HEIGHT + MODAL_CONTENTS_HEIGHT, "px)"),
                minHeight: "".concat(MODAL_HEADER_HEIGHT + MODAL_CONTENTS_HEIGHT, "px"),
            },
        } },
        React$1.createElement(Container$G, { style: style },
            React$1.createElement(CocoLINELinkWithKeyVisual$1, { lineLinkUrl: lineLinkUrl, imgixHost: imgixHost, style: { padding: '20px' } }))));
};
var index$m = memo(CocoLINEConsultationModal);
var Container$G = styled.div(templateObject_1$K || (templateObject_1$K = __makeTemplateObject([""], [""])));
var templateObject_1$K;

var QuickInfoCard = function (_a) {
    var title = _a.title, descriptionHTML = _a.descriptionHTML, color = _a.color, iconUrl = _a.iconUrl, style = _a.style;
    return (React$1.createElement(Container$F, { style: style },
        React$1.createElement(ImageContainer$3, null,
            React$1.createElement(Image$9, { src: iconUrl })),
        React$1.createElement(Content, null,
            React$1.createElement(Title$b, { color: color }, title),
            React$1.createElement(Description$6, null, descriptionHTML))));
};
var QuickInfoCard$1 = memo(QuickInfoCard);
var Container$F = styled.div(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n  background: ", ";\n  padding: 10px 15px;\n  display: flex;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  align-items: center;\n"], ["\n  color: ", ";\n  ", ";\n  background: ", ";\n  padding: 10px 15px;\n  display: flex;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  align-items: center;\n"])), COLORS.TEXT.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_2), COLORS.BACKGROUND.SURFACE);
var ImageContainer$3 = styled.div(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n  flex-shrink: 0;\n"], ["\n  flex-shrink: 0;\n"])));
var Image$9 = styled.img(templateObject_3$z || (templateObject_3$z = __makeTemplateObject(["\n  object-fit: cover;\n  width: 48px;\n  height: 48px;\n"], ["\n  object-fit: cover;\n  width: 48px;\n  height: 48px;\n"])));
var Content = styled.div(templateObject_4$w || (templateObject_4$w = __makeTemplateObject(["\n  margin-left: 10px;\n"], ["\n  margin-left: 10px;\n"])));
var Title$b = styled.div(templateObject_5$p || (templateObject_5$p = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_4), { lineHeight: '160%', fontWeight: '700' })), function (props) { return props.color; });
var Description$6 = styled.div(templateObject_6$l || (templateObject_6$l = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_1), { lineHeight: '150%' })));
var templateObject_1$J, templateObject_2$G, templateObject_3$z, templateObject_4$w, templateObject_5$p, templateObject_6$l;

var CocoUneasinessOverseasTravelSection = function (_a) {
    var imgixHost = _a.imgixHost, title = _a.title, travelarVoiceInfoList = _a.travelarVoiceInfoList, style = _a.style;
    var randomLineIconUrl = addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/random-line-gray.png"));
    return (React$1.createElement(Container$E, { style: style },
        React$1.createElement(TitleSection$1, null,
            React$1.createElement(LeftRandomLineImageContainer, null,
                React$1.createElement(Image$8, { src: randomLineIconUrl, width: 32, height: 28 })),
            React$1.createElement(Title$a, null,
                title.title1,
                React$1.createElement("br", null),
                title.title2),
            React$1.createElement(RightRandomLineImageContainer, null,
                React$1.createElement(Image$8, { src: randomLineIconUrl, width: 43, height: 38 }))),
        travelarVoiceInfoList.map(function (travelerVoiceInfo, idx) { return (React$1.createElement(QuickInfoCard$1, { key: "uneasiness-overseas-travel-section-".concat(idx), title: travelerVoiceInfo.title, descriptionHTML: travelerVoiceInfo.descriptionHTML, color: travelerVoiceInfo.color, iconUrl: addAutoFormatAndCompress("".concat(imgixHost).concat(travelerVoiceInfo.iconPath)) })); })));
};
var UneasinessOverseasTravelSection = memo(CocoUneasinessOverseasTravelSection);
var Container$E = styled.div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  background: ", ";\n  padding: 20px 20px 20px;\n  width: 100%;\n  box-sizing: border-box;\n"], ["\n  background: ", ";\n  padding: 20px 20px 20px;\n  width: 100%;\n  box-sizing: border-box;\n"])), COLORS.BACKGROUND.BASE);
var TitleSection$1 = styled.div(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Title$a = styled.div(templateObject_3$y || (templateObject_3$y = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n  margin-bottom: 23px;\n  text-align: center;\n"], ["\n  color: ", ";\n  ", ";\n  margin-bottom: 23px;\n  text-align: center;\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.HEADLINE_2), { letterSpacing: '2px' })));
var Image$8 = styled.img(templateObject_4$v || (templateObject_4$v = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
var LeftRandomLineImageContainer = styled.div(templateObject_5$o || (templateObject_5$o = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  bottom: 20px;\n  transform: rotate(-90deg);\n  object-fit: cover;\n  width: 43px;\n  height: 38px;\n"], ["\n  position: absolute;\n  left: 0;\n  bottom: 20px;\n  transform: rotate(-90deg);\n  object-fit: cover;\n  width: 43px;\n  height: 38px;\n"])));
var RightRandomLineImageContainer = styled.div(templateObject_6$k || (templateObject_6$k = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  bottom: 14px;\n  object-fit: cover;\n  width: 43px;\n  height: 38px;\n"], ["\n  position: absolute;\n  right: 0;\n  bottom: 14px;\n  object-fit: cover;\n  width: 43px;\n  height: 38px;\n"])));
var templateObject_1$I, templateObject_2$F, templateObject_3$y, templateObject_4$v, templateObject_5$o, templateObject_6$k;

var CocoESIMOverseasTravelSection = function (_a) {
    var imgixHost = _a.imgixHost, title = _a.title, eSIMInfoList = _a.eSIMInfoList, style = _a.style;
    return (React$1.createElement(Container$D, { style: style },
        React$1.createElement(TitleSection, null, title),
        React$1.createElement(CardContainer, null, eSIMInfoList.map(function (eSIMInfo, idx) { return (React$1.createElement(QuickInfoCard$1, { key: "esim-overseas-travel-section-".concat(idx), title: eSIMInfo.title, descriptionHTML: eSIMInfo.description, color: eSIMInfo.color, iconUrl: addAutoFormatAndCompress("".concat(imgixHost).concat(eSIMInfo.iconPath)) })); }))));
};
var index$l = memo(CocoESIMOverseasTravelSection);
var Container$D = styled.div(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  background: ", ";\n  padding: 20px 20px 20px;\n  width: 100%;\n  box-sizing: border-box;\n"], ["\n  background: ", ";\n  padding: 20px 20px 20px;\n  width: 100%;\n  box-sizing: border-box;\n"])), COLORS.BACKGROUND.BASE);
var TitleSection = styled.div(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n  text-align: center;\n"], ["\n  color: ", ";\n  ", ";\n  text-align: center;\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.HEADLINE_2), { letterSpacing: '2px' })));
var CardContainer = styled.div(templateObject_3$x || (templateObject_3$x = __makeTemplateObject(["\n  margin-top: 23px;\n"], ["\n  margin-top: 23px;\n"])));
var templateObject_1$H, templateObject_2$E, templateObject_3$x;

var CocoESIMTrifaSection = function (_a) {
    var style = _a.style, imgixHost = _a.imgixHost;
    return (React$1.createElement(Container$C, { style: style },
        React$1.createElement(CocoLightBulbTitle$1, { title: {
                title1: '旅行者全員、おひとり',
                title2: '1GBを無料で利用できます',
            }, imgixHost: imgixHost }),
        React$1.createElement(Description$5, null,
            "\u3053\u3053\u308D\u304B\u3089\u3067\u6D77\u5916\u822A\u7A7A\u5238\uFF0B\u30DB\u30C6\u30EB\u3092\u4E88\u7D04\u3059\u308C\u3070\u3001",
            React$1.createElement("br", null),
            "12\u6B73\u4EE5\u4E0A\u306E\u65C5\u884C\u80051\u540D\u306B\u3064\u304D1GB\u307E\u3067\u7121\u6599\uFF01"),
        React$1.createElement(QuickInfoCard$1, { title: '追加ギガはアプリでチャージ', descriptionHTML: '必要な分だけすぐにチャージできるから、便利でおトク！', color: '#03AA54', iconUrl: addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/esim/icons/charge.png")), style: { marginTop: '15px' } }),
        React$1.createElement(CautionText$2, { style: { marginTop: '15px' } }, "\u203B\u5404\u81EA\u306E\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306B\u3066\u3001\u30A2\u30D7\u30EA\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3068\u8A2D\u5B9A\u304C\u5FC5\u8981\u3067\u3059\u3002"),
        React$1.createElement(CautionText$2, { style: { marginTop: '10px' } },
            "\u203BeSIM\u5BFE\u5FDC\u7AEF\u672B\u3092\u304A\u6301\u3061\u306E\u65C5\u884C\u8005\u3055\u307E\u306E\u307F\u5BFE\u8C61\u3068\u306A\u308A\u307E\u3059\u3002\u3054\u81EA\u5206\u306E\u30B9\u30DE\u30DB\u306E\u5BFE\u5FDC\u6709\u7121\u306F\u3001",
            React$1.createElement(A$2, { href: "https://erake.freshdesk.com/ja-JP/support/home", target: "_blank", rel: "noreferrer" }, "\u3053\u3061\u3089"),
            "\u3067\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),
        React$1.createElement(CocoLightBulbTitle$1, { title: {
                title1: '予約後は、ガイドに従って',
                title2: 'アプリでかんたん準備',
            }, imgixHost: imgixHost, style: { marginTop: '30px' } }),
        React$1.createElement(Description$5, null, "\u63A5\u7D9A\u306B\u306F\u3001\u6D77\u5916eSIM\u30A2\u30D7\u30EA\u300E\u30C8\u30EA\u30D5\u30A1\u300F\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002 24\u6642\u9593365\u65E5\u5BFE\u5FDC\u306E\u30C1\u30E3\u30C3\u30C8\u30B5\u30DD\u30FC\u30C8\u4ED8\u304D\uFF01"),
        React$1.createElement(CocoTrifaLink$1, { style: { marginTop: '15px' }, imgixHost: imgixHost, isGrayBackground: false })));
};
var index$k = memo(CocoESIMTrifaSection);
var Container$C = styled.div(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  padding: 20px 20px 30px;\n  background: #eda403;\n"], ["\n  padding: 20px 20px 30px;\n  background: #eda403;\n"])));
var Description$5 = styled.p(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-top: 15px;\n  text-align: center;\n"], ["\n  ", ";\n  color: ", ";\n  margin-top: 15px;\n  text-align: center;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.INVERT_TEXT.PRIMARY);
var CautionText$2 = styled.p(templateObject_3$w || (templateObject_3$w = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_2), { letterSpacing: '1px' })), COLORS.INVERT_TEXT.PRIMARY);
var A$2 = styled.a(templateObject_4$u || (templateObject_4$u = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), COLORS.TEXT.INVERSE_PRIMARY);
var templateObject_1$G, templateObject_2$D, templateObject_3$w, templateObject_4$u;

var CocoSelectOptionCard = function (_a) {
    var children = _a.children, title = _a.title, price = _a.price, onClickRadio = _a.onClickRadio, inputRadioName = _a.inputRadioName, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, dataTestId = _a.dataTestId, style = _a.style;
    return (React$1.createElement(React$1.Fragment, null, typeof onClickRadio !== 'undefined' ? (React$1.createElement(Container$B, { isSelected: isSelected, style: style, onClick: onClickRadio, "data-is-clickable": 'true', "data-testid": dataTestId },
        React$1.createElement(Inner$2, null,
            React$1.createElement(UpperContainer, null,
                React$1.createElement(RadioButtonAndTitle, null,
                    React$1.createElement(CocoInputRadio$1, { name: inputRadioName, checked: isSelected, defaultChecked: isSelected, style: { flex: 1, display: 'flex' }, labelStyle: {
                            flex: 1,
                            marginRight: 0,
                            cursor: 'pointer',
                        }, buttonSize: 16 },
                        React$1.createElement(Title$9, null, title))),
                typeof price !== 'undefined' && (React$1.createElement(Price$3, null,
                    React$1.createElement(React$1.Fragment, null,
                        React$1.createElement(Unit, null,
                            price > 0 ? '+' : '',
                            "\u00A5"),
                        price.toLocaleString(),
                        price > 0 && React$1.createElement(PricePerOne, null, " / 1\u540D"))))),
            React$1.createElement(Description$4, null, children)))) : (React$1.createElement(Container$B, { style: style, "data-is-clickable": 'false' },
        React$1.createElement(Inner$2, null,
            React$1.createElement(FlexContainer$1, null,
                React$1.createElement(TitleAndDescriptionContainer, null,
                    React$1.createElement(WithoutRadioTitle, { isSelected: isSelected }, title),
                    React$1.createElement(Description$4, null, children))))))));
};
var index$j = memo(CocoSelectOptionCard);
var Container$B = styled.div(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 6px;\n  border: 1px solid\n    ", ";\n  cursor: pointer;\n"], ["\n  background-color: ", ";\n  border-radius: 6px;\n  border: 1px solid\n    ", ";\n  cursor: pointer;\n"])), function (props) {
    return props.isSelected ? 'rgba(255, 77, 79, 0.1)' : COLORS.BACKGROUND.SURFACE;
}, function (props) {
    return props.isSelected ? COLORS.GENERAL.PRIMARY : COLORS.BORDER.SECONDARY;
});
var Inner$2 = styled.div(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 7px 15px 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 7px 15px 10px;\n"])));
var Title$9 = styled.p(templateObject_3$v || (templateObject_3$v = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-top: 5px;\n"], ["\n  ", ";\n  color: ", ";\n  margin-top: 5px;\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_2), COLORS.TEXT.PRIMARY);
var Description$4 = styled.p(templateObject_4$t || (templateObject_4$t = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_2), COLORS.TEXT.NO_IMPORTANT);
var UpperContainer = styled.div(templateObject_5$n || (templateObject_5$n = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var RadioButtonAndTitle = styled.div(templateObject_6$j || (templateObject_6$j = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Unit = styled.span(templateObject_7$f || (templateObject_7$f = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_2));
var Price$3 = styled.div(templateObject_8$e || (templateObject_8$e = __makeTemplateObject(["\n  margin-left: 10px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-right: 1px;\n    white-space: nowrap;\n    letterspacing: '0.06em';\n  }\n"], ["\n  margin-left: 10px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-right: 1px;\n    white-space: nowrap;\n    letterspacing: '0.06em';\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.SUB_TITLE_1), { lineHeight: 2.24 })), COLORS.TEXT.PRIMARY);
var PricePerOne = styled.span(templateObject_9$d || (templateObject_9$d = __makeTemplateObject(["\n  ", "\n  color: ", "\n  vertical-align: middle;\n"], ["\n  ", "\n  color: ", "\n  vertical-align: middle;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_2), { lineHeight: 2.4 })), COLORS.TEXT.PRIMARY);
var FlexContainer$1 = styled.div(templateObject_10$c || (templateObject_10$c = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var TitleAndDescriptionContainer = styled.div(templateObject_11$9 || (templateObject_11$9 = __makeTemplateObject([""], [""])));
var WithoutRadioTitle = styled.p(templateObject_12$9 || (templateObject_12$9 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1), function (props) { return (props.isSelected ? '#03AA54' : COLORS.TEXT.PRIMARY); });
var templateObject_1$F, templateObject_2$C, templateObject_3$v, templateObject_4$t, templateObject_5$n, templateObject_6$j, templateObject_7$f, templateObject_8$e, templateObject_9$d, templateObject_10$c, templateObject_11$9, templateObject_12$9;

var NonScaleIndicator = function (_a) {
    var pageCount = _a.pageCount, currentPage = _a.currentPage, style = _a.style;
    return (React$1.createElement(Container$A, { style: style }, __spreadArray([], __read(new Array(pageCount)), false).map(function (_, index) {
        return (React$1.createElement(IndicatorDot$1, { key: index, variants: IndicatorDotVariant, initial: index === currentPage ? 'active' : 'inactive', animate: index === currentPage ? 'active' : 'inactive', transition: {
                duration: 0.5,
                ease: 'easeOut',
            } }));
    })));
};
var NonScaleIndicator$1 = memo(NonScaleIndicator);
var Container$A = styled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var IndicatorDot$1 = styled(motion.div)(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin: 0 2px;\n  background: ", ";\n"], ["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin: 0 2px;\n  background: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var IndicatorDotVariant = {
    active: {
        scale: 1,
        opacity: 1,
    },
    inactive: {
        scale: 1,
        opacity: 0.5,
    },
};
var templateObject_1$E, templateObject_2$B;

var useLocalState$9 = function (pageCount, currentPage) {
    var startPosition = useMemo(function () {
        return currentPage < 3
            ? 0
            : currentPage >= pageCount - 3
                ? pageCount - 7
                : currentPage - 3;
    }, [currentPage, pageCount]);
    var endPosition = useMemo(function () {
        return Math.min(pageCount, startPosition + 6);
    }, [pageCount, startPosition]);
    var isUseLayoutTransition = useMemo(function () {
        return currentPage >= 3 && currentPage < pageCount - 3;
    }, [currentPage, pageCount]);
    var getDotScale = function (page, selectedPage, pageCount, startPosition, endPosition, isInitial) {
        var isOverFirstPage = selectedPage >= 4;
        var isUnderLastPage = selectedPage < pageCount - 4;
        var isScaleTransition = isOverFirstPage && isUnderLastPage;
        if (isScaleTransition) {
            if (isInitial)
                return 0;
            var pageDiff = Math.abs(page - selectedPage);
            if (pageDiff === 0) {
                return 1.0;
            }
            else if (pageDiff === 1) {
                return 1.0;
            }
            else if (pageDiff === 2) {
                return 4 / 6;
            }
            else {
                return 2 / 6;
            }
        }
        else {
            if ((isUnderLastPage && page === endPosition) ||
                (isOverFirstPage && page === startPosition)) {
                return 2 / 6;
            }
            else {
                return 1.0;
            }
        }
    };
    return {
        startPosition: startPosition,
        endPosition: endPosition,
        isUseLayoutTransition: isUseLayoutTransition,
        getDotScale: getDotScale,
    };
};

var Indicators = function (_a) {
    var pageCount = _a.pageCount, currentPage = _a.currentPage, style = _a.style;
    var _b = useLocalState$9(pageCount, currentPage), startPosition = _b.startPosition, endPosition = _b.endPosition, isUseLayoutTransition = _b.isUseLayoutTransition, getDotScale = _b.getDotScale;
    return (React$1.createElement(Container$z, { style: style },
        React$1.createElement(DotContainer, null,
            React$1.createElement(AnimateSharedLayout, null, __spreadArray([], __read(new Array(pageCount)), false).map(function (_, index) {
                return {
                    index: index,
                    id: "item-".concat(index),
                    isActive: index === currentPage,
                    isVisible: index >= startPosition && index <= endPosition,
                };
            })
                .filter(function (item) { return item.isVisible; })
                .map(function (item) {
                return (React$1.createElement(IndicatorDot, { key: item.id, layout: isUseLayoutTransition, initial: {
                        opacity: item.isActive ? 1 : 0.5,
                        scale: getDotScale(item.index, currentPage, pageCount, startPosition, endPosition, false),
                    }, animate: {
                        opacity: item.isActive ? 1 : 0.5,
                        scale: getDotScale(item.index, currentPage, pageCount, startPosition, endPosition, false),
                    }, exit: { opacity: 0, scale: 0.0 }, transition: isUseLayoutTransition
                        ? {
                            duration: 0.4,
                            ease: 'easeOut',
                        }
                        : {
                            duration: 0.3,
                            ease: 'easeOut',
                        } }));
            })))));
};
var ScaleIndicator = memo(Indicators);
var Container$z = styled.div(templateObject_1$D || (templateObject_1$D = __makeTemplateObject([""], [""])));
var DotContainer = styled(motion.div)(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"])));
var IndicatorDot = styled(motion.div)(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin: 0 2px;\n  background: ", ";\n"], ["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  margin: 0 2px;\n  background: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var templateObject_1$D, templateObject_2$A, templateObject_3$u;

/**
 * モーダル周りのStateを管理する
 * @returns
 */
var useModal = function () {
    var _a = __read(useState(false), 2), isOpenModal = _a[0], setIsOpen = _a[1];
    var openModal = useCallback(function () { return setIsOpen(true); }, []);
    var closeModal = useCallback(function () { return setIsOpen(false); }, []);
    return { isOpenModal: isOpenModal, openModal: openModal, closeModal: closeModal };
};

/**
 * EventListenerのHooks.
 * こちらのものを利用
 * https://usehooks-typescript.com/react-hook/use-event-listener
 */
var useEventListener = function (eventName, handler, element) {
    // Create a ref that stores handler
    var savedHandler = useRef();
    useEffect(function () {
        // Define the listening target
        var targetElement = (element === null || element === void 0 ? void 0 : element.current) || window;
        if (!(targetElement && targetElement.addEventListener)) {
            return;
        }
        // Update saved handler if necessary
        if (savedHandler.current !== handler) {
            savedHandler.current = handler;
        }
        // Create event listener that calls handler function stored in ref
        var eventListener = function (event) {
            // eslint-disable-next-line no-extra-boolean-cast
            if (!!(savedHandler === null || savedHandler === void 0 ? void 0 : savedHandler.current)) {
                savedHandler.current(event);
            }
        };
        targetElement.addEventListener(eventName, eventListener);
        // Remove event listener on cleanup
        return function () {
            targetElement.removeEventListener(eventName, eventListener);
        };
    }, [eventName, element, handler]);
};

/**
 * ReactのElementのサイズを取得
 * こちらのものを利用
 * https://usehooks-typescript.com/react-hook/use-element-size
 */
var useElementSize = function (elementRef) {
    var _a = __read(useState({
        width: 0,
        height: 0,
    }), 2), size = _a[0], setSize = _a[1];
    // Prevent too many rendering using useCallback
    var updateSize = useCallback(function () {
        var node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        if (node) {
            setSize({
                width: node.offsetWidth || 0,
                height: node.offsetHeight || 0,
            });
        }
    }, [elementRef]);
    // Initial size on mount
    useEffect(function () {
        updateSize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEventListener('resize', updateSize);
    return size;
};

/**
 * body要素のスクロールをロックします
 *
 * 横方向にスクロールしている最中に、ウインドウの縦方向のスクロールを防ぐ等（逆も然り）の目的で利用されます
 *
 * @param enabled body要素のスクロールのロックを有効にするかどうか
 */
var useLockBodyScroll = function (enabled) {
    useEffect(function () {
        document.body.style.overflow = enabled ? 'hidden' : ''; // enabled がfalseに切り替わった場合には、もとに戻す
    }, [enabled]);
};

var modules = {};

var Link$2 = {};

var scrollLink = {};

var scrollSpy$2 = {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$5 = freeGlobal$2 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root$5.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$3(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$3(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$3(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString$2.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$3(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$3(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle;

var passiveEventListeners = {};

Object.defineProperty(passiveEventListeners, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
passiveEventListeners.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

passiveEventListeners.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

Object.defineProperty(scrollSpy$2, "__esModule", {
  value: true
});

var _lodash = lodash_throttle;

var _lodash2 = _interopRequireDefault$9(_lodash);

var _passiveEventListeners$1 = passiveEventListeners;

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy$1 = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy$1.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy$1.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners$1.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy$1.scrollSpyContainers[scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy$1.currentPositionX(scrollSpyContainer), scrollSpy$1.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy$1.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy$1.scrollSpyContainers[scrollSpy$1.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy$1.currentPositionX(scrollSpyContainer), scrollSpy$1.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy$1.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy$1.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy$1.spySetState && scrollSpy$1.spySetState.length && scrollSpy$1.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy$1.spySetState.splice(scrollSpy$1.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy$1.scrollHandler);
  },


  update: function update() {
    return scrollSpy$1.scrollSpyContainers.forEach(function (c) {
      return scrollSpy$1.scrollHandler(c);
    });
  }
};

scrollSpy$2.default = scrollSpy$1;

var scroller$1 = {};

var utils = {};

Object.defineProperty(utils, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

utils.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

var animateScroll$1 = {};

var smooth = {};

Object.defineProperty(smooth, "__esModule", {
  value: true
});
smooth.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

var cancelEvents = {};

Object.defineProperty(cancelEvents, "__esModule", {
  value: true
});

var _passiveEventListeners = passiveEventListeners;

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

cancelEvents.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

var scrollEvents = {};

Object.defineProperty(scrollEvents, "__esModule", {
	value: true
});

var Events$1 = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events$1.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events$1.registered[evtName] = null;
		}
	}
};

scrollEvents.default = Events$1;

Object.defineProperty(animateScroll$1, "__esModule", {
  value: true
});

var _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils$2 = utils;

_interopRequireDefault$8(_utils$2);

var _smooth = smooth;

var _smooth2 = _interopRequireDefault$8(_smooth);

var _cancelEvents = cancelEvents;

var _cancelEvents2 = _interopRequireDefault$8(_cancelEvents);

var _scrollEvents$2 = scrollEvents;

var _scrollEvents2$2 = _interopRequireDefault$8(_scrollEvents$2);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2$2.default.registered['end']) {
      _scrollEvents2$2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  }
  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2$2.default.registered['end']) {
    _scrollEvents2$2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2$2.default.registered['end']) {
      _scrollEvents2$2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2$2.default.registered['begin']) {
        _scrollEvents2$2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2$2.default.registered['begin']) {
    _scrollEvents2$2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends$5({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

animateScroll$1.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

Object.defineProperty(scroller$1, "__esModule", {
  value: true
});

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils$1 = utils;

var _utils2$1 = _interopRequireDefault$7(_utils$1);

var _animateScroll$1 = animateScroll$1;

var _animateScroll2$1 = _interopRequireDefault$7(_animateScroll$1);

var _scrollEvents$1 = scrollEvents;

var _scrollEvents2$1 = _interopRequireDefault$7(_scrollEvents$1);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

scroller$1.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends$4({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2$1.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2$1.default.registered['begin']) {
        _scrollEvents2$1.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2$1.default.registered['end']) {
        _scrollEvents2$1.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2$1.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min();
		} else {
		  module.exports = requireReactIs_development();
		}
} (reactIs));
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var scrollHash$2 = {};

Object.defineProperty(scrollHash$2, "__esModule", {
  value: true
});

var _utils = utils;

var _utils2 = _interopRequireDefault$6(_utils);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash$1 = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

scrollHash$2.default = scrollHash$1;

Object.defineProperty(scrollLink, "__esModule", {
  value: true
});

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$4 = React$1;

var _react2$4 = _interopRequireDefault$5(_react$4);

var _scrollSpy$1 = scrollSpy$2;

var _scrollSpy2$1 = _interopRequireDefault$5(_scrollSpy$1);

var _scroller$2 = scroller$1;

var _scroller2$2 = _interopRequireDefault$5(_scroller$2);

var _propTypes$2 = propTypes.exports;

var _propTypes2$2 = _interopRequireDefault$5(_propTypes$2);

var _scrollHash = scrollHash$2;

var _scrollHash2 = _interopRequireDefault$5(_scrollHash);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes$1 = {
  to: _propTypes2$2.default.string.isRequired,
  containerId: _propTypes2$2.default.string,
  container: _propTypes2$2.default.object,
  activeClass: _propTypes2$2.default.string,
  activeStyle: _propTypes2$2.default.object,
  spy: _propTypes2$2.default.bool,
  horizontal: _propTypes2$2.default.bool,
  smooth: _propTypes2$2.default.oneOfType([_propTypes2$2.default.bool, _propTypes2$2.default.string]),
  offset: _propTypes2$2.default.number,
  delay: _propTypes2$2.default.number,
  isDynamic: _propTypes2$2.default.bool,
  onClick: _propTypes2$2.default.func,
  duration: _propTypes2$2.default.oneOfType([_propTypes2$2.default.number, _propTypes2$2.default.func]),
  absolute: _propTypes2$2.default.bool,
  onSetActive: _propTypes2$2.default.func,
  onSetInactive: _propTypes2$2.default.func,
  ignoreCancelEvents: _propTypes2$2.default.bool,
  hashSpy: _propTypes2$2.default.bool,
  saveHashHistory: _propTypes2$2.default.bool,
  spyThrottle: _propTypes2$2.default.number
};

scrollLink.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2$2.default;

  var Link = function (_React$PureComponent) {
    _inherits$5(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck$5(this, Link);

      var _this = _possibleConstructorReturn$5(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass$4(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2$1.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2$1.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2$1.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2$1.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends$3({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends$3({}, this.props.style);
        }

        var props = _extends$3({}, this.props);

        for (var prop in protoTypes$1) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2$4.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2$4.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends$3({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  Link.propTypes = protoTypes$1;

  Link.defaultProps = { offset: 0 };

  return Link;
};

Object.defineProperty(Link$2, "__esModule", {
  value: true
});

var _react$3 = React$1;

var _react2$3 = _interopRequireDefault$4(_react$3);

var _scrollLink$2 = scrollLink;

var _scrollLink2$2 = _interopRequireDefault$4(_scrollLink$2);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits$4(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$4(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$4(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2$3.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn$4(_this, _ret);
  }

  return LinkElement;
}(_react2$3.default.Component);

Link$2.default = (0, _scrollLink2$2.default)(LinkElement);

var Button = {};

Object.defineProperty(Button, "__esModule", {
  value: true
});

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$2 = React$1;

var _react2$2 = _interopRequireDefault$3(_react$2);

var _scrollLink$1 = scrollLink;

var _scrollLink2$1 = _interopRequireDefault$3(_scrollLink$1);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits$3(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck$3(this, ButtonElement);

    return _possibleConstructorReturn$3(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass$3(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2$2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2$2.default.Component);

Button.default = (0, _scrollLink2$1.default)(ButtonElement);

var Element = {};

var scrollElement = {};

Object.defineProperty(scrollElement, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1 = React$1;

var _react2$1 = _interopRequireDefault$2(_react$1);

var _reactDom = require$$1;

_interopRequireDefault$2(_reactDom);

var _scroller$1 = scroller$1;

var _scroller2$1 = _interopRequireDefault$2(_scroller$1);

var _propTypes$1 = propTypes.exports;

var _propTypes2$1 = _interopRequireDefault$2(_propTypes$1);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

scrollElement.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits$2(Element, _React$Component);

    function Element(props) {
      _classCallCheck$2(this, Element);

      var _this = _possibleConstructorReturn$2(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass$2(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2$1.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2$1.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2$1.default.createElement(Component, _extends$2({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2$1.default.Component);

  Element.propTypes = {
    name: _propTypes2$1.default.string,
    id: _propTypes2$1.default.string
  };

  return Element;
};

Object.defineProperty(Element, "__esModule", {
  value: true
});

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React$1;

var _react2 = _interopRequireDefault$1(_react);

var _scrollElement$1 = scrollElement;

var _scrollElement2$1 = _interopRequireDefault$1(_scrollElement$1);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault$1(_propTypes);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits$1(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck$1(this, ElementWrapper);

    return _possibleConstructorReturn$1(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass$1(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends$1({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends$1({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

Element.default = (0, _scrollElement2$1.default)(ElementWrapper);

/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = React$1;
var scrollSpy = scrollSpy$2;
var defaultScroller = scroller$1;
var PropTypes = propTypes.exports;
var scrollHash = scrollHash$2;

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

var Helpers_1 = Helpers;

Object.defineProperty(modules, "__esModule", {
  value: true
});
modules.Helpers = modules.ScrollElement = modules.ScrollLink = modules.animateScroll = modules.scrollSpy = Events = modules.Events = scroller = modules.scroller = modules.Element = modules.Button = modules.Link = undefined;

var _Link = Link$2;

var _Link2 = _interopRequireDefault(_Link);

var _Button = Button;

var _Button2 = _interopRequireDefault(_Button);

var _Element = Element;

var _Element2 = _interopRequireDefault(_Element);

var _scroller = scroller$1;

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = scrollEvents;

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = scrollSpy$2;

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = animateScroll$1;

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = scrollLink;

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = scrollElement;

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = Helpers_1;

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

modules.Link = _Link2.default;
modules.Button = _Button2.default;
modules.Element = _Element2.default;
var scroller = modules.scroller = _scroller2.default;
var Events = modules.Events = _scrollEvents2.default;
modules.scrollSpy = _scrollSpy2.default;
modules.animateScroll = _animateScroll2.default;
modules.ScrollLink = _scrollLink2.default;
modules.ScrollElement = _scrollElement2.default;
modules.Helpers = _Helpers2.default;
modules.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

var EXPEDIA_IMAGE_SIZES = {
    WIDTH_200: 's',
    WIDTH_350: 'b',
    WIDTH_500: 'y',
    WIDTH_1000: 'z',
    WIDTH_2000: 'w',
    SQUARE_70x70: 't',
    SQUARE_90x90: 'n',
    SQUARE_140x140: 'g',
    SQUARE_180x180: 'd',
    SIZE_160x90: 'e',
    SIZE_255x144: 'l',
};
/**
 * 画像のサイズ指定をする
 * @param originalUrl
 * @param size
 */
var resizedExpediaImageUrl = function (originalUrl, size) {
    if (!isExpediaImage(originalUrl)) {
        return originalUrl;
    }
    return originalUrl.replace(/(_.*|)\.jpg$/, "_".concat(size, ".jpg"));
};
var isExpediaImage = function (url) {
    try {
        var hostname = new URL(url).hostname;
        return hostname === 'i.travelapi.com';
    }
    catch (e) {
        console.warn(e);
        return false;
    }
};

var notUndefinedOrNull = function (x) {
    return x !== undefined && x !== null;
};

var ja = {exports: {}};

(function (module, exports) {
	!function(e,_){module.exports=_(requireDayjs_min());}(commonjsGlobal,(function(e){function _(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=_(e),d={name:"ja",weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),ordinal:function(e){return e+"日"},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日 dddd HH:mm",l:"YYYY/MM/DD",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日(ddd) HH:mm"},meridiem:function(e){return e<12?"午前":"午後"},relativeTime:{future:"%s後",past:"%s前",s:"数秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}};return t.default.locale(d,null,!0),d}));
} (ja));

var timezone$1 = {exports: {}};

(function (module, exports) {
	!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10));}var d=r[3],l=24===d?0:d,v=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",h=+e;return (o.utc(v).valueOf()-(h-=h%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute");}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return "timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"));return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return [i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t;};}}));
} (timezone$1));

var timezone = timezone$1.exports;

var utc$1 = {exports: {}};

(function (module, exports) {
	!function(t,i){module.exports=i();}(commonjsGlobal,(function(){var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t);};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds();}else r.call(this);};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r;}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return !!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return "s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)};}}));
} (utc$1));

var utc = utc$1.exports;

dayjs_minExports.extend(utc);
dayjs_minExports.extend(timezone);
/**
 * 2020-04-13T18:00:00.000+09:00といった時間の表記からUTCOffsetを取得する
 * @param time 2020-04-13T18:00:00.000+09:00などのフォーマットの文字列
 * @returns UTCのオフセット(540など)
 */
var getUTCOffset = function (time) {
    var match = time.match(/([+\-])(\d{2}):(\d{2})$/);
    if (match && match.length === 4) {
        var isPlusOrMinus = match[1] === '-' ? -1 : 1;
        var hour = Number(match[2]);
        var minute = Number(match[3]);
        if (Number.isInteger(hour) && Number.isInteger(minute)) {
            return (hour * 60 + minute) * isPlusOrMinus;
        }
        else {
            throw Error('invalid Number format');
        }
    }
    else if (time.match(/Z$/)) {
        // UTCTimeのときは0
        return 0;
    }
    else {
        throw Error('invalid Time format');
    }
};

/**
 * react-scrollのeventは1度しかregisterできないから、ルートのほうでこのHooksを使って子のコンポーネントに渡すよう
 */
var useIsScrollingAnimation = function () {
    var _a = __read(useState(false), 2), isScrollingAnimation = _a[0], setIsScrollingAnimation = _a[1];
    useEffect(function () {
        // スクロールアニメーション時の開始/終了を監視
        Events.scrollEvent.register('begin', function () {
            setIsScrollingAnimation(true);
        });
        Events.scrollEvent.register('end', function () {
            setIsScrollingAnimation(false);
        });
        return function () {
            // 監視を解除
            Events.scrollEvent.remove('begin');
            Events.scrollEvent.remove('end');
        };
    }, []);
    return isScrollingAnimation;
};
// NOTE: (zoma) こちらの状態管理ライブラリを持ってきている https://github.com/jamiebuilds/unstated-next/blob/master/src/unstated-next.tsx
var EMPTY = Symbol();
function createContainer(useHook) {
    var Context = React$1.createContext(EMPTY);
    var Provider = function (props) {
        var value = useHook(props.initialState);
        return React$1.createElement(Context.Provider, { value: value }, props.children);
    };
    function useContainer() {
        var value = React$1.useContext(Context);
        if (value === EMPTY) {
            throw new Error('Component must be wrapped with <Container.Provider>');
        }
        return value;
    }
    return { Provider: Provider, useContainer: useContainer };
}
var IsScrollingAnimation = createContainer(useIsScrollingAnimation);

var index$i = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': IsScrollingAnimation
});

var useScrollDetail = function (tabs, changeCurrentTab) {
    var isScrollingAnimation = IsScrollingAnimation.useContainer();
    // セクションのReference
    var sectionRefs = useRef(__spreadArray([], __read(new Array(tabs.length)), false).map(function () {
        return React$1.createRef();
    }));
    useEffect(function () {
        var currentLength = sectionRefs.current.length;
        var tabsLength = tabs.length;
        if (currentLength < tabsLength) {
            // 新しいrefを追加
            sectionRefs.current = __spreadArray(__spreadArray([], __read(sectionRefs.current), false), __read(Array(tabsLength - currentLength)
                .fill(0)
                .map(function () { return React$1.createRef(); })), false);
        }
        else if (currentLength > tabsLength) {
            // 不要なrefを削除
            sectionRefs.current = sectionRefs.current.slice(0, tabsLength);
        }
    }, [tabs]);
    // スクロールのハンドリング
    var scrollHandler = useCallback(function () {
        // アニメーション中の場合はreturn
        if (isScrollingAnimation)
            return;
        // セクションのポジションがマイナスのときの個数でどこまでスクロールするか計算する
        var negativePositions = sectionRefs.current
            .map(function (ref) { return ref.current; })
            .filter(function (element) {
            return notUndefinedOrNull(element);
        })
            .map(function (element) {
            return Math.floor(element.getBoundingClientRect().top) - 60;
        })
            .filter(function (top) { return top <= 0; });
        if (negativePositions.length > 1) {
            changeCurrentTab(tabs[negativePositions.length - 1].tabType);
        }
        else {
            changeCurrentTab(tabs[0].tabType);
        }
    }, [tabs, isScrollingAnimation, changeCurrentTab]);
    useEffect(function () {
        // スクロールイベントの監視
        window === null || window === void 0 ? void 0 : window.addEventListener('scroll', scrollHandler);
        return function () {
            // 監視を解除
            window === null || window === void 0 ? void 0 : window.removeEventListener('scroll', scrollHandler);
        };
    }, [scrollHandler]);
    // アニメーションが終わったあとにscrollHandlerを１度実行する
    useEffect(function () {
        if (!isScrollingAnimation) {
            scrollHandler();
        }
    }, [isScrollingAnimation, scrollHandler]);
    // セクションにスクロールするメソッド
    var scrollToSection = function (tabType, delay) {
        scroller.scrollTo(tabType, {
            duration: 800,
            delay: delay !== null && delay !== void 0 ? delay : 0,
            smooth: 'easeInOutQuart',
            offset: -60,
        });
        changeCurrentTab(tabType);
    };
    var getPositionByTabType = useCallback(function (tabType) {
        var _a;
        return (_a = tabs.map(function (tab) { return tab.tabType; }).indexOf(tabType)) !== null && _a !== void 0 ? _a : 0;
    }, [tabs]);
    return {
        sectionRefs: sectionRefs,
        scrollToSection: scrollToSection,
        getPositionByTabType: getPositionByTabType,
    };
};

var useLocalState$8 = function (imageUrls, selectedIndex, showPageNumber, onChangeSwipingState) {
    var _a = __read(useState(false), 2), isSwiping = _a[0], setIsSwiping = _a[1];
    var _b = __read(useState(0), 2), currentPage = _b[0], setCurrentPage = _b[1];
    var hasImages = useMemo(function () {
        return imageUrls.length > 0;
    }, [imageUrls.length]);
    var pageCount = useMemo(function () {
        return imageUrls.length;
    }, [imageUrls.length]);
    useEffect(function () {
        if (typeof selectedIndex !== 'undefined') {
            setCurrentPage(selectedIndex);
        }
    }, [selectedIndex]);
    var _showPageNumber = showPageNumber !== null && showPageNumber !== void 0 ? showPageNumber : true;
    useEffect(function () {
        onChangeSwipingState === null || onChangeSwipingState === void 0 ? void 0 : onChangeSwipingState(isSwiping);
    }, [isSwiping, onChangeSwipingState]);
    // カルーセルを横方向にスクロールしている最中には、ウインドウの縦方向のスクロールをロックする
    useLockBodyScroll(isSwiping);
    return {
        isSwiping: isSwiping,
        setIsSwiping: setIsSwiping,
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        hasImages: hasImages,
        pageCount: pageCount,
        _showPageNumber: _showPageNumber,
    };
};

var CocoSlideImage = function (_a) {
    var imageUrls = _a.imageUrls, aspectRatio = _a.aspectRatio, infiniteLoop = _a.infiniteLoop, selectedIndex = _a.selectedIndex, showPageNumber = _a.showPageNumber, totalImageCount = _a.totalImageCount, onClickDetail = _a.onClickDetail, onClickImage = _a.onClickImage, onChangeImage = _a.onChangeImage, onChangeSwipingState = _a.onChangeSwipingState, _b = _a.showArrows, showArrows = _b === void 0 ? false : _b, style = _a.style;
    var _c = useLocalState$8(imageUrls, selectedIndex, showPageNumber, onChangeSwipingState), isSwiping = _c.isSwiping, setIsSwiping = _c.setIsSwiping, currentPage = _c.currentPage, setCurrentPage = _c.setCurrentPage, hasImages = _c.hasImages, pageCount = _c.pageCount, _showPageNumber = _c._showPageNumber;
    return (React$1.createElement(Container$y, { style: style, onClick: function (event) {
            // スワイプ中はイベントの伝搬させない
            if (isSwiping) {
                event.preventDefault();
            }
        } },
        React$1.createElement(CocoAspectRatio$1, { ratio: aspectRatio }, imageUrls.length === 0 ? (React$1.createElement(EmptyContainer, null)) : (React$1.createElement(PageOverlay, null,
            React$1.createElement(Carousel, { infiniteLoop: infiniteLoop !== null && infiniteLoop !== void 0 ? infiniteLoop : true, showThumbs: false, showIndicators: false, showStatus: false, showArrows: false, renderArrowPrev: showArrows && imageUrls.length > 1
                    ? function (clickHandler) { return (React$1.createElement(ScrollIcon, { clickHandler: clickHandler, direction: 'left' })); }
                    : undefined, renderArrowNext: showArrows && imageUrls.length > 1
                    ? function (clickHandler) { return (React$1.createElement(ScrollIcon, { clickHandler: clickHandler, direction: 'right' })); }
                    : undefined, emulateTouch: true, selectedItem: currentPage, swipeable: typeof showArrows !== 'undefined' && showArrows
                    ? false
                    : hasImages, swipeScrollTolerance: 60, onChange: function (index) {
                    setCurrentPage(index);
                    onChangeImage === null || onChangeImage === void 0 ? void 0 : onChangeImage();
                }, onSwipeStart: function () { return setIsSwiping(true); }, onSwipeEnd: function () { return setIsSwiping(false); }, onClickItem: onClickImage }, imageUrls
                .filter(function (x) { return x !== undefined && x !== null; })
                .map(function (image, index) {
                return (React$1.createElement(LazyLoadImage, { key: index, effect: "blur", threshold: 200, width: '100%', height: '100%', src: image, style: {
                        objectFit: 'cover',
                    } }));
            })),
            !showArrows && (React$1.createElement(React$1.Fragment, null,
                React$1.createElement(LeftTapArea, { onClick: function (event) {
                        event.preventDefault();
                        // 上の階層へのイベントの伝播を止める
                        event.stopPropagation();
                        if (hasImages) {
                            setCurrentPage(currentPage - 1);
                        }
                    } }),
                React$1.createElement(RightTapArea, { onClick: function (event) {
                        event.preventDefault();
                        // 上の階層へのイベントの伝播を止める
                        event.stopPropagation();
                        if (hasImages) {
                            setCurrentPage(currentPage + 1);
                        }
                    } })))))),
        _showPageNumber && (React$1.createElement(React$1.Fragment, null, typeof totalImageCount === 'number' && totalImageCount > 0 ? (React$1.createElement(PageNumberContainer, { onClick: function () { return onClickDetail === null || onClickDetail === void 0 ? void 0 : onClickDetail(); }, hideArrow: typeof onClickDetail === 'undefined' },
            React$1.createElement(PageNumberLabel, { hideArrow: typeof onClickDetail === 'undefined' }, "".concat(totalImageCount, "\u679A\u306E\u5199\u771F")))) : pageCount > 1 ? (React$1.createElement(PageNumberContainer, { onClick: function () { return onClickDetail === null || onClickDetail === void 0 ? void 0 : onClickDetail(); }, hideArrow: typeof onClickDetail === 'undefined' },
            React$1.createElement(PageNumberLabel, { hideArrow: typeof onClickDetail === 'undefined' }, "".concat(currentPage + 1, "/").concat(pageCount)))) : (React$1.createElement(React$1.Fragment, null)))),
        pageCount > 1 ? (React$1.createElement(IndicatorContainer, null, pageCount > 7 ? (React$1.createElement(ScaleIndicator, { pageCount: pageCount, currentPage: currentPage })) : (React$1.createElement(NonScaleIndicator$1, { pageCount: pageCount, currentPage: currentPage })))) : (React$1.createElement(React$1.Fragment, null))));
};
var CocoSlideImage$1 = memo(CocoSlideImage);
var ScrollIcon = function (_a) {
    var direction = _a.direction, clickHandler = _a.clickHandler;
    return (React$1.createElement(ScrollIconContainer, { direction: direction, onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            clickHandler();
        } },
        React$1.createElement(ScrollIconInnerContainer, null, direction === 'left' ? (React$1.createElement("svg", { width: "7", height: "11", viewBox: "0 0 7 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React$1.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.05013 4.7929C0.659605 5.18342 0.6596 5.81658 1.05012 6.20711L5.37133 10.5283C5.71846 10.8754 6.28128 10.8755 6.62842 10.5283C6.97556 10.1812 6.97556 9.61839 6.62843 9.27125L3.5643 6.20712C3.17378 5.8166 3.17378 5.18344 3.56431 4.79292L6.62848 1.72884C6.97562 1.38171 6.97562 0.818899 6.62849 0.471766C6.28136 0.124633 5.71854 0.12463 5.3714 0.471758L1.05013 4.7929Z", fill: "white", fillOpacity: "0.85" }))) : (React$1.createElement("svg", { width: "7", height: "11", viewBox: "0 0 7 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React$1.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.94974 6.2071C6.34027 5.81658 6.34028 5.18342 5.94975 4.79289L1.62855 0.471686C1.28141 0.124553 0.718595 0.124549 0.371457 0.471677C0.0243197 0.818805 0.0243152 1.38161 0.371448 1.72875L3.43558 4.79288C3.8261 5.1834 3.8261 5.81656 3.43557 6.20708L0.371395 9.27116C0.0242576 9.61829 0.0242534 10.1811 0.371386 10.5282C0.718519 10.8754 1.28134 10.8754 1.62847 10.5282L5.94974 6.2071Z", fill: "white", fillOpacity: "0.85" }))))));
};
var ScrollIconContainer = styled.div(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  padding: 5px;\n  height: auto !important;\n  position: absolute;\n  top: calc(50% - 18px);\n  right: ", ";\n  left: ", ";\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding: 5px;\n  height: auto !important;\n  position: absolute;\n  top: calc(50% - 18px);\n  right: ", ";\n  left: ", ";\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) { return (props.direction === 'right' ? '0' : 'unset'); }, function (props) { return (props.direction === 'left' ? '0' : 'unset'); });
var ScrollIconInnerContainer = styled.div(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  width: 25px;\n  height: 25px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  background-color: rgba(0, 0, 0, 0.25);\n"], ["\n  width: 25px;\n  height: 25px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  background-color: rgba(0, 0, 0, 0.25);\n"])));
var Container$y = styled.div(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  background: #ccc;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  transform: translate3d(0, 0, 0);\n  .carousel,\n  .slider-wrapper,\n  .slider {\n    height: 100%;\n  }\n"], ["\n  height: 100%;\n  width: 100%;\n  background: #ccc;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  transform: translate3d(0, 0, 0);\n  .carousel,\n  .slider-wrapper,\n  .slider {\n    height: 100%;\n  }\n"])));
var PageNumberContainer = styled.div(templateObject_4$s || (templateObject_4$s = __makeTemplateObject(["\n  position: absolute;\n  cursor: pointer;\n  padding: ", ";\n  right: 0;\n  bottom: 0;\n  transform: translate3d(0, 0, 1px);\n"], ["\n  position: absolute;\n  cursor: pointer;\n  padding: ", ";\n  right: 0;\n  bottom: 0;\n  transform: translate3d(0, 0, 1px);\n"])), function (props) {
    return props.hideArrow === true ? '8px 10px 8px 8px' : '8px 21px 8px 8px';
});
var PageNumberLabel = styled.span(templateObject_5$m || (templateObject_5$m = __makeTemplateObject(["\n  font-family: Avenir Next, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 160%;\n  letter-spacing: 0.1em;\n  color: ", ";\n  position: relative;\n  ::after {\n    content: '';\n    display: ", ";\n    width: 5px;\n    height: 5px;\n    border-top: solid 1px ", ";\n    border-right: solid 1px ", ";\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    top: 0;\n    bottom: 0;\n    right: -10px;\n    margin: auto;\n    position: absolute;\n  }\n"], ["\n  font-family: Avenir Next, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 160%;\n  letter-spacing: 0.1em;\n  color: ", ";\n  position: relative;\n  ::after {\n    content: '';\n    display: ", ";\n    width: 5px;\n    height: 5px;\n    border-top: solid 1px ", ";\n    border-right: solid 1px ", ";\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    top: 0;\n    bottom: 0;\n    right: -10px;\n    margin: auto;\n    position: absolute;\n  }\n"])), COLORS.INVERT_TEXT.PRIMARY, function (props) { return (props.hideArrow === true ? 'none' : 'block'); }, COLORS.INVERT_TEXT.PRIMARY, COLORS.INVERT_TEXT.PRIMARY);
var PageOverlay = styled.div(templateObject_6$i || (templateObject_6$i = __makeTemplateObject(["\n  position: relative;\n  & div:first-of-type {\n    height: 100%;\n  }\n  :after {\n    content: '';\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.1);\n    transform: translate3d(0, 0, 1px);\n  }\n"], ["\n  position: relative;\n  & div:first-of-type {\n    height: 100%;\n  }\n  :after {\n    content: '';\n    position: absolute;\n    pointer-events: none;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.1);\n    transform: translate3d(0, 0, 1px);\n  }\n"])));
var IndicatorContainer = styled.div(templateObject_7$e || (templateObject_7$e = __makeTemplateObject(["\n  position: absolute;\n  bottom: 10px;\n  right: 0;\n  left: 0;\n  width: fit-content;\n  margin: auto;\n  transform: translate3d(0, 0, 1px);\n  .react-carousel-dots-dot {\n    background-color: white;\n    opacity: 0.5;\n    border: none;\n  }\n  .react-carousel-dots-dot.active {\n    background-color: white;\n    opacity: 1;\n  }\n"], ["\n  position: absolute;\n  bottom: 10px;\n  right: 0;\n  left: 0;\n  width: fit-content;\n  margin: auto;\n  transform: translate3d(0, 0, 1px);\n  .react-carousel-dots-dot {\n    background-color: white;\n    opacity: 0.5;\n    border: none;\n  }\n  .react-carousel-dots-dot.active {\n    background-color: white;\n    opacity: 1;\n  }\n"])));
var LeftTapArea = styled.div(templateObject_8$d || (templateObject_8$d = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 50px;\n  transform: translate3d(0, 0, 1px);\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 50px;\n  transform: translate3d(0, 0, 1px);\n"])));
var RightTapArea = styled.div(templateObject_9$c || (templateObject_9$c = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 50px;\n  transform: translate3d(0, 0, 1px);\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 50px;\n  transform: translate3d(0, 0, 1px);\n"])));
var EmptyContainer = styled.div(templateObject_10$b || (templateObject_10$b = __makeTemplateObject(["\n  background: rgba(0, 0, 0, 0.1);\n"], ["\n  background: rgba(0, 0, 0, 0.1);\n"])));
var templateObject_1$C, templateObject_2$z, templateObject_3$t, templateObject_4$s, templateObject_5$m, templateObject_6$i, templateObject_7$e, templateObject_8$d, templateObject_9$c, templateObject_10$b;

var ImageItem = function (_a) {
    var index = _a.index, imageUrl = _a.imageUrl;
    return (React$1.createElement(CocoAspectRatio$1, { key: index, ratio: '240/360', style: {
            width: '100%',
        } },
        React$1.createElement(Container$x, null,
            React$1.createElement(LazyLoadImage, { effect: "opacity", delayTime: 200, threshold: 200, width: '100%', height: '100%', src: imageUrl, style: {
                    objectFit: 'cover',
                } }))));
};
var ImageItem$1 = memo(ImageItem);
var Container$x = styled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n"], ["\n  height: 100%;\n  width: 100%;\n"])));
var templateObject_1$B;

var CocoQuiltedImageList = function (_a) {
    var imageUrls = _a.imageUrls, style = _a.style;
    return (React$1.createElement(Container$w, { style: style }, __spreadArray([], __read(new Array(imageUrls.length)), false).map(function (_, index) {
        if (index % 5 === 0) {
            var image = imageUrls[index];
            return (React$1.createElement(React$1.Fragment, { key: index },
                index > 0 && React$1.createElement("div", { style: { paddingTop: '3px' } }),
                React$1.createElement("div", null,
                    React$1.createElement(ImageItem$1, { index: index, imageUrl: image }))));
        }
        else if (index % 5 === 1 || index % 5 === 3) {
            var image1 = imageUrls[index];
            var image2 = imageUrls[index + 1];
            return (React$1.createElement(React$1.Fragment, { key: index },
                index > 0 && React$1.createElement("div", { style: { paddingTop: '3px' } }),
                React$1.createElement(SmallContainer, null,
                    typeof image1 !== 'undefined' ? (React$1.createElement(ImageItem$1, { index: index, imageUrl: image1 })) : (React$1.createElement(React$1.Fragment, null)),
                    React$1.createElement("div", { style: { paddingLeft: '3px' } }),
                    typeof image2 !== 'undefined' ? (React$1.createElement(ImageItem$1, { index: index + 1, imageUrl: image2 })) : (React$1.createElement(React$1.Fragment, null)))));
        }
    })));
};
var index$h = memo(CocoQuiltedImageList);
var Container$w = styled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  .lazy-load-image-background.opacity {\n    background-image: none !important;\n    opacity: 0;\n  }\n\n  .lazy-load-image-background.opacity.lazy-load-image-loaded {\n    opacity: 1;\n    transition: opacity 0.4s;\n    transition-timing-function: ease-out;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  .lazy-load-image-background.opacity {\n    background-image: none !important;\n    opacity: 0;\n  }\n\n  .lazy-load-image-background.opacity.lazy-load-image-loaded {\n    opacity: 1;\n    transition: opacity 0.4s;\n    transition-timing-function: ease-out;\n  }\n"])));
var SmallContainer = styled.div(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var templateObject_1$A, templateObject_2$y;

var CocoPcFooter = function (_a) {
    var imgixHost = _a.imgixHost, hostUrl = _a.hostUrl, hasLinks = _a.hasLinks, style = _a.style;
    var generateHrefExternalOrInternalPath = useLocalState$c(hostUrl).generateHrefExternalOrInternalPath;
    return (React$1.createElement(Container$v, { style: style },
        hasLinks && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(PageLinks, null, PAGE_LINKS.map(function (section, index) { return (React$1.createElement(Section$1, { key: index },
                React$1.createElement(SectionTitle$1, null, typeof section.header.link === 'undefined' ? (section.header.title) : (React$1.createElement(SectionLink, { href: section.header.link }, section.header.title))),
                React$1.createElement(LinkList, null, section.links.map(function (link, index) {
                    var _a, _b;
                    return (React$1.createElement(LinkListItem, { key: index },
                        React$1.createElement(Link$1, { href: generateHrefExternalOrInternalPath(link), target: (_a = link.target) !== null && _a !== void 0 ? _a : undefined, rel: (_b = link.rel) !== null && _b !== void 0 ? _b : undefined }, link.title)));
                })),
                section.header.title === '海外旅行' && (React$1.createElement(LinkList, null, OVERSEAS_LINKS.map(function (link, index) { return (React$1.createElement(LinkOverseasListItem, { key: index },
                    React$1.createElement(Link$1, { href: generateHrefExternalOrInternalPath(link) }, link.title))); }))))); })),
            React$1.createElement(SnsLinkList, null, SNS_LINKS.map(function (link, index) { return (React$1.createElement(SnsLinkListItem, { key: index },
                React$1.createElement(Link$1, { href: link.href, target: link.target, rel: link.rel },
                    React$1.createElement(SnsImage, { src: addAutoFormatAndCompress("".concat(imgixHost).concat(link.src)), alt: link.alt })))); })))),
        React$1.createElement(LogoContainer$1, null,
            React$1.createElement(Link$1, { href: hostUrl },
                React$1.createElement(Logo, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/logo/white.png")), alt: "\u3053\u3053\u308D\u304B\u3089" }))),
        React$1.createElement(Licence, null,
            "\u6771\u4EAC\u90FD\u77E5\u4E8B\u767B\u9332\u65C5\u884C\u696D\u7B2C2-7574\u53F7",
            React$1.createElement("br", null),
            "\u4E00\u822C\u793E\u56E3\u6CD5\u4EBA\u65E5\u672C\u65C5\u884C\u696D\u5354\u4F1A\uFF08JATA\uFF09\u6B63\u4F1A\u54E1",
            React$1.createElement("br", null),
            "\u00A9 Hotspring, Inc.")));
};
var index$g = memo(CocoPcFooter);
var Container$v = styled.footer(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  background-color: #212121;\n  padding-block: 40px;\n"], ["\n  background-color: #212121;\n  padding-block: 40px;\n"])));
var LinkList = styled.ul(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n"])));
var LinkListItem = styled.li(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n  display: inline-block;\n  width: 50%;\n  font-size: 13px;\n  letter-spacing: 1px;\n"], ["\n  display: inline-block;\n  width: 50%;\n  font-size: 13px;\n  letter-spacing: 1px;\n"])));
var Link$1 = styled.a(templateObject_4$r || (templateObject_4$r = __makeTemplateObject(["\n  display: inline-block;\n  text-decoration: none;\n  margin-block: 5px;\n  color: ", ";\n  ", ";\n"], ["\n  display: inline-block;\n  text-decoration: none;\n  margin-block: 5px;\n  color: ", ";\n  ", ";\n"])), COLORS.INVERT_TEXT.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.BODY_3));
var SnsLinkList = styled.ul(templateObject_5$l || (templateObject_5$l = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-block-end: 25px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-block-end: 25px;\n"])));
var SnsLinkListItem = styled.li(templateObject_6$h || (templateObject_6$h = __makeTemplateObject(["\n  margin-inline: 12px;\n"], ["\n  margin-inline: 12px;\n"])));
var LogoContainer$1 = styled.div(templateObject_7$d || (templateObject_7$d = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-block-end: 30px;\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-block-end: 30px;\n"])));
var Licence = styled.p(templateObject_8$c || (templateObject_8$c = __makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n  ", ";\n"], ["\n  text-align: center;\n  color: ", ";\n  ", ";\n"])), COLORS.INVERT_TEXT.NO_IMPORTANT, createFontStyle(MOBILE_FONT_STYLES.NOTE_1));
var SnsImage = styled.img(templateObject_9$b || (templateObject_9$b = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n"], ["\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n"])));
var Logo = styled.img(templateObject_10$a || (templateObject_10$a = __makeTemplateObject(["\n  height: 30px;\n  object-fit: cover;\n"], ["\n  height: 30px;\n  object-fit: cover;\n"])));
var PageLinks = styled.div(templateObject_11$8 || (templateObject_11$8 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-start;\n  padding-block-end: 25px;\n  margin-inline: auto;\n  width: 90%;\n  max-width: 1100px;\n"], ["\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-start;\n  padding-block-end: 25px;\n  margin-inline: auto;\n  width: 90%;\n  max-width: 1100px;\n"])));
var Section$1 = styled.div(templateObject_12$8 || (templateObject_12$8 = __makeTemplateObject(["\n  width: 30%;\n"], ["\n  width: 30%;\n"])));
var SectionTitle$1 = styled.h3(templateObject_13$6 || (templateObject_13$6 = __makeTemplateObject(["\n  margin-block: 10px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-block: 10px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, PC_FONT_STYLES.BODY_BOLD_1), { lineHeight: '1.5' })), COLORS.INVERT_TEXT.PRIMARY);
var LinkOverseasListItem = styled.li(templateObject_14$6 || (templateObject_14$6 = __makeTemplateObject(["\n  display: inline-block;\n  width: 30%;\n  font-size: 13px;\n  letter-spacing: 1px;\n  margin-inline-end: 10px;\n"], ["\n  display: inline-block;\n  width: 30%;\n  font-size: 13px;\n  letter-spacing: 1px;\n  margin-inline-end: 10px;\n"])));
var SectionLink = styled.a(templateObject_15$3 || (templateObject_15$3 = __makeTemplateObject(["\n  display: inline-block;\n  text-decoration: none;\n  color: ", ";\n"], ["\n  display: inline-block;\n  text-decoration: none;\n  color: ", ";\n"])), COLORS.TEXT.INVERSE_PRIMARY);
var templateObject_1$z, templateObject_2$x, templateObject_3$s, templateObject_4$r, templateObject_5$l, templateObject_6$h, templateObject_7$d, templateObject_8$c, templateObject_9$b, templateObject_10$a, templateObject_11$8, templateObject_12$8, templateObject_13$6, templateObject_14$6, templateObject_15$3;

var CircleWithCharacterIcon = function (_a) {
    var iconText = _a.iconText, iconBackgroundColor = _a.iconBackgroundColor;
    return (React$1.createElement(Circle$1, { style: { backgroundColor: iconBackgroundColor } },
        React$1.createElement(Text, null, iconText.charAt(0))));
};
var CircleWithCharacterIcon$1 = memo(CircleWithCharacterIcon);
var Circle$1 = styled.div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  display: table;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  position: relative;\n  color: ", ";\n"], ["\n  display: table;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  position: relative;\n  color: ", ";\n"])), COLORS.INVERT_TEXT.PRIMARY);
var Text = styled.span(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n  padding-left: 2px;\n  font-size: 18px;\n  line-height: 18px;\n"], ["\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n  padding-left: 2px;\n  font-size: 18px;\n  line-height: 18px;\n"])));
var templateObject_1$y, templateObject_2$w;

var COLLAPSE_DESCRIPTION_LENGTH = 140;
var useLocalState$7 = function (description, time) {
    var _a = __read(useState(false), 2), isExpanded = _a[0], setIsExpanded = _a[1];
    var isLongDescription = description.length > COLLAPSE_DESCRIPTION_LENGTH;
    var descriptionText = useMemo(function () {
        if (isLongDescription && !isExpanded) {
            return description.slice(0, COLLAPSE_DESCRIPTION_LENGTH - 1) + '…';
        }
        else {
            return description;
        }
    }, [description, isExpanded, isLongDescription]);
    var iconBackgroundColor = useMemo(function () {
        var rest = Number(time) % 3;
        if (rest === 0) {
            return COLORS.GENERAL.PRIMARY;
        }
        else if (rest === 1) {
            return COLORS.STATUS.SUCCESS_OR_POSITIVE;
        }
        else {
            // rest === 2 or NaN
            return '#F1CA5C';
        }
    }, [time]);
    return {
        descriptionText: descriptionText,
        setIsExpanded: setIsExpanded,
        isExpanded: isExpanded,
        isLongDescription: isLongDescription,
        iconBackgroundColor: iconBackgroundColor,
    };
};

var ReviewItem = function (_a) {
    var review = _a.review, style = _a.style;
    var _b = useLocalState$7(review.text, review.time), descriptionText = _b.descriptionText, isExpanded = _b.isExpanded, setIsExpanded = _b.setIsExpanded, isLongDescription = _b.isLongDescription, iconBackgroundColor = _b.iconBackgroundColor;
    return (React$1.createElement(Container$u, { style: style },
        React$1.createElement(Header$3, null,
            React$1.createElement(IconContainer, null, typeof review.iconUrl !== 'undefined' ? (React$1.createElement(LazyLoadImage, { effect: "blur", threshold: 200, width: '100%', height: '100%', src: review.iconUrl, style: {
                    objectFit: 'cover',
                } })) : (React$1.createElement(CircleWithCharacterIcon$1, { iconText: review.authorName, iconBackgroundColor: iconBackgroundColor }))),
            React$1.createElement(NameAndRateContainer, null,
                React$1.createElement(Name, null, review.authorName),
                React$1.createElement(RatingAndPublishedAt, null,
                    React$1.createElement(RatingsContainer, null,
                        React$1.createElement(CocoRatings$1, { rating: review.rating, starDimension: '14px', showRatingValue: true })),
                    React$1.createElement(PublishedAt, null,
                        "\u6295\u7A3F\u65E5\uFF1A",
                        review.postedDateText)))),
        typeof review.title !== 'undefined' && React$1.createElement(Title$8, null, review.title),
        React$1.createElement(Description$3, null, descriptionText),
        isLongDescription && !isExpanded ? (React$1.createElement(NextReadingAndLogoContainer, null,
            React$1.createElement(ReadMoreButton, { onClick: function () { return setIsExpanded(true); } }, "\u7D9A\u304D\u3092\u307F\u308B..."),
            typeof review.sourceLogoUrl !== 'undefined' && (React$1.createElement(SourceImg, { src: review.sourceLogoUrl })))) : (React$1.createElement(React$1.Fragment, null,
            React$1.createElement("div", { style: { paddingTop: '4px' } }),
            React$1.createElement(LogoContainer, null, typeof review.sourceLogoUrl !== 'undefined' && (React$1.createElement(SourceImg, { src: review.sourceLogoUrl })))))));
};
var ReviewItem$1 = memo(ReviewItem);
var Container$u = styled.div(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  padding: 15px 0;\n  border-bottom: 1px solid ", ";\n\n  &:last-child {\n    border-bottom: none;\n  }\n"], ["\n  padding: 15px 0;\n  border-bottom: 1px solid ", ";\n\n  &:last-child {\n    border-bottom: none;\n  }\n"])), COLORS.BORDER.SECONDARY);
var Header$3 = styled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var IconContainer = styled.div(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  flex-shrink: 0;\n"], ["\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  flex-shrink: 0;\n"])));
var Title$8 = styled.p(templateObject_4$q || (templateObject_4$q = __makeTemplateObject(["\n  margin-top: 8px;\n  ", ";\n"], ["\n  margin-top: 8px;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '150%', letterSpacing: '1px' })));
var Description$3 = styled.p(templateObject_5$k || (templateObject_5$k = __makeTemplateObject(["\n  margin-top: 8px;\n  ", ";\n"], ["\n  margin-top: 8px;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_3), { letterSpacing: '1px' })));
var NameAndRateContainer = styled.div(templateObject_6$g || (templateObject_6$g = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n  width: 100%;\n  flex-shrink: 1;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n  width: 100%;\n  flex-shrink: 1;\n  justify-content: center;\n"])));
var Name = styled.p(templateObject_7$c || (templateObject_7$c = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  color: ", ";\n  ", ";\n"], ["\n  font-weight: bold;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_1), { lineHeight: '120%', letterSpacing: '0.1em' })));
var RatingsContainer = styled.div(templateObject_8$b || (templateObject_8$b = __makeTemplateObject(["\n  margin-top: 4px;\n"], ["\n  margin-top: 4px;\n"])));
var RatingAndPublishedAt = styled.div(templateObject_9$a || (templateObject_9$a = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: baseline;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: baseline;\n"])));
var PublishedAt = styled.span(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject(["\n  text-align: end;\n  flex: none;\n  flex-grow: 1;\n  color: ", ";\n  ", ";\n"], ["\n  text-align: end;\n  flex: none;\n  flex-grow: 1;\n  color: ", ";\n  ", ";\n"])), COLORS.TEXT.NO_IMPORTANT, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_7), { letterSpacing: '1px' })));
var ReadMoreButton = styled.p(templateObject_11$7 || (templateObject_11$7 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: 13px;\n  letter-spacing: 0.1em;\n  color: ", ";\n  padding: 10px 0;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  display: inline-block;\n  font-size: 13px;\n  letter-spacing: 0.1em;\n  color: ", ";\n  padding: 10px 0;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var NextReadingAndLogoContainer = styled.div(templateObject_12$7 || (templateObject_12$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var LogoContainer = styled.div(templateObject_13$5 || (templateObject_13$5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n"])));
var SourceImg = styled.img(templateObject_14$5 || (templateObject_14$5 = __makeTemplateObject(["\n  height: 14px;\n"], ["\n  height: 14px;\n"])));
var templateObject_1$x, templateObject_2$v, templateObject_3$r, templateObject_4$q, templateObject_5$k, templateObject_6$g, templateObject_7$c, templateObject_8$b, templateObject_9$a, templateObject_10$9, templateObject_11$7, templateObject_12$7, templateObject_13$5, templateObject_14$5;

var COLLAPSE_LENGTH = 3;
var DISPLAY_REVIEW_SEPARATION = 5;
var useLocalState$6 = function (reviewList, showAllReviews) {
    var shouldCollapse = reviewList.length > COLLAPSE_LENGTH;
    var _a = __read(useState(!shouldCollapse), 2), isExpanded = _a[0], setIsExpanded = _a[1];
    var _b = __read(useState(DISPLAY_REVIEW_SEPARATION), 2), displayReviewLength = _b[0], setDisplayReviewLength = _b[1];
    var displayReviewItems = useMemo(function () {
        if (showAllReviews) {
            return reviewList;
        }
        else if (shouldCollapse && !isExpanded) {
            return reviewList.slice(0, COLLAPSE_LENGTH);
        }
        else {
            return reviewList;
        }
    }, [showAllReviews, shouldCollapse, isExpanded, reviewList]);
    return {
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        displayReviewLength: displayReviewLength,
        setDisplayReviewLength: setDisplayReviewLength,
        displayReviewItems: displayReviewItems,
        DISPLAY_REVIEW_SEPARATION: DISPLAY_REVIEW_SEPARATION,
    };
};

var CocoHotelGuestReviewList = function (_a) {
    var reviewList = _a.reviewList, style = _a.style, _b = _a.showAllReviews, showAllReviews = _b === void 0 ? false : _b, _c = _a.showTitle, showTitle = _c === void 0 ? true : _c;
    var _d = useLocalState$6(reviewList, showAllReviews), isExpanded = _d.isExpanded, setIsExpanded = _d.setIsExpanded, displayReviewLength = _d.displayReviewLength, setDisplayReviewLength = _d.setDisplayReviewLength, displayReviewItems = _d.displayReviewItems, DISPLAY_REVIEW_SEPARATION = _d.DISPLAY_REVIEW_SEPARATION;
    return (React$1.createElement(Container$t, { style: style },
        showTitle && React$1.createElement(Title$7, null, "\u6CE8\u76EE\u306E\u53E3\u30B3\u30DF"),
        showAllReviews || isExpanded ? (React$1.createElement(React$1.Fragment, null,
            displayReviewItems
                .slice(0, showAllReviews ? reviewList.length : displayReviewLength)
                .map(function (item, index) { return (React$1.createElement(ReviewItem$1, { key: index, review: item })); }),
            !showAllReviews && displayReviewItems.length > displayReviewLength && (React$1.createElement(CocoWhiteButton, { fullWidth: true, height: '50px', disableHover: true, onClick: function () {
                    return setDisplayReviewLength(displayReviewLength + DISPLAY_REVIEW_SEPARATION);
                }, style: { margin: '20px 0' } }, "\u53E3\u30B3\u30DF\u3092\u3082\u3063\u3068\u307F\u308B")))) : (React$1.createElement(React$1.Fragment, null,
            displayReviewItems.slice(0, 2).map(function (item, index) { return (React$1.createElement(ReviewItem$1, { key: index, review: item })); }),
            React$1.createElement(CollapseContainer, null,
                React$1.createElement(CollapseInner, null,
                    React$1.createElement(ReviewItem$1, { review: displayReviewItems[2] })),
                React$1.createElement(CocoWhiteButton, { fullWidth: true, height: '50px', disableHover: true, style: {
                        position: 'absolute',
                        bottom: 0,
                    }, onClick: function () { return setIsExpanded(true); } }, "\u53E3\u30B3\u30DF\u3092\u3082\u3063\u3068\u307F\u308B"))))));
};
var index$f = memo(CocoHotelGuestReviewList);
var Container$t = styled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject([""], [""])));
var Title$7 = styled.h3(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.SUB_TITLE_1), { letterSpacing: '0.1em' })));
var CollapseContainer = styled.div(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n  position: relative;\n  padding-bottom: 15px;\n"], ["\n  position: relative;\n  padding-bottom: 15px;\n"])));
var CollapseInner = styled.div(templateObject_4$p || (templateObject_4$p = __makeTemplateObject(["\n  position: relative;\n  ::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0) 15%,\n      rgba(255, 255, 255, 0.7) 45%,\n      #ffffff 100%\n    );\n  }\n"], ["\n  position: relative;\n  ::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0) 15%,\n      rgba(255, 255, 255, 0.7) 45%,\n      #ffffff 100%\n    );\n  }\n"])));
var templateObject_1$w, templateObject_2$u, templateObject_3$q, templateObject_4$p;

var FacilityList = function (_a) {
    var facilities = _a.facilities, style = _a.style;
    return (React$1.createElement(Container$s, { style: style }, facilities.map(function (facilities, index) { return (React$1.createElement(ListItem$1, { key: index }, facilities)); })));
};
var FacilityList$1 = memo(FacilityList);
var Container$s = styled.ul(templateObject_1$v || (templateObject_1$v = __makeTemplateObject([""], [""])));
var ListItem$1 = styled.li(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  width: 50%;\n  color: ", ";\n  padding: 5px 0 5px 10px;\n  ", ";\n\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 12px;\n    left: 0;\n    width: 2px;\n    height: 2px;\n    border: 1px solid #000;\n    border-radius: 2px;\n  }\n\n  &:nth-child(odd) {\n    padding-right: 5px;\n  }\n"], ["\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n  width: 50%;\n  color: ", ";\n  padding: 5px 0 5px 10px;\n  ", ";\n\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 12px;\n    left: 0;\n    width: 2px;\n    height: 2px;\n    border: 1px solid #000;\n    border-radius: 2px;\n  }\n\n  &:nth-child(odd) {\n    padding-right: 5px;\n  }\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_2), { letterSpacing: '1px' })));
var templateObject_1$v, templateObject_2$t;

var CocoHotelDetailInfo = function (_a) {
    var title = _a.title, hotelImage = _a.hotelImage, summaryDescription = _a.summaryDescription, description = _a.description, areaItems = _a.areaItems, station = _a.station, beginCheckinTime = _a.beginCheckinTime, endCheckinTime = _a.endCheckinTime, checkoutTime = _a.checkoutTime, phoneNumber = _a.phoneNumber, roomsCount = _a.roomsCount, hotelType = _a.hotelType, pets = _a.pets, mealText = _a.mealText, amenityText = _a.amenityText, facilities = _a.facilities, location = _a.location, accessText = _a.accessText, style = _a.style, mapStyle = _a.mapStyle;
    return (React$1.createElement(Container$r, { style: style },
        typeof title !== 'undefined' && React$1.createElement(Title$6, null, title),
        typeof hotelImage !== 'undefined' && (React$1.createElement(HotelDetailImageContainer, null,
            React$1.createElement(Image$7, { src: hotelImage }))),
        typeof summaryDescription !== 'undefined' && (React$1.createElement(Description$2, null, summaryDescription)),
        typeof summaryDescription === 'undefined' &&
            typeof description !== 'undefined' && (React$1.createElement(Description$2, null, description)),
        React$1.createElement(Table$1, null,
            React$1.createElement(Tbody, null,
                typeof areaItems !== 'undefined' && areaItems.length > 0 && (React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u30A8\u30EA\u30A2")),
                    React$1.createElement(Td, { className: "area-list" }, areaItems.map(function (item, index) { return (React$1.createElement(React$1.Fragment, { key: index },
                        index > 0 && React$1.createElement(React$1.Fragment, null, ">"),
                        typeof item.linkPath !== 'undefined' ? (React$1.createElement(Link, { href: item.linkPath }, item.name)) : (React$1.createElement("span", null, item.name)))); })))),
                typeof station !== 'undefined' && (React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u6700\u5BC4\u99C5")),
                    React$1.createElement(Td, { className: "area-list" },
                        React$1.createElement(Link, { href: station.linkPath }, station.name)))),
                React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3")),
                    React$1.createElement(Td, null, typeof beginCheckinTime === 'undefined' &&
                        typeof endCheckinTime === 'undefined'
                        ? '24時間'
                        : "".concat(beginCheckinTime ? beginCheckinTime : '', " \u301C\n                ").concat(endCheckinTime ? endCheckinTime : ''))),
                typeof checkoutTime !== 'undefined' && (React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8")),
                    React$1.createElement(Td, null, checkoutTime))),
                typeof phoneNumber !== 'undefined' && (React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u96FB\u8A71\u756A\u53F7")),
                    React$1.createElement(Td, null, phoneNumber))),
                typeof roomsCount !== 'undefined' && (React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u5BA2\u5BA4\u6570")),
                    React$1.createElement(Td, null,
                        roomsCount,
                        "\u5BA4"))),
                typeof hotelType !== 'undefined' && (React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u65BD\u8A2D\u30BF\u30A4\u30D7")),
                    React$1.createElement(Td, null, typeof hotelType.linkPath !== 'undefined' ? (React$1.createElement(Link, { href: hotelType.linkPath }, hotelType.name)) : (React$1.createElement("p", null, hotelType.name))))),
                typeof pets !== 'undefined' && pets.length > 0 && (React$1.createElement(React$1.Fragment, null,
                    React$1.createElement(Tr, null,
                        React$1.createElement(Th, null,
                            React$1.createElement(RowTitle, null, "\u30DA\u30C3\u30C8")),
                        React$1.createElement(Td, null, pets.join('、'))))))),
        typeof mealText !== 'undefined' && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(InnerTitle, null, "\u98DF\u4E8B"),
            React$1.createElement(InnerText, null, mealText))),
        (typeof facilities !== 'undefined' ||
            typeof amenityText !== 'undefined') && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(CocoDivider$1, null),
            React$1.createElement(InnerTitle, null, "\u8A2D\u5099\uFF0F\u30B5\u30FC\u30D3\u30B9"))),
        typeof amenityText !== 'undefined' && (React$1.createElement(InnerText, null, amenityText)),
        typeof facilities !== 'undefined' && (React$1.createElement(FacilityList$1, { facilities: facilities })),
        typeof (location === null || location === void 0 ? void 0 : location.address) !== 'undefined' && (React$1.createElement(Table$1, { className: "address-table", disableBorder: typeof facilities === 'undefined' },
            React$1.createElement(Tbody, null,
                React$1.createElement(Tr, null,
                    React$1.createElement(Th, null,
                        React$1.createElement(RowTitle, null, "\u4F4F\u6240")),
                    React$1.createElement(Td, null, location.address))))),
        typeof (location === null || location === void 0 ? void 0 : location.mapUrl) !== 'undefined' && (React$1.createElement(CocoAspectRatio$1, { ratio: '250/375', style: mapStyle },
            React$1.createElement(LazyLoadComponent, { threshold: 300 },
                React$1.createElement(EmbedIframe, { src: location.mapUrl })))),
        typeof (location === null || location === void 0 ? void 0 : location.description) !== 'undefined' ? (React$1.createElement(AccessDescription, null, location.description)) : typeof accessText !== 'undefined' ? (React$1.createElement(AccessDescription, null, accessText)) : (React$1.createElement(React$1.Fragment, null))));
};
var index$e = memo(CocoHotelDetailInfo);
var Container$r = styled.div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject([""], [""])));
var Title$6 = styled.h3(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1));
var HotelDetailImageContainer = styled.div(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var Image$7 = styled.img(templateObject_4$o || (templateObject_4$o = __makeTemplateObject(["\n  width: 100%;\n  border-radius: 10px;\n  aspect-ratio: 375 / 210;\n"], ["\n  width: 100%;\n  border-radius: 10px;\n  aspect-ratio: 375 / 210;\n"])));
var Description$2 = styled.p(templateObject_5$j || (templateObject_5$j = __makeTemplateObject(["\n  ", ";\n  margin: 10px 0 20px;\n"], ["\n  ", ";\n  margin: 10px 0 20px;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_3), { lineHeight: '180%', letterSpacing: '0.1em' })));
var Table$1 = styled.table(templateObject_6$f || (templateObject_6$f = __makeTemplateObject(["\n  table-layout: fixed;\n  width: 100%;\n  text-align: left;\n  &.address-table {\n    tr {\n      border-top: ", ";\n      border-bottom: 0;\n    }\n  }\n"], ["\n  table-layout: fixed;\n  width: 100%;\n  text-align: left;\n  &.address-table {\n    tr {\n      border-top: ", ";\n      border-bottom: 0;\n    }\n  }\n"])), function (props) {
    return props.disableBorder === true
        ? 0
        : "1px solid ".concat(COLORS.BORDER.SECONDARY);
});
var Tbody = styled.tbody(templateObject_7$b || (templateObject_7$b = __makeTemplateObject([""], [""])));
var Tr = styled.tr(templateObject_8$a || (templateObject_8$a = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n"])), COLORS.BORDER.SECONDARY);
var Th = styled.th(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject(["\n  vertical-align: middle;\n  width: 65px;\n  padding: 15px 0;\n"], ["\n  vertical-align: middle;\n  width: 65px;\n  padding: 15px 0;\n"])));
var RowTitle = styled.h3(templateObject_10$8 || (templateObject_10$8 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '1.5' })));
var Td = styled.td(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject(["\n  padding: 15px 0 15px 15px;\n  ", ";\n  word-break: break-all;\n  vertical-align: middle;\n\n  &.area-list {\n    line-height: 1.8;\n    a,\n    span {\n      padding: 0 5px;\n      &:first-child {\n        padding-left: 0;\n      }\n    }\n  }\n  a {\n    color: ", ";\n  }\n"], ["\n  padding: 15px 0 15px 15px;\n  ", ";\n  word-break: break-all;\n  vertical-align: middle;\n\n  &.area-list {\n    line-height: 1.8;\n    a,\n    span {\n      padding: 0 5px;\n      &:first-child {\n        padding-left: 0;\n      }\n    }\n  }\n  a {\n    color: ", ";\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_3), { lineHeight: '1.5' })), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var Link = styled.a(templateObject_12$6 || (templateObject_12$6 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var InnerTitle = styled.h3(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject(["\n  padding-top: 15px;\n  ", ";\n"], ["\n  padding-top: 15px;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { lineHeight: '1.5' })));
var InnerText = styled.p(templateObject_14$4 || (templateObject_14$4 = __makeTemplateObject(["\n  padding: 15px 0;\n  ", ";\n"], ["\n  padding: 15px 0;\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_3));
var EmbedIframe = styled.iframe(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject(["\n  border: 0;\n  height: 100%;\n  width: 100%;\n"], ["\n  border: 0;\n  height: 100%;\n  width: 100%;\n"])));
var AccessDescription = styled.p(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject(["\n  margin-top: 10px;\n  ", ";\n  white-space: pre-wrap;\n"], ["\n  margin-top: 10px;\n  ", ";\n  white-space: pre-wrap;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_1), { lineHeight: '1.5', letterSpacing: '1px' })));
var templateObject_1$u, templateObject_2$s, templateObject_3$p, templateObject_4$o, templateObject_5$j, templateObject_6$f, templateObject_7$b, templateObject_8$a, templateObject_9$9, templateObject_10$8, templateObject_11$6, templateObject_12$6, templateObject_13$4, templateObject_14$4, templateObject_15$2, templateObject_16$1;

var useLocalState$5 = function (visibleSeconds) {
    var _a = __read(useState(true), 2), isVisible = _a[0], setIsVisible = _a[1];
    useMemo(function () {
        if (typeof visibleSeconds !== 'undefined') {
            setTimeout(function () {
                setIsVisible(false);
            }, 1000 * visibleSeconds);
        }
    }, [visibleSeconds, setIsVisible]);
    var onClickCloseButton = useCallback(function () {
        setIsVisible(false);
    }, []);
    return {
        onClickCloseButton: onClickCloseButton,
        isVisible: isVisible,
    };
};

var CocoNotification = function (_a) {
    var title = _a.title, clickableText = _a.clickableText, children = _a.children, onClickText = _a.onClickText, visibleSeconds = _a.visibleSeconds, style = _a.style;
    var _b = useLocalState$5(visibleSeconds), isVisible = _b.isVisible, onClickCloseButton = _b.onClickCloseButton;
    return isVisible ? (React$1.createElement(Container$q, { style: style },
        React$1.createElement(Inner$1, null,
            React$1.createElement(TitleContainer$2, null,
                React$1.createElement(Title$5, null, title),
                typeof onClickCloseButton !== 'undefined' && (React$1.createElement("div", { onClick: onClickCloseButton, style: {
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        cursor: 'pointer',
                    } },
                    React$1.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React$1.createElement("path", { d: "M11.8333 1.34163L10.6583 0.166626L5.99996 4.82496L1.34163 0.166626L0.166626 1.34163L4.82496 5.99996L0.166626 10.6583L1.34163 11.8333L5.99996 7.17496L10.6583 11.8333L11.8333 10.6583L7.17496 5.99996L11.8333 1.34163Z", fill: "white" }))))),
            typeof onClickText !== 'undefined' &&
                typeof onClickText !== 'undefined' && (React$1.createElement(A$1, { href: "#", onClick: function (e) {
                    e.preventDefault();
                    onClickText();
                } }, clickableText)),
            children))) : (React$1.createElement(React$1.Fragment, null));
};
var index$d = memo(CocoNotification);
var Container$q = styled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  z-index: ", ";\n"], ["\n  z-index: ", ";\n"])), Z_INDEX.TOOLTIP);
var A$1 = styled.a(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), COLORS.TEXT.INVERSE_PRIMARY);
var Inner$1 = styled.div(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  background: ", ";\n  border: 1px solid ", ";\n  ", ";\n  color: ", ";\n  padding: 12px 25px;\n  border-radius: 6px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);\n"], ["\n  background: ", ";\n  border: 1px solid ", ";\n  ", ";\n  color: ", ";\n  padding: 12px 25px;\n  border-radius: 6px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);\n"])), COLORS.STATUS.SUCCESS_OR_POSITIVE, COLORS.STATUS.SUCCESS_OR_POSITIVE, createFontStyle(MOBILE_FONT_STYLES.NOTE_1), COLORS.TEXT.INVERSE_PRIMARY);
var TitleContainer$2 = styled.div(templateObject_4$n || (templateObject_4$n = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var Title$5 = styled.h1(templateObject_5$i || (templateObject_5$i = __makeTemplateObject(["\n  margin-bottom: 3px;\n  ", ";\n"], ["\n  margin-bottom: 3px;\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_2));
var templateObject_1$t, templateObject_2$r, templateObject_3$o, templateObject_4$n, templateObject_5$i;

var useLocalState$4 = function (tabs, current, tabMargin, onClickTab) {
    var _a = __read(useState(0), 2), underBarLeft = _a[0], setUnderBarLeft = _a[1];
    var _b = __read(useState(0), 2), underBarWidth = _b[0], setUnderBarWidth = _b[1];
    var tabRefs = useRef([]);
    var handleOnTabClick = useCallback(function (tab) {
        onClickTab(tab);
    }, [onClickTab]);
    var getPositionByTabType = function (tabType, enableTabTypes) {
        var _a;
        return (_a = enableTabTypes.indexOf(tabType)) !== null && _a !== void 0 ? _a : 0;
    };
    var enableTabTypes = useMemo(function () {
        return tabs.map(function (tab) { return tab.tabType; });
    }, [tabs]);
    var currentTabPosition = useMemo(function () {
        return getPositionByTabType(current, enableTabTypes);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [current, tabs]);
    useEffect(function () {
        // 各タブの幅を計算
        var widths = tabRefs.current.map(function (ref) { return (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0; });
        // アクティブなタブまでの全タブの幅の合計を計算してleftを設定
        var leftPosition = widths
            .slice(0, currentTabPosition)
            .reduce(function (acc, width) {
            // 最初のタブ以外にマージンを加算
            return acc + width + tabMargin;
        }, 0);
        setUnderBarLeft(leftPosition);
        // アクティブなタブの幅を設定
        setUnderBarWidth(widths[currentTabPosition] || 0);
    }, [currentTabPosition, tabs.length, tabMargin]);
    var tabVariants = {
        inactive: { color: COLORS.TEXT.PRIMARY },
        active: {
            color: COLORS.GENERAL.PRIMARY,
        },
    };
    return {
        tabRefs: tabRefs,
        underBarLeft: underBarLeft,
        underBarWidth: underBarWidth,
        currentTabPosition: currentTabPosition,
        tabVariants: tabVariants,
        handleOnTabClick: handleOnTabClick,
    };
};

var TAB_MARGIN = 20;
var CocoScrollTabs = function (_a) {
    var tabs = _a.tabs, current = _a.current, onClickTab = _a.onClickTab, style = _a.style;
    var _b = useLocalState$4(tabs, current, TAB_MARGIN, onClickTab), underBarLeft = _b.underBarLeft, underBarWidth = _b.underBarWidth, tabVariants = _b.tabVariants, handleOnTabClick = _b.handleOnTabClick, tabRefs = _b.tabRefs;
    return (React$1.createElement(Container$p, { style: style },
        React$1.createElement(InnerContainer$3, null,
            tabs.map(function (tab, index) { return (React$1.createElement(TabContainer, { key: tab.tabType, ref: function (el) { return (tabRefs.current[index] = el); }, onClick: function () { return handleOnTabClick(tab.tabType); }, variants: tabVariants, initial: tab.isActive ? 'active' : 'inactive', animate: tab.isActive ? 'active' : 'inactive', transition: { ease: 'easeOut', duration: 0.3 } }, typeof tab.linkUrl === 'undefined' ? (tab.label) : (React$1.createElement("a", { href: tab.linkUrl }, tab.label)))); }),
            React$1.createElement(TabUnderBar, { animate: {
                    left: "".concat(underBarLeft, "px"),
                    width: "".concat(underBarWidth, "px"),
                }, transition: { ease: 'easeOut', duration: 0.3 } }))));
};
var index$c = React$1.memo(CocoScrollTabs);
var Container$p = styled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  padding: 0 20px;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n  background: ", ";\n  z-index: ", ";\n"], ["\n  padding: 0 20px;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n  background: ", ";\n  z-index: ", ";\n"])), COLORS.BORDER.PRIMARY, COLORS.BACKGROUND.SURFACE, Z_INDEX.TAB_MENU);
var InnerContainer$3 = styled(motion.div)(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n"])));
var TabContainer = styled(motion.div)(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 0 11px;\n\n  ", ";\n  white-space: nowrap;\n  cursor: pointer;\n  :nth-child(n + 2) {\n    margin-left: ", "px;\n  }\n  :last-child {\n    padding-right: 20px;\n  }\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  @media screen and (max-width: 350px) {\n    font-size: 11px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 0 11px;\n\n  ", ";\n  white-space: nowrap;\n  cursor: pointer;\n  :nth-child(n + 2) {\n    margin-left: ", "px;\n  }\n  :last-child {\n    padding-right: 20px;\n  }\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  @media screen and (max-width: 350px) {\n    font-size: 11px;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_1), { lineHeight: '180%', letterSpacing: '0.04em' })), TAB_MARGIN);
var TabUnderBar = styled(motion.div)(templateObject_4$m || (templateObject_4$m = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  height: 2px;\n  bottom: 0;\n"], ["\n  position: absolute;\n  background-color: ", ";\n  height: 2px;\n  bottom: 0;\n"])), COLORS.GENERAL.PRIMARY);
var templateObject_1$s, templateObject_2$q, templateObject_3$n, templateObject_4$m;

var CocoHotelSummary = function (_a) {
    var imgixHost = _a.imgixHost, hotelInfo = _a.hotelInfo, onClickHotelDetail = _a.onClickHotelDetail, onClickChangeHotel = _a.onClickChangeHotel, style = _a.style;
    return (React$1.createElement(Container$o, { style: style },
        typeof hotelInfo.hotelThumbnailUrl !== 'undefined' && (React$1.createElement(CocoAspectRatio$1, { ratio: "160/375" },
            React$1.createElement(CoverImage, { src: hotelInfo.hotelThumbnailUrl }),
            typeof hotelInfo.rating !== 'undefined' &&
                Math.floor(hotelInfo.rating) !== 0 && (React$1.createElement(HotelRateContainer$3, null,
                React$1.createElement(Image$6, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: hotelInfo.hotelName }),
                React$1.createElement(HotelRankText$3, null,
                    Math.floor(hotelInfo.rating),
                    "\u3064\u661F\u30DB\u30C6\u30EB"))))),
        React$1.createElement(ContainerInner, { hasThumbnail: typeof hotelInfo.hotelThumbnailUrl !== 'undefined' },
            React$1.createElement(HotelName$3, null, hotelInfo.hotelName),
            typeof hotelInfo.summaryTitle !== 'undefined' && (React$1.createElement(HotelSummaryTitle$3, null, hotelInfo.summaryTitle)),
            React$1.createElement(ReservationStayPeriod, { checkInDate: hotelInfo.checkInCheckOutInfo.checkInDate, checkInTimeRange: hotelInfo.checkInCheckOutInfo.availableCheckInTimeRange, checkOutDate: hotelInfo.checkInCheckOutInfo.checkOutDate, checkOutTime: hotelInfo.checkInCheckOutInfo.checkOutTime, style: { marginTop: '15px' } }),
            (typeof onClickChangeHotel !== 'undefined' ||
                typeof onClickHotelDetail !== 'undefined') && (React$1.createElement(HotelDetailTriggerContainer$1, { hasButton: typeof onClickChangeHotel !== 'undefined' },
                typeof onClickChangeHotel !== 'undefined' && (React$1.createElement(CocoWhiteButton, { height: 40, width: 180, onClick: onClickChangeHotel }, "\u30DB\u30C6\u30EB\u3092\u5909\u66F4\u3059\u308B")),
                typeof onClickHotelDetail !== 'undefined' && (React$1.createElement(HotelDetailTrigger$1, { onClick: onClickHotelDetail },
                    "\u30DB\u30C6\u30EB\u8A73\u7D30",
                    React$1.createElement("svg", { width: "7", height: "10", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginLeft: '5px' } },
                        React$1.createElement("path", { d: "M0.757324 0.757324L4.99997 4.99996L0.757324 9.2426", stroke: "#46A7ED", strokeWidth: "2" })))))))));
};
var index$b = memo(CocoHotelSummary);
var Container$o = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var CoverImage = styled.img(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  object-fit: cover;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n"], ["\n  object-fit: cover;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n"])));
var ContainerInner = styled.div(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  padding: 17px 15px 15px;\n  border: 1px solid rgba(0, 0, 0, 0.09);\n  border-top-width: ", ";\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  box-sizing: border-box;\n"], ["\n  padding: 17px 15px 15px;\n  border: 1px solid rgba(0, 0, 0, 0.09);\n  border-top-width: ", ";\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  box-sizing: border-box;\n"])), function (props) { return (props.hasThumbnail ? '0' : '1px'); }, function (props) { return (props.hasThumbnail ? '0' : '6px'); }, function (props) { return (props.hasThumbnail ? '0' : '6px'); });
var HotelSummaryTitle$3 = styled.p(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var HotelName$3 = styled.p(templateObject_5$h || (templateObject_5$h = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1));
var HotelDetailTriggerContainer$1 = styled.div(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n  margin-top: 15px;\n  display: flex;\n  justify-content: ", ";\n"], ["\n  margin-top: 15px;\n  display: flex;\n  justify-content: ", ";\n"])), function (props) {
    return props.hasButton ? 'space-between' : 'flex-end';
});
var HotelDetailTrigger$1 = styled.p(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '100%' })), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var HotelRateContainer$3 = styled.div(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject(["\n  position: absolute;\n  bottom: -16px;\n  padding: 2px 6px 3px 10px;\n  left: 10px;\n  height: 24px;\n  width: 90px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  bottom: -16px;\n  padding: 2px 6px 3px 10px;\n  left: 10px;\n  height: 24px;\n  width: 90px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var HotelRankText$3 = styled.p(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject(["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"], ["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_2));
var Image$6 = styled.img(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject(["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"], ["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"])));
var templateObject_1$r, templateObject_2$p, templateObject_3$m, templateObject_4$l, templateObject_5$h, templateObject_6$e, templateObject_7$a, templateObject_8$9, templateObject_9$8, templateObject_10$7;

var CocoHotelAndRoomSummary = function (_a) {
    var imgixHost = _a.imgixHost, hotelInfo = _a.hotelInfo, onClickHotelDetail = _a.onClickHotelDetail, onClickChangeHotel = _a.onClickChangeHotel, toIcon = _a.toIcon, roomName = _a.roomName, thumbnailUrl = _a.thumbnailUrl, facilities = _a.facilities, onClickRoomDetail = _a.onClickRoomDetail, changeHotelRoomUrl = _a.changeHotelRoomUrl, style = _a.style;
    return (React$1.createElement(Container$n, { style: style, hasThumbnail: typeof hotelInfo.hotelThumbnailUrl !== 'undefined' },
        typeof hotelInfo.hotelThumbnailUrl !== 'undefined' && (React$1.createElement(CocoAspectRatio$1, { ratio: "160/375" },
            React$1.createElement(HotelCoverImage, { src: hotelInfo.hotelThumbnailUrl }),
            typeof hotelInfo.rating !== 'undefined' &&
                Math.floor(hotelInfo.rating) !== 0 && (React$1.createElement(HotelRateContainer$2, null,
                React$1.createElement(Image$5, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: hotelInfo.hotelName }),
                React$1.createElement(HotelRankText$2, null,
                    Math.floor(hotelInfo.rating),
                    "\u3064\u661F\u30DB\u30C6\u30EB"))))),
        React$1.createElement(HotelContainerInner, null,
            React$1.createElement(HotelName$2, null, hotelInfo.hotelName),
            typeof hotelInfo.summaryTitle !== 'undefined' && (React$1.createElement(HotelSummaryTitle$2, null, hotelInfo.summaryTitle)),
            React$1.createElement(ReservationStayPeriod, { checkInDate: hotelInfo.checkInCheckOutInfo.checkInDate, checkInTimeRange: hotelInfo.checkInCheckOutInfo.availableCheckInTimeRange, checkOutDate: hotelInfo.checkInCheckOutInfo.checkOutDate, checkOutTime: hotelInfo.checkInCheckOutInfo.checkOutTime, style: { marginTop: '15px' } }),
            (typeof onClickChangeHotel !== 'undefined' ||
                typeof onClickHotelDetail !== 'undefined') && (React$1.createElement(HotelDetailTriggerContainer, { hasButton: typeof onClickChangeHotel !== 'undefined' },
                typeof onClickChangeHotel !== 'undefined' && (React$1.createElement(CocoWhiteButton, { height: 40, width: 180, onClick: onClickChangeHotel }, "\u30DB\u30C6\u30EB\u3092\u5909\u66F4\u3059\u308B")),
                typeof onClickHotelDetail !== 'undefined' && (React$1.createElement(HotelDetailTrigger, { onClick: onClickHotelDetail },
                    "\u30DB\u30C6\u30EB\u8A73\u7D30",
                    React$1.createElement("svg", { width: "7", height: "10", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginLeft: '5px' } },
                        React$1.createElement("path", { d: "M0.757324 0.757324L4.99997 4.99996L0.757324 9.2426", stroke: "#46A7ED", strokeWidth: "2" }))))))),
        React$1.createElement(CocoDivider$1, null),
        React$1.createElement(RoomContainerInner, null,
            React$1.createElement(RoomInfoContainer$2, null,
                typeof thumbnailUrl !== 'undefined' && (React$1.createElement(CocoAspectRatio$1, { ratio: "60/60", style: { width: '60px' } },
                    React$1.createElement(RoomCoverImage, { src: resizedExpediaImageUrl(thumbnailUrl, EXPEDIA_IMAGE_SIZES.WIDTH_1000) }))),
                React$1.createElement(RoomName$2, null, roomName)),
            React$1.createElement(TagContainer$2, null, typeof facilities !== 'undefined' &&
                facilities.length > 0 &&
                facilities.map(function (facility, index) { return (React$1.createElement(FacilityTagContainer, { key: index },
                    React$1.createElement(TagIcon, { src: toIcon(facility.type) }),
                    React$1.createElement(TagText, null, facility.label))); })),
            (typeof changeHotelRoomUrl !== 'undefined' ||
                typeof onClickRoomDetail !== 'undefined') && (React$1.createElement(ButtonContainer, { hasButton: typeof changeHotelRoomUrl !== 'undefined' },
                typeof changeHotelRoomUrl !== 'undefined' && (React$1.createElement(A, { href: changeHotelRoomUrl },
                    React$1.createElement(CocoWhiteButton, { height: 40, padding: 10, disableHover: true, "data-testid": "reservation-hotel-room_open-detail-modal" }, "\u5BBF\u6CCA\u30D7\u30E9\u30F3\u3092\u5909\u66F4\u3059\u308B"))),
                typeof onClickRoomDetail !== 'undefined' && (React$1.createElement(GotoRoomDetailTrigger, { onClick: onClickRoomDetail },
                    "\u5BA2\u5BA4\u8A73\u7D30",
                    React$1.createElement("svg", { width: "7", height: "10", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginLeft: '5px' } },
                        React$1.createElement("path", { d: "M0.757324 0.757324L4.99997 4.99996L0.757324 9.2426", stroke: "#46A7ED", strokeWidth: "2" })))))))));
};
var index$a = memo(CocoHotelAndRoomSummary);
var Container$n = styled.div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  position: relative;\n  border: 1px solid rgba(0, 0, 0, 0.09);\n  border-top-width: ", ";\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  box-sizing: border-box;\n"], ["\n  position: relative;\n  border: 1px solid rgba(0, 0, 0, 0.09);\n  border-top-width: ", ";\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  box-sizing: border-box;\n"])), function (props) { return (props.hasThumbnail ? '0' : '1px'); }, function (props) { return (props.hasThumbnail ? '0' : '6px'); }, function (props) { return (props.hasThumbnail ? '0' : '6px'); });
var HotelCoverImage = styled.img(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  object-fit: cover;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n"], ["\n  object-fit: cover;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n"])));
var HotelContainerInner = styled.div(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  padding: 17px 15px 15px;\n  box-sizing: border-box;\n"], ["\n  padding: 17px 15px 15px;\n  box-sizing: border-box;\n"])));
var HotelSummaryTitle$2 = styled.p(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var HotelName$2 = styled.p(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1));
var HotelDetailTriggerContainer = styled.div(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  margin-top: 15px;\n  display: flex;\n  justify-content: ", ";\n"], ["\n  margin-top: 15px;\n  display: flex;\n  justify-content: ", ";\n"])), function (props) {
    return props.hasButton ? 'space-between' : 'flex-end';
});
var HotelDetailTrigger = styled.p(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '100%' })), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var HotelRateContainer$2 = styled.div(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n  position: absolute;\n  bottom: -16px;\n  padding: 2px 6px 3px 10px;\n  left: 10px;\n  height: 24px;\n  width: 90px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  bottom: -16px;\n  padding: 2px 6px 3px 10px;\n  left: 10px;\n  height: 24px;\n  width: 90px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var HotelRankText$2 = styled.p(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject(["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"], ["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_2));
var Image$5 = styled.img(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject(["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"], ["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"])));
var RoomInfoContainer$2 = styled.div(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"])));
var RoomCoverImage = styled.img(templateObject_12$5 || (templateObject_12$5 = __makeTemplateObject(["\n  width: 60px;\n  height: 60px;\n  border-radius: 5px;\n  object-fit: cover;\n  border-radius: 5px;\n"], ["\n  width: 60px;\n  height: 60px;\n  border-radius: 5px;\n  object-fit: cover;\n  border-radius: 5px;\n"])));
var RoomName$2 = styled.span(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  flex: 1;\n  margin-left: 10px;\n"], ["\n  ", "\n  color: ", ";\n  flex: 1;\n  margin-left: 10px;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { letterSpacing: '0.1em' })), COLORS.TEXT.PRIMARY);
var RoomContainerInner = styled.div(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject(["\n  padding: 15px;\n"], ["\n  padding: 15px;\n"])));
var TagContainer$2 = styled.div(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  div {\n    margin: 10px 8px 0 0;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  div {\n    margin: 10px 8px 0 0;\n  }\n"])));
var ButtonContainer = styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  margin-top: 15px;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  margin-top: 15px;\n"])), function (props) {
    return props.hasButton ? 'space-between' : 'flex-end';
});
var A = styled.a(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  text-decoration: none;\n"], ["\n  text-decoration: none;\n"])));
var GotoRoomDetailTrigger = styled.p(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '100%' })), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var FacilityTagContainer = styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  background: #f8f7f0;\n  border-radius: 4px;\n  padding: 5px 7px;\n  display: flex;\n  width: fit-content;\n"], ["\n  background: #f8f7f0;\n  border-radius: 4px;\n  padding: 5px 7px;\n  display: flex;\n  width: fit-content;\n"])));
var TagText = styled.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  margin-left: 4px;\n  ", "\n  color: ", ";\n"], ["\n  margin-left: 4px;\n  ", "\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1), { letterSpacing: '0.1em' })), COLORS.TEXT.PRIMARY);
var TagIcon = styled.img(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n"], ["\n  width: 16px;\n  height: 16px;\n"])));
var templateObject_1$q, templateObject_2$o, templateObject_3$l, templateObject_4$k, templateObject_5$g, templateObject_6$d, templateObject_7$9, templateObject_8$8, templateObject_9$7, templateObject_10$6, templateObject_11$5, templateObject_12$5, templateObject_13$3, templateObject_14$3, templateObject_15$1, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;

var PCGlobalHeaderJPOrOverseasTabs = function (_a) {
    var activeTab = _a.activeTab, jpPageUrl = _a.jpPageUrl, overseasPageUrl = _a.overseasPageUrl, style = _a.style;
    return (React$1.createElement(Container$m, { style: style },
        React$1.createElement(Overseas, { isActive: activeTab === 'overseas', href: overseasPageUrl }, "\u6D77\u5916\u65C5\u884C"),
        React$1.createElement(JP, { isActive: activeTab === 'jp', href: jpPageUrl }, "\u56FD\u5185\u65C5\u884C")));
};
var PCGlobalHeaderJPOrOverseasTabs$1 = memo(PCGlobalHeaderJPOrOverseasTabs);
var Container$m = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  display: flex;\n\n  a {\n    width: 85px;\n    height: 37px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-decoration: none;\n    ", ";\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"], ["\n  display: flex;\n\n  a {\n    width: 85px;\n    height: 37px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-decoration: none;\n    ", ";\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '1.8' })));
var Overseas = styled.a(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 2px 0 0 2px;\n  color: ", ";\n"], ["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 2px 0 0 2px;\n  color: ", ";\n"])), function (props) {
    return props.isActive
        ? COLORS.STATUS.SUCCESS_OR_POSITIVE
        : COLORS.BACKGROUND.SURFACE;
}, COLORS.STATUS.SUCCESS_OR_POSITIVE, function (props) {
    return props.isActive
        ? COLORS.INVERT_TEXT.PRIMARY
        : COLORS.STATUS.SUCCESS_OR_POSITIVE;
});
var JP = styled.a(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  background: ", ";\n  border: 1px solid #26b76d;\n  border-radius: 0 2px 2px 0;\n  color: ", ";\n"], ["\n  background: ", ";\n  border: 1px solid #26b76d;\n  border-radius: 0 2px 2px 0;\n  color: ", ";\n"])), function (props) {
    return props.isActive ? '#26b76d' : COLORS.BACKGROUND.SURFACE;
}, function (props) {
    return props.isActive ? COLORS.INVERT_TEXT.PRIMARY : '#26b76d';
});
var templateObject_1$p, templateObject_2$n, templateObject_3$k;

var PCGlobalHeaderMenu = function (_a) {
    var callbackQueryParams = _a.callbackQueryParams, logout = _a.logout, imgixHost = _a.imgixHost, email = _a.email, style = _a.style;
    var arrayChunk = useCallback(function (array, size) {
        if (size <= 0)
            throw new Error('size must be greater than 0');
        var result = [];
        for (var i = 0, j = array.length; i < j; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    }, []);
    return (React$1.createElement(Container$l, { style: style },
        React$1.createElement("div", null,
            React$1.createElement(Section, null,
                React$1.createElement(SectionTitle, null, "\u6D77\u5916\u65C5\u884C"),
                arrayChunk(GLOBAL_MENU_DP_PAGE_LINKS, 2).map(function (links, index) { return (React$1.createElement(SectionContents, { key: index }, links.map(function (link, index) { return (React$1.createElement(LeftSectionsLink, { key: index, href: link.path, style: { width: "".concat(index === 0 ? '195px' : 'unset') } },
                    React$1.createElement("img", { src: addAutoFormatAndCompress("".concat(imgixHost).concat(link.spIconLinkUrl)), alt: link.title }),
                    React$1.createElement(SectionContentTitleWithIcon, null, link.title))); }))); })),
            React$1.createElement(Section, null,
                React$1.createElement(SectionTitle, null, "\u56FD\u5185\u65C5\u884C"),
                arrayChunk(GLOBAL_MENU_JP_PAGE_LINKS, 2).map(function (links, index) { return (React$1.createElement(SectionContents, { key: index }, links.map(function (link, index) { return (React$1.createElement(LeftSectionsLink, { key: index, href: link.path, style: { width: "".concat(index === 0 ? '195px' : 'unset') } },
                    React$1.createElement("img", { src: addAutoFormatAndCompress("".concat(imgixHost).concat(link.spIconLinkUrl)), alt: link.title }),
                    React$1.createElement(SectionContentTitleWithIcon, null, link.title))); }))); }),
                React$1.createElement(SectionContents, null,
                    React$1.createElement(LeftSectionsLink, { href: '/plans', style: { width: '195px' } },
                        React$1.createElement(SectionContentTitleWithoutIcon, null, "\u56FD\u5185\u65C5\u884C\u30E2\u30C7\u30EB\u30B3\u30FC\u30B9")),
                    React$1.createElement(LeftSectionsLink, { href: '/spots' },
                        React$1.createElement(SectionContentTitleWithoutIcon, null, "\u56FD\u5185\u89B3\u5149\u30B9\u30DD\u30C3\u30C8")))),
            typeof email !== 'undefined' && (React$1.createElement(Section, null,
                React$1.createElement(SectionTitle, null, "\u30D8\u30EB\u30D7\u30FB\u305D\u306E\u4ED6"),
                React$1.createElement(SectionContents, null,
                    React$1.createElement(LeftSectionsLink, { href: '/faq', style: { width: 'unset' } },
                        React$1.createElement(SectionContentTitleWithoutIcon, null, "\u3088\u304F\u3042\u308B\u8CEA\u554F\u30FB\u304A\u554F\u3044\u5408\u308F\u305B")))))),
        React$1.createElement("div", { style: { marginLeft: '30px' } }, typeof email === 'undefined' ? (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(SectionTitle, null, "\u30D8\u30EB\u30D7\u30FB\u305D\u306E\u4ED6"),
            React$1.createElement(SectionContents, null,
                React$1.createElement(RightSectionsLink, { href: '/histories' },
                    React$1.createElement(SectionContentTitleWithoutIcon, null, "\u6700\u8FD1\u30C1\u30A7\u30C3\u30AF\u3057\u305F\u5BBF"))),
            React$1.createElement(SectionContents, null,
                React$1.createElement(RightSectionsLink, { href: '/faq' },
                    React$1.createElement(SectionContentTitleWithoutIcon, null, "\u3088\u304F\u3042\u308B\u8CEA\u554F\u30FB\u304A\u554F\u3044\u5408\u308F\u305B"))),
            React$1.createElement(SectionContents, null,
                React$1.createElement(RightSectionsLink, { href: "/sign-in?".concat(callbackQueryParams) },
                    React$1.createElement(SectionContentTitleWithoutIcon, null, "\u30ED\u30B0\u30A4\u30F3"))),
            React$1.createElement(SectionContents, null,
                React$1.createElement(RightSectionsLink, { href: "/sign-up?".concat(callbackQueryParams) },
                    React$1.createElement(SectionContentTitleWithoutIcon, null, "\u4F1A\u54E1\u767B\u9332"))))) : (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(SectionTitle, null, "\u4F1A\u54E1\u30E1\u30CB\u30E5\u30FC"),
            React$1.createElement(MemberMenuContainer, null,
                React$1.createElement(MemberMenuSectionTitle, null, "\u65C5\u884C\u60C5\u5831"),
                React$1.createElement(MemberMenuContentsContainer, null,
                    React$1.createElement(SectionContents, null,
                        React$1.createElement(MemberSectionLink, { href: "/order/histories", style: { width: '139px' } },
                            React$1.createElement(MemberSectionContentTitle, null, "\u4E88\u7D04\u306E\u78BA\u8A8D")),
                        React$1.createElement(MemberSectionLink, { href: "/faq" },
                            React$1.createElement(MemberSectionContentTitle, null, "\u4E88\u7D04\u306B\u95A2\u3059\u308B\u304A\u554F\u3044\u5408\u308F\u305B"))),
                    React$1.createElement(SectionContents, null,
                        React$1.createElement(MemberSectionLink, { href: "/histories", style: { width: '139px' } },
                            React$1.createElement(MemberSectionContentTitle, null, "\u6700\u8FD1\u30C1\u30A7\u30C3\u30AF\u3057\u305F\u5BBF")),
                        React$1.createElement(MemberSectionLink, { href: "/bookmarks" },
                            React$1.createElement(MemberSectionContentTitle, null, "\u4FDD\u5B58\u3057\u305F\u5BBF"))),
                    React$1.createElement(SectionContents, null,
                        React$1.createElement(MemberSectionLink, { href: "/my-reviews", style: { width: '139px' } },
                            React$1.createElement(MemberSectionContentTitle, null, "\u53E3\u30B3\u30DF\u306E\u6295\u7A3F\u30FB\u7BA1\u7406")))),
                React$1.createElement(MemberMenuSectionTitle, { style: { marginTop: '20px' } },
                    "\u4F1A\u54E1\u60C5\u5831",
                    React$1.createElement(Email, null, email)),
                React$1.createElement(MemberMenuContentsContainer, null,
                    React$1.createElement(SectionContents, null,
                        React$1.createElement(MemberSectionLink, { href: "/sign/reset-email", style: { width: '139px' } },
                            React$1.createElement(MemberSectionContentTitle, null, "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5909\u66F4")),
                        React$1.createElement(MemberSectionLink, { onClick: logout },
                            React$1.createElement(MemberSectionContentTitle, null, "\u30ED\u30B0\u30A2\u30A6\u30C8"))))))))));
};
var PCGlobalHeaderMenu$1 = memo(PCGlobalHeaderMenu);
var Container$l = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  width: fit-content;\n  padding: 30px;\n  background-color: ", ";\n  border-radius: 10px;\n  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);\n  display: flex;\n"], ["\n  width: fit-content;\n  padding: 30px;\n  background-color: ", ";\n  border-radius: 10px;\n  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);\n  display: flex;\n"])), COLORS.BACKGROUND.SURFACE);
var Section = styled.div(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  + div {\n    margin-top: 30px;\n  }\n"], ["\n  + div {\n    margin-top: 30px;\n  }\n"])));
var SectionTitle = styled.p(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.SUB_TITLE_1), { lineHeight: '120%' })), COLORS.TEXT.PRIMARY);
var SectionContents = styled.div(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  display: flex;\n  margin-top: 10px;\n"], ["\n  display: flex;\n  margin-top: 10px;\n"])));
var LeftSectionsLink = styled.a(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: ", ";\n\n  > img {\n    width: 32px;\n  }\n\n  + a {\n    margin-left: 20px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: ", ";\n\n  > img {\n    width: 32px;\n  }\n\n  + a {\n    margin-left: 20px;\n  }\n"])), COLORS.TEXT.PRIMARY);
var RightSectionsLink = styled.a(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n"], ["\n  text-decoration: none;\n  color: ", ";\n"])), COLORS.TEXT.PRIMARY);
var SectionContentTitleWithIcon = styled.p(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  margin-left: 4px;\n  ", ";\n"], ["\n  margin-left: 4px;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { lineHeight: '120%', letterSpacing: '0.84px' })));
var SectionContentTitleWithoutIcon = styled.p(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  padding: 4px 3px;\n  ", ";\n"], ["\n  padding: 4px 3px;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { lineHeight: '120%', letterSpacing: '0.84px' })));
var MemberMenuContainer = styled.div(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject(["\n  margin-top: 10px;\n  width: 100%;\n"], ["\n  margin-top: 10px;\n  width: 100%;\n"])));
var MemberMenuSectionTitle = styled.p(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  padding: 10px;\n  border-radius: 3px;\n  background-color: ", ";\n  ", ";\n"], ["\n  padding: 10px;\n  border-radius: 3px;\n  background-color: ", ";\n  ", ";\n"])), COLORS.BACKGROUND.BASE, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '120%', letterSpacing: '.78px' })));
var Email = styled.p(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n  margin-top: 5px;\n  ", ";\n"], ["\n  margin-top: 5px;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_2), { lineHeight: '120%' })));
var MemberMenuContentsContainer = styled.div(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  padding-left: 10px;\n  padding-right: 10px;\n"], ["\n  padding-left: 10px;\n  padding-right: 10px;\n"])));
var MemberSectionLink = styled.a(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n\n  + a {\n    margin-left: 20px;\n  }\n"], ["\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n\n  + a {\n    margin-left: 20px;\n  }\n"])), COLORS.TEXT.PRIMARY);
var MemberSectionContentTitle = styled.p(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject(["\n  padding: 4px 0;\n  ", ";\n"], ["\n  padding: 4px 0;\n  ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { lineHeight: '120%', letterSpacing: '0.84px' })));
var templateObject_1$o, templateObject_2$m, templateObject_3$j, templateObject_4$j, templateObject_5$f, templateObject_6$c, templateObject_7$8, templateObject_8$7, templateObject_9$6, templateObject_10$5, templateObject_11$4, templateObject_12$4, templateObject_13$2, templateObject_14$2;

var CocoPCGlobalHeader = function (_a) {
    var activeTab = _a.activeTab, jpPageUrl = _a.jpPageUrl, overseasPageUrl = _a.overseasPageUrl, email = _a.email, callbackQueryParams = _a.callbackQueryParams, logout = _a.logout, imgixHost = _a.imgixHost, hostUrl = _a.hostUrl, style = _a.style;
    return (React$1.createElement(Container$k, { style: style },
        React$1.createElement(Inner, null,
            React$1.createElement(PCGlobalHeaderJPOrOverseasTabs$1, { activeTab: activeTab, jpPageUrl: jpPageUrl, overseasPageUrl: overseasPageUrl, style: { paddingBottom: '20px' } }),
            React$1.createElement("a", { href: hostUrl },
                React$1.createElement(CocoProductLogo$1, { type: 'pc', style: { paddingBottom: '20px' } })),
            React$1.createElement(FlexContainer, null,
                typeof email === 'undefined' && (React$1.createElement(Login, { href: "/sign-in?".concat(callbackQueryParams) }, "\u30ED\u30B0\u30A4\u30F3")),
                React$1.createElement(MenuHoverTriggerContainer, null,
                    React$1.createElement(CocoWhiteButton, { height: '38px', containerType: 'button' },
                        React$1.createElement("svg", { width: "14", height: "10", viewBox: "0 0 14 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React$1.createElement("rect", { width: "14", height: "2", rx: "1", fill: "black", fillOpacity: "0.87" }),
                            React$1.createElement("rect", { y: "4", width: "14", height: "2", rx: "1", fill: "black", fillOpacity: "0.87" }),
                            React$1.createElement("rect", { y: "8", width: "14", height: "2", rx: "1", fill: "black", fillOpacity: "0.87" })),
                        React$1.createElement("p", { style: { marginLeft: '5px' } }, "\u30E1\u30CB\u30E5\u30FC")),
                    React$1.createElement(MenuItemsContainer, null,
                        React$1.createElement(PCGlobalHeaderMenu$1, { callbackQueryParams: callbackQueryParams, logout: logout, imgixHost: imgixHost, email: email })))))));
};
var index$9 = memo(CocoPCGlobalHeader);
var Container$k = styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  width: 100%;\n  padding-top: 20px;\n  background-color: ", ";\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  z-index: ", ";\n"], ["\n  width: 100%;\n  padding-top: 20px;\n  background-color: ", ";\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\n  z-index: ", ";\n"])), COLORS.BACKGROUND.SURFACE, Z_INDEX.PC_GLOBAL_HEADER);
var Inner = styled.div(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var FlexContainer = styled.div(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"])));
var Login = styled.a(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  margin-bottom: 20px;\n  color: ", ";\n  text-decoration: none;\n  ", ";\n"], ["\n  margin-bottom: 20px;\n  color: ", ";\n  text-decoration: none;\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '180%' })));
var MenuHoverTriggerContainer = styled.div(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  position: relative;\n  margin-left: 20px;\n  padding-bottom: 20px;\n\n  :hover {\n    > div {\n      visibility: visible;\n    }\n  }\n"], ["\n  position: relative;\n  margin-left: 20px;\n  padding-bottom: 20px;\n\n  :hover {\n    > div {\n      visibility: visible;\n    }\n  }\n"])));
var MenuItemsContainer = styled.div(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  // NOTE: (akutsu) \u521D\u671F\u5024\u306F hidden \u3068\u3057\u305F\u4E0A\u306791\u884C\u76EE\u306E\u30B3\u30FC\u30C9\u306B\u3088\u3063\u3066\u300C\u30E1\u30CB\u30E5\u30FC\u300D\u306B\u30DB\u30D0\u30FC\u6642\u306B visible \u306B\u5909\u66F4\u3057\u3066\u3044\u308B\n  visibility: hidden;\n  position: absolute;\n  top: 50px;\n  right: 0;\n  width: max-content;\n  z-index: ", ";\n"], ["\n  // NOTE: (akutsu) \u521D\u671F\u5024\u306F hidden \u3068\u3057\u305F\u4E0A\u306791\u884C\u76EE\u306E\u30B3\u30FC\u30C9\u306B\u3088\u3063\u3066\u300C\u30E1\u30CB\u30E5\u30FC\u300D\u306B\u30DB\u30D0\u30FC\u6642\u306B visible \u306B\u5909\u66F4\u3057\u3066\u3044\u308B\n  visibility: hidden;\n  position: absolute;\n  top: 50px;\n  right: 0;\n  width: max-content;\n  z-index: ", ";\n"])), Z_INDEX.PC_GLOBAL_HEADER_MENUS);
var templateObject_1$n, templateObject_2$l, templateObject_3$i, templateObject_4$i, templateObject_5$e, templateObject_6$b;

var FreeBaggageAllowance = function (_a) {
    var gdsVendor = _a.gdsVendor, freeBaggageAllowance = _a.freeBaggageAllowance, _b = _a.hasBaggageOption, hasBaggageOption = _b === void 0 ? false : _b, style = _a.style;
    return (React$1.createElement(Container$j, { style: style },
        React$1.createElement(Title$4, null, "\u53D7\u8A17\u624B\u8377\u7269"),
        gdsVendor === GDS_VENDORS.AMADEUS ? (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(BaggageAllowanceText, null,
                "\u7121\u6599\u3067\u9810\u3051\u3089\u308C\u308B\u91CF\uFF1A",
                freeBaggageAllowance),
            freeBaggageAllowance === '0個' ||
                freeBaggageAllowance === '0kg' ||
                freeBaggageAllowance === '0ポンド' ? (React$1.createElement(Supplement, null, "\u53D7\u8A17\u624B\u8377\u7269\u306B\u306F\u8FFD\u52A0\u6599\u91D1\u304C\u304B\u304B\u308A\u307E\u3059\u3002\u7A7A\u6E2F\u3067\u306E\u624B\u7D9A\u304D\u306F\u9AD8\u984D\u306B\u306A\u308B\u5834\u5408\u304C\u3042\u308B\u305F\u3081\u3001\u4E88\u7D04\u5F8C\u306B\u822A\u7A7A\u4F1A\u793E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306B\u3066\u4E8B\u524D\u8CFC\u5165\u304C\u304A\u3059\u3059\u3081\u3067\u3059\u3002")) : (React$1.createElement(Supplement, null, "\u4E0A\u8A18\u3092\u8D85\u3048\u308B\u53D7\u8A17\u624B\u8377\u7269\u306B\u306F\u8FFD\u52A0\u6599\u91D1\u304C\u304B\u304B\u308A\u307E\u3059\u3002\u7A7A\u6E2F\u3067\u306E\u624B\u7D9A\u304D\u306F\u9AD8\u984D\u306B\u306A\u308B\u5834\u5408\u304C\u3042\u308B\u305F\u3081\u3001\u4E88\u7D04\u5F8C\u306B\u822A\u7A7A\u4F1A\u793E\u30DB\u30FC\u30E0\u30DA\u30FC\u30B8\u306B\u3066\u4E8B\u524D\u8CFC\u5165\u304C\u304A\u3059\u3059\u3081\u3067\u3059\u3002")))) : (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(BaggageAllowanceText, null,
                "\u7121\u6599\u3067\u9810\u3051\u3089\u308C\u308B\u91CF\uFF1A",
                freeBaggageAllowance),
            hasBaggageOption && (React$1.createElement(React$1.Fragment, null,
                React$1.createElement(Supplement, null, "\u53D7\u8A17\u624B\u8377\u7269\u306B\u306F\u8FFD\u52A0\u6599\u91D1\u304C\u304B\u304B\u308A\u307E\u3059\u3002\u7A7A\u6E2F\u3067\u306E\u624B\u7D9A\u304D\u306F\u9AD8\u984D\u306B\u306A\u308B\u5834\u5408\u304C\u3042\u308B\u305F\u3081\u3001\u4E8B\u524D\u8CFC\u5165\u304C\u304A\u3059\u3059\u3081\u3067\u3059\u3002"),
                React$1.createElement(BaggageOptionContainer, null,
                    React$1.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React$1.createElement("circle", { cx: "7", cy: "7", r: "7", fill: "#5AC486" }),
                        React$1.createElement("path", { d: "M6.16191 10.0806C5.91868 10.0806 5.67546 9.98938 5.46264 9.80696L3 7.34432L4.36813 5.97619L6.16191 7.76996L9.93187 4L11.3 5.36813L6.86117 9.80696C6.67876 9.98938 6.43553 10.0806 6.16191 10.0806Z", fill: "white" })),
                    React$1.createElement(BaggageOptionNote, null, "\u5F8C\u306E\u753B\u9762\u3067\u8FFD\u52A0\u306E\u53D7\u8A17\u624B\u8377\u7269\u3092\u8CFC\u5165\u3067\u304D\u307E\u3059\u3002"))))))));
};
var FreeBaggageAllowance$1 = memo(FreeBaggageAllowance);
var Container$j = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  padding: 15px;\n  border-radius: 6px;\n  border: 1px solid ", ";\n"], ["\n  padding: 15px;\n  border-radius: 6px;\n  border: 1px solid ", ";\n"])), COLORS.BORDER.SECONDARY);
var Title$4 = styled.p(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_2));
var BaggageAllowanceText = styled.p(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  margin-top: 10px;\n  ", "\n"], ["\n  margin-top: 10px;\n  ", "\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_3));
var Supplement = styled.p(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  margin-top: 10px;\n  ", "\n"], ["\n  margin-top: 10px;\n  ", "\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1));
var BaggageOptionContainer = styled.div(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid ", ";\n  background: #e4f6ea;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid ", ";\n  background: #e4f6ea;\n"])), COLORS.GENERAL.SECONDARY);
var BaggageOptionNote = styled.div(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  margin-left: 5px;\n  ", "\n  color: #009B4C;\n"], ["\n  margin-left: 5px;\n  ", "\n  color: #009B4C;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_2), { lineHeight: 1.4 })));
var templateObject_1$m, templateObject_2$k, templateObject_3$h, templateObject_4$h, templateObject_5$d, templateObject_6$a;

var AirportInformation = function (_a) {
    var date = _a.date, time = _a.time, airport = _a.airport, style = _a.style;
    return (React$1.createElement(Container$i, { style: style },
        React$1.createElement(DateTimeContainer, null,
            React$1.createElement(Time$2, null, time),
            React$1.createElement(Date$1, null, date)),
        React$1.createElement(AirportContainer, null,
            React$1.createElement(AirportName, null, airport.airportName),
            React$1.createElement(AirportCodeAndLocation, null,
                React$1.createElement(AirportCode, null, airport.airportIATACode),
                React$1.createElement(AirportLocation, null, airport.countryAndCityName)))));
};
var AirportInformation$1 = memo(AirportInformation);
var Container$i = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var DateTimeContainer = styled.div(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  text-align: center;\n  margin-right: 40px;\n"], ["\n  text-align: center;\n  margin-right: 40px;\n"])));
var Time$2 = styled.p(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { fontWeight: FONT_WEIGHT.WEIGHT_700, letterSpacing: '0.01em' })));
var Date$1 = styled.p(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(MOBILE_FONT_STYLES.CAPTION_1));
var AirportContainer = styled.div(templateObject_5$c || (templateObject_5$c = __makeTemplateObject([""], [""])));
var AirportName = styled.p(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_2));
var AirportCodeAndLocation = styled.div(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var AirportCode = styled.div(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n  margin-right: 4px;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 0 3px;\n  ", "\n\n  transform: scale(0.9);\n"], ["\n  margin-right: 4px;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 0 3px;\n  ", "\n\n  transform: scale(0.9);\n"])), COLORS.TEXT.NOTE_OR_CAPTION, COLORS.BORDER.SECONDARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { fontWeight: FONT_WEIGHT.WEIGHT_500, lineHeight: '180%' })));
var AirportLocation = styled.p(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(MOBILE_FONT_STYLES.CAPTION_1));
var templateObject_1$l, templateObject_2$j, templateObject_3$g, templateObject_4$g, templateObject_5$c, templateObject_6$9, templateObject_7$7, templateObject_8$6, templateObject_9$5;

var CocoFlightScheduleNote = function (_a) {
    var children = _a.children, style = _a.style;
    return (React$1.createElement(Note, { style: style }, children));
};
var CocoFlightScheduleNote$1 = memo(CocoFlightScheduleNote);
var Note = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  padding: 10px;\n  border: 1px solid #67b7ef;\n  background: #e3f2fc;\n  border-radius: 6px;\n  ", "\n  color: #1e8cdd;\n"], ["\n  padding: 10px;\n  border: 1px solid #67b7ef;\n  background: #e3f2fc;\n  border-radius: 6px;\n  ", "\n  color: #1e8cdd;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_2), { lineHeight: 1.4 })));
var templateObject_1$k;

var ConnectingTime = function (_a) {
    var connectingTime = _a.connectingTime, isConnectingToAnotherAirport = _a.isConnectingToAnotherAirport, isTransit = _a.isTransit, style = _a.style;
    return (React$1.createElement(Container$h, { style: style },
        React$1.createElement(InnerContainer$2, { style: style },
            React$1.createElement(Time$1, null, connectingTime)),
        React$1.createElement("div", null,
            React$1.createElement(Label$1, null, isTransit
                ? '一時寄港 (給油/整備のため)'
                : "\u4E57\u308A\u7D99\u304E".concat(isConnectingToAnotherAirport ? '（別空港）' : '（空港内）')),
            (isConnectingToAnotherAirport || isTransit) && (React$1.createElement(CocoFlightScheduleNote$1, { style: {
                    marginTop: '3px',
                    padding: '5px 10px',
                    letterSpacing: '0.1em',
                } },
                isTransit
                    ? '待機後、同じ便に搭乗します'
                    : '別空港への移動が必要です',
                "\u3002")))));
};
var ConnectingTime$1 = memo(ConnectingTime);
var Container$h = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var InnerContainer$2 = styled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  margin-right: 10px;\n  height: 100%;\n  min-width: 80px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::after {\n    position: absolute;\n    display: inline-block;\n    content: '';\n    height: 135%;\n    width: 3px;\n    background-color: ", ";\n  }\n"], ["\n  margin-right: 10px;\n  height: 100%;\n  min-width: 80px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::after {\n    position: absolute;\n    display: inline-block;\n    content: '';\n    height: 135%;\n    width: 3px;\n    background-color: ", ";\n  }\n"])), COLORS.BORDER.SECONDARY);
var Time$1 = styled.div(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  position: relative;\n  padding: 0 8px;\n  border-radius: 100px;\n  background-color: #9e9e9e;\n  color: ", ";\n  ", ";\n  z-index: 1;\n"], ["\n  position: relative;\n  padding: 0 8px;\n  border-radius: 100px;\n  background-color: #9e9e9e;\n  color: ", ";\n  ", ";\n  z-index: 1;\n"])), COLORS.TEXT.INVERSE_PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1), { letterSpacing: '0.04em', lineHeight: '180%' })));
var Label$1 = styled.p(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  color: ", ";\n\n  ", "\n\n  span {\n    vertical-align: 1px;\n    ", "\n  }\n"], ["\n  color: ", ";\n\n  ", "\n\n  span {\n    vertical-align: 1px;\n    ", "\n  }\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_1), { letterSpacing: '0.1em', lineHeight: '180%' })), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1), { letterSpacing: '0.1em', lineHeight: '180%' })));
var templateObject_1$j, templateObject_2$i, templateObject_3$f, templateObject_4$f;

var FlightTime = function (_a) {
    var flightTime = _a.flightTime, style = _a.style;
    return (React$1.createElement(Container$g, { style: style },
        React$1.createElement(InnerContainer$1, { style: style },
            React$1.createElement(Circle, { style: { top: 0 } }),
            React$1.createElement(Time, null, flightTime),
            React$1.createElement(Circle, { style: { bottom: 0 } }))));
};
var FlightTime$1 = memo(FlightTime);
var Container$g = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject([""], [""])));
var InnerContainer$1 = styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  height: 100%;\n  min-width: 80px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::after {\n    position: absolute;\n    display: inline-block;\n    content: '';\n    height: 100%;\n    width: 3px;\n    background-color: ", ";\n  }\n"], ["\n  height: 100%;\n  min-width: 80px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::after {\n    position: absolute;\n    display: inline-block;\n    content: '';\n    height: 100%;\n    width: 3px;\n    background-color: ", ";\n  }\n"])), COLORS.GENERAL.SECONDARY);
var Time = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  padding: 0 8px;\n  border-radius: 100px;\n  background-color: ", ";\n  color: ", ";\n  ", ";\n  z-index: 1;\n"], ["\n  padding: 0 8px;\n  border-radius: 100px;\n  background-color: ", ";\n  color: ", ";\n  ", ";\n  z-index: 1;\n"])), COLORS.GENERAL.SECONDARY, COLORS.TEXT.INVERSE_PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1), { letterSpacing: '0.04em', lineHeight: '180%' })));
var Circle = styled.div(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 3px solid ", ";\n  z-index: 1;\n"], ["\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background-color: ", ";\n  border: 3px solid ", ";\n  z-index: 1;\n"])), COLORS.BACKGROUND.SURFACE, COLORS.GENERAL.SECONDARY);
var templateObject_1$i, templateObject_2$h, templateObject_3$e, templateObject_4$e;

var Header$1 = function (_a) {
    var imgixHost = _a.imgixHost, carrierIATACode = _a.carrierIATACode, carrierName = _a.carrierName, carrierType = _a.carrierType, flightNumber = _a.flightNumber, flightClassName = _a.flightClassName, fareClassCode = _a.fareClassCode, style = _a.style;
    return (React$1.createElement(Container$f, { style: style },
        React$1.createElement(CarrierIcon, { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" },
            React$1.createElement("rect", { fill: "#46a7ed", height: "24", rx: "4", width: "24" }),
            React$1.createElement("path", { d: "m18.75 15v-1.5l-6-3.75v-4.125c0-.6225-.5025-1.125-1.125-1.125s-1.125.5025-1.125 1.125v4.125l-6 3.75v1.5l6-1.875v4.125l-1.5 1.125v1.125l2.625-.75 2.625.75v-1.125l-1.5-1.125v-4.125z", fill: "#e3f2fc" })),
        React$1.createElement(TextContainer, null,
            React$1.createElement(Title$3, null,
                carrierName,
                " ",
                carrierIATACode,
                carrierType === CARRIER_TYPE.LCC && (React$1.createElement(Image$4, { src: "".concat(imgixHost, "/images/shared/ui-components/CocoFlightSummary/lcc-icon.png") })),
                flightNumber,
                "\u4FBF"),
            React$1.createElement(FlightClassName, { "data-testid": "header-flight_class_name" },
                flightClassName,
                typeof fareClassCode !== 'undefined' && "\uFF08".concat(fareClassCode, "\uFF09")))));
};
var Header$2 = memo(Header$1);
var Container$f = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  padding: 8px 10px;\n  border-radius: 6px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n"], ["\n  padding: 8px 10px;\n  border-radius: 6px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n"])), COLORS.BACKGROUND.BASE);
var CarrierIcon = styled.svg(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  border-radius: 2px;\n"], ["\n  width: 24px;\n  height: 24px;\n  border-radius: 2px;\n"])));
var TextContainer = styled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  margin-left: 8px;\n"], ["\n  margin-left: 8px;\n"])));
var Title$3 = styled.p(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { letterSpacing: '1px', lineHeight: '120%' })));
var FlightClassName = styled.p(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  margin-top: 2px;\n  color: ", ";\n  ", "\n"], ["\n  margin-top: 2px;\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_1), { letterSpacing: '0.04em', lineHeight: '120%' })));
var Image$4 = styled.img(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  height: 12px;\n  padding: 0 2px;\n"], ["\n  height: 12px;\n  padding: 0 2px;\n"])));
var templateObject_1$h, templateObject_2$g, templateObject_3$d, templateObject_4$d, templateObject_5$b, templateObject_6$8;

var CocoFlightSchedule = function (_a) {
    var imgixHost = _a.imgixHost, flightScheduleInfoList = _a.flightScheduleInfoList, style = _a.style;
    return (React$1.createElement(Container$e, { style: style }, flightScheduleInfoList.map(function (flightScheduleInfo, index) {
        var departureDate = flightScheduleInfo.departureDate, departureTime = flightScheduleInfo.departureTime, departureAirport = flightScheduleInfo.departureAirport, arrivalDate = flightScheduleInfo.arrivalDate, arrivalTime = flightScheduleInfo.arrivalTime, arrivalAirport = flightScheduleInfo.arrivalAirport, flightTime = flightScheduleInfo.flightTime, connectingTime = flightScheduleInfo.connectingTime, flightInfo = flightScheduleInfo.flightInfo, isConnectingToAnotherAirport = flightScheduleInfo.isConnectingToAnotherAirport, isTransitArrival = flightScheduleInfo.isTransitArrival;
        var isTransitDeparture = typeof flightInfo === 'undefined';
        return (React$1.createElement(Fragment, { key: index },
            !isTransitDeparture && (React$1.createElement(React$1.Fragment, null,
                React$1.createElement(Header$2, __assign({ imgixHost: imgixHost }, flightInfo, { style: { position: 'relative', zIndex: '1' } })),
                flightInfo.codeShareAirlines.length > 0 && (React$1.createElement(CocoFlightScheduleNote$1, { style: { marginTop: '15px' } },
                    flightInfo.carrierIATACode,
                    flightInfo.flightNumber,
                    "\u4FBF\u306F",
                    flightInfo.codeShareAirlines.join('、'),
                    "\u3068\u306E\u5171\u540C\u904B\u822A\u4FBF\u3067\u3059\u3002")))),
            React$1.createElement(AirportInformationContainer, { style: { marginTop: isTransitDeparture ? 0 : undefined } },
                React$1.createElement(AirportInformation$1, { date: departureDate, time: departureTime, airport: departureAirport }),
                React$1.createElement(AirportInformation$1, { date: arrivalDate, time: arrivalTime, airport: arrivalAirport, style: { marginTop: '85px' } }),
                React$1.createElement(FlightTimeContainer, null,
                    React$1.createElement(FlightTime$1, { flightTime: flightTime, style: { height: '90%' } }))),
            typeof connectingTime !== 'undefined' &&
                (isTransitArrival ||
                    typeof isConnectingToAnotherAirport !== 'undefined') && (React$1.createElement(ConnectingTimeContainer, null,
                React$1.createElement(ConnectingTimeInnerContainer, null,
                    React$1.createElement(ConnectingTime$1, { connectingTime: connectingTime, isConnectingToAnotherAirport: isConnectingToAnotherAirport !== null && isConnectingToAnotherAirport !== void 0 ? isConnectingToAnotherAirport : false, isTransit: isTransitArrival, style: { height: '100%' } }))))));
    })));
};
var CocoFlightSchedule$1 = memo(CocoFlightSchedule);
var Container$e = styled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject([""], [""])));
var AirportInformationContainer = styled.div(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  height: fit-content;\n  position: relative;\n  margin-top: 17.5px;\n  padding: 0 10px;\n"], ["\n  height: fit-content;\n  position: relative;\n  margin-top: 17.5px;\n  padding: 0 10px;\n"])));
var FlightTimeContainer = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  height: 100%;\n  position: absolute;\n  top: 10%;\n  left: 43px;\n"], ["\n  height: 100%;\n  position: absolute;\n  top: 10%;\n  left: 43px;\n"])));
var ConnectingTimeContainer = styled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  height: 100px;\n  position: relative;\n"], ["\n  height: 100px;\n  position: relative;\n"])));
var ConnectingTimeInnerContainer = styled.div(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  height: 100%;\n  position: absolute;\n  left: 43px;\n  bottom: 0;\n"], ["\n  height: 100%;\n  position: absolute;\n  left: 43px;\n  bottom: 0;\n"])));
var templateObject_1$g, templateObject_2$f, templateObject_3$c, templateObject_4$c, templateObject_5$a;

var GDS_VENDORS = {
    AMADEUS: 'AMADEUS',
    TRAVEL_FUSION: 'TRAVEL_FUSION',
};
var CocoFlightDetailModal = function (_a) {
    var imgixHost = _a.imgixHost, flightDetailInfo = _a.flightDetailInfo, isOpen = _a.isOpen, onClose = _a.onClose, minWidth = _a.minWidth, style = _a.style;
    var flightScheduleInfoList = flightDetailInfo.flightScheduleInfoList, showDifferentAirportsAlertForDeparture = flightDetailInfo.showDifferentAirportsAlertForDeparture, showDifferentAirportsAlertForArrival = flightDetailInfo.showDifferentAirportsAlertForArrival, freeBaggageAllowance = flightDetailInfo.freeBaggageAllowance, hasBaggageOption = flightDetailInfo.hasBaggageOption, footerInfo = flightDetailInfo.footerInfo, _b = flightDetailInfo.loadingFreeBaggageAllowance, loadingFreeBaggageAllowance = _b === void 0 ? false : _b, gdsVendor = flightDetailInfo.gdsVendor, passportRequiredBeforeReservation = flightDetailInfo.passportRequiredBeforeReservation;
    return (React$1.createElement(CocoModal$1, { title: "\u30D5\u30E9\u30A4\u30C8\u8A73\u7D30", isOpen: isOpen, onClose: onClose, minWidth: minWidth },
        React$1.createElement(Container$d, { style: style },
            React$1.createElement(InnerContainer, null,
                typeof flightDetailInfo.note !== 'undefined' && (React$1.createElement(CocoFlightScheduleNote$1, { style: { marginBottom: '15px' } }, flightDetailInfo.note)),
                React$1.createElement(CocoFlightSchedule$1, { imgixHost: imgixHost, flightScheduleInfoList: flightScheduleInfoList }),
                (showDifferentAirportsAlertForDeparture ||
                    showDifferentAirportsAlertForArrival) && (React$1.createElement(ShowDifferentAirportsAlertForDepartureContainer, null,
                    showDifferentAirportsAlertForDeparture && (React$1.createElement(CocoFlightScheduleNote$1, null, "\u884C\u304D\u306E\u51FA\u767A\u7A7A\u6E2F\u3068\u5E30\u308A\u306E\u5230\u7740\u7A7A\u6E2F\u304C\u7570\u306A\u308A\u307E\u3059\u3002\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002")),
                    showDifferentAirportsAlertForArrival && (React$1.createElement(CocoFlightScheduleNote$1, { style: {
                            marginTop: showDifferentAirportsAlertForDeparture
                                ? '10px'
                                : '0',
                        } }, "\u884C\u304D\u306E\u5230\u7740\u7A7A\u6E2F\u3068\u5E30\u308A\u306E\u51FA\u767A\u7A7A\u6E2F\u304C\u7570\u306A\u308A\u307E\u3059\u3002\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002")))),
                typeof freeBaggageAllowance === 'undefined' &&
                    loadingFreeBaggageAllowance && (React$1.createElement(LoadingContainer$1, null,
                    React$1.createElement(reactActivity.exports.Spinner, { size: 25, color: COLORS.GENERAL.PRIMARY, speed: 0.85 }))),
                typeof freeBaggageAllowance !== 'undefined' && (React$1.createElement(FreeBaggageAllowance$1, { gdsVendor: gdsVendor, freeBaggageAllowance: freeBaggageAllowance, hasBaggageOption: hasBaggageOption, style: { marginTop: '20px' } })),
                passportRequiredBeforeReservation && (React$1.createElement(CocoFlightScheduleNote$1, { style: {
                        marginTop: '20px',
                        letterSpacing: '160%',
                    } }, "\u9078\u629E\u4E2D\u306E\u822A\u7A7A\u4F1A\u793E\u306F\u3001\u4E88\u7D04\u6642\u306B\u65C5\u884C\u8005\u5168\u54E1\u5206\u306E\u30D1\u30B9\u30DD\u30FC\u30C8\u60C5\u5831\u304C\u5FC5\u8981\u3067\u3059\u3002\u30D1\u30B9\u30DD\u30FC\u30C8\u672A\u767A\u884C/\u66F4\u65B0\u524D\u306E\u5834\u5408\u306F\u3054\u4E88\u7D04\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002"))),
            typeof footerInfo !== 'undefined' && (React$1.createElement(CocoDPFlightFixedFooter$1, { onClickLINEIcon: footerInfo.onClickLINEIcon, supplement: footerInfo.supplement, buttonText: footerInfo.buttonText, onClick: loadingFreeBaggageAllowance ? undefined : footerInfo.onClick, imgixHost: footerInfo.imgixHost, heading: footerInfo.heading, minWidth: minWidth })))));
};
var index$8 = memo(CocoFlightDetailModal);
var Container$d = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject([""], [""])));
var InnerContainer = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  padding: 20px 20px 25px;\n  /* \u753B\u9762\u306E\u9AD8\u3055 - \u30D8\u30C3\u30C0\u30FC\u306E\u9AD8\u3055 - \u30D5\u30C3\u30BF\u30FC\u306E\u9AD8\u3055 - padding-top - padding-bottom */\n  min-height: calc(100svh - 50px - 126px - 20px - 25px);\n"], ["\n  padding: 20px 20px 25px;\n  /* \u753B\u9762\u306E\u9AD8\u3055 - \u30D8\u30C3\u30C0\u30FC\u306E\u9AD8\u3055 - \u30D5\u30C3\u30BF\u30FC\u306E\u9AD8\u3055 - padding-top - padding-bottom */\n  min-height: calc(100svh - 50px - 126px - 20px - 25px);\n"])));
var ShowDifferentAirportsAlertForDepartureContainer = styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  margin-top: 20px;\n"], ["\n  margin-top: 20px;\n"])));
var LoadingContainer$1 = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  margin-top: 20px;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n"], ["\n  margin-top: 20px;\n  padding: 0 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n"])));
var templateObject_1$f, templateObject_2$e, templateObject_3$b, templateObject_4$b;

var SupportHeaderImageContainer = function (_a) {
    var imgixHost = _a.imgixHost, style = _a.style;
    return (React$1.createElement(Container$c, { style: style },
        React$1.createElement(CocoAspectRatio$1, { ratio: '264/375' },
            React$1.createElement(Image$3, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/support-header-v2.png")) }))));
};
var Container$c = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject([""], [""])));
var Image$3 = styled.img(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
var templateObject_1$e, templateObject_2$d;

var FAQList = function (_a) {
    var style = _a.style;
    return (React$1.createElement(Container$b, { itemScope: true, itemType: "https://schema.org/FAQPage", style: style },
        React$1.createElement(Title$2, null, "\u3088\u304F\u3042\u308B\u8CEA\u554F"),
        React$1.createElement(CocoFAQItem$1, { id: "support-faq1", label: "\u3069\u306E\u3088\u3046\u306B\u7533\u3057\u8FBC\u3081\u307E\u3059\u304B\uFF1F", answer: "\u300E\u3053\u3053\u308D\u304B\u3089\u300F\u3067\u6D77\u5916\u65C5\u884C\u3092\u3054\u4E88\u7D04\u3044\u305F\u3060\u304F\u969B\u306B\u3042\u308F\u305B\u3066\u304A\u7533\u3057\u8FBC\u307F\u3044\u305F\u3060\u3051\u307E\u3059\u3002" }),
        React$1.createElement(CocoFAQItem$1, { id: "support-faq2", label: "\u7533\u3057\u8FBC\u307F\u6761\u4EF6\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F", answer: "\u672C\u30B5\u30DD\u30FC\u30C8\u306F\u3001\u300E\u3053\u3053\u308D\u304B\u3089\u300F\u3092\u901A\u3058\u3066\u6D77\u5916\u65C5\u884C\u3092\u3054\u4E88\u7D04\u9802\u3044\u305F\u65B9\u306B\u306E\u307F\u63D0\u4F9B\u3057\u3066\u304A\u308A\u307E\u3059\u3002" }),
        React$1.createElement(CocoFAQItem$1, { id: "support-faq3", label: "\u30D7\u30E9\u30F3\u306E\u6599\u91D1\u306F\u3001\u65C5\u884C\u4EBA\u6570\u306B\u3088\u3063\u3066\u5909\u308F\u308A\u307E\u3059\u304B\uFF1F", answer: "\u5404\u30D7\u30E9\u30F3\u306E\u8868\u793A\u6599\u91D1\u306F1\u540D\u69D8\u3042\u305F\u308A\u306E\u6599\u91D1\uFF08\u5927\u4EBA\u30FB\u5B50\u3069\u3082\u540C\u4E00\uFF09\u3068\u306A\u3063\u3066\u304A\u308A\u3001\u4E00\u90E8\u306E\u65C5\u884C\u8005\u3055\u307E\u306E\u307F\u306E\u7533\u3057\u8FBC\u307F\u306F\u304A\u53D7\u3051\u3067\u304D\u307E\u305B\u3093\u3002\u306A\u304A\u3001\u8907\u6570\u306E\u65C5\u884C\u306B\u5BFE\u3057\u3066\u30D7\u30E9\u30F3\u3092\u3054\u5229\u7528\u3055\u308C\u308B\u5834\u5408\u306F\u3001\u65C5\u884C\u3054\u3068\u306B\u30D7\u30E9\u30F3\u306E\u7533\u3057\u8FBC\u307F\u304C\u5FC5\u8981\u3068\u306A\u308A\u307E\u3059\u306E\u3067\u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002" })));
};
var FAQList$1 = memo(FAQList);
var Container$b = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  padding: 28px 20px 26px;\n  > div + div {\n    margin-top: 15px;\n  }\n"], ["\n  padding: 28px 20px 26px;\n  > div + div {\n    margin-top: 15px;\n  }\n"])));
var Title$2 = styled.h2(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  margin-bottom: 24px;\n"], ["\n  ", "\n  color: ", ";\n  margin-bottom: 24px;\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1), COLORS.TEXT.PRIMARY);
var templateObject_1$d, templateObject_2$c;

var PlanComparison = function () {
    return (React$1.createElement(Container$a, null,
        React$1.createElement(Header, null, "\u30D7\u30E9\u30F3\u306E\u6BD4\u8F03\u8868"),
        React$1.createElement(Table, null,
            React$1.createElement(TableHeader, null,
                React$1.createElement("th", null),
                React$1.createElement("th", null, "\u7121\u6599"),
                React$1.createElement("th", null, "\u304A\u307E\u304B\u305B")),
            React$1.createElement(TableBody, null,
                React$1.createElement(TableRowWithBackground, null,
                    React$1.createElement("th", null, "\u6599\u91D1"),
                    React$1.createElement(TableDataNumber, null, "\u00A50"),
                    React$1.createElement(TableDataNumber, null, "\u00A55,500")),
                React$1.createElement(TableRow, null,
                    React$1.createElement("th", null,
                        "\u30B9\u30BF\u30C3\u30D5\u3078\u306E",
                        React$1.createElement("br", null),
                        "LINE\u76F8\u8AC7"),
                    React$1.createElement("td", null,
                        React$1.createElement(CircleIcon, null)),
                    React$1.createElement("td", null,
                        React$1.createElement(CircleIcon, null))),
                React$1.createElement(TableRowWithBackground, null,
                    React$1.createElement("th", null,
                        "\u5FC5\u8981\u624B\u7D9A\u304D",
                        React$1.createElement("br", null),
                        "\u306E\u3054\u6848\u5185"),
                    React$1.createElement("td", null,
                        React$1.createElement(CircleIcon, null)),
                    React$1.createElement("td", null,
                        React$1.createElement(CircleIcon, null))),
                React$1.createElement(TableRow, null,
                    React$1.createElement("th", null,
                        "\u4F5C\u6210\u66F8\u985E\u306E",
                        React$1.createElement("br", null),
                        "\u76EE\u8996\u30C1\u30A7\u30C3\u30AF"),
                    React$1.createElement("td", null,
                        React$1.createElement(BarIcon, null)),
                    React$1.createElement("td", null,
                        React$1.createElement(CircleIcon, null))),
                React$1.createElement(TableRowWithBackground, null,
                    React$1.createElement("th", null,
                        "\u5404\u7A2E\u7533\u8ACB\u306E\u4EE3\u884C",
                        React$1.createElement("br", null),
                        "\uFF08\u5B9F\u8CBB\u5225\uFF09"),
                    React$1.createElement("td", null,
                        React$1.createElement(BarIcon, null)),
                    React$1.createElement("td", null,
                        React$1.createElement(CircleIcon, null)))))));
};
var PlanComparison$1 = memo(PlanComparison);
var Container$a = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  padding: 0 20px 30px;\n  background: ", ";\n"], ["\n  padding: 0 20px 30px;\n  background: ", ";\n"])), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var CircleIcon = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  border: 1.75px solid ", ";\n  width: 17px;\n  height: 17px;\n  box-sizing: border-box;\n  border-radius: 100%;\n  margin: auto;\n"], ["\n  border: 1.75px solid ", ";\n  width: 17px;\n  height: 17px;\n  box-sizing: border-box;\n  border-radius: 100%;\n  margin: auto;\n"])), COLORS.BACKGROUND.SURFACE);
var BarIcon = styled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  width: 17px;\n  height: 1.5px;\n  background: rgba(255, 255, 255, 0.38);\n  margin: auto;\n"], ["\n  width: 17px;\n  height: 1.5px;\n  background: rgba(255, 255, 255, 0.38);\n  margin: auto;\n"])));
var Header = styled.h2(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  text-align: center;\n  margin-block-end: 15px;\n  ", ";\n  color: ", ";\n"], ["\n  text-align: center;\n  margin-block-end: 15px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.HEADLINE_3), COLORS.INVERT_TEXT.PRIMARY);
var TableDataNumber = styled.td(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  ", ";\n  text-align: center;\n  color: ", ";\n"], ["\n  ", ";\n  text-align: center;\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_4), { lineHeight: '1.6' })), COLORS.INVERT_TEXT.PRIMARY);
var TableHeader = styled.thead(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  text-align: center;\n  th {\n    ", "\n    text-align: center;\n    color: ", ";\n    padding-block-end: 10px;\n  }\n"], ["\n  text-align: center;\n  th {\n    ", "\n    text-align: center;\n    color: ", ";\n    padding-block-end: 10px;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_3), { lineHeight: '1.8' })), COLORS.INVERT_TEXT.PRIMARY);
var Table = styled.table(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  border-collapse: separate;\n  margin: auto;\n  width: 100%;\n"], ["\n  border-collapse: separate;\n  margin: auto;\n  width: 100%;\n"])));
var TableRow = styled.tr(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject([""], [""])));
var TableBody = styled.tbody(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  th {\n    text-align: start;\n    width: 91.25px;\n    vertical-align: middle;\n    height: 36px;\n    padding-inline-start: 10px;\n    padding-block: 10px;\n  }\n  td {\n    text-align: center;\n    vertical-align: middle;\n    width: 89.97px;\n    padding-block: 10px;\n  }\n"], ["\n  ", "\n  color: ", ";\n  th {\n    text-align: start;\n    width: 91.25px;\n    vertical-align: middle;\n    height: 36px;\n    padding-inline-start: 10px;\n    padding-block: 10px;\n  }\n  td {\n    text-align: center;\n    vertical-align: middle;\n    width: 89.97px;\n    padding-block: 10px;\n  }\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_2), COLORS.INVERT_TEXT.PRIMARY);
var TableRowWithBackground = styled.tr(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n  th {\n    background-color: rgba(255, 255, 255, 0.1);\n    border-start-start-radius: 10px;\n    border-end-start-radius: 10px;\n  }\n\n  td {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  td:last-child {\n    border-end-end-radius: 10px;\n    border-start-end-radius: 10px;\n  }\n"], ["\n  th {\n    background-color: rgba(255, 255, 255, 0.1);\n    border-start-start-radius: 10px;\n    border-end-start-radius: 10px;\n  }\n\n  td {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  td:last-child {\n    border-end-end-radius: 10px;\n    border-start-end-radius: 10px;\n  }\n"])));
var templateObject_1$c, templateObject_2$b, templateObject_3$a, templateObject_4$a, templateObject_5$9, templateObject_6$7, templateObject_7$6, templateObject_8$5, templateObject_9$4, templateObject_10$4;

var SupportPlansSection = function (_a) {
    var imgixHost = _a.imgixHost, supportPlanInfoList = _a.supportPlanInfoList, arrowImageUrl = _a.arrowImageUrl, idSuffix = _a.idSuffix, style = _a.style;
    return (React$1.createElement(Container$9, { style: style },
        React$1.createElement(CocoLightBulbTitle$1, { imgixHost: imgixHost, title: {
                title1: 'あなたの不安に寄り添った',
                title2: '充実のサポート',
            } }),
        React$1.createElement(Description$1, null, "\u5404\u30D7\u30E9\u30F3\u30011\u540D\u69D8\u3042\u305F\u308A\u306E\u6599\u91D1\u3067\u3059"),
        supportPlanInfoList.map(function (plan, idx) {
            return (React$1.createElement(CocoSupportPlanCard$1, { key: idx, idSuffix: idSuffix, arrowImageUrl: arrowImageUrl, isRecommend: plan.isRecommend, supportPlanInfo: __assign({}, plan) }));
        }),
        React$1.createElement(CautionText$1, null, "\u203B\u30B5\u30DD\u30FC\u30C8\u5185\u5BB9\u3084\u6599\u91D1\u306F\u5909\u66F4\u3059\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u4E88\u7D04\u6642\u306B\u5FC5\u305A\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),
        React$1.createElement(CautionText$1, null, "\u203B\u5404\u7A2E\u7533\u8ACB\u4EE3\u884C\u306B\u3064\u3044\u3066\u306F\u5BE9\u67FB\u901A\u904E\u3084\u6E21\u822A\u30FB\u5165\u56FD\u3092\u4FDD\u8A3C\u3059\u308B\u3082\u306E\u3067\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u306E\u3067\u3001\u4E88\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002")));
};
var SupportPlansSection$1 = memo(SupportPlansSection);
var Container$9 = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  padding: 30px 20px;\n  background: ", ";\n"], ["\n  padding: 30px 20px;\n  background: ", ";\n"])), COLORS.STATUS.SUCCESS_OR_POSITIVE);
styled.h3(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 8px;\n  justify-content: space-around;\n  ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 8px;\n  justify-content: space-around;\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.HEADLINE_3), COLORS.INVERT_TEXT.PRIMARY);
var Description$1 = styled.p(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-bottom: 15px;\n  text-align: center;\n"], ["\n  ", ";\n  color: ", ";\n  margin-bottom: 15px;\n  text-align: center;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.INVERT_TEXT.PRIMARY);
styled.img(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  object-fit: cover;\n"], ["\n  object-fit: cover;\n"])));
var CautionText$1 = styled.p(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_2), { letterSpacing: '1px' })), COLORS.INVERT_TEXT.PRIMARY);
styled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
styled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  bottom: 8px;\n  object-fit: cover;\n"], ["\n  position: absolute;\n  left: 0;\n  bottom: 8px;\n  object-fit: cover;\n"])));
styled.div(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  position: absolute;\n  transform: rotate(90deg);\n  right: 0;\n  bottom: 14px;\n  object-fit: cover;\n"], ["\n  position: absolute;\n  transform: rotate(90deg);\n  right: 0;\n  bottom: 14px;\n  object-fit: cover;\n"])));
var templateObject_1$b, templateObject_2$a, templateObject_3$9, templateObject_4$9, templateObject_5$8, templateObject_6$6, templateObject_7$5, templateObject_8$4;

var CocoSupportDetailModal = function (_a) {
    var imgixHost = _a.imgixHost, supportPlanInfoList = _a.supportPlanInfoList, isOpen = _a.isOpen, onClose = _a.onClose, minWidth = _a.minWidth, style = _a.style;
    var travelSectionTitle = {
        title1: '海外旅行には、',
        title2: '不安がたくさん...',
    };
    var travelarVoiceInfoList = [
        {
            title: 'ネットでの予約は難しい...',
            descriptionHTML: 'たくさんのホテルや航空券から自分で選ぶのは難しいので、プロに相談したい...',
            color: '#03AA54',
            iconPath: '/images/overseas/shared/person-icon-1.png',
        },
        {
            title: '手続きや準備が不安...',
            descriptionHTML: '必要な手続きや現地での過ごし方など、自分ひとりで調べるのは難しい...',
            color: '#FF4D4F',
            iconPath: '/images/overseas/shared/person-icon-2.png',
        },
        {
            title: '忙しくて、時間がとれない... ',
            descriptionHTML: '面倒な手続きを進めるには、休みの日だけでは時間が足りない... ',
            color: '#239AEA',
            iconPath: '/images/overseas/shared/person-icon-3.png',
        },
    ];
    return (React$1.createElement(CocoModal$1, { title: "\u6D77\u5916\u3042\u3093\u3057\u3093\u30B5\u30DD\u30FC\u30C8\u306B\u3064\u3044\u3066", isOpen: isOpen, onClose: onClose, minWidth: minWidth },
        React$1.createElement(Container$8, { style: style },
            React$1.createElement(SupportHeaderImageContainer, { imgixHost: imgixHost }),
            React$1.createElement(UneasinessOverseasTravelSection, { title: travelSectionTitle, travelarVoiceInfoList: travelarVoiceInfoList, imgixHost: imgixHost }),
            React$1.createElement(SupportPlansSection$1, { imgixHost: imgixHost, supportPlanInfoList: supportPlanInfoList, idSuffix: 'CocoSupportDetailModal', arrowImageUrl: "https://cocolocala-staging.imgix.net/images/shared/ui-components/CocoAccordion/arrow-down.svg" }),
            React$1.createElement(PlanComparison$1, null),
            React$1.createElement(FAQList$1, null))));
};
var index$7 = memo(CocoSupportDetailModal);
var Container$8 = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var templateObject_1$a;

var RoomRateItem = function (_a) {
    var mealLabel = _a.mealLabel, availableRooms = _a.availableRooms, penaltyStartDateTime = _a.penaltyStartDateTime, priceDiff = _a.priceDiff, totalPrice = _a.totalPrice, style = _a.style;
    return (React$1.createElement(Container$7, { style: style },
        React$1.createElement(LeftContent, null,
            React$1.createElement(TitleContainer$1, null,
                React$1.createElement(Title$1, null, mealLabel),
                typeof availableRooms !== 'undefined' && availableRooms <= 5 && (React$1.createElement(AvailableRoomsLabel$1, null,
                    "\u306E\u3053\u308A",
                    availableRooms,
                    "\u90E8\u5C4B"))),
            typeof penaltyStartDateTime === 'undefined' ? (React$1.createElement(RefundableInfo, null, "\u30AD\u30E3\u30F3\u30BB\u30EB\u4E0D\u53EF")) : (React$1.createElement(RefundableInfo, null, "".concat(penaltyStartDateTime, "\u307E\u3067\u30AD\u30E3\u30F3\u30BB\u30EB\u7121\u6599")))),
        React$1.createElement(Price$2, null, typeof priceDiff !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
            React$1.createElement("span", null,
                priceDiff < 0 ? '−' : '+',
                "\u00A5"),
            Math.abs(priceDiff).toLocaleString())) : typeof totalPrice !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
            React$1.createElement("span", null, "\u00A5"),
            totalPrice.toLocaleString())) : (React$1.createElement(React$1.Fragment, null)))));
};
var RoomRateItem$1 = memo(RoomRateItem);
var Container$7 = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var LeftContent = styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject([""], [""])));
var TitleContainer$1 = styled.div(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Title$1 = styled.p(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { letterSpacing: '0.1em', lineHeight: 1 })));
var RefundableInfo = styled.p(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  margin-top: 5px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-top: 5px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1), { letterSpacing: '0.1em', lineHeight: 1 })), COLORS.GENERAL.SECONDARY);
var Price$2 = styled.p(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  margin-top: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 20px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-left: 2px;\n    font-size: 13px;\n  }\n"], ["\n  margin-top: 3px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 20px;\n  ", "\n  color: ", ";\n\n  span {\n    margin-left: 2px;\n    font-size: 13px;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { fontWeight: 'bold', letterSpacing: '0.01em' })), COLORS.TEXT.PRIMARY);
var AvailableRoomsLabel$1 = styled.p(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  margin-left: 2px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-left: 2px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1), { letterSpacing: '0.1em' })), COLORS.GENERAL.PRIMARY);
var templateObject_1$9, templateObject_2$9, templateObject_3$8, templateObject_4$8, templateObject_5$7, templateObject_6$5, templateObject_7$4;

var CocoHotelRoom = function (_a) {
    var room = _a.room, onClickDetail = _a.onClickDetail, onClickSelect = _a.onClickSelect, selectedRateId = _a.selectedRateId, inputRadioName = _a.inputRadioName, radioTestId = _a.radioTestId, style = _a.style;
    return (React$1.createElement(Container$6, { style: style },
        room.imageUrls.length > 0 && (React$1.createElement(CocoSlideImage$1, { aspectRatio: '150/335', imageUrls: room.imageUrls, style: {
                borderTopLeftRadius: '6px',
                borderTopRightRadius: '6px',
                overflow: 'hidden',
                zIndex: 0,
            } })),
        React$1.createElement(RoomInfoContainer$1, null,
            React$1.createElement(RoomName$1, null, room.roomName),
            room.amenityTagInfoList.length > 0 && (React$1.createElement(TagContainer$1, null, room.amenityTagInfoList.map(function (amenity, index) { return (React$1.createElement(CocoAmenityTag$1, __assign({ key: index }, amenity))); }))),
            typeof onClickDetail !== 'undefined' && (React$1.createElement(CocoWhiteButton, { style: {
                    width: '100%',
                    height: '40px',
                    marginTop: '10px',
                }, fullWidth: true, fontWeight: 'bold', "data-testid": "vacant-hotel-room_show-detail-button-".concat(room.roomId), onClick: onClickDetail }, "\u8A73\u7D30\u3092\u307F\u308B"))),
        typeof onClickSelect !== 'undefined' && room.rates.length > 0 && (React$1.createElement(React$1.Fragment, null,
            React$1.createElement(CocoDivider$1, { color: COLORS.BORDER.SECONDARY }),
            React$1.createElement(RoomSelectContainer$1, null, room.rates.map(function (rate, index) {
                return (React$1.createElement(CocoInputRadio$1, { key: index, id: "hotel-room-".concat(room.roomId, "-rate-").concat(rate.rateId), dataTestId: "".concat(radioTestId, "-rate-").concat(index), name: inputRadioName !== null && inputRadioName !== void 0 ? inputRadioName : "hotel-room", value: rate.rateId, onChange: function (value) {
                        onClickSelect(value);
                    }, labelStyle: { width: '90%' }, defaultChecked: typeof selectedRateId !== 'undefined' &&
                        selectedRateId === rate.rateId, buttonSize: 16, style: {
                        border: "".concat(typeof selectedRateId !== 'undefined' &&
                            selectedRateId === rate.rateId
                            ? "2px solid ".concat(COLORS.GENERAL.PRIMARY)
                            : "1px solid ".concat(COLORS.BORDER.PRIMARY)),
                        borderRadius: '8px',
                        padding: '10px',
                        marginTop: "".concat(index === 0 ? '0' : '10px'),
                    } },
                    React$1.createElement(RoomRateItem$1, { mealLabel: rate.mealLabel, availableRooms: rate.availableRooms, penaltyStartDateTime: rate.penaltyStartDateTime, priceDiff: rate.priceDiff, totalPrice: rate.totalPrice, style: {
                            cursor: 'pointer',
                        } })));
            }))))));
};
var index$6 = memo(CocoHotelRoom);
var Container$6 = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 6px;\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 6px;\n  overflow: hidden;\n"])), COLORS.BACKGROUND.SURFACE, COLORS.BORDER.SECONDARY);
var RoomInfoContainer$1 = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  padding: 10px 15px;\n"], ["\n  padding: 10px 15px;\n"])));
var RoomName$1 = styled.span(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  margin-left: 2px;\n  color: ", ";\n  ", "\n"], ["\n  margin-left: 2px;\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_2));
var TagContainer$1 = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  div {\n    margin-top: 10px;\n    margin-right: 10px;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  div {\n    margin-top: 10px;\n    margin-right: 10px;\n  }\n"])));
var RoomSelectContainer$1 = styled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  padding: 15px;\n"], ["\n  padding: 15px;\n"])));
var templateObject_1$8, templateObject_2$8, templateObject_3$7, templateObject_4$7, templateObject_5$6;

var useLocalState$3 = function (cocolocalaHotelId, onClick) {
    var _a = __read(useState(false), 2), isSwiping = _a[0], setIsSwiping = _a[1];
    var onClickContainer = useCallback(function () {
        if (isSwiping)
            return;
        onClick(cocolocalaHotelId);
    }, [cocolocalaHotelId, isSwiping, onClick]);
    return { isSwiping: isSwiping, setIsSwiping: setIsSwiping, onClickContainer: onClickContainer };
};

var CocoDPFlightHotelListItem = function (_a) {
    var hotel = _a.hotel, onClick = _a.onClick, imgixHost = _a.imgixHost, _b = _a.isPriceCache, isPriceCache = _b === void 0 ? false : _b, style = _a.style;
    var _c = useLocalState$3(hotel.cocolocalaHotelId, onClick), setIsSwiping = _c.setIsSwiping, onClickContainer = _c.onClickContainer;
    return (React$1.createElement(Container$5, { onClick: onClickContainer, style: style },
        React$1.createElement(ImageContainer$2, null,
            React$1.createElement(CocoSlideImage$1, { aspectRatio: '180/377', imageUrls: hotel.imageUrls, onChangeSwipingState: setIsSwiping, showPageNumber: false, showArrows: true }),
            typeof hotel.discountInfo !== 'undefined' && (React$1.createElement(DiscountLabelContainer, null, hotel.discountInfo.map(function (discountInfo, index) { return (React$1.createElement(CocoDiscountLabel$1, { style: { borderTopRightRadius: 0, borderBottomRightRadius: 0 }, key: index, label: discountInfo.label, priceValue: "".concat(discountInfo.priceValue), labelColor: discountInfo.labelColor, backgroundColor: discountInfo.backgroundColor })); })))),
        React$1.createElement(HotelOuterContainer, null,
            typeof hotel.rating !== 'undefined' && Math.floor(hotel.rating) !== 0 && (React$1.createElement(HotelRateContainer$1, null,
                React$1.createElement(Image$2, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: hotel.name }),
                React$1.createElement(HotelRankText$1, null,
                    Math.floor(hotel.rating),
                    "\u3064\u661F\u30DB\u30C6\u30EB"))),
            typeof hotel.summaryTitle !== 'undefined' && (React$1.createElement(HotelSummaryTitle$1, null, hotel.summaryTitle)),
            React$1.createElement(HotelContainer, null,
                React$1.createElement(HotelInfoContainer$1, null,
                    React$1.createElement(HotelName$1, null, hotel.name),
                    typeof hotel.priceDescription !== 'undefined' && (React$1.createElement(PriceInfo, null, hotel.priceDescription))),
                (typeof hotel.priceDiff !== 'undefined' ||
                    typeof hotel.totalPrice !== 'undefined') && (React$1.createElement(HotelPriceContainer, null,
                    typeof hotel.strikethroughPrice !== 'undefined' && (React$1.createElement(StrikethroughPrice, null,
                        "\u00A5",
                        React$1.createElement("span", null, hotel.strikethroughPrice.toLocaleString()))),
                    React$1.createElement(Price$1, { "data-is-discounted": typeof hotel.strikethroughPrice !== 'undefined'
                            ? 'true'
                            : 'false' }, typeof hotel.priceDiff !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                        React$1.createElement("span", null,
                            hotel.priceDiff < 0 ? '−' : '+',
                            "\u00A5"),
                        Math.abs(hotel.priceDiff).toLocaleString())) : typeof hotel.totalPrice !== 'undefined' ? (React$1.createElement(React$1.Fragment, null,
                        React$1.createElement("span", null, "\u00A5"),
                        hotel.totalPrice.toLocaleString(),
                        isPriceCache && React$1.createElement(React$1.Fragment, null, "~"))) : (React$1.createElement(React$1.Fragment, null)))))))));
};
var index$5 = memo(CocoDPFlightHotelListItem);
var Container$5 = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  background-color: ", ";\n  cursor: pointer;\n"], ["\n  background-color: ", ";\n  cursor: pointer;\n"])), COLORS.BACKGROUND.SURFACE);
var ImageContainer$2 = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var DiscountLabelContainer = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  align-items: flex-end;\n  gap: 5px;\n  bottom: 0;\n  right: 0;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  align-items: flex-end;\n  gap: 5px;\n  bottom: 0;\n  right: 0;\n  margin-bottom: 4px;\n"])));
var HotelOuterContainer = styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  padding: 15px 15px 10px;\n  position: relative;\n"], ["\n  padding: 15px 15px 10px;\n  position: relative;\n"])));
var HotelContainer = styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var HotelInfoContainer$1 = styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject([""], [""])));
var HotelRateContainer$1 = styled.div(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  position: absolute;\n  top: -15px;\n  left: 10px;\n  padding: 4px 6px 3px 8px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: -15px;\n  left: 10px;\n  padding: 4px 6px 3px 8px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var HotelRankText$1 = styled.p(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"], ["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_2));
var HotelSummaryTitle$1 = styled.p(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var HotelName$1 = styled.p(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_1));
var HotelPriceContainer = styled.div(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  margin-left: 5px;\n  text-align: right;\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-end;\n"], ["\n  margin-left: 5px;\n  text-align: right;\n  display: flex;\n  flex-flow: column;\n  justify-content: flex-end;\n"])));
var PriceInfo = styled.p(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n  margin-top: 3px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-top: 3px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var Price$1 = styled.p(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n  ", "\n  color: ", ";\n\n  span {\n    margin-left: 2px;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n\n  &[data-is-discounted='true'] {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-shrink: 0;\n  ", "\n  color: ", ";\n\n  span {\n    margin-left: 2px;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n\n  &[data-is-discounted='true'] {\n    color: ", ";\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { fontWeight: 'bold', letterSpacing: '0.01em' })), COLORS.TEXT.PRIMARY, COLORS.GENERAL.PRIMARY);
var StrikethroughPrice = styled.p(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n\n  span {\n    text-decoration: line-through;\n    font-size: 12px;\n  }\n"], ["\n  color: ", ";\n  ", ";\n\n  span {\n    text-decoration: line-through;\n    font-size: 12px;\n  }\n"])), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_7), { letterSpacing: ' 0.02em' })));
var Image$2 = styled.img(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"], ["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"])));
var templateObject_1$7, templateObject_2$7, templateObject_3$6, templateObject_4$6, templateObject_5$5, templateObject_6$4, templateObject_7$3, templateObject_8$3, templateObject_9$3, templateObject_10$3, templateObject_11$3, templateObject_12$3, templateObject_13$1, templateObject_14$1, templateObject_15;

var CocoHotelDetailHeader = function (_a) {
    var hotel = _a.hotel, imgixHost = _a.imgixHost, _b = _a.isSoldOut, isSoldOut = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, staffComment = _a.staffComment, style = _a.style;
    return (React$1.createElement(Container$4, { style: style },
        React$1.createElement(ImageContainer$1, null,
            React$1.createElement(CocoSlideImage$1, { aspectRatio: '210/375', imageUrls: hotel.imageUrls, showPageNumber: false, showArrows: true })),
        React$1.createElement(HotelInfoContainer, null,
            Math.floor(hotel.rating) !== 0 && (React$1.createElement(HotelRateContainer, null,
                React$1.createElement(Image$1, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/icons/hotel-rate.svg")), alt: hotel.name }),
                React$1.createElement(HotelRankText, null,
                    Math.floor(hotel.rating),
                    "\u3064\u661F\u30DB\u30C6\u30EB"))),
            typeof hotel.summaryTitle !== 'undefined' && (React$1.createElement(HotelSummaryTitle, null, hotel.summaryTitle)),
            React$1.createElement(HotelName, null, hotel.name),
            React$1.createElement(RateAndLocationContainer, null,
                Math.floor(hotel.rating) !== 0 && (React$1.createElement(CocoRatings$1, { rating: hotel.rating, starDimension: '14px', showOneStar: true, showRatingValue: true, ratingValueStyle: { marginRight: '10px' } })),
                React$1.createElement(Location, null, hotel.location)),
            isLoading ? (React$1.createElement(LoadingContainer, null,
                React$1.createElement(reactActivity.exports.Dots, { color: COLORS.TEXT.DISABLE, size: 8 }))) : (React$1.createElement(React$1.Fragment, null,
                isSoldOut && (React$1.createElement(SoldOutText, null,
                    "\u7A7A\u5BA4\u306A\u3057",
                    React$1.createElement("span", null, "\u5225\u306E\u6761\u4EF6\u3067\u304A\u8A66\u3057\u304F\u3060\u3055\u3044"))),
                typeof staffComment !== 'undefined' && (React$1.createElement(CocoStaffComment$1, { staffComment: {
                        status: 'POSITIVE',
                        text: staffComment,
                    }, imgixHost: imgixHost, style: { marginTop: '10px' } })))))));
};
var index$4 = memo(CocoHotelDetailHeader);
var Container$4 = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var ImageContainer$1 = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var HotelInfoContainer = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  position: relative;\n  padding: 23px 20px 0;\n"], ["\n  position: relative;\n  padding: 23px 20px 0;\n"])));
var HotelRateContainer = styled.div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  position: absolute;\n  top: -15px;\n  left: 10px;\n  padding: 4px 6px 3px 8px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: -15px;\n  left: 10px;\n  padding: 4px 6px 3px 8px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 1000px;\n  background-color: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var HotelRankText = styled.p(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"], ["\n  margin-left: 5px;\n  ", ";\n  color: #f1bc27;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1));
var HotelSummaryTitle = styled.p(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var HotelName = styled.p(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  margin-bottom: 5px;\n  ", ";\n"], ["\n  margin-bottom: 5px;\n  ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_1));
var RateAndLocationContainer = styled.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Location = styled.p(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_1), COLORS.TEXT.NOTE_OR_CAPTION);
var Image$1 = styled.img(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"], ["\n  width: 12px;\n  height: 15px;\n  object-fit: cover;\n"])));
var SoldOutText = styled.p(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  margin-top: 10px;\n  margin-bottom: 7px;\n  color: ", ";\n  ", ";\n\n  span {\n    margin-left: 7px;\n    color: ", ";\n    ", ";\n  }\n"], ["\n  margin-top: 10px;\n  margin-bottom: 7px;\n  color: ", ";\n  ", ";\n\n  span {\n    margin-left: 7px;\n    color: ", ";\n    ", ";\n  }\n"])), COLORS.TEXT.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_1), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(MOBILE_FONT_STYLES.NOTE_2));
var LoadingContainer = styled.div(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 5px 0;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 5px 0;\n"])));
var templateObject_1$6, templateObject_2$6, templateObject_3$5, templateObject_4$5, templateObject_5$4, templateObject_6$3, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$2, templateObject_11$2, templateObject_12$2;

var isBetween$1 = {exports: {}};

(function (module, exports) {
	!function(e,i){module.exports=i();}(commonjsGlobal,(function(){return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return (r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))};}}));
} (isBetween$1));

var isBetween = isBetween$1.exports;

dayjs_minExports.extend(isBetween);
/**
 * カレンダーUIで使う共通の処理のhooks
 * @param param0
 * @returns
 */
var useDateCalendar = function (_a) {
    var numberOfMonthGenerate = _a.numberOfMonthGenerate, selectedBeginDate = _a.selectedBeginDate, selectedEndDate = _a.selectedEndDate, selectableBeginDate = _a.selectableBeginDate, selectableEndDate = _a.selectableEndDate;
    // 引数で受け取った月のカレンダーを生成
    var getCalendar = useCallback(function (month) {
        // 月の日数を算出
        var numberOfMonth = month.endOf('month').date();
        // 月の日数を配列化
        var days = __spreadArray([], __read(Array(numberOfMonth).keys()), false).map(function (i) { return ++i; });
        // 1日の曜日を数字で取得(0: 日 - 6: 土)
        var dayOfWeek = month.startOf('month').day();
        // 週ごとの二次元配列を生成
        var calendar = __spreadArray([], __read(Array(6)), false).map(function (_, weekIndex) {
            return __spreadArray([], __read(Array(7)), false).map(function (_, dayIndex) {
                var i = 7 * weekIndex + dayIndex - dayOfWeek;
                if (i < 0 || days[i] === undefined) {
                    return undefined;
                }
                return days[i];
            });
        });
        // undefinedを除去し返す
        return calendar
            .filter(function (week) {
            return week.filter(function (day) { return typeof day !== 'undefined'; }).length > 0;
        })
            .map(function (week) {
            return week.map(function (day) {
                if (typeof day !== 'undefined') {
                    return month.clone().set('date', day);
                }
                else {
                    return 'no-date';
                }
            });
        });
    }, []);
    var currentMonth = dayjs_minExports();
    var calendar = useMemo(function () {
        return __spreadArray([], __read(Array(numberOfMonthGenerate).keys()), false).map(function (index) { return ({
            month: currentMonth.add(index, 'month'),
            weeks: getCalendar(currentMonth.add(index, 'month')),
        }); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [numberOfMonthGenerate]);
    // 選択できない日付のとき
    var isUnselectableDate = useCallback(function (date) {
        return ((typeof selectableBeginDate !== 'undefined' &&
            date.isBefore(selectableBeginDate, 'date')) ||
            (typeof selectableEndDate !== 'undefined' &&
                date.isAfter(selectableEndDate, 'date')) ||
            date.isBefore(dayjs_minExports(), 'date'));
    }, [selectableBeginDate, selectableEndDate]);
    var getCellType = useCallback(function (date) {
        if (
        // 選択開始日と選択終了日が同じだったときは単一の選択表示タイプ
        typeof selectedBeginDate !== 'undefined' &&
            typeof selectedEndDate !== 'undefined' &&
            date.isSame(selectedBeginDate, 'date') &&
            date.isSame(selectedEndDate, 'date')) {
            return DATE_CELL_TYPE.SELECTED;
        }
        else if (
        // 選択の開始日のとき
        typeof selectedBeginDate !== 'undefined' &&
            date.isSame(selectedBeginDate, 'date')) {
            return DATE_CELL_TYPE.SELECT_BEGIN;
        }
        else if (
        // 選択の終了日のとき
        typeof selectedEndDate !== 'undefined' &&
            date.isSame(selectedEndDate, 'date')) {
            return DATE_CELL_TYPE.SELECT_END;
        }
        else if (
        // 選択の開始と選択の終了日の間のとき
        typeof selectedBeginDate !== 'undefined' &&
            typeof selectedEndDate !== 'undefined' &&
            date.isBetween(selectedBeginDate, selectedEndDate, 'date', '()')) {
            return DATE_CELL_TYPE.SELECT_BETWEEN;
        }
        else if (
        // 選択出来ない日付のとき
        isUnselectableDate(date)) {
            return DATE_CELL_TYPE.UNSELECTABLE;
        }
        else {
            return DATE_CELL_TYPE.SELECTABLE;
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectableBeginDate, selectableEndDate, selectedBeginDate, selectedEndDate]);
    return { calendar: calendar, getCellType: getCellType, isUnselectableDate: isUnselectableDate };
};

var useLocalState$2 = function (_a) {
    var checkInDate = _a.checkInDate, checkOutDate = _a.checkOutDate, hiddenSkipInputStayDate = _a.hiddenSkipInputStayDate, selectableBeginDate = _a.selectableBeginDate, selectableEndDate = _a.selectableEndDate, maxSelectableDays = _a.maxSelectableDays, onClose = _a.onClose;
    var _b = __read(useState(checkInDate ? checkInDate : undefined), 2), selectedCheckInDate = _b[0], setSelectedCheckInDate = _b[1];
    var _c = __read(useState(checkOutDate ? checkOutDate : undefined), 2), selectedCheckOutDate = _c[0], setSelectedCheckOutDate = _c[1];
    var diffOfDates = useMemo(function () {
        return selectedCheckInDate && selectedCheckOutDate
            ? "".concat(selectedCheckOutDate.diff(selectedCheckInDate, 'd'), "\u6CCA")
            : '未選択';
    }, [selectedCheckInDate, selectedCheckOutDate]);
    var _selectableEndDate = useMemo(function () {
        // 選択開始日が選ばれ、maxSelectableDaysが設定されている場合には、選択開始日からmaxSelectableDays日後の日付を選択可能な終了日とする
        if (typeof selectedCheckInDate !== 'undefined' &&
            typeof selectedCheckOutDate === 'undefined' &&
            typeof maxSelectableDays !== 'undefined') {
            return selectedCheckInDate === null || selectedCheckInDate === void 0 ? void 0 : selectedCheckInDate.add(maxSelectableDays, 'day');
        }
        else {
            return selectableEndDate;
        }
    }, [
        selectedCheckInDate,
        selectedCheckOutDate,
        maxSelectableDays,
        selectableEndDate,
    ]);
    var _d = __read(useState(true), 2), isSelectedCheckInDate = _d[0], setIsSelectedCheckInDate = _d[1];
    // 12ヶ月分のカレンダーを生成
    var _e = useDateCalendar({
        numberOfMonthGenerate: 12,
        selectedBeginDate: selectedCheckInDate,
        selectedEndDate: selectedCheckOutDate,
        selectableBeginDate: selectableBeginDate,
        selectableEndDate: _selectableEndDate,
    }), monthList = _e.calendar, getCellType = _e.getCellType, isUnselectableDate = _e.isUnselectableDate;
    useEffect(function () {
        setSelectedCheckInDate(checkInDate);
        setSelectedCheckOutDate(checkOutDate);
    }, [checkInDate, checkOutDate]);
    var canSearch = useMemo(function () {
        return !!selectedCheckInDate && !!selectedCheckOutDate;
    }, [selectedCheckInDate, selectedCheckOutDate]);
    var searchButtonWidth = useMemo(function () {
        return hiddenSkipInputStayDate !== true ? '165px' : '100%';
    }, [hiddenSkipInputStayDate]);
    var onSelectDate = useCallback(function (selectedDate, e) {
        // NOTE(akutsu): 選択した日付が今日以前の場合、即returnする
        if (isUnselectableDate(selectedDate))
            return;
        // NOTE: (zoma) これをしておかないと日付を選択した瞬間、resetSelectedDateで解除されちゃうのでイベント伝播しないようにした
        e.stopPropagation();
        // NOTE(akutsu): フォーカスがチェックイン且つ空室の場合、チェックイン日の更新、フォーカスをチェックアウトに変更、チェックアウト日を未定、にする
        if (isSelectedCheckInDate) {
            setSelectedCheckInDate(selectedDate);
            setIsSelectedCheckInDate(false);
            setSelectedCheckOutDate(undefined);
        }
        // NOTE(akutsu): フォーカスがチェックアウト且つ空室
        if (!isSelectedCheckInDate) {
            // NOTE(akutsu): チェックイン日が未定またはチェックイン日より前の日付を選んだ場合、チェックイン日の更新、フォーカスをチェックアウトに変更、チェックアウト日を未定、にする
            if (!selectedCheckInDate ||
                (selectedCheckInDate && selectedDate.isBefore(selectedCheckInDate))) {
                setSelectedCheckInDate(selectedDate);
                setIsSelectedCheckInDate(false);
                setSelectedCheckOutDate(undefined);
            }
            else if (selectedCheckInDate.isSame(selectedDate, 'day')) {
                // NOTE(yoshimitsu): 選択した日がチェックイン日と同日の場合何もしない
                return;
            }
            else {
                // NOTE(akutsu): チェックアウト日を更新し、フォーカスをチェックインに変更
                setSelectedCheckOutDate(selectedDate);
                setIsSelectedCheckInDate(true);
            }
        }
    }, [isSelectedCheckInDate, selectedCheckInDate, isUnselectableDate]);
    var setCheckInDate = useCallback(function () {
        return setIsSelectedCheckInDate(true);
    }, [setIsSelectedCheckInDate]);
    var _onClose = useCallback(function () {
        setSelectedCheckInDate(checkInDate);
        setSelectedCheckOutDate(checkOutDate);
        onClose();
    }, [checkInDate, checkOutDate, onClose]);
    var unSetCheckInDate = useCallback(function () {
        return setIsSelectedCheckInDate(false);
    }, [setIsSelectedCheckInDate]);
    // NOTE: (zoma) 選択可能な日時がある場合、その範囲の月しか表示は必要ないので、フィルタしている
    var filterMonthList = useCallback(function (month) {
        if (typeof selectableBeginDate !== 'undefined' &&
            typeof selectableEndDate !== 'undefined') {
            return ((month.isSame(selectableBeginDate, 'month') ||
                month.isAfter(selectableBeginDate)) &&
                (month.isSame(selectableEndDate, 'month') ||
                    month.isBefore(selectableEndDate)));
        }
        else if (typeof selectableBeginDate !== 'undefined') {
            return (month.isSame(selectableBeginDate, 'month') ||
                month.isAfter(selectableBeginDate));
        }
        else if (typeof selectableEndDate !== 'undefined') {
            return (month.isSame(selectableEndDate, 'month') ||
                month.isBefore(selectableEndDate));
        }
        else {
            return true;
        }
    }, [selectableBeginDate, selectableEndDate]);
    var resetSelectedDate = useCallback(function () {
        setSelectedCheckInDate(undefined);
        setSelectedCheckOutDate(undefined);
    }, []);
    return {
        selectedCheckInDate: selectedCheckInDate,
        setSelectedCheckInDate: setSelectedCheckInDate,
        selectedCheckOutDate: selectedCheckOutDate,
        setSelectedCheckOutDate: setSelectedCheckOutDate,
        diffOfDates: diffOfDates,
        isSelectedCheckInDate: isSelectedCheckInDate,
        setIsSelectedCheckInDate: setIsSelectedCheckInDate,
        monthList: monthList,
        canSearch: canSearch,
        searchButtonWidth: searchButtonWidth,
        getCellType: getCellType,
        onSelectDate: onSelectDate,
        setCheckInDate: setCheckInDate,
        unSetCheckInDate: unSetCheckInDate,
        filterMonthList: filterMonthList,
        resetSelectedDate: resetSelectedDate,
        _onClose: _onClose,
    };
};

var CocoDPFlightCalendarModal = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '日程を選択' : _b, subTitle = _a.subTitle, isOpen = _a.isOpen, _c = _a.headerLeftLabel, headerLeftLabel = _c === void 0 ? '出発日' : _c, _d = _a.headerRightLabel, headerRightLabel = _d === void 0 ? '現地出発日' : _d, checkInDate = _a.checkInDate, checkOutDate = _a.checkOutDate, selectableBeginDate = _a.selectableBeginDate, selectableEndDate = _a.selectableEndDate, maxSelectableDays = _a.maxSelectableDays, onClick = _a.onClick, onClose = _a.onClose, minWidth = _a.minWidth;
    var _e = useLocalState$2({
        checkInDate: checkInDate,
        checkOutDate: checkOutDate,
        selectableBeginDate: selectableBeginDate,
        selectableEndDate: selectableEndDate,
        maxSelectableDays: maxSelectableDays,
        onClose: onClose,
    }), monthList = _e.monthList, getCellType = _e.getCellType, onSelectDate = _e.onSelectDate, selectedCheckInDate = _e.selectedCheckInDate, selectedCheckOutDate = _e.selectedCheckOutDate, isSelectedCheckInDate = _e.isSelectedCheckInDate, setCheckInDate = _e.setCheckInDate, unSetCheckInDate = _e.unSetCheckInDate, filterMonthList = _e.filterMonthList, resetSelectedDate = _e.resetSelectedDate, _onClose = _e._onClose;
    return (React$1.createElement(CocoModal$1, { title: title, subTitle: subTitle, isOpen: isOpen, onClose: _onClose, minWidth: minWidth },
        React$1.createElement(Container$3, null,
            React$1.createElement(CalendarModalHeader, null,
                React$1.createElement(CalendarModalHeaderLeftOrRight, { onClick: setCheckInDate, className: isSelectedCheckInDate ? 'selected' : '' },
                    React$1.createElement("div", null,
                        React$1.createElement(CalendarModalHeaderParagraph, null, headerLeftLabel),
                        React$1.createElement(CalendarModalHeaderDate, { "data-test-id": 'check-in-date' }, selectedCheckInDate
                            ? selectedCheckInDate.format('YYYY/MM/DD')
                            : '日付を選択'))),
                React$1.createElement(CalendarModalHeaderCenter, null,
                    React$1.createElement("div", null,
                        React$1.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React$1.createElement("path", { d: "M9.99992 3.33334L8.82075 4.51251L13.4749 9.16668H3.33325V10.8333H13.4749L8.82075 15.4875L9.99992 16.6667L16.6666 10L9.99992 3.33334Z", fill: "black" })))),
                React$1.createElement(CalendarModalHeaderLeftOrRight, { onClick: unSetCheckInDate, className: isSelectedCheckInDate ? '' : 'selected' },
                    React$1.createElement("div", null,
                        React$1.createElement(CalendarModalHeaderParagraph, null, headerRightLabel),
                        React$1.createElement(CalendarModalHeaderDate, { "data-test-id": 'check-out-date' }, selectedCheckOutDate
                            ? selectedCheckOutDate.format('YYYY/MM/DD')
                            : '日付を選択')))),
            React$1.createElement(CalendarContainer, null, monthList
                .filter(function (month) { return filterMonthList(month.month); })
                .map(function (month, index) {
                return (React$1.createElement(CalendarModalBody, { key: index },
                    React$1.createElement(Month, null, month.month.format('YYYY年M月')),
                    React$1.createElement(CalendarTable, { onClick: resetSelectedDate },
                        React$1.createElement("thead", null,
                            React$1.createElement("tr", null,
                                React$1.createElement(WeekHeader, { "data-is-sunday": "true" }, "\u65E5"),
                                React$1.createElement(WeekHeader, null, "\u6708"),
                                React$1.createElement(WeekHeader, null, "\u706B"),
                                React$1.createElement(WeekHeader, null, "\u6C34"),
                                React$1.createElement(WeekHeader, null, "\u6728"),
                                React$1.createElement(WeekHeader, null, "\u91D1"),
                                React$1.createElement(WeekHeader, { "data-is-saturday": "true" }, "\u571F"))),
                        React$1.createElement("tbody", null, month.weeks.map(function (week, index) {
                            return (React$1.createElement("tr", { key: "week-".concat(index) }, week.map(function (date, index) {
                                if (date === 'no-date') {
                                    return React$1.createElement("td", { key: "day-".concat(index) });
                                }
                                else {
                                    return (React$1.createElement(CocoCalendarDateCell$1, { key: "day-".concat(index), date: date, cellType: getCellType(date), onClick: function (e) { return onSelectDate(date, e); }, minWidth: minWidth }));
                                }
                            })));
                        })))));
            })),
            React$1.createElement(FixedBottomContainer$1, null, typeof selectedCheckInDate === 'undefined' ||
                typeof selectedCheckOutDate === 'undefined' ? (React$1.createElement(CocoDisableButton, { fullWidth: true, height: '47px', style: { fontSize: '15px' } }, "\u6C7A\u5B9A")) : (React$1.createElement(CocoRedButton, { onClick: function () {
                    onClick({
                        going: selectedCheckInDate,
                        returning: selectedCheckOutDate,
                    });
                    onClose();
                }, height: '47px', style: { width: '100%', fontSize: '15px' } }, "\u3053\u306E\u65E5\u7A0B\u3067\u6C7A\u5B9A"))))));
};
var index$3 = memo(CocoDPFlightCalendarModal);
var Container$3 = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
// NOTE: (zoma) min-heightは、ヘッダー部分とフッター部分の高さやpaddingを画面いっぱいの高さから差し引いた大きさが、
// カレンダー領域の高さとしている。
var CalendarContainer = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  background-color: ", ";\n  padding-bottom: 70px;\n  margin: 0 20px;\n  min-height: calc(100vh - 287px);\n"], ["\n  background-color: ", ";\n  padding-bottom: 70px;\n  margin: 0 20px;\n  min-height: calc(100vh - 287px);\n"])), COLORS.BACKGROUND.SURFACE);
var CalendarModalBody = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  background-color: ", ";\n  margin-bottom: 30px;\n"], ["\n  background-color: ", ";\n  margin-bottom: 30px;\n"])), COLORS.BACKGROUND.SURFACE);
var Month = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  font-size: 18px;\n  font-family: 'Avenir Next', sans-serif;\n  color: ", ";\n  text-align: center;\n  font-weight: 600;\n  letter-spacing: 0;\n"], ["\n  font-size: 18px;\n  font-family: 'Avenir Next', sans-serif;\n  color: ", ";\n  text-align: center;\n  font-weight: 600;\n  letter-spacing: 0;\n"])), COLORS.TEXT.PRIMARY);
var CalendarTable = styled.table(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  table-layout: fixed;\n  width: 100%;\n  margin-top: 20px;\n"], ["\n  table-layout: fixed;\n  width: 100%;\n  margin-top: 20px;\n"])));
var WeekHeader = styled.th(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 180%;\n  text-align: center;\n  color: ", ";\n  padding-bottom: 10px;\n\n  &[data-is-saturday='true'] {\n    color: #0c68b9;\n  }\n\n  &[data-is-sunday='true'] {\n    color: #ff4d4f;\n  }\n"], ["\n  font-size: 14px;\n  line-height: 180%;\n  text-align: center;\n  color: ", ";\n  padding-bottom: 10px;\n\n  &[data-is-saturday='true'] {\n    color: #0c68b9;\n  }\n\n  &[data-is-sunday='true'] {\n    color: #ff4d4f;\n  }\n"])), COLORS.TEXT.NO_IMPORTANT);
var FixedBottomContainer$1 = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  padding: 15px;\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  box-sizing: border-box;\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);\n  background-color: ", ";\n"], ["\n  padding: 15px;\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  box-sizing: border-box;\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);\n  background-color: ", ";\n"])), COLORS.BACKGROUND.SURFACE);
var CalendarModalHeaderCenter = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  align-items: center;\n"], ["\n  height: 100%;\n  display: flex;\n  align-items: center;\n"])));
var CalendarModalHeaderParagraph = styled.p(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.NOTE_OR_CAPTION, createFontStyle(MOBILE_FONT_STYLES.CAPTION_BOLD_1));
var CalendarModalHeaderDate = styled.p(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n  padding-top: 8px;\n  ", ";\n"], ["\n  text-align: center;\n  color: ", ";\n  padding-top: 8px;\n  ", ";\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { letterSpacing: '0.02em' })));
var CalendarModalHeaderLeftOrRight = styled.div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  width: 47%;\n  cursor: pointer;\n\n  &.selected {\n    p + p {\n      color: #46a7ed;\n    }\n\n    border-bottom: 2px solid #46a7ed;\n  }\n\n  > div {\n    margin: 0 auto;\n  }\n"], ["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  width: 47%;\n  cursor: pointer;\n\n  &.selected {\n    p + p {\n      color: #46a7ed;\n    }\n\n    border-bottom: 2px solid #46a7ed;\n  }\n\n  > div {\n    margin: 0 auto;\n  }\n"])));
var CalendarModalHeader = styled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  height: 60px;\n  position: sticky;\n  top: 50px;\n  background-color: ", ";\n  margin: 0 0 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  height: 60px;\n  position: sticky;\n  top: 50px;\n  background-color: ", ";\n  margin: 0 0 20px;\n"])), COLORS.BORDER.SECONDARY, COLORS.BACKGROUND.SURFACE);
var templateObject_1$5, templateObject_2$5, templateObject_3$4, templateObject_4$4, templateObject_5$3, templateObject_6$2, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11$1, templateObject_12$1;

var img = "data:image/svg+xml,%3csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7 8L13.364 1.63603L11.9497 0.221819L7 5.17157L2.05026 0.221819L0.636047 1.63603L7 8Z' fill='black' fill-opacity='0.15'/%3e%3c/svg%3e";

var DPFlightInputSelect = function (_a) {
    var initialSelectedValue = _a.initialSelectedValue, value = _a.value, options = _a.options, onChange = _a.onChange, style = _a.style;
    return (React$1.createElement(SelectWrapper, { style: style },
        React$1.createElement(Select, { defaultValue: initialSelectedValue && typeof value === 'undefined'
                ? initialSelectedValue
                : undefined, value: value, onChange: function (e) {
                if (onChange) {
                    onChange(e.target.value);
                }
            } }, options.map(function (option, index) {
            return (React$1.createElement(Option, { key: index, value: option.value }, option.label));
        })),
        React$1.createElement(ImageContainer, null,
            React$1.createElement(Image, { src: img, alt: "arrow-bottom" }))));
};
var DPFlightInputSelect$1 = memo(DPFlightInputSelect);
var SelectWrapper = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  position: relative;\n  ", "\n  width: 100%;\n"], ["\n  position: relative;\n  ", "\n  width: 100%;\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_1));
var Image = styled.img(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  width: 14px;\n  height: 9px;\n  object-fit: cover;\n"], ["\n  width: 14px;\n  height: 9px;\n  object-fit: cover;\n"])));
var Select = styled.select(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  margin: 0;\n  background: none;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: bold;\n  line-height: 180%;\n  letter-spacing: 2px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding: 11px 24px 11px 15px;\n  ", "\n  width: 100%;\n"], ["\n  margin: 0;\n  background: none;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: bold;\n  line-height: 180%;\n  letter-spacing: 2px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  border-radius: 6px;\n  padding: 11px 24px 11px 15px;\n  ", "\n  width: 100%;\n"])), createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_2));
var Option = styled.option(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  color: ", ";\n  background: ", ";\n"], ["\n  color: ", ";\n  background: ", ";\n"])), COLORS.TEXT.PRIMARY, COLORS.BACKGROUND.SURFACE);
var ImageContainer = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  position: absolute;\n  right: 14px;\n  top: 12px;\n"], ["\n  position: absolute;\n  right: 14px;\n  top: 12px;\n"])));
var templateObject_1$4, templateObject_2$4, templateObject_3$3, templateObject_4$3, templateObject_5$2;

var useLocalState$1 = function (_a) {
    var initialValues = _a.initialValues;
    var _b = __read(useState(typeof initialValues !== 'undefined' ? initialValues.numberOfAdults : 2), 2), numberOfAdults = _b[0], setNumberOfAdults = _b[1];
    var _c = __read(useState(typeof initialValues !== 'undefined' ? initialValues.childAges.length : 0), 2), numberOfChildren = _c[0], setNumberOfChildren = _c[1];
    var _d = __read(useState(typeof initialValues !== 'undefined' ? initialValues.childAges : []), 2), childAges = _d[0], setChildAges = _d[1];
    var childAgesWithoutNullish = useMemo(function () {
        return childAges.filter(function (x) {
            return x !== undefined && x !== null;
        });
    }, [childAges]);
    var isValidInput = useMemo(function () {
        // 大人の人数が0人のとき
        if (numberOfAdults === 0) {
            return false;
        }
        // 子供の人数と入力された年齢の数が合わないとき
        if (numberOfChildren > 0 &&
            !(childAges.length === 0 ||
                childAges.every(function (value) { return typeof value === 'number'; }))) {
            return false;
        }
        return true;
    }, [childAges, numberOfAdults, numberOfChildren]);
    var handleChangeNumberOfAdults = useCallback(function (action) {
        switch (action) {
            case 'plus':
                setNumberOfAdults(numberOfAdults + 1);
                break;
            case 'minus':
                numberOfAdults > 0
                    ? setNumberOfAdults(numberOfAdults - 1)
                    : setNumberOfAdults(0);
                break;
        }
    }, [numberOfAdults]);
    var handleChangeNumberOfChildren = useCallback(function (action) {
        switch (action) {
            case 'plus':
                setChildAges(childAges.concat(undefined));
                setNumberOfChildren(numberOfChildren + 1);
                break;
            case 'minus':
                if (numberOfChildren > 0) {
                    setChildAges(childAges.slice(0, -1));
                    setNumberOfChildren(numberOfChildren - 1);
                }
                else {
                    setChildAges([]);
                    setNumberOfChildren(0);
                }
                break;
        }
    }, [childAges, numberOfChildren]);
    var handleChangeChildAges = useCallback(function (value, index) {
        var newChildAges = childAges.slice();
        newChildAges[index] =
            Number.isFinite(value) && value >= 0 ? value : undefined;
        setChildAges(newChildAges);
    }, [childAges]);
    var isInfantCountExceedsAdults = childAges.filter(function (age) { return typeof age === 'number' && age <= 1; }).length >
        numberOfAdults;
    return {
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        childAges: childAges,
        childAgesWithoutNullish: childAgesWithoutNullish,
        isValidInput: isValidInput,
        handleChangeNumberOfAdults: handleChangeNumberOfAdults,
        handleChangeNumberOfChildren: handleChangeNumberOfChildren,
        handleChangeChildAges: handleChangeChildAges,
        isInfantCountExceedsAdults: isInfantCountExceedsAdults,
    };
};

var AGE_OPTIONS = function (enableInfant) {
    return [
        { label: '年齢を選択', value: '' },
        // TODO: (zoma) 赤ちゃん対応がリリースされたら、このフラグを消して 常に0, 1歳が選べるようにする
        enableInfant ? { label: '0歳', value: '0' } : undefined,
        enableInfant ? { label: '1歳', value: '1' } : undefined,
        { label: '2歳', value: '2' },
        { label: '3歳', value: '3' },
        { label: '4歳', value: '4' },
        { label: '5歳', value: '5' },
        { label: '6歳', value: '6' },
        { label: '7歳', value: '7' },
        { label: '8歳', value: '8' },
        { label: '9歳', value: '9' },
        { label: '10歳', value: '10' },
        { label: '11歳', value: '11' },
        { label: '12歳', value: '12' },
        { label: '13歳', value: '13' },
        { label: '14歳', value: '14' },
        { label: '15歳', value: '15' },
        { label: '16歳', value: '16' },
        { label: '17歳', value: '17' },
    ].filter(function (age) { return typeof age !== 'undefined'; });
};
var MIN_NUMBER_OF_ADULTS = 1;
var MAX_NUMBER_OF_ADULTS = 5;
var MIN_NUMBER_OF_CHILDREN = 0;
var MAX_NUMBER_OF_CHILDREN = 5;
var CocoNumberOfPeopleModal = function (_a) {
    var _b, _c, _d;
    var initialValues = _a.initialValues, onClick = _a.onClick, onClose = _a.onClose, isOpen = _a.isOpen, _e = _a.minWidth, minWidth = _e === void 0 ? TABLET_MAX_WIDTH : _e, _f = _a.enableInfant, enableInfant = _f === void 0 ? false : _f;
    var _g = useLocalState$1({
        initialValues: {
            numberOfAdults: (_b = initialValues === null || initialValues === void 0 ? void 0 : initialValues.numberOfAdults) !== null && _b !== void 0 ? _b : 2,
            numberOfChildren: (_c = initialValues === null || initialValues === void 0 ? void 0 : initialValues.childAges.length) !== null && _c !== void 0 ? _c : 0,
            childAges: (_d = initialValues === null || initialValues === void 0 ? void 0 : initialValues.childAges) !== null && _d !== void 0 ? _d : [],
        },
    }), numberOfAdults = _g.numberOfAdults, numberOfChildren = _g.numberOfChildren, childAges = _g.childAges, childAgesWithoutNullish = _g.childAgesWithoutNullish, handleChangeNumberOfAdults = _g.handleChangeNumberOfAdults, handleChangeNumberOfChildren = _g.handleChangeNumberOfChildren, handleChangeChildAges = _g.handleChangeChildAges, isValidInput = _g.isValidInput, isInfantCountExceedsAdults = _g.isInfantCountExceedsAdults;
    return (React$1.createElement(CocoModal$1, { title: "\u4EBA\u6570\u3092\u9078\u629E", isOpen: isOpen, onClose: onClose, topMarginVh: 0, minWidth: minWidth },
        React$1.createElement(ModalContainer, null,
            React$1.createElement(InputContainer, null,
                React$1.createElement(CocoDPFlightInputNumberField, { label: '大人', subLabel: "18\u6B73\u4EE5\u4E0A", initialValue: numberOfAdults, minValue: MIN_NUMBER_OF_ADULTS, maxValue: MAX_NUMBER_OF_ADULTS, onChange: handleChangeNumberOfAdults, testid: 'adult', style: { marginBottom: '30px' } }),
                React$1.createElement(CocoDPFlightInputNumberField, { label: '子ども', subLabel: "0\u301C17\u6B73", initialValue: numberOfChildren, minValue: MIN_NUMBER_OF_CHILDREN, maxValue: MAX_NUMBER_OF_CHILDREN, onChange: handleChangeNumberOfChildren, testid: 'child', style: { marginBottom: '30px' } }),
                typeof childAges !== 'undefined' && childAges.length > 0 && (React$1.createElement(React$1.Fragment, null,
                    React$1.createElement(Annotation, null, "\u73FE\u5730\u51FA\u767A\u65E5\u6642\u70B9\u3067\u306E\u5E74\u9F62\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    childAges.map(function (childAge, index) { return (React$1.createElement(List, { key: index },
                        React$1.createElement(ListItem, null,
                            "\u5B50\u3069\u3082\u306E\u5E74\u9F62",
                            index + 1),
                        React$1.createElement(ListItem, null,
                            React$1.createElement(DPFlightInputSelect$1, { onChange: function (value) {
                                    return handleChangeChildAges(Number(value), index);
                                }, options: AGE_OPTIONS(enableInfant), initialSelectedValue: typeof childAge === 'number'
                                    ? childAge.toString()
                                    : undefined, style: { width: '140px' } })))); }),
                    childAges.some(function (age) { return typeof age === 'number' && age <= 1; }) && (React$1.createElement(Note$1, { style: { marginTop: '15px' } }, "2\u6B73\u672A\u6E80\u306E\u304A\u5B50\u3055\u307E\u306F\u3001\u5927\u4EBA\u306E\u819D\u306E\u4E0A\u3067\u306E\u3054\u642D\u4E57\u3068\u306A\u308A\u307E\u3059\uFF08\u304A\u5B50\u3055\u307E\u306E\u5EA7\u5E2D\u306F\u4E88\u7D04\u3067\u304D\u307E\u305B\u3093\uFF09\u3002")),
                    childAges.filter(function (age) { return typeof age === 'number' && age <= 1; })
                        .length >= 2 && (React$1.createElement(Note$1, { style: { marginTop: '15px' } }, "2\u6B73\u672A\u6E80\u306E\u304A\u5B50\u3055\u307E\u30922\u540D\u4EE5\u4E0A\u304A\u9023\u308C\u306E\u5834\u5408\u3001\u540C\u3058\u5217\u3067\u306E\u5EA7\u5E2D\u6307\u5B9A\u306F\u3067\u304D\u307E\u305B\u3093\u3002")),
                    childAges.some(function (age) { return typeof age === 'number' && age === 2; }) && (React$1.createElement(Note$1, { style: { marginTop: '15px' } }, "\u304A\u5B50\u3055\u307E\u304C\u65C5\u884C\u4E2D\u306B2\u6B73\u306E\u8A95\u751F\u65E5\u3092\u8FCE\u3048\u308B\u5834\u5408\u3001\u822A\u7A7A\u4F1A\u793E\u306B\u3088\u3063\u3066\u904B\u8CC3\u898F\u5B9A\u304C\u7570\u306A\u308A\u307E\u3059\u3002\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002")),
                    childAges.some(function (age) { return typeof age === 'number' && age === 12; }) && (React$1.createElement(Note$1, { style: { marginTop: '15px' } }, "\u304A\u5B50\u3055\u307E\u304C\u65C5\u884C\u4E2D\u306B12\u6B73\u306E\u8A95\u751F\u65E5\u3092\u8FCE\u3048\u308B\u5834\u5408\u3001\u822A\u7A7A\u4F1A\u793E\u306B\u3088\u3063\u3066\u904B\u8CC3\u898F\u5B9A\u304C\u7570\u306A\u308A\u307E\u3059\u3002\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002")))),
                numberOfAdults > 2 && (React$1.createElement(Note$1, { style: { marginTop: '15px' } }, "\u8907\u6570\u306E\u5BA2\u5BA4\u3092\u3054\u5E0C\u671B\u306E\u5834\u5408\u30011\u90E8\u5C4B\u305A\u3064\u3054\u4E88\u7D04\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u30021\u90E8\u5C4B\u5206\u306E\u4EBA\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002")),
                isInfantCountExceedsAdults && (React$1.createElement(Note$1, { danger: true, style: { marginTop: '15px' } }, "2\u6B73\u672A\u6E80\u306E\u304A\u5B50\u3055\u307E\u306E\u4EBA\u6570\u304C\u3001\u5927\u4EBA\u306E\u4EBA\u6570\u3092\u8D85\u3048\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002")))),
        React$1.createElement(FixedBottomContainer, { minWidth: minWidth }, isInfantCountExceedsAdults ? (React$1.createElement(CocoDisableButton, { fullWidth: true, style: { fontSize: '15px' } }, "\u4EBA\u6570\u3092\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044")) : isValidInput ? (React$1.createElement(CocoRedButton, { onClick: function () {
                onClick({
                    numberOfAdults: numberOfAdults,
                    childAges: childAgesWithoutNullish,
                });
                onClose();
            }, style: { width: '100%', fontSize: '15px' } }, "\u6C7A\u5B9A")) : (React$1.createElement(CocoDisableButton, { fullWidth: true, style: { fontSize: '15px' } }, "\u6C7A\u5B9A")))));
};
var index$2 = memo(CocoNumberOfPeopleModal);
var ModalContainer = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  margin: 38px 20px 0;\n"], ["\n  margin: 38px 20px 0;\n"])));
var InputContainer = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  button span {\n    border-color: ", ";\n    &:before {\n      border-color: ", ";\n    }\n    &:after {\n      border-color: ", ";\n    }\n  }\n"], ["\n  button span {\n    border-color: ", ";\n    &:before {\n      border-color: ", ";\n    }\n    &:after {\n      border-color: ", ";\n    }\n  }\n"])), COLORS.BORDER.PRIMARY, COLORS.BORDER.PRIMARY, COLORS.BORDER.PRIMARY);
var Annotation = styled.p(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  margin-bottom: 15px;\n"], ["\n  color: ", ";\n  ", "\n  margin-bottom: 15px;\n"])), COLORS.GENERAL.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1));
var List = styled.ul(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n"])));
var ListItem = styled.li(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.NO_IMPORTANT, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_3), { lineHeight: '160%', letterSpacing: '0.06em' })));
var FixedBottomContainer = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  width: 100%;\n  @media (min-width: ", ") {\n    max-width: 400px;\n  }\n  background-color: ", ";\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  box-sizing: border-box;\n  position: fixed;\n  bottom: 0;\n"], ["\n  width: 100%;\n  @media (min-width: ", ") {\n    max-width: 400px;\n  }\n  background-color: ", ";\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  box-sizing: border-box;\n  position: fixed;\n  bottom: 0;\n"])), function (props) { return props.minWidth; }, COLORS.BACKGROUND.SURFACE);
var templateObject_1$3, templateObject_2$3, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6$1;

var DPFlightVacantHotelRoomInputRadio = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, checked = _a.checked, defaultChecked = _a.defaultChecked, inputRef = _a.inputRef, onChange = _a.onChange, children = _a.children, labelStyle = _a.labelStyle, _b = _a.buttonSize, buttonSize = _b === void 0 ? 20 : _b, dataTestId = _a.dataTestId, style = _a.style;
    return (React$1.createElement(Container$2, { style: style },
        React$1.createElement("input", { id: id, type: "radio", name: name, value: value, checked: checked, defaultChecked: defaultChecked, ref: inputRef, onChange: function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange(event.currentTarget.value); }, autoComplete: 'off', "data-test-id": dataTestId, style: { width: '100%', height: '100%' } }),
        React$1.createElement(Label, { className: "input-radio", htmlFor: id, buttonSize: buttonSize, style: labelStyle }, children)));
};
var DPFlightVacantHotelRoomInputRadio$1 = memo(DPFlightVacantHotelRoomInputRadio);
var Container$2 = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  input[type='radio'] {\n    display: none;\n  }\n  input[type='radio']:checked {\n    + .input-radio:after {\n      border: 2px solid ", ";\n    }\n    + .input-radio:before {\n      display: block;\n    }\n  }\n"], ["\n  input[type='radio'] {\n    display: none;\n  }\n  input[type='radio']:checked {\n    + .input-radio:after {\n      border: 2px solid ", ";\n    }\n    + .input-radio:before {\n      display: block;\n    }\n  }\n"])), COLORS.GENERAL.PRIMARY);
var Label = styled.label(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  padding: 12px 14px 12px 35px;\n  ", "\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    left: 10px;\n    bottom: 0;\n    width: ", "px;\n    height: ", "px;\n    border: 2px solid ", ";\n    border-radius: 10px;\n    background: ", ";\n  }\n  &:before {\n    content: '';\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    left: 14px;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 6px;\n    background-color: ", ";\n    z-index: 1;\n  }\n"], ["\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  padding: 12px 14px 12px 35px;\n  ", "\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    margin: auto;\n    top: 0;\n    left: 10px;\n    bottom: 0;\n    width: ", "px;\n    height: ", "px;\n    border: 2px solid ", ";\n    border-radius: 10px;\n    background: ", ";\n  }\n  &:before {\n    content: '';\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    left: 14px;\n    width: ", "px;\n    height: ", "px;\n    border-radius: 6px;\n    background-color: ", ";\n    z-index: 1;\n  }\n"])), createFontStyle(MOBILE_FONT_STYLES.SUB_TITLE_2), function (props) { return props.buttonSize; }, function (props) { return props.buttonSize; }, COLORS.SHADOW.DEFAULT, COLORS.BACKGROUND.SURFACE, function (props) { return Number(props.buttonSize) - 8; }, function (props) { return Number(props.buttonSize) - 8; }, COLORS.GENERAL.PRIMARY);
var templateObject_1$2, templateObject_2$2;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$4 = freeGlobal || freeSelf || Function('return this')();

var _root = root$4;

var root$3 = _root;

/** Built-in value references. */
var Symbol$3 = root$3.Symbol;

var _Symbol = Symbol$3;

var Symbol$2 = _Symbol;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$3.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$3 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$3.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$1 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$1;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$2;

var baseGetTag = _baseGetTag,
    isObject$1 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$1;

var root$2 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$2['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$1;

var isFunction = isFunction_1,
    isMasked = _isMasked,
    isObject = isObject_1,
    toSource = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$3(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$3;

var getNative$2 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$2(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$1(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$1;

var eq = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$1.prototype.clear = listCacheClear;
ListCache$1.prototype['delete'] = listCacheDelete;
ListCache$1.prototype.get = listCacheGet;
ListCache$1.prototype.has = listCacheHas;
ListCache$1.prototype.set = listCacheSet;

var _ListCache = ListCache$1;

var getNative$1 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative$1(root$1, 'Map');

var _Map = Map$1;

var Hash = _Hash,
    ListCache = _ListCache,
    Map = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = mapCacheClear;
MapCache$1.prototype['delete'] = mapCacheDelete;
MapCache$1.prototype.get = mapCacheGet;
MapCache$1.prototype.has = mapCacheHas;
MapCache$1.prototype.set = mapCacheSet;

var _MapCache = MapCache$1;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var getNative = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root, 'Set');

var _Set = Set$1;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$1() {
  // No operation performed.
}

var noop_1 = noop$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$2(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$2;

var Set = _Set,
    noop = noop_1,
    setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set && (1 / setToArray$1(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

var _createSet = createSet$1;

var SetCache = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    cacheHas = _cacheHas,
    createSet = _createSet,
    setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq$1;

var baseUniq = _baseUniq;

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

var uniq_1 = uniq;

var useLocalState = function (room, onClickDetail, onClickSelect, selectedRateId) {
    var isNoSmoking = useMemo(function () {
        return room.smokingCondition === 'NoSmoking';
    }, [room.smokingCondition]);
    var bedLabels = useMemo(function () {
        var _a, _b;
        var configuration = (_a = room.bedGroups[0]) === null || _a === void 0 ? void 0 : _a.configuration;
        if (typeof configuration === 'undefined')
            return [];
        var labels = (_b = configuration
            .map(function (config) {
            if (typeof config === 'undefined')
                return undefined;
            switch (config.size) {
                case 'King':
                    return 'キング';
                case 'Twin':
                    if (config.quantity === 2) {
                        return 'ツイン';
                    }
                    else {
                        return 'シングル';
                    }
                case 'TwinXL':
                    if (config.quantity === 2) {
                        return 'ツイン';
                    }
                    else {
                        return 'セミダブル';
                    }
                case 'Queen':
                    return 'クイーン';
                case 'Full':
                    if (config.quantity === 2) {
                        return 'ツイン';
                    }
                    else {
                        return 'ダブル';
                    }
                case 'Crib':
                    return 'ベビーベッド';
                default:
                    return undefined;
            }
        })
            .filter(notUndefinedOrNull)) !== null && _b !== void 0 ? _b : [];
        return uniq_1(labels);
    }, [room.bedGroups]);
    var onClickRoomDetailButton = useCallback(function () {
        onClickDetail(room);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [room]);
    var onClickSelectButton = useCallback(function (rateId) {
        var selectedRate = room.rates.find(function (rate) { return rate.rateId === rateId; });
        if (typeof selectedRate !== 'undefined') {
            onClickSelect(room.roomId, selectedRate);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [room.rates, room.roomId]);
    var isDefaultExpanded = useMemo(function () {
        return room.rates.some(function (rate) { return selectedRateId === rate.rateId; });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        isNoSmoking: isNoSmoking,
        bedLabels: bedLabels,
        onClickRoomDetailButton: onClickRoomDetailButton,
        onClickSelectButton: onClickSelectButton,
        isDefaultExpanded: isDefaultExpanded,
    };
};

// TODO: (akutsu) いずれGraphQLのスキーマから自動生成した型を使えるようにしてanyから脱する
var CocoDPFlightVacantHotelRoom = function (_a) {
    var room = _a.room, onClickDetail = _a.onClickDetail, onClickSelect = _a.onClickSelect, selectedRateId = _a.selectedRateId, style = _a.style;
    var _b = useLocalState(room, onClickDetail, onClickSelect, selectedRateId), isNoSmoking = _b.isNoSmoking, bedLabels = _b.bedLabels, onClickRoomDetailButton = _b.onClickRoomDetailButton, onClickSelectButton = _b.onClickSelectButton, isDefaultExpanded = _b.isDefaultExpanded;
    return (React$1.createElement(Container$1, { style: style },
        room.images.length > 0 && (React$1.createElement(CocoSlideImage$1, { aspectRatio: '150/335', imageUrls: room.images.map(function (image) {
                return resizedExpediaImageUrl(image.url, EXPEDIA_IMAGE_SIZES.WIDTH_1000);
            }), showArrows: true, showPageNumber: false, style: {
                borderTopLeftRadius: '6px',
                borderTopRightRadius: '6px',
                overflow: 'hidden',
                zIndex: 0,
            } })),
        React$1.createElement(RoomInfoContainer, null,
            React$1.createElement(RoomName, null, room.roomName),
            React$1.createElement(TagContainer, null,
                bedLabels
                    .filter(function (bedLabel) { return typeof bedLabel !== 'undefined'; })
                    .map(function (bedLabel, index) { return (React$1.createElement(CocoAmenityTag$1, { key: index, amenityType: AMENITY_TYPE.BED, label: bedLabel })); }),
                typeof room.view !== 'undefined' && (React$1.createElement(CocoAmenityTag$1, { amenityType: AMENITY_TYPE.VIEW, label: room.view })),
                isNoSmoking && (React$1.createElement(CocoAmenityTag$1, { amenityType: AMENITY_TYPE.NO_SMOKING })),
                room.hasWifi && (React$1.createElement(CocoAmenityTag$1, { amenityType: AMENITY_TYPE.FREE_WIFI }))),
            React$1.createElement(RoomDetailContainer, { style: typeof room.availableRooms === 'undefined' ||
                    room.availableRooms > 5
                    ? undefined
                    : { justifyContent: 'space-between' } },
                room.availableRooms <= 5 && (React$1.createElement(AvailableRoomsLabel, null,
                    "\u6B8B\u308A",
                    room.availableRooms,
                    "\u90E8\u5C4B")),
                React$1.createElement(RoomDetailTrigger, { onClick: onClickRoomDetailButton },
                    "\u5BA2\u5BA4\u8A73\u7D30",
                    React$1.createElement("svg", { width: "7", height: "10", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginLeft: '4px' } },
                        React$1.createElement("path", { d: "M0.757324 0.757324L4.99997 4.99996L0.757324 9.2426", stroke: "#46A7ED", strokeWidth: "2" }))))),
        React$1.createElement(CocoDivider$1, { color: COLORS.BORDER.SECONDARY }),
        React$1.createElement(CocoSimpleAccordion$1, { title: room.roomId, arrowImageUrl: "https://cocolocala.imgix.net/images/shared/ui-components/CocoSimpleAccordion/circle-arrow-down.svg", arrowImageStyle: { marginRight: '8px' }, isDefaultExpanded: isDefaultExpanded, id: room.roomId, titleDOM: React$1.createElement(AccordionTitleContainer, null,
                React$1.createElement(Price, null,
                    React$1.createElement("span", null,
                        room.minimumRoomRatePriceDiffPerPerson >= 0 ? '+' : '-',
                        "\u00A5"),
                    Math.abs(room.minimumRoomRatePriceDiffPerPerson).toLocaleString(),
                    "~"),
                React$1.createElement(AccordionLabel, null, "\u8FFD\u52A0\u6599\u91D1/1\u540D")) },
            React$1.createElement(RoomSelectContainer, null, room.rates.map(function (rate, index) {
                return (React$1.createElement(DPFlightVacantHotelRoomInputRadio$1, { key: index, id: "coco-dp-flight-vacant-hotel-room_select-radio-".concat(room.roomId, "-rate-").concat(rate.rateId), name: "hotel-room", value: rate.rateId, onChange: function (value) {
                        onClickSelectButton(value);
                    }, labelStyle: { width: '85%' }, buttonSize: 16, defaultChecked: selectedRateId === rate.rateId, style: {
                        border: "".concat(typeof selectedRateId !== 'undefined' &&
                            selectedRateId === rate.rateId
                            ? "1px solid ".concat(COLORS.GENERAL.PRIMARY)
                            : "1px solid ".concat(COLORS.BORDER.PRIMARY)),
                        borderRadius: '8px',
                        backgroundColor: selectedRateId === rate.rateId
                            ? 'rgba(255, 77, 79, 0.1)'
                            : undefined,
                        marginTop: "".concat(index === 0 ? '0' : '10px'),
                    } },
                    React$1.createElement(RoomRateContainer, null,
                        React$1.createElement("div", null,
                            React$1.createElement(TitleContainer, null,
                                React$1.createElement(Title, null, rate.mealLabel))),
                        React$1.createElement(Price, null,
                            React$1.createElement("span", null,
                                rate.occupancyPricing.ratePriceDiffPerPerson >= 0
                                    ? '+'
                                    : '-',
                                "\u00A5"),
                            Math.abs(rate.occupancyPricing.ratePriceDiffPerPerson).toLocaleString()))));
            })))));
};
var index$1 = memo(CocoDPFlightVacantHotelRoom);
var Container$1 = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14);\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14);\n"])), COLORS.BACKGROUND.SURFACE, COLORS.BORDER.SECONDARY);
var RoomInfoContainer = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  padding: 10px 15px;\n"], ["\n  padding: 10px 15px;\n"])));
var RoomName = styled.span(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  margin-left: 2px;\n  color: ", ";\n  ", "\n"], ["\n  margin-left: 2px;\n  color: ", ";\n  ", "\n"])), COLORS.TEXT.PRIMARY, createFontStyle(MOBILE_FONT_STYLES.BODY_BOLD_2));
var TagContainer = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  div {\n    margin-top: 10px;\n    margin-right: 10px;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  div {\n    margin-top: 10px;\n    margin-right: 10px;\n  }\n"])));
var RoomDetailContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  padding-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n"])));
var RoomDetailTrigger = styled.p(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_BOLD_1), { lineHeight: '100%' })), COLORS.STATUS.SUCCESS_OR_POSITIVE);
var RoomSelectContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding: 0 15px 15px 15px;\n"], ["\n  padding: 0 15px 15px 15px;\n"])));
var RoomRateContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var TitleContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Title = styled.p(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  white-space: normal;\n  word-break: break-word;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n"], ["\n  color: ", ";\n  ", "\n  white-space: normal;\n  word-break: break-word;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n"])), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.BODY_BOLD_2), { letterSpacing: '0.1em', lineHeight: 1 })));
var Price = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  margin-left: 2px;\n  ", "\n  color: ", ";\n  text-wrap: nowrap;\n  span {\n    margin-right: 1px;\n    ", ";\n    vertical-align: top;\n  }\n"], ["\n  margin-left: 2px;\n  ", "\n  color: ", ";\n  text-wrap: nowrap;\n  span {\n    margin-right: 1px;\n    ", ";\n    vertical-align: top;\n  }\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_2), { fontWeight: 'bold', letterSpacing: '-0.02em', lineHeight: 1 })), COLORS.TEXT.PRIMARY, createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NUM_4), { fontWeight: 'bold', letterSpacing: '-0.02em' })));
var AvailableRoomsLabel = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  padding: 2px 5px;\n  background-color: ", ";\n  border-radius: 2px;\n  ", ";\n  color: ", ";\n"], ["\n  padding: 2px 5px;\n  background-color: ", ";\n  border-radius: 2px;\n  ", ";\n  color: ", ";\n"])), COLORS.GENERAL.PRIMARY, createFontStyle(__assign({}, MOBILE_FONT_STYLES.CAPTION_BOLD_1)), COLORS.INVERT_TEXT.PRIMARY);
var AccordionTitleContainer = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var AccordionLabel = styled.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  margin-left: 4px;\n  ", ";\n  color: ", ";\n"], ["\n  margin-left: 4px;\n  ", ";\n  color: ", ";\n"])), createFontStyle(MOBILE_FONT_STYLES.CAPTION_1), COLORS.TEXT.NOTE_OR_CAPTION);
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;

var CocoCancelForAnyReasonMainDescription = function (_a) {
    var style = _a.style, imgixHost = _a.imgixHost;
    return (React$1.createElement(Container, { style: style },
        React$1.createElement(CocoLightBulbTitle$1, { title: { title1: '旅行当日まで、', title2: 'キャンセル料を100%免除' }, imgixHost: imgixHost }),
        React$1.createElement(Description, null,
            "\u300C\u3089\u304F\u3089\u304F\u30AD\u30E3\u30F3\u30BB\u30EB\u300D\u52A0\u5165\u6599\u91D1\u3092\u9664\u3044\u305F\u3001",
            React$1.createElement("br", null),
            "\u3059\u3079\u3066\u306E\u6599\u91D1\u304C\u8FD4\u91D1\u5BFE\u8C61\u3068\u306A\u308A\u307E\u3059\u3002"),
        React$1.createElement(Img, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/rakuraku-cancel-1-v3.png")), width: 335, height: 187 }),
        React$1.createElement(Img, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/rakuraku-cancel-3-v1.png")), width: 335, height: 187, style: { marginTop: '15px' } }),
        React$1.createElement(CautionText, null, "\u203B\u30DB\u30C6\u30EB\u3068\u822A\u7A7A\u5238\u30BB\u30C3\u30C8\u3067\u306E\u4E88\u7D04\u6642\u306E\u307F\u52A0\u5165\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u5358\u4F53\u3067\u306E\u4E88\u7D04\u6642\u306B\u306F\u52A0\u5165\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002"),
        React$1.createElement(CautionText, null, "\u203B\u5EA7\u5E2D\u6307\u5B9A\u3084\u53D7\u8A17\u624B\u8377\u7269\u8FFD\u52A0\u306A\u3069\u3001\u30B5\u30D7\u30E9\u30A4\u30E4\u30FC\u306B\u76F4\u63A5\u304A\u652F\u6255\u3044\u3044\u305F\u3060\u3044\u305F\u6599\u91D1\u306B\u3064\u304D\u307E\u3057\u3066\u306F\u88DC\u511F\u306E\u5BFE\u8C61\u5916\u3068\u306A\u308A\u307E\u3059\u3002"),
        React$1.createElement(CautionText, null, "\u203B\u7121\u65AD\u3067\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u3001\u307E\u305F\u306F\u5F80\u8DEF\u30D5\u30E9\u30A4\u30C8\u51FA\u767A\u6642\u523B\u4EE5\u964D\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u306E\u5834\u5408\u306F\u3001\u898F\u5B9A\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u6599\u304C\u767A\u751F\u3057\u307E\u3059\u3002"),
        React$1.createElement(CocoLightBulbTitle$1, { title: {
                title1: '面倒な手続きは一切不要、',
                title2: 'わずか1タップで加入！',
            }, imgixHost: imgixHost, style: { marginTop: '30px', marginBottom: '15px' } }),
        React$1.createElement(Img, { src: addAutoFormatAndCompress("".concat(imgixHost, "/images/overseas/shared/rakuraku-cancel-2-v5.png")), width: 335, height: 135 }),
        React$1.createElement(CautionText, null, "\u203B\u65C5\u884C\u4E88\u7D04\u5F8C\u306E\u52A0\u5165\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u304B\u306A\u3089\u305A\u65C5\u884C\u4E88\u7D04\u6642\u306B\u30BB\u30C3\u30C8\u3067\u52A0\u5165\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"),
        React$1.createElement(CautionText, null, "\u203B\u52A0\u5165\u5F8C\u306E\u300C\u3089\u304F\u3089\u304F\u30AD\u30E3\u30F3\u30BB\u30EB\u300D\u306E\u53D6\u308A\u6D88\u3057\u304A\u3088\u3073\u6599\u91D1\u306E\u8FD4\u91D1\u306F\u53D7\u3051\u4ED8\u3051\u3066\u304A\u308A\u307E\u305B\u3093\u3002"),
        React$1.createElement(CautionText, null, "\u203B\u91CD\u8907\u3067\u4E88\u7D04\u3055\u308C\u305F\u5834\u5408\u3001\u300C\u3089\u304F\u3089\u304F\u30AD\u30E3\u30F3\u30BB\u30EB\u300D\u306E\u6599\u91D1\u306F\u8FD4\u91D1\u306E\u4E0A\u3001\u901A\u5E38\u901A\u308A\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u6599\u304C\u767A\u751F\u3057\u307E\u3059\u3002")));
};
var index = memo(CocoCancelForAnyReasonMainDescription);
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px 20px 30px;\n  background: ", ";\n"], ["\n  padding: 20px 20px 30px;\n  background: ", ";\n"])), COLORS.GENERAL.SECONDARY);
var Description = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-top: 15px;\n  margin-bottom: 15px;\n  text-align: center;\n"], ["\n  ", ";\n  color: ", ";\n  margin-top: 15px;\n  margin-bottom: 15px;\n  text-align: center;\n"])), createFontStyle(MOBILE_FONT_STYLES.NOTE_BOLD_1), COLORS.INVERT_TEXT.PRIMARY);
var CautionText = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-top: 15px;\n"], ["\n  ", ";\n  color: ", ";\n  margin-top: 15px;\n"])), createFontStyle(__assign(__assign({}, MOBILE_FONT_STYLES.NOTE_2), { letterSpacing: '1px' })), COLORS.INVERT_TEXT.PRIMARY);
var Img = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: auto;\n  display: block;\n"], ["\n  margin: auto;\n  display: block;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { CARRIER_TYPE, AMENITY_TYPE as COCO_AMENITY_TYPE, COLORS, index$n as CocoAboutHotelGradeModal, CocoAccordion$1 as CocoAccordion, index$z as CocoActivityCardList, CocoAmenityTag$1 as CocoAmenityTag, CocoAspectRatio$1 as CocoAspectRatio, index$F as CocoBreadCrumbList, CocoBubbleComment$1 as CocoBubbleComment, CocoButton$1 as CocoButton, index as CocoCancelForAnyReasonMainDescription, index$t as CocoCheckLabelButton, index$3 as CocoDPFlightCalendarModal, CocoDPFlightFixedFooter$1 as CocoDPFlightFixedFooter, index$5 as CocoDPFlightHotelListItem, index$o as CocoDPFlightTabs, index$1 as CocoDPFlightVacantHotelRoom, CocoDisableButton, CocoDiscountLabel$1 as CocoDiscountLabel, CocoDivider$1 as CocoDivider, index$s as CocoDrawer, index$l as CocoESIMOverseasTravelSection, index$k as CocoESIMTrifaSection, CocoFAQItem$1 as CocoFAQItem, CocoFlightClassLabel$1 as CocoFlightClassLabel, index$8 as CocoFlightDetailModal, index$C as CocoFlightHeader, index$B as CocoFlightSummary, index$r as CocoFooter, index$D as CocoHeaderBar, index$a as CocoHotelAndRoomSummary, index$w as CocoHotelCautions, index$4 as CocoHotelDetailHeader, index$e as CocoHotelDetailInfo, index$f as CocoHotelGuestReviewList, index$6 as CocoHotelRoom, index$b as CocoHotelSummary, CocoInputRadio$1 as CocoInputRadio, index$E as CocoLINEBanner, index$m as CocoLINEConsultationModal, CocoLINELinkWithKeyVisual$1 as CocoLINELinkWithKeyVisual, CocoLightBulbTitle$1 as CocoLightBulbTitle, index$x as CocoLimitedTimeSaleBanner, index$y as CocoLoadingMessage, index$q as CocoLogoNavigationBar, CocoModal$1 as CocoModal, Note$1 as CocoNote, index$d as CocoNotification, index$2 as CocoNumberOfPeopleModal, index$G as CocoOverlaySpinner, index$9 as CocoPCGlobalHeader, index$g as CocoPcFooter, CocoProductLogo$1 as CocoProductLogo, index$h as CocoQuiltedImageList, CocoRatings$1 as CocoRatings, CocoRedButton, ReservationStayPeriod as CocoReservationStayPeriod, index$v as CocoRichHotelContent, index$c as CocoScrollTabs, index$j as CocoSelectOptionCard, index$A as CocoSelectOptionPageHeader, CocoSimpleAccordion$1 as CocoSimpleAccordion, index$u as CocoSkeletonImageContainer, CocoSlideImage$1 as CocoSlideImage, CocoStaffComment$1 as CocoStaffComment, CocoStepper$1 as CocoStepper, index$7 as CocoSupportDetailModal, index$p as CocoSupportPlan, CocoSupportPlanCard$1 as CocoSupportPlanCard, CocoTrifaLink$1 as CocoTrifaLink, UneasinessOverseasTravelSection as CocoUneasinessOverseasTravelSection, CocoWhiteButton, CocoWhiteGradientButton, EXPEDIA_IMAGE_SIZES, FLIGHT_CLASS, FONT_FAMILY, FONT_WEIGHT, GDS_VENDORS, index$i as IsScrollingAnimationContainer, LIMITED_TIME_SALE_COLORS, MOBILE_FONT_STYLES, OPACITIES, PC_FONT_STYLES, TABLET_MAX_WIDTH, Z_INDEX, addAutoFormatAndCompress, createFontStyle, getUTCOffset, isExpediaImage, notUndefinedOrNull, resizedExpediaImageUrl, use100vh, useElementSize, useEventListener, useLockBodyScroll, useModal, useScrollDetail };
